/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.6.2.0 (NJsonSchema v10.1.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf, of } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordOutput>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    impersonate(body: ImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    delegatedImpersonate(body: DelegatedImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/DelegatedImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>_observableThrow(response_);
        }));
    }

    protected processDelegatedImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(<any>null);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>_observableThrow(response_);
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(<any>response_);
                } catch (e) {
                    return <Observable<SwitchToLinkedAccountOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwitchToLinkedAccountOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchToLinkedAccountOutput>(<any>null);
    }
}

@Injectable()
export class AgenciesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional)
     * @param companyNameFilter (optional)
     * @param referenceFilter (optional)
     * @param countryFilter (optional)
     * @param cityFilter (optional)
     * @param stateFilter (optional)
     * @param addressFilter (optional)
     * @param zipCodeFilter (optional)
     * @param phoneNumberFilter (optional)
     * @param mobileNumberFilter (optional)
     * @param faxFilter (optional)
     * @param vatNumberFilter (optional)
     * @param cCIAAFilter (optional)
     * @param emailFilter (optional)
     * @param accountingCodeFilter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(filter: string | null | undefined, companyNameFilter: string | null | undefined, referenceFilter: string | null | undefined, countryFilter: string | null | undefined, cityFilter: string | null | undefined, stateFilter: string | null | undefined, addressFilter: string | null | undefined, zipCodeFilter: string | null | undefined, phoneNumberFilter: string | null | undefined, mobileNumberFilter: string | null | undefined, faxFilter: string | null | undefined, vatNumberFilter: string | null | undefined, cCIAAFilter: string | null | undefined, emailFilter: string | null | undefined, accountingCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAgencyForView> {
        let url_ = this.baseUrl + "/api/services/app/Agencies/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (companyNameFilter !== undefined && companyNameFilter !== null)
            url_ += "CompanyNameFilter=" + encodeURIComponent("" + companyNameFilter) + "&";
        if (referenceFilter !== undefined && referenceFilter !== null)
            url_ += "ReferenceFilter=" + encodeURIComponent("" + referenceFilter) + "&";
        if (countryFilter !== undefined && countryFilter !== null)
            url_ += "CountryFilter=" + encodeURIComponent("" + countryFilter) + "&";
        if (cityFilter !== undefined && cityFilter !== null)
            url_ += "CityFilter=" + encodeURIComponent("" + cityFilter) + "&";
        if (stateFilter !== undefined && stateFilter !== null)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&";
        if (addressFilter !== undefined && addressFilter !== null)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (zipCodeFilter !== undefined && zipCodeFilter !== null)
            url_ += "ZipCodeFilter=" + encodeURIComponent("" + zipCodeFilter) + "&";
        if (phoneNumberFilter !== undefined && phoneNumberFilter !== null)
            url_ += "PhoneNumberFilter=" + encodeURIComponent("" + phoneNumberFilter) + "&";
        if (mobileNumberFilter !== undefined && mobileNumberFilter !== null)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&";
        if (faxFilter !== undefined && faxFilter !== null)
            url_ += "FaxFilter=" + encodeURIComponent("" + faxFilter) + "&";
        if (vatNumberFilter !== undefined && vatNumberFilter !== null)
            url_ += "VatNumberFilter=" + encodeURIComponent("" + vatNumberFilter) + "&";
        if (cCIAAFilter !== undefined && cCIAAFilter !== null)
            url_ += "CCIAAFilter=" + encodeURIComponent("" + cCIAAFilter) + "&";
        if (emailFilter !== undefined && emailFilter !== null)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (accountingCodeFilter !== undefined && accountingCodeFilter !== null)
            url_ += "AccountingCodeFilter=" + encodeURIComponent("" + accountingCodeFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAgencyForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAgencyForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAgencyForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAgencyForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAgencyForView>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAgencyForEdit(id: string | undefined): Observable<GetAgencyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Agencies/GetAgencyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAgencyForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAgencyForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgencyForEdit(response: HttpResponseBase): Observable<GetAgencyForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAgencyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAgencyForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrEdit(body: CreateOrEditAgencyInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agencies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agencies/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param companyNameFilter (optional)
     * @param referenceFilter (optional)
     * @param countryFilter (optional)
     * @param cityFilter (optional)
     * @param stateFilter (optional)
     * @param addressFilter (optional)
     * @param zipCodeFilter (optional)
     * @param phoneNumberFilter (optional)
     * @param mobileNumberFilter (optional)
     * @param faxFilter (optional)
     * @param vatNumberFilter (optional)
     * @param cCIAAFilter (optional)
     * @param emailFilter (optional)
     * @param accountingCodeFilter (optional)
     * @return Success
     */
    getAgenciesToExcel(filter: string | null | undefined, companyNameFilter: string | null | undefined, referenceFilter: string | null | undefined, countryFilter: string | null | undefined, cityFilter: string | null | undefined, stateFilter: string | null | undefined, addressFilter: string | null | undefined, zipCodeFilter: string | null | undefined, phoneNumberFilter: string | null | undefined, mobileNumberFilter: string | null | undefined, faxFilter: string | null | undefined, vatNumberFilter: string | null | undefined, cCIAAFilter: string | null | undefined, emailFilter: string | null | undefined, accountingCodeFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Agencies/GetAgenciesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (companyNameFilter !== undefined && companyNameFilter !== null)
            url_ += "CompanyNameFilter=" + encodeURIComponent("" + companyNameFilter) + "&";
        if (referenceFilter !== undefined && referenceFilter !== null)
            url_ += "ReferenceFilter=" + encodeURIComponent("" + referenceFilter) + "&";
        if (countryFilter !== undefined && countryFilter !== null)
            url_ += "CountryFilter=" + encodeURIComponent("" + countryFilter) + "&";
        if (cityFilter !== undefined && cityFilter !== null)
            url_ += "CityFilter=" + encodeURIComponent("" + cityFilter) + "&";
        if (stateFilter !== undefined && stateFilter !== null)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&";
        if (addressFilter !== undefined && addressFilter !== null)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (zipCodeFilter !== undefined && zipCodeFilter !== null)
            url_ += "ZipCodeFilter=" + encodeURIComponent("" + zipCodeFilter) + "&";
        if (phoneNumberFilter !== undefined && phoneNumberFilter !== null)
            url_ += "PhoneNumberFilter=" + encodeURIComponent("" + phoneNumberFilter) + "&";
        if (mobileNumberFilter !== undefined && mobileNumberFilter !== null)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&";
        if (faxFilter !== undefined && faxFilter !== null)
            url_ += "FaxFilter=" + encodeURIComponent("" + faxFilter) + "&";
        if (vatNumberFilter !== undefined && vatNumberFilter !== null)
            url_ += "VatNumberFilter=" + encodeURIComponent("" + vatNumberFilter) + "&";
        if (cCIAAFilter !== undefined && cCIAAFilter !== null)
            url_ += "CCIAAFilter=" + encodeURIComponent("" + cCIAAFilter) + "&";
        if (emailFilter !== undefined && emailFilter !== null)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (accountingCodeFilter !== undefined && accountingCodeFilter !== null)
            url_ += "AccountingCodeFilter=" + encodeURIComponent("" + accountingCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgenciesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgenciesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgenciesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getAgency(input: string | undefined): Observable<AgencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Agencies/GetAgency?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgency(<any>response_);
                } catch (e) {
                    return <Observable<AgencyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgencyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgency(response: HttpResponseBase): Observable<AgencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgencyDto>(<any>null);
    }
}

@Injectable()
export class AgencyDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @return Success
     */
    getNewOrders(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AgencyDashboard/GetNewOrders?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewOrders(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNewOrders(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @return Success
     */
    getTotalProfit(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AgencyDashboard/GetTotalProfit?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalProfit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalProfit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalProfit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param numOfReservations (optional)
     * @return Success
     */
    getLastReservations(numOfReservations: number | undefined): Observable<ReservationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgencyDashboard/GetLastReservations?";
        if (numOfReservations === null)
            throw new Error("The parameter 'numOfReservations' cannot be null.");
        else if (numOfReservations !== undefined)
            url_ += "numOfReservations=" + encodeURIComponent("" + numOfReservations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastReservations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastReservations(<any>response_);
                } catch (e) {
                    return <Observable<ReservationListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastReservations(response: HttpResponseBase): Observable<ReservationListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ReservationListDto[]>(<any>null));
    }

    /**
     * @param numDaysTolerance (optional)
     * @return Success
     */
    getReservationsNearDeparture(numDaysTolerance: number | undefined): Observable<ReservationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgencyDashboard/GetReservationsNearDeparture?";
        if (numDaysTolerance === null)
            throw new Error("The parameter 'numDaysTolerance' cannot be null.");
        else if (numDaysTolerance !== undefined)
            url_ += "numDaysTolerance=" + encodeURIComponent("" + numDaysTolerance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationsNearDeparture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationsNearDeparture(<any>response_);
                } catch (e) {
                    return <Observable<ReservationListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationsNearDeparture(response: HttpResponseBase): Observable<ReservationListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ReservationListDto[]>(<any>null));
    }

    /**
     * @param numDaysTolerance (optional)
     * @return Success
     */
    getReservationsTimelimitExpiring(numDaysTolerance: number | undefined): Observable<ReservationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgencyDashboard/GetReservationsTimelimitExpiring?";
        if (numDaysTolerance === null)
            throw new Error("The parameter 'numDaysTolerance' cannot be null.");
        else if (numDaysTolerance !== undefined)
            url_ += "numDaysTolerance=" + encodeURIComponent("" + numDaysTolerance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationsTimelimitExpiring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationsTimelimitExpiring(<any>response_);
                } catch (e) {
                    return <Observable<ReservationListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationsTimelimitExpiring(response: HttpResponseBase): Observable<ReservationListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ReservationListDto[]>(<any>null));
    }

    /**
     * @param numOfReservations (optional)
     * @return Success
     */
    getReservationsWithStatusAlert(numOfReservations: number | undefined): Observable<ReservationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgencyDashboard/GetReservationsWithStatusAlert?";
        if (numOfReservations === null)
            throw new Error("The parameter 'numOfReservations' cannot be null.");
        else if (numOfReservations !== undefined)
            url_ += "numOfReservations=" + encodeURIComponent("" + numOfReservations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationsWithStatusAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationsWithStatusAlert(<any>response_);
                } catch (e) {
                    return <Observable<ReservationListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationsWithStatusAlert(response: HttpResponseBase): Observable<ReservationListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ReservationListDto[]>(<any>null));
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @return Success
     */
    getReservationsSegmentsCountByDateRange(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AgencyDashboard/GetReservationsSegmentsCountByDateRange?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationsSegmentsCountByDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationsSegmentsCountByDateRange(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationsSegmentsCountByDateRange(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class AgencyFeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createAgencyFee(body: AgencyFeeDto | undefined): Observable<AgencyFeeRoot> {
        let url_ = this.baseUrl + "/api/services/app/AgencyFee/CreateAgencyFee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAgencyFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAgencyFee(<any>response_);
                } catch (e) {
                    return <Observable<AgencyFeeRoot>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgencyFeeRoot>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAgencyFee(response: HttpResponseBase): Observable<AgencyFeeRoot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyFeeRoot.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgencyFeeRoot>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteAgencyFee(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AgencyFee/DeleteAgencyFee?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAgencyFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAgencyFee(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAgencyFee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAgencyFeeById(id: string | null | undefined): Observable<AgencyFeeDto> {
        let url_ = this.baseUrl + "/api/services/app/AgencyFee/GetAgencyFeeById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyFeeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyFeeById(<any>response_);
                } catch (e) {
                    return <Observable<AgencyFeeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgencyFeeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgencyFeeById(response: HttpResponseBase): Observable<AgencyFeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyFeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgencyFeeDto>(<any>null);
    }

    /**
     * @param enabled (optional)
     * @param keyWord (optional)
     * @param feeProductType (optional)
     * @param validFrom (optional)
     * @param validTo (optional)
     * @param agenciesId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAgencyFees(enabled: boolean | null | undefined, keyWord: string | null | undefined, feeProductType: FeeProductType | undefined, validFrom: moment.Moment | null | undefined, validTo: moment.Moment | null | undefined, agenciesId: string[] | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfFeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AgencyFee/GetAgencyFees?";
        if (enabled !== undefined && enabled !== null)
            url_ += "Enabled=" + encodeURIComponent("" + enabled) + "&";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (feeProductType === null)
            throw new Error("The parameter 'feeProductType' cannot be null.");
        else if (feeProductType !== undefined)
            url_ += "FeeProductType=" + encodeURIComponent("" + feeProductType) + "&";
        if (validFrom !== undefined && validFrom !== null)
            url_ += "ValidFrom=" + encodeURIComponent(validFrom ? "" + validFrom.toJSON() : "") + "&";
        if (validTo !== undefined && validTo !== null)
            url_ += "ValidTo=" + encodeURIComponent(validTo ? "" + validTo.toJSON() : "") + "&";
        if (agenciesId !== undefined && agenciesId !== null)
            agenciesId && agenciesId.forEach(item => { url_ += "AgenciesId=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgencyFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgencyFees(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFeeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFeeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgencyFees(response: HttpResponseBase): Observable<PagedResultDtoOfFeeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFeeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFeeListDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param enabled (optional)
     * @return Success
     */
    setEnabled(id: string | null | undefined, enabled: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AgencyFee/SetEnabled?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (enabled === null)
            throw new Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEnabled(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAgencyFee(body: AgencyFeeDto | undefined): Observable<AgencyFeeRoot> {
        let url_ = this.baseUrl + "/api/services/app/AgencyFee/UpdateAgencyFee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAgencyFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAgencyFee(<any>response_);
                } catch (e) {
                    return <Observable<AgencyFeeRoot>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgencyFeeRoot>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAgencyFee(response: HttpResponseBase): Observable<AgencyFeeRoot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyFeeRoot.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgencyFeeRoot>(<any>null);
    }
}

@Injectable()
export class AgencyMasterDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @return Success
     */
    getCountDaysSales(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined): Observable<GetCountDaySalesOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/AgencyMasterDashboard/GetCountDaysSales?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountDaysSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountDaysSales(<any>response_);
                } catch (e) {
                    return <Observable<GetCountDaySalesOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCountDaySalesOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountDaysSales(response: HttpResponseBase): Observable<GetCountDaySalesOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCountDaySalesOutput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<GetCountDaySalesOutput[]>(<any>null));
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @return Success
     */
    getSalesSummary(period: SalesSummaryDatePeriod, dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined): Observable<SalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/AgencyMasterDashboard/GetSalesSummary?";
        if (period === undefined || period === null)
            throw new Error("The parameter 'period' must be defined and cannot be null.");
        else
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(<any>response_);
                } catch (e) {
                    return <Observable<SalesSummaryOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<SalesSummaryOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<SalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalesSummaryOutput>(<any>null);
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @return Success
     */
    getNewOrders(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AgencyMasterDashboard/GetNewOrders?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewOrders(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNewOrders(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @return Success
     */
    getTotalProfit(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AgencyMasterDashboard/GetTotalProfit?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalProfit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalProfit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalProfit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param numOfReservations (optional)
     * @return Success
     */
    getLastReservations(numOfReservations: number | undefined): Observable<ReservationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgencyMasterDashboard/GetLastReservations?";
        if (numOfReservations === null)
            throw new Error("The parameter 'numOfReservations' cannot be null.");
        else if (numOfReservations !== undefined)
            url_ += "numOfReservations=" + encodeURIComponent("" + numOfReservations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastReservations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastReservations(<any>response_);
                } catch (e) {
                    return <Observable<ReservationListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastReservations(response: HttpResponseBase): Observable<ReservationListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ReservationListDto[]>(<any>null));
    }

    /**
     * @param numDaysTolerance (optional)
     * @return Success
     */
    getReservationsNearDeparture(numDaysTolerance: number | undefined): Observable<ReservationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgencyMasterDashboard/GetReservationsNearDeparture?";
        if (numDaysTolerance === null)
            throw new Error("The parameter 'numDaysTolerance' cannot be null.");
        else if (numDaysTolerance !== undefined)
            url_ += "numDaysTolerance=" + encodeURIComponent("" + numDaysTolerance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationsNearDeparture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationsNearDeparture(<any>response_);
                } catch (e) {
                    return <Observable<ReservationListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationsNearDeparture(response: HttpResponseBase): Observable<ReservationListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ReservationListDto[]>(<any>null));
    }

    /**
     * @param numDaysTolerance (optional)
     * @return Success
     */
    getReservationsTimelimitExpiring(numDaysTolerance: number | undefined): Observable<ReservationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgencyMasterDashboard/GetReservationsTimelimitExpiring?";
        if (numDaysTolerance === null)
            throw new Error("The parameter 'numDaysTolerance' cannot be null.");
        else if (numDaysTolerance !== undefined)
            url_ += "numDaysTolerance=" + encodeURIComponent("" + numDaysTolerance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationsTimelimitExpiring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationsTimelimitExpiring(<any>response_);
                } catch (e) {
                    return <Observable<ReservationListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationsTimelimitExpiring(response: HttpResponseBase): Observable<ReservationListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ReservationListDto[]>(<any>null));
    }

    /**
     * @param numOfReservations (optional)
     * @return Success
     */
    getReservationsWithStatusAlert(numOfReservations: number | undefined): Observable<ReservationListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AgencyMasterDashboard/GetReservationsWithStatusAlert?";
        if (numOfReservations === null)
            throw new Error("The parameter 'numOfReservations' cannot be null.");
        else if (numOfReservations !== undefined)
            url_ += "numOfReservations=" + encodeURIComponent("" + numOfReservations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationsWithStatusAlert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationsWithStatusAlert(<any>response_);
                } catch (e) {
                    return <Observable<ReservationListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationsWithStatusAlert(response: HttpResponseBase): Observable<ReservationListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReservationListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ReservationListDto[]>(<any>null));
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @return Success
     */
    getReservationsSegmentsCountByDateRange(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AgencyMasterDashboard/GetReservationsSegmentsCountByDateRange?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationsSegmentsCountByDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationsSegmentsCountByDateRange(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationsSegmentsCountByDateRange(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class AircraftsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyWord (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getList(keyWord: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAircraft> {
        let url_ = this.baseUrl + "/api/services/app/Aircrafts/GetList?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAircraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAircraft>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfAircraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAircraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAircraft>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAircraft(id: string | null | undefined): Observable<Aircraft> {
        let url_ = this.baseUrl + "/api/services/app/Aircrafts/GetAircraft?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAircraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAircraft(<any>response_);
                } catch (e) {
                    return <Observable<Aircraft>><any>_observableThrow(e);
                }
            } else
                return <Observable<Aircraft>><any>_observableThrow(response_);
        }));
    }

    protected processGetAircraft(response: HttpResponseBase): Observable<Aircraft> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Aircraft.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Aircraft>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrEdit(body: Aircraft | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Aircrafts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Aircrafts/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyWord (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAircraftsToExcel(keyWord: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Aircrafts/GetAircraftsToExcel?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAircraftsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAircraftsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAircraftsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class AirlineCompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param name (optional)
     * @return Success
     */
    getByName(name: string | null | undefined): Observable<AirlineDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/AirlineCompany/GetByName?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByName(<any>response_);
                } catch (e) {
                    return <Observable<AirlineDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirlineDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetByName(response: HttpResponseBase): Observable<AirlineDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirlineDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<AirlineDTO[]>(<any>null));
    }

    /**
     * @return Success
     */
    getAll(): Observable<AirlineDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/AirlineCompany/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<AirlineDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirlineDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AirlineDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirlineDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<AirlineDTO[]>(<any>null));
    }
}

@Injectable()
export class AirlineRoutesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAirlineRoutes(body: GetUpdateAirlineRoutesInput | undefined): Observable<PagedResultDtoOfAirlineRouteDto> {
        let url_ = this.baseUrl + "/api/services/app/AirlineRoutes/UpdateAirlineRoutes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAirlineRoutes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAirlineRoutes(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAirlineRouteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAirlineRouteDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAirlineRoutes(response: HttpResponseBase): Observable<PagedResultDtoOfAirlineRouteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAirlineRouteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAirlineRouteDto>(<any>null);
    }

    /**
     * @param airlineIdentifiers (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUpdateAirlineRoutes(airlineIdentifiers: string[] | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAirlineRouteDto> {
        let url_ = this.baseUrl + "/api/services/app/AirlineRoutes/GetUpdateAirlineRoutes?";
        if (airlineIdentifiers !== undefined && airlineIdentifiers !== null)
            airlineIdentifiers && airlineIdentifiers.forEach(item => { url_ += "AirlineIdentifiers=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpdateAirlineRoutes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateAirlineRoutes(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAirlineRouteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAirlineRouteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpdateAirlineRoutes(response: HttpResponseBase): Observable<PagedResultDtoOfAirlineRouteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAirlineRouteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAirlineRouteDto>(<any>null);
    }

    /**
     * @param suppliers (optional)
     * @param departureAirportCode (optional)
     * @param arrivalAirportCode (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAirlineRoutes(suppliers: string[] | null | undefined, departureAirportCode: string | null | undefined, arrivalAirportCode: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAirlineRouteFlatDTO> {
        let url_ = this.baseUrl + "/api/services/app/AirlineRoutes/GetAirlineRoutes?";
        if (suppliers !== undefined && suppliers !== null)
            suppliers && suppliers.forEach(item => { url_ += "Suppliers=" + encodeURIComponent("" + item) + "&"; });
        if (departureAirportCode !== undefined && departureAirportCode !== null)
            url_ += "DepartureAirportCode=" + encodeURIComponent("" + departureAirportCode) + "&";
        if (arrivalAirportCode !== undefined && arrivalAirportCode !== null)
            url_ += "ArrivalAirportCode=" + encodeURIComponent("" + arrivalAirportCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirlineRoutes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirlineRoutes(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAirlineRouteFlatDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAirlineRouteFlatDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetAirlineRoutes(response: HttpResponseBase): Observable<PagedResultDtoOfAirlineRouteFlatDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAirlineRouteFlatDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAirlineRouteFlatDTO>(<any>null);
    }

    /**
     * @return Success
     */
    getTFSuppliers(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/AirlineRoutes/GetTFSuppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTFSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTFSuppliers(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTFSuppliers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<string[]>(<any>null));
    }

    /**
     * @param suppliers (optional)
     * @param departureAirportCode (optional)
     * @param arrivalAirportCode (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAirlineRoutesToExcel(suppliers: string[] | null | undefined, departureAirportCode: string | null | undefined, arrivalAirportCode: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AirlineRoutes/GetAirlineRoutesToExcel?";
        if (suppliers !== undefined && suppliers !== null)
            suppliers && suppliers.forEach(item => { url_ += "Suppliers=" + encodeURIComponent("" + item) + "&"; });
        if (departureAirportCode !== undefined && departureAirportCode !== null)
            url_ += "DepartureAirportCode=" + encodeURIComponent("" + departureAirportCode) + "&";
        if (arrivalAirportCode !== undefined && arrivalAirportCode !== null)
            url_ += "ArrivalAirportCode=" + encodeURIComponent("" + arrivalAirportCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirlineRoutesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirlineRoutesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAirlineRoutesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class AirlinesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyWord (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getList(keyWord: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAirlineModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Airlines/GetList?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAirlineModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAirlineModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfAirlineModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAirlineModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAirlineModelDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAirline(id: string | null | undefined): Observable<AirlineModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Airlines/GetAirline?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirline(<any>response_);
                } catch (e) {
                    return <Observable<AirlineModelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirlineModelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAirline(response: HttpResponseBase): Observable<AirlineModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirlineModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AirlineModelDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrEdit(body: AirlineModelDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Airlines/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Airlines/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyWord (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAirlinesToExcel(keyWord: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Airlines/GetAirlinesToExcel?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirlinesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirlinesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAirlinesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class AirportsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param isBlackList (optional)
     * @param isMultiCity (optional)
     * @param name (optional)
     * @param airportCode (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getList(isBlackList: boolean | null | undefined, isMultiCity: boolean | null | undefined, name: string | null | undefined, airportCode: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAirportModel> {
        let url_ = this.baseUrl + "/api/services/app/Airports/GetList?";
        if (isBlackList !== undefined && isBlackList !== null)
            url_ += "IsBlackList=" + encodeURIComponent("" + isBlackList) + "&";
        if (isMultiCity !== undefined && isMultiCity !== null)
            url_ += "IsMultiCity=" + encodeURIComponent("" + isMultiCity) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (airportCode !== undefined && airportCode !== null)
            url_ += "AirportCode=" + encodeURIComponent("" + airportCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAirportModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAirportModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfAirportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAirportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAirportModel>(<any>null);
    }

    /**
     * @param isBlackList (optional)
     * @param isMultiCity (optional)
     * @param name (optional)
     * @param airportCode (optional)
     * @return Success
     */
    getListAutoComplete(isBlackList: boolean | null | undefined, isMultiCity: boolean | null | undefined, name: string | null | undefined, airportCode: string | null | undefined): Observable<AirportDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Airports/GetListAutoComplete?";
        if (isBlackList !== undefined && isBlackList !== null)
            url_ += "IsBlackList=" + encodeURIComponent("" + isBlackList) + "&";
        if (isMultiCity !== undefined && isMultiCity !== null)
            url_ += "IsMultiCity=" + encodeURIComponent("" + isMultiCity) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (airportCode !== undefined && airportCode !== null)
            url_ += "AirportCode=" + encodeURIComponent("" + airportCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListAutoComplete(<any>response_);
                } catch (e) {
                    return <Observable<AirportDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirportDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListAutoComplete(response: HttpResponseBase): Observable<AirportDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirportDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<AirportDTO[]>(<any>null));
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAirportById(id: string | null | undefined): Observable<AirportModel> {
        let url_ = this.baseUrl + "/api/services/app/Airports/GetAirportById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirportById(<any>response_);
                } catch (e) {
                    return <Observable<AirportModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirportModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAirportById(response: HttpResponseBase): Observable<AirportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AirportModel>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    enable(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Airports/Enable?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnable(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEnable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    disable(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Airports/Disable?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrEditAirport(body: AirportModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Airports/CreateOrEditAirport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditAirport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAirport(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditAirport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Airports/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param airportCode (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAirportByGroupCode(airportCode: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAirportModel> {
        let url_ = this.baseUrl + "/api/services/app/Airports/GetAirportByGroupCode?";
        if (airportCode !== undefined && airportCode !== null)
            url_ += "AirportCode=" + encodeURIComponent("" + airportCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirportByGroupCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirportByGroupCode(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAirportModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAirportModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAirportByGroupCode(response: HttpResponseBase): Observable<PagedResultDtoOfAirportModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAirportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAirportModel>(<any>null);
    }

    /**
     * @param isBlackList (optional)
     * @param isMultiCity (optional)
     * @param name (optional)
     * @param airportCode (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAirportsToExcel(isBlackList: boolean | null | undefined, isMultiCity: boolean | null | undefined, name: string | null | undefined, airportCode: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Airports/GetAirportsToExcel?";
        if (isBlackList !== undefined && isBlackList !== null)
            url_ += "IsBlackList=" + encodeURIComponent("" + isBlackList) + "&";
        if (isMultiCity !== undefined && isMultiCity !== null)
            url_ += "IsMultiCity=" + encodeURIComponent("" + isMultiCity) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (airportCode !== undefined && airportCode !== null)
            url_ += "AirportCode=" + encodeURIComponent("" + airportCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirportsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirportsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAirportsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class AnalyticsDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @param agencyId (optional)
     * @return Success
     */
    getOrderTypes(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, agencyId: string | null | undefined): Observable<LinearChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AnalyticsDashboard/GetOrderTypes?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderTypes(<any>response_);
                } catch (e) {
                    return <Observable<LinearChartDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LinearChartDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderTypes(response: HttpResponseBase): Observable<LinearChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinearChartDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LinearChartDto[]>(<any>null));
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @return Success
     */
    getSalesByAgency(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined): Observable<LinearChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AnalyticsDashboard/GetSalesByAgency?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesByAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesByAgency(<any>response_);
                } catch (e) {
                    return <Observable<LinearChartDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LinearChartDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesByAgency(response: HttpResponseBase): Observable<LinearChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinearChartDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LinearChartDto[]>(<any>null));
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @param agencyId (optional)
     * @return Success
     */
    getSalesByAirlineCompanies(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, agencyId: string | null | undefined): Observable<LinearChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AnalyticsDashboard/GetSalesByAirlineCompanies?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesByAirlineCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesByAirlineCompanies(<any>response_);
                } catch (e) {
                    return <Observable<LinearChartDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LinearChartDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesByAirlineCompanies(response: HttpResponseBase): Observable<LinearChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinearChartDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LinearChartDto[]>(<any>null));
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @param agencyId (optional)
     * @return Success
     */
    getSalesBySchedulesAndCompanies(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, agencyId: string | null | undefined): Observable<LinearChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AnalyticsDashboard/GetSalesBySchedulesAndCompanies?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesBySchedulesAndCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesBySchedulesAndCompanies(<any>response_);
                } catch (e) {
                    return <Observable<LinearChartDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LinearChartDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesBySchedulesAndCompanies(response: HttpResponseBase): Observable<LinearChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinearChartDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LinearChartDto[]>(<any>null));
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @param agencyId (optional)
     * @return Success
     */
    getSalesByFlightType(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, agencyId: string | null | undefined): Observable<LinearChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AnalyticsDashboard/GetSalesByFlightType?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesByFlightType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesByFlightType(<any>response_);
                } catch (e) {
                    return <Observable<LinearChartDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LinearChartDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesByFlightType(response: HttpResponseBase): Observable<LinearChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinearChartDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LinearChartDto[]>(<any>null));
    }

    /**
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @param agencyId (optional)
     * @return Success
     */
    getOrderScheduleRatio(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, agencyId: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AnalyticsDashboard/GetOrderScheduleRatio?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderScheduleRatio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderScheduleRatio(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderScheduleRatio(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class ApprovalProcessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllApprovalProcesses(): Observable<ApprovalProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalProcess/GetAllApprovalProcesses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApprovalProcesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApprovalProcesses(<any>response_);
                } catch (e) {
                    return <Observable<ApprovalProcessDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApprovalProcessDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllApprovalProcesses(response: HttpResponseBase): Observable<ApprovalProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprovalProcessDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ApprovalProcessDto[]>(<any>null));
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getApprovalProcess(id: string | null | undefined): Observable<ApprovalProcessDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalProcess/GetApprovalProcess?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalProcess(<any>response_);
                } catch (e) {
                    return <Observable<ApprovalProcessDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApprovalProcessDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetApprovalProcess(response: HttpResponseBase): Observable<ApprovalProcessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalProcessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovalProcessDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateApprovalProcess(body: ApprovalProcessDto | undefined): Observable<ApprovalProcessDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalProcess/CreateOrUpdateApprovalProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateApprovalProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateApprovalProcess(<any>response_);
                } catch (e) {
                    return <Observable<ApprovalProcessDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApprovalProcessDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateApprovalProcess(response: HttpResponseBase): Observable<ApprovalProcessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalProcessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovalProcessDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteApprovalProcess(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalProcess/DeleteApprovalProcess?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApprovalProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApprovalProcess(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteApprovalProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    getApprovalProcessByUser(userId: string | null | undefined): Observable<ApprovalProcessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalProcess/GetApprovalProcessByUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalProcessByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalProcessByUser(<any>response_);
                } catch (e) {
                    return <Observable<ApprovalProcessDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApprovalProcessDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetApprovalProcessByUser(response: HttpResponseBase): Observable<ApprovalProcessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprovalProcessDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ApprovalProcessDto[]>(<any>null));
    }

    /**
     * @return Success
     */
    getAllApprovers(): Observable<ApproverDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalProcess/GetAllApprovers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApprovers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApprovers(<any>response_);
                } catch (e) {
                    return <Observable<ApproverDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApproverDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllApprovers(response: HttpResponseBase): Observable<ApproverDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApproverDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ApproverDto[]>(<any>null));
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getApproversAutocomplete(input: string | null | undefined): Observable<ApproverDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalProcess/GetApproversAutocomplete?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApproversAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApproversAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<ApproverDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApproverDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetApproversAutocomplete(response: HttpResponseBase): Observable<ApproverDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApproverDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ApproverDto[]>(<any>null));
    }
}

@Injectable()
export class AssistedBookingCarServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    assistedBooking(body: CarBookRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingCar/AssistedBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAssistedBooking(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    getAssistedBooking(assistedBookingId: string | null | undefined): Observable<CarAssistedBooking> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingCar/GetAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<CarAssistedBooking>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarAssistedBooking>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssistedBooking(response: HttpResponseBase): Observable<CarAssistedBooking> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarAssistedBooking.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarAssistedBooking>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    deleteAssistedBooking(assistedBookingId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingCar/DeleteAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAssistedBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @param body (optional)
     * @return Success
     */
    updateAssistedBookingStatus(assistedBookingId: string | null | undefined, body: AssistedBookingStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingCar/UpdateAssistedBookingStatus?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssistedBookingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssistedBookingStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssistedBookingStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AssistedBookingFlightServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    assistedBooking(body: AirBookRequestDTO | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingFlight/AssistedBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAssistedBooking(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    getAssistedBooking(assistedBookingId: string | null | undefined): Observable<FlightAssistedBooking> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingFlight/GetAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<FlightAssistedBooking>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlightAssistedBooking>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssistedBooking(response: HttpResponseBase): Observable<FlightAssistedBooking> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlightAssistedBooking.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlightAssistedBooking>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    deleteAssistedBooking(assistedBookingId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingFlight/DeleteAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAssistedBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @param body (optional)
     * @return Success
     */
    updateAssistedBookingStatus(assistedBookingId: string | null | undefined, body: AssistedBookingStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingFlight/UpdateAssistedBookingStatus?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssistedBookingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssistedBookingStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssistedBookingStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AssistedBookingHotelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    assistedBooking(body: BookStructureRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingHotel/AssistedBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAssistedBooking(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    getAssistedBooking(assistedBookingId: string | null | undefined): Observable<HotelAssistedBooking> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingHotel/GetAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<HotelAssistedBooking>><any>_observableThrow(e);
                }
            } else
                return <Observable<HotelAssistedBooking>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssistedBooking(response: HttpResponseBase): Observable<HotelAssistedBooking> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelAssistedBooking.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HotelAssistedBooking>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    deleteAssistedBooking(assistedBookingId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingHotel/DeleteAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAssistedBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @param body (optional)
     * @return Success
     */
    updateAssistedBookingStatus(assistedBookingId: string | null | undefined, body: AssistedBookingStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingHotel/UpdateAssistedBookingStatus?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssistedBookingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssistedBookingStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssistedBookingStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AssistedBookingTrainServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    assistedBooking(body: TrainBookRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingTrain/AssistedBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAssistedBooking(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    getAssistedBooking(assistedBookingId: string | null | undefined): Observable<TrainAssistedBooking> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingTrain/GetAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<TrainAssistedBooking>><any>_observableThrow(e);
                }
            } else
                return <Observable<TrainAssistedBooking>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssistedBooking(response: HttpResponseBase): Observable<TrainAssistedBooking> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainAssistedBooking.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrainAssistedBooking>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    deleteAssistedBooking(assistedBookingId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingTrain/DeleteAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAssistedBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @param body (optional)
     * @return Success
     */
    updateAssistedBookingStatus(assistedBookingId: string | null | undefined, body: AssistedBookingStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingTrain/UpdateAssistedBookingStatus?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssistedBookingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssistedBookingStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssistedBookingStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AssistedBookingTripServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param tripRootId (optional)
     * @return Success
     */
    assistedBooking(tripRootId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingTrip/AssistedBooking?";
        if (tripRootId !== undefined && tripRootId !== null)
            url_ += "tripRootId=" + encodeURIComponent("" + tripRootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAssistedBooking(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    deleteAssistedBooking(assistedBookingId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingTrip/DeleteAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAssistedBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param assistedBookingId (optional)
     * @return Success
     */
    getAssistedBooking(assistedBookingId: string | null | undefined): Observable<TripAssistedBooking> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingTrip/GetAssistedBooking?";
        if (assistedBookingId !== undefined && assistedBookingId !== null)
            url_ += "assistedBookingId=" + encodeURIComponent("" + assistedBookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<TripAssistedBooking>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripAssistedBooking>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssistedBooking(response: HttpResponseBase): Observable<TripAssistedBooking> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripAssistedBooking.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripAssistedBooking>(<any>null);
    }

    /**
     * @param message (optional)
     * @param body (optional)
     * @return Success
     */
    updateAssistedBooking(message: string | null | undefined, body: TripAssistedBooking | undefined): Observable<TripAssistedBooking> {
        let url_ = this.baseUrl + "/api/services/app/AssistedBookingTrip/UpdateAssistedBooking?";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssistedBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssistedBooking(<any>response_);
                } catch (e) {
                    return <Observable<TripAssistedBooking>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripAssistedBooking>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAssistedBooking(response: HttpResponseBase): Observable<TripAssistedBooking> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripAssistedBooking.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripAssistedBooking>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuditLogListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuditLogListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuditLogListDto>(<any>null);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined && browserInfo !== null)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined && minExecutionDuration !== null)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(<any>response_);
                } catch (e) {
                    return <Observable<NameValueDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<NameValueDto[]>(<any>null));
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param entityTypeFullName (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getEntityChanges(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, entityTypeFullName: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityChangeListDto>(<any>null);
    }

    /**
     * @param entityTypeFullName (optional)
     * @param entityId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getEntityTypeChanges(entityTypeFullName: string | null | undefined, entityId: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityChangeListDto>(<any>null);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param entityTypeFullName (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getEntityChangesToExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | null | undefined, entityTypeFullName: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined && entityTypeFullName !== null)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param entityChangeId (optional)
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(<any>response_);
                } catch (e) {
                    return <Observable<EntityPropertyChangeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityPropertyChangeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<EntityPropertyChangeDto[]>(<any>null));
    }
}

@Injectable()
export class BookingToolTenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<BookingToolTenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/BookingToolTenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<BookingToolTenantSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookingToolTenantSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<BookingToolTenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingToolTenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookingToolTenantSettingsEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAllSettings(body: BookingToolTenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BookingToolTenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCacheDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCacheDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCacheDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CarServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLocationAutocomplete(text: string): Observable<LocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetLocationAutocomplete?";
        if (text === undefined || text === null)
            throw new Error("The parameter 'text' must be defined and cannot be null.");
        else
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<LocationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationAutocomplete(response: HttpResponseBase): Observable<LocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LocationDto[]>(<any>null));
    }

    /**
     * @param airportCode (optional)
     * @return Success
     */
    getLocationByAirportCode(airportCode: string | null | undefined): Observable<LocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetLocationByAirportCode?";
        if (airportCode !== undefined && airportCode !== null)
            url_ += "airportCode=" + encodeURIComponent("" + airportCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationByAirportCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationByAirportCode(<any>response_);
                } catch (e) {
                    return <Observable<LocationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationByAirportCode(response: HttpResponseBase): Observable<LocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LocationDto[]>(<any>null));
    }

    /**
     * @param latitude (optional)
     * @param longitude (optional)
     * @param ray (optional)
     * @return Success
     */
    getLocationNearTo(latitude: number | undefined, longitude: number | undefined, ray: number | undefined): Observable<LocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetLocationNearTo?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ray === null)
            throw new Error("The parameter 'ray' cannot be null.");
        else if (ray !== undefined)
            url_ += "ray=" + encodeURIComponent("" + ray) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationNearTo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationNearTo(<any>response_);
                } catch (e) {
                    return <Observable<LocationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationNearTo(response: HttpResponseBase): Observable<LocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LocationDto[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    startSearch(body: CarAvailabilityRequestDto | undefined): Observable<AvailabilityCarCache> {
        let url_ = this.baseUrl + "/api/services/app/Car/StartSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartSearch(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityCarCache>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityCarCache>><any>_observableThrow(response_);
        }));
    }

    protected processStartSearch(response: HttpResponseBase): Observable<AvailabilityCarCache> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityCarCache.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityCarCache>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @return Success
     */
    checkResults(availabilityId: string | null | undefined): Observable<AvailabilityCarCache> {
        let url_ = this.baseUrl + "/api/services/app/Car/CheckResults?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckResults(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityCarCache>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityCarCache>><any>_observableThrow(response_);
        }));
    }

    protected processCheckResults(response: HttpResponseBase): Observable<AvailabilityCarCache> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityCarCache.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityCarCache>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @param body (optional)
     * @return Success
     */
    searchResults(availabilityId: string | null | undefined, body: CarAvailabilityPagedRequestDto | undefined): Observable<PaginationOfCarAvailabilityRequestDtoCarDto> {
        let url_ = this.baseUrl + "/api/services/app/Car/SearchResults?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchResults(<any>response_);
                } catch (e) {
                    return <Observable<PaginationOfCarAvailabilityRequestDtoCarDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginationOfCarAvailabilityRequestDtoCarDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchResults(response: HttpResponseBase): Observable<PaginationOfCarAvailabilityRequestDtoCarDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationOfCarAvailabilityRequestDtoCarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationOfCarAvailabilityRequestDtoCarDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSupplierInfo(availabilityId: string, supplierCode: string): Observable<SupplierInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetSupplierInfo?";
        if (availabilityId === undefined || availabilityId === null)
            throw new Error("The parameter 'availabilityId' must be defined and cannot be null.");
        else
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        if (supplierCode === undefined || supplierCode === null)
            throw new Error("The parameter 'supplierCode' must be defined and cannot be null.");
        else
            url_ += "supplierCode=" + encodeURIComponent("" + supplierCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierInfo(<any>response_);
                } catch (e) {
                    return <Observable<SupplierInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SupplierInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupplierInfo(response: HttpResponseBase): Observable<SupplierInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierInfoDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTermsAndConditions(availabilityId: string, supplierCode: string): Observable<TermsAndConditionsDto> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetTermsAndConditions?";
        if (availabilityId === undefined || availabilityId === null)
            throw new Error("The parameter 'availabilityId' must be defined and cannot be null.");
        else
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        if (supplierCode === undefined || supplierCode === null)
            throw new Error("The parameter 'supplierCode' must be defined and cannot be null.");
        else
            url_ += "supplierCode=" + encodeURIComponent("" + supplierCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermsAndConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermsAndConditions(<any>response_);
                } catch (e) {
                    return <Observable<TermsAndConditionsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TermsAndConditionsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermsAndConditions(response: HttpResponseBase): Observable<TermsAndConditionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermsAndConditionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TermsAndConditionsDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProviderInfo(availabilityId: string): Observable<ProviderInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetProviderInfo?";
        if (availabilityId === undefined || availabilityId === null)
            throw new Error("The parameter 'availabilityId' must be defined and cannot be null.");
        else
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderInfo(<any>response_);
                } catch (e) {
                    return <Observable<ProviderInfoDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProviderInfoDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProviderInfo(response: HttpResponseBase): Observable<ProviderInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderInfoDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ProviderInfoDto[]>(<any>null));
    }

    /**
     * @return Success
     */
    getAvailabilityById(availabilityId: string): Observable<AvailabilityCarCache> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetAvailabilityById?";
        if (availabilityId === undefined || availabilityId === null)
            throw new Error("The parameter 'availabilityId' must be defined and cannot be null.");
        else
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailabilityById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailabilityById(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityCarCache>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityCarCache>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailabilityById(response: HttpResponseBase): Observable<AvailabilityCarCache> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityCarCache.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityCarCache>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    checkoutData(body: CarBookRequestBaseDto | undefined): Observable<CarBookResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Car/CheckoutData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckoutData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckoutData(<any>response_);
                } catch (e) {
                    return <Observable<CarBookResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarBookResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckoutData(response: HttpResponseBase): Observable<CarBookResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarBookResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarBookResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCheckoutDataByReservationId(reservationId: string): Observable<CarBookResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetCheckoutDataByReservationId?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined and cannot be null.");
        else
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutDataByReservationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutDataByReservationId(<any>response_);
                } catch (e) {
                    return <Observable<CarBookResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarBookResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCheckoutDataByReservationId(response: HttpResponseBase): Observable<CarBookResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarBookResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarBookResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAdditionalServices(countryCode: string, supplierCode: string): Observable<AdditionalServiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetAdditionalServices?";
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined and cannot be null.");
        else
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (supplierCode === undefined || supplierCode === null)
            throw new Error("The parameter 'supplierCode' must be defined and cannot be null.");
        else
            url_ += "SupplierCode=" + encodeURIComponent("" + supplierCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdditionalServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdditionalServices(<any>response_);
                } catch (e) {
                    return <Observable<AdditionalServiceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdditionalServiceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdditionalServices(response: HttpResponseBase): Observable<AdditionalServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdditionalServiceDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<AdditionalServiceDto[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    book(body: CarBookRequestDto | undefined): Observable<AjaxResponseOfReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Car/Book";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBook(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processBook(response: HttpResponseBase): Observable<AjaxResponseOfReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfReservationDto>(<any>null);
    }

    /**
     * @return Success
     */
    issue(reservationId: string): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Car/Issue?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined and cannot be null.");
        else
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIssue(<any>response_);
                } catch (e) {
                    return <Observable<ReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processIssue(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(<any>null);
    }

    /**
     * @param fullVoucher (optional)
     * @return Success
     */
    getVoucher(bookingReference: string, fullVoucher: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Car/GetVoucher?";
        if (bookingReference === undefined || bookingReference === null)
            throw new Error("The parameter 'bookingReference' must be defined and cannot be null.");
        else
            url_ += "BookingReference=" + encodeURIComponent("" + bookingReference) + "&";
        if (fullVoucher === null)
            throw new Error("The parameter 'fullVoucher' cannot be null.");
        else if (fullVoucher !== undefined)
            url_ += "FullVoucher=" + encodeURIComponent("" + fullVoucher) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucher(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucher(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class CarLocationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyWord (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getList(keyWord: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfCarLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/CarLocations/GetList?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCarLocationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCarLocationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfCarLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCarLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCarLocationDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCarLocationById(id: string | null | undefined): Observable<CarLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/CarLocations/GetCarLocationById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarLocationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarLocationById(<any>response_);
                } catch (e) {
                    return <Observable<CarLocationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CarLocationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCarLocationById(response: HttpResponseBase): Observable<CarLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarLocationDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrEditCarLocation(body: CarLocationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CarLocations/CreateOrEditCarLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCarLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCarLocation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCarLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CarLocations/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyWord (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCarLocationsToExcel(keyWord: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CarLocations/GetCarLocationsToExcel?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarLocationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarLocationsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCarLocationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class CenterOfCostsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCentersOfCosts(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/CenterOfCosts/GetCentersOfCosts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCentersOfCosts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCentersOfCosts(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCentersOfCosts(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCentersOfCostsForUser(id: number | null | undefined): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/CenterOfCosts/GetCentersOfCostsForUser?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCentersOfCostsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCentersOfCostsForUser(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCentersOfCostsForUser(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param search (optional)
     * @param headquartersId (optional)
     * @param userId (optional)
     * @return Success
     */
    getCentersOfCostsAutocomplete(search: string | null | undefined, headquartersId: number | null | undefined, userId: number | null | undefined): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/CenterOfCosts/GetCentersOfCostsAutocomplete?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (headquartersId !== undefined && headquartersId !== null)
            url_ += "headquartersId=" + encodeURIComponent("" + headquartersId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCentersOfCostsAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCentersOfCostsAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCentersOfCostsAutocomplete(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCenterOfCosts(id: number | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/CenterOfCosts/GetCenterOfCosts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCenterOfCosts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCenterOfCosts(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCenterOfCosts(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatConfiguration(): Observable<GetUserChatConfigurationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<GetUserChatConfigurationOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserChatConfigurationOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserChatConfiguration(response: HttpResponseBase): Observable<GetUserChatConfigurationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatConfigurationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserChatConfigurationOutput>(<any>null);
    }
}

@Injectable()
export class CommonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    findAgencies(): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Common/FindAgencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAgencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAgencies(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindAgencies(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCompany(): Observable<ReferenceDataModel> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetCompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompany(<any>response_);
                } catch (e) {
                    return <Observable<ReferenceDataModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReferenceDataModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompany(response: HttpResponseBase): Observable<ReferenceDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferenceDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferenceDataModel>(<any>null);
    }

    /**
     * @return Success
     */
    getAgency(): Observable<ReferenceDataModel> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetAgency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgency(<any>response_);
                } catch (e) {
                    return <Observable<ReferenceDataModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReferenceDataModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgency(response: HttpResponseBase): Observable<ReferenceDataModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferenceDataModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferenceDataModel>(<any>null);
    }

    /**
     * @return Success
     */
    getPointOfSaleSettings(): Observable<PointOfSaleSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Common/GetPointOfSaleSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointOfSaleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointOfSaleSettings(<any>response_);
                } catch (e) {
                    return <Observable<PointOfSaleSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointOfSaleSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPointOfSaleSettings(response: HttpResponseBase): Observable<PointOfSaleSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PointOfSaleSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointOfSaleSettingsEditDto>(<any>null);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param onlyFreeItems (optional)
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSubscribableEditionComboboxItemDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(<any>response_);
                } catch (e) {
                    return <Observable<GetDefaultEditionNameOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDefaultEditionNameOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDefaultEditionNameOutput>(<any>null);
    }
}

@Injectable()
export class CompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCompany(): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompany";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompany(<any>response_);
                } catch (e) {
                    return <Observable<CompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompany(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateCompany(body: CompanyDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateOrUpdateCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCompany(<any>response_);
                } catch (e) {
                    return <Observable<CompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateCompany(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateTravelPolicy(body: TravelPolicyDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateOrUpdateTravelPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateTravelPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTravelPolicy(<any>response_);
                } catch (e) {
                    return <Observable<CompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateTravelPolicy(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(<any>null);
    }

    /**
     * @param travelPolicyId (optional)
     * @return Success
     */
    deleteTravelPolicy(travelPolicyId: string | null | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteTravelPolicy?";
        if (travelPolicyId !== undefined && travelPolicyId !== null)
            url_ += "travelPolicyId=" + encodeURIComponent("" + travelPolicyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTravelPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTravelPolicy(<any>response_);
                } catch (e) {
                    return <Observable<CompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTravelPolicy(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateInvoiceProfile(body: InvoiceProfileDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateOrUpdateInvoiceProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateInvoiceProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateInvoiceProfile(<any>response_);
                } catch (e) {
                    return <Observable<CompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateInvoiceProfile(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(<any>null);
    }

    /**
     * @param invoiceProfileId (optional)
     * @return Success
     */
    deleteInvoiceProfile(invoiceProfileId: string | null | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteInvoiceProfile?";
        if (invoiceProfileId !== undefined && invoiceProfileId !== null)
            url_ += "invoiceProfileId=" + encodeURIComponent("" + invoiceProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInvoiceProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInvoiceProfile(<any>response_);
                } catch (e) {
                    return <Observable<CompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteInvoiceProfile(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(<any>null);
    }

    /**
     * @param invoiceProfileId (optional)
     * @return Success
     */
    getInvoiceProfile(invoiceProfileId: string | null | undefined): Observable<InvoiceProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetInvoiceProfile?";
        if (invoiceProfileId !== undefined && invoiceProfileId !== null)
            url_ += "invoiceProfileId=" + encodeURIComponent("" + invoiceProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceProfile(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoiceProfile(response: HttpResponseBase): Observable<InvoiceProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceProfileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateLabel(body: LabelDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateOrUpdateLabel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLabel(<any>response_);
                } catch (e) {
                    return <Observable<CompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateLabel(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(<any>null);
    }

    /**
     * @param labelId (optional)
     * @return Success
     */
    deleteLabel(labelId: string | null | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteLabel?";
        if (labelId !== undefined && labelId !== null)
            url_ += "labelId=" + encodeURIComponent("" + labelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLabel(<any>response_);
                } catch (e) {
                    return <Observable<CompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteLabel(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(<any>null);
    }

    /**
     * @param labelId (optional)
     * @return Success
     */
    archiveLabel(labelId: string | null | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/ArchiveLabel?";
        if (labelId !== undefined && labelId !== null)
            url_ += "labelId=" + encodeURIComponent("" + labelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveLabel(<any>response_);
                } catch (e) {
                    return <Observable<CompanyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyDto>><any>_observableThrow(response_);
        }));
    }

    protected processArchiveLabel(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFieldsConfig(): Observable<FieldConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetFieldsConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldsConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldsConfig(<any>response_);
                } catch (e) {
                    return <Observable<FieldConfigDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldConfigDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFieldsConfig(response: HttpResponseBase): Observable<FieldConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldConfigDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<FieldConfigDto[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateFieldConfig(body: FieldConfigInputDto | undefined): Observable<FieldConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/CreateOrUpdateFieldConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateFieldConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateFieldConfig(<any>response_);
                } catch (e) {
                    return <Observable<FieldConfigDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldConfigDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateFieldConfig(response: HttpResponseBase): Observable<FieldConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldConfigDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<FieldConfigDto[]>(<any>null));
    }
}

@Injectable()
export class CompanyHQServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCompanyHQs(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyHQ/GetCompanyHQs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyHQs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyHQs(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyHQs(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCompanyHQsForUser(id: number | null | undefined): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyHQ/GetCompanyHQsForUser?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyHQsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyHQsForUser(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyHQsForUser(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param search (optional)
     * @param userId (optional)
     * @return Success
     */
    getCompanyHQsAutocomplete(search: string | null | undefined, userId: number | null | undefined): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyHQ/GetCompanyHQsAutocomplete?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyHQsAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyHQsAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyHQsAutocomplete(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCompanyHQ(id: number | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyHQ/GetCompanyHQ?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyHQ(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyHQ(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyHQ(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }
}

@Injectable()
export class CountryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param name (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getCountries(name: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfCountryListDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetCountries?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCountryListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCountryListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<PagedResultDtoOfCountryListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCountryListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCountryListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCountries(): Observable<CountryListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetAllCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountries(<any>response_);
                } catch (e) {
                    return <Observable<CountryListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCountries(response: HttpResponseBase): Observable<CountryListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<CountryListDto[]>(<any>null));
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getCountryById(id: string | null | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetCountryById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryById(<any>response_);
                } catch (e) {
                    return <Observable<CountryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountryById(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryDto>(<any>null);
    }

    /**
     * @param isoCode (optional)
     * @return Success
     */
    getCountryByIsoCode(isoCode: string | null | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetCountryByIsoCode?";
        if (isoCode !== undefined && isoCode !== null)
            url_ += "isoCode=" + encodeURIComponent("" + isoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryByIsoCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryByIsoCode(<any>response_);
                } catch (e) {
                    return <Observable<CountryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountryByIsoCode(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryDto>(<any>null);
    }
}

@Injectable()
export class DashboardCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param dashboardName (optional)
     * @param application (optional)
     * @return Success
     */
    getUserDashboard(dashboardName: string | null | undefined, application: string | null | undefined): Observable<Dashboard> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetUserDashboard?";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined && application !== null)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDashboard(<any>response_);
                } catch (e) {
                    return <Observable<Dashboard>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dashboard>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDashboard(response: HttpResponseBase): Observable<Dashboard> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dashboard.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dashboard>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    savePage(body: SavePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/SavePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSavePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    renamePage(body: RenamePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/RenamePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenamePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenamePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRenamePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addNewPage(body: AddNewPageInput | undefined): Observable<AddNewPageOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddNewPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewPage(<any>response_);
                } catch (e) {
                    return <Observable<AddNewPageOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddNewPageOutput>><any>_observableThrow(response_);
        }));
    }

    protected processAddNewPage(response: HttpResponseBase): Observable<AddNewPageOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddNewPageOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddNewPageOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @param dashboardName (optional)
     * @param application (optional)
     * @return Success
     */
    deletePage(id: string | null | undefined, dashboardName: string | null | undefined, application: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/DeletePage?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined && application !== null)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addWidget(body: AddWidgetInput | undefined): Observable<Widget> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddWidget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWidget(<any>response_);
                } catch (e) {
                    return <Observable<Widget>><any>_observableThrow(e);
                }
            } else
                return <Observable<Widget>><any>_observableThrow(response_);
        }));
    }

    protected processAddWidget(response: HttpResponseBase): Observable<Widget> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Widget.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Widget>(<any>null);
    }

    /**
     * @param dashboardName (optional)
     * @param application (optional)
     * @return Success
     */
    getDashboardDefinition(dashboardName: string | null | undefined, application: string | null | undefined): Observable<DashboardOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetDashboardDefinition?";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined && application !== null)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardDefinition(<any>response_);
                } catch (e) {
                    return <Observable<DashboardOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DashboardOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardDefinition(response: HttpResponseBase): Observable<DashboardOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardOutput>(<any>null);
    }

    /**
     * @param dashboardName (optional)
     * @param application (optional)
     * @return Success
     */
    getAllWidgetDefinitions(dashboardName: string | null | undefined, application: string | null | undefined): Observable<WidgetOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllWidgetDefinitions?";
        if (dashboardName !== undefined && dashboardName !== null)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application !== undefined && application !== null)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWidgetDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWidgetDefinitions(<any>response_);
                } catch (e) {
                    return <Observable<WidgetOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WidgetOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWidgetDefinitions(response: HttpResponseBase): Observable<WidgetOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetOutput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<WidgetOutput[]>(<any>null));
    }

    /**
     * @param application (optional)
     * @return Success
     */
    getSettingName(application: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetSettingName?";
        if (application !== undefined && application !== null)
            url_ += "application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetSettingName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param date (optional)
     * @return Success
     */
    sendAndGetDate(date: moment.Moment | null | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param date (optional)
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment | null | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param searchTerm (optional)
     * @return Success
     */
    getCountries(searchTerm: string | null | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<NameValueOfString[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendAndGetSelectedCountries(body: NameValueOfString[] | null | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<NameValueOfString[]>(<any>null));
    }

    /**
     * @param input (optional)
     * @return Success
     */
    sendAndGetValue(input: string | null | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(<any>response_);
                } catch (e) {
                    return <Observable<StringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<StringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringOutput>(<any>null);
    }
}

@Injectable()
export class DiagnosticServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getPublicIpAddress(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Diagnostic/GetPublicIpAddress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicIpAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicIpAddress(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublicIpAddress(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class DynamicEntityPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: number | undefined): Observable<DynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DynamicEntityPropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicEntityPropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicEntityPropertyDto>(<any>null);
    }

    /**
     * @param entityFullName (optional)
     * @return Success
     */
    getAllPropertiesOfAnEntity(entityFullName: string | null | undefined): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllPropertiesOfAnEntity?";
        if (entityFullName !== undefined && entityFullName !== null)
            url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPropertiesOfAnEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPropertiesOfAnEntity(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDynamicEntityPropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfDynamicEntityPropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPropertiesOfAnEntity(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfDynamicEntityPropertyDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDynamicEntityPropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfDynamicEntityPropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfDynamicEntityPropertyDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    add(body: DynamicEntityPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: DynamicEntityPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllEntitiesHasDynamicProperty(): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityProperty/GetAllEntitiesHasDynamicProperty";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEntitiesHasDynamicProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEntitiesHasDynamicProperty(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEntitiesHasDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput>(<any>null);
    }
}

@Injectable()
export class DynamicEntityPropertyDefinitionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllAllowedInputTypeNames(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllAllowedInputTypeNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAllowedInputTypeNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAllowedInputTypeNames(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAllowedInputTypeNames(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<string[]>(<any>null));
    }

    /**
     * @return Success
     */
    getAllEntities(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyDefinition/GetAllEntities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEntities(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEntities(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<string[]>(<any>null));
    }
}

@Injectable()
export class DynamicEntityPropertyValueServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: number | undefined): Observable<DynamicEntityPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DynamicEntityPropertyValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicEntityPropertyValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicEntityPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicEntityPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicEntityPropertyValueDto>(<any>null);
    }

    /**
     * @param entityId (optional)
     * @param propertyId (optional)
     * @return Success
     */
    getAll(entityId: string | null | undefined, propertyId: number | undefined): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAll?";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDynamicEntityPropertyValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfDynamicEntityPropertyValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicEntityPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicEntityPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfDynamicEntityPropertyValueDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    add(body: DynamicEntityPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: DynamicEntityPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllDynamicEntityPropertyValues(entityFullName: string, entityId: string): Observable<GetAllDynamicEntityPropertyValuesOutput> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/GetAllDynamicEntityPropertyValues?";
        if (entityFullName === undefined || entityFullName === null)
            throw new Error("The parameter 'entityFullName' must be defined and cannot be null.");
        else
            url_ += "EntityFullName=" + encodeURIComponent("" + entityFullName) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDynamicEntityPropertyValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDynamicEntityPropertyValues(<any>response_);
                } catch (e) {
                    return <Observable<GetAllDynamicEntityPropertyValuesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAllDynamicEntityPropertyValuesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDynamicEntityPropertyValues(response: HttpResponseBase): Observable<GetAllDynamicEntityPropertyValuesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllDynamicEntityPropertyValuesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllDynamicEntityPropertyValuesOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    insertOrUpdateAllValues(body: InsertOrUpdateAllValuesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/InsertOrUpdateAllValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertOrUpdateAllValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertOrUpdateAllValues(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsertOrUpdateAllValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    cleanValues(body: CleanValuesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicEntityPropertyValue/CleanValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCleanValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCleanValues(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCleanValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DynamicPropertyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: number | undefined): Observable<DynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DynamicPropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicPropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicPropertyDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ListResultDtoOfDynamicPropertyDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDynamicPropertyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfDynamicPropertyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicPropertyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfDynamicPropertyDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    add(body: DynamicPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: DynamicPropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param name (optional)
     * @return Success
     */
    findAllowedInputType(name: string | null | undefined): Observable<IInputType> {
        let url_ = this.baseUrl + "/api/services/app/DynamicProperty/FindAllowedInputType?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAllowedInputType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAllowedInputType(<any>response_);
                } catch (e) {
                    return <Observable<IInputType>><any>_observableThrow(e);
                }
            } else
                return <Observable<IInputType>><any>_observableThrow(response_);
        }));
    }

    protected processFindAllowedInputType(response: HttpResponseBase): Observable<IInputType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IInputType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IInputType>(<any>null);
    }
}

@Injectable()
export class DynamicPropertyValueServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: number | undefined): Observable<DynamicPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DynamicPropertyValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicPropertyValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DynamicPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicPropertyValueDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAllValuesOfDynamicProperty(id: number | undefined): Observable<ListResultDtoOfDynamicPropertyValueDto> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/GetAllValuesOfDynamicProperty?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllValuesOfDynamicProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllValuesOfDynamicProperty(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDynamicPropertyValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfDynamicPropertyValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllValuesOfDynamicProperty(response: HttpResponseBase): Observable<ListResultDtoOfDynamicPropertyValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDynamicPropertyValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfDynamicPropertyValueDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    add(body: DynamicPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: DynamicPropertyValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DynamicPropertyValue/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEditionListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEditionListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEditionListDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getEditionForEdit(id: number | null | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEditionEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEditionEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param selectedEditionId (optional)
     * @param addAllItem (optional)
     * @param onlyFreeItems (optional)
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | null | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined && selectedEditionId !== null)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<SubscribableEditionComboboxItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscribableEditionComboboxItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<SubscribableEditionComboboxItemDto[]>(<any>null));
    }

    /**
     * @param editionId (optional)
     * @return Success
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class EventSyncServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    eventSyncList(body: GetAllEventSyncInputDto | undefined): Observable<PagedResultDtoOfEventSyncDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSync/EventSyncList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEventSyncList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEventSyncList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEventSyncDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEventSyncDto>><any>_observableThrow(response_);
        }));
    }

    protected processEventSyncList(response: HttpResponseBase): Observable<PagedResultDtoOfEventSyncDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEventSyncDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEventSyncDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: string | null | undefined): Observable<EventSyncDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSync/Get?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<EventSyncDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventSyncDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EventSyncDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventSyncDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventSyncDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    worksEventSync(body: EventSyncDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSync/WorksEventSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorksEventSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorksEventSync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processWorksEventSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changeStatusEventSync(body: ChangeStatusEventSyncInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSync/ChangeStatusEventSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeStatusEventSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeStatusEventSync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeStatusEventSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param enabled (optional)
     * @param keyWord (optional)
     * @param feeProductType (optional)
     * @param validFrom (optional)
     * @param validTo (optional)
     * @param agenciesId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getFees(enabled: boolean | null | undefined, keyWord: string | null | undefined, feeProductType: FeeProductType | undefined, validFrom: moment.Moment | null | undefined, validTo: moment.Moment | null | undefined, agenciesId: string[] | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfFeeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Fee/GetFees?";
        if (enabled !== undefined && enabled !== null)
            url_ += "Enabled=" + encodeURIComponent("" + enabled) + "&";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (feeProductType === null)
            throw new Error("The parameter 'feeProductType' cannot be null.");
        else if (feeProductType !== undefined)
            url_ += "FeeProductType=" + encodeURIComponent("" + feeProductType) + "&";
        if (validFrom !== undefined && validFrom !== null)
            url_ += "ValidFrom=" + encodeURIComponent(validFrom ? "" + validFrom.toJSON() : "") + "&";
        if (validTo !== undefined && validTo !== null)
            url_ += "ValidTo=" + encodeURIComponent(validTo ? "" + validTo.toJSON() : "") + "&";
        if (agenciesId !== undefined && agenciesId !== null)
            agenciesId && agenciesId.forEach(item => { url_ += "AgenciesId=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFees(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFeeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFeeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFees(response: HttpResponseBase): Observable<PagedResultDtoOfFeeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFeeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFeeListDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getFeeById(id: string | null | undefined): Observable<FeeDto> {
        let url_ = this.baseUrl + "/api/services/app/Fee/GetFeeById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeeById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeeById(<any>response_);
                } catch (e) {
                    return <Observable<FeeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFeeById(response: HttpResponseBase): Observable<FeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeeDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateFee(body: FeeDto | undefined): Observable<FeeRoot> {
        let url_ = this.baseUrl + "/api/services/app/Fee/UpdateFee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFee(<any>response_);
                } catch (e) {
                    return <Observable<FeeRoot>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeeRoot>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateFee(response: HttpResponseBase): Observable<FeeRoot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeeRoot.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeeRoot>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createFee(body: FeeDto | undefined): Observable<FeeRoot> {
        let url_ = this.baseUrl + "/api/services/app/Fee/CreateFee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFee(<any>response_);
                } catch (e) {
                    return <Observable<FeeRoot>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeeRoot>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFee(response: HttpResponseBase): Observable<FeeRoot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeeRoot.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeeRoot>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteFee(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Fee/DeleteFee?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFee(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteFee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @param enabled (optional)
     * @return Success
     */
    setEnabled(id: string | null | undefined, enabled: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Fee/SetEnabled?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (enabled === null)
            throw new Error("The parameter 'enabled' cannot be null.");
        else if (enabled !== undefined)
            url_ += "enabled=" + encodeURIComponent("" + enabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEnabled(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class FeedAccountantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<FeedAccountantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/FeedAccountantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<FeedAccountantSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeedAccountantSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<FeedAccountantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeedAccountantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeedAccountantSettingsEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAllSettings(body: FeedAccountantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FeedAccountantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getZucchettiSettings(): Observable<ZucchettiSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/FeedAccountantSettings/GetZucchettiSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZucchettiSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZucchettiSettings(<any>response_);
                } catch (e) {
                    return <Observable<ZucchettiSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ZucchettiSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetZucchettiSettings(response: HttpResponseBase): Observable<ZucchettiSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZucchettiSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ZucchettiSettingsEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateZucchettiSettings(body: ZucchettiSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FeedAccountantSettings/UpdateZucchettiSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZucchettiSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZucchettiSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateZucchettiSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FlightServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param query (optional)
     * @return Success
     */
    getDestinationAutocomplete(query: string | null | undefined, isPackageRateDestination: boolean | null): Observable<AirportDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Flight/GetDestinationAutocomplete?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (isPackageRateDestination !== undefined && isPackageRateDestination !== null)
            url_ += "isPackageRateDestination=" + encodeURIComponent("" + isPackageRateDestination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinationAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinationAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<AirportDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirportDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDestinationAutocomplete(response: HttpResponseBase): Observable<AirportDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirportDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<AirportDTO[]>(<any>null));
    }

    /**
     * @param code (optional)
     * @return Success
     */
    getAirport(code: string | null | undefined): Observable<AirportDTO> {
        let url_ = this.baseUrl + "/api/services/app/Flight/GetAirport?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirport(<any>response_);
                } catch (e) {
                    return <Observable<AirportDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirportDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetAirport(response: HttpResponseBase): Observable<AirportDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirportDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AirportDTO>(<any>null);
    }

    /**
     * @param latitude (optional)
     * @param longitude (optional)
     * @param ray (optional)
     * @return Success
     */
    getAirportNearTo(latitude: number | undefined, longitude: number | undefined, ray: number | undefined): Observable<AirportDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Flight/GetAirportNearTo?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ray === null)
            throw new Error("The parameter 'ray' cannot be null.");
        else if (ray !== undefined)
            url_ += "ray=" + encodeURIComponent("" + ray) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAirportNearTo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAirportNearTo(<any>response_);
                } catch (e) {
                    return <Observable<AirportDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirportDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAirportNearTo(response: HttpResponseBase): Observable<AirportDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirportDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<AirportDTO[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    search(body: AvailabilityRequestDTO | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Flight/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    searchMulticity(body: AvailabilityRequestMulticityDTO | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Flight/SearchMulticity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMulticity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMulticity(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processSearchMulticity(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    calendarShopping(body: AvailabilityRequestMulticityDTO | undefined): Observable<CalendarShoppingDto> {
        let url_ = this.baseUrl + "/api/services/app/Flight/CalendarShopping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalendarShopping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalendarShopping(<any>response_);
                } catch (e) {
                    return <Observable<CalendarShoppingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarShoppingDto>><any>_observableThrow(response_);
        }));
    }

    protected processCalendarShopping(response: HttpResponseBase): Observable<CalendarShoppingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarShoppingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarShoppingDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    startSearch(body: AvailabilityRequestMulticityDTO | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Flight/StartSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartSearch(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processStartSearch(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @return Success
     */
    checkSearch(availabilityId: string | null | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Flight/CheckSearch?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSearch(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCheckSearch(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @param groupItineraryId (optional)
     * @param itineraryId (optional)
     * @param pricingInformationId (optional)
     * @param outwardId (optional)
     * @param returnId (optional)
     * @return Success
     */
    getCheckoutData(availabilityId: string | null | undefined, groupItineraryId: string | null | undefined, itineraryId: string | null | undefined, pricingInformationId: string | null | undefined, outwardId: string | null | undefined, returnId: string | null | undefined): Observable<AirBookResponseDTO> {
        let url_ = this.baseUrl + "/api/services/app/Flight/GetCheckoutData?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "AvailabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        if (groupItineraryId !== undefined && groupItineraryId !== null)
            url_ += "GroupItineraryId=" + encodeURIComponent("" + groupItineraryId) + "&";
        if (itineraryId !== undefined && itineraryId !== null)
            url_ += "ItineraryId=" + encodeURIComponent("" + itineraryId) + "&";
        if (pricingInformationId !== undefined && pricingInformationId !== null)
            url_ += "PricingInformationId=" + encodeURIComponent("" + pricingInformationId) + "&";
        if (outwardId !== undefined && outwardId !== null)
            url_ += "OutwardId=" + encodeURIComponent("" + outwardId) + "&";
        if (returnId !== undefined && returnId !== null)
            url_ += "ReturnId=" + encodeURIComponent("" + returnId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutData(<any>response_);
                } catch (e) {
                    return <Observable<AirBookResponseDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirBookResponseDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetCheckoutData(response: HttpResponseBase): Observable<AirBookResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirBookResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AirBookResponseDTO>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    seatMapData(body: AirExtraRequestDTO | undefined): Observable<FlightAncillaryDTO> {
        let url_ = this.baseUrl + "/api/services/app/Flight/SeatMapData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeatMapData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeatMapData(<any>response_);
                } catch (e) {
                    return <Observable<FlightAncillaryDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlightAncillaryDTO>><any>_observableThrow(response_);
        }));
    }

    protected processSeatMapData(response: HttpResponseBase): Observable<FlightAncillaryDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlightAncillaryDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlightAncillaryDTO>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    getCheckoutDataByReservationId(reservationId: string | null | undefined): Observable<AirBookResponseDTO> {
        let url_ = this.baseUrl + "/api/services/app/Flight/GetCheckoutDataByReservationId?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutDataByReservationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutDataByReservationId(<any>response_);
                } catch (e) {
                    return <Observable<AirBookResponseDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AirBookResponseDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetCheckoutDataByReservationId(response: HttpResponseBase): Observable<AirBookResponseDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirBookResponseDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AirBookResponseDTO>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @param groupItineraryId (optional)
     * @param itineraryId (optional)
     * @param pricingInformationId (optional)
     * @param body (optional)
     * @return Success
     */
    validate(availabilityId: string | null | undefined, groupItineraryId: string | null | undefined, itineraryId: string | null | undefined, pricingInformationId: string | null | undefined, body: PersonNameDataDTO[] | null | undefined): Observable<ApiResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Flight/Validate?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        if (groupItineraryId !== undefined && groupItineraryId !== null)
            url_ += "groupItineraryId=" + encodeURIComponent("" + groupItineraryId) + "&";
        if (itineraryId !== undefined && itineraryId !== null)
            url_ += "itineraryId=" + encodeURIComponent("" + itineraryId) + "&";
        if (pricingInformationId !== undefined && pricingInformationId !== null)
            url_ += "pricingInformationId=" + encodeURIComponent("" + pricingInformationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidate(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidate(response: HttpResponseBase): Observable<ApiResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfBoolean>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    book(body: AirBookRequestDTO | undefined): Observable<ApiResponseOfReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Flight/Book";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBook(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processBook(response: HttpResponseBase): Observable<ApiResponseOfReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfReservationDto>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    issue(orderId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Flight/Issue?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIssue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processIssue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    confirm(orderId: string | null | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Flight/Confirm?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(<any>response_);
                } catch (e) {
                    return <Observable<ReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(<any>null);
    }

    /**
     * @param origin (optional)
     * @param destination (optional)
     * @param pointOfSaleCountry (optional)
     * @param lengthOfStay (optional)
     * @param minFare (optional)
     * @param maxFare (optional)
     * @param departureDate (optional)
     * @param numOfdays (optional)
     * @return Success
     */
    getLeadPriceCalendar(origin: string | null | undefined, destination: string | null | undefined, pointOfSaleCountry: string | null | undefined, lengthOfStay: string | null | undefined, minFare: number | null | undefined, maxFare: number | null | undefined, departureDate: moment.Moment | null | undefined, numOfdays: number | undefined): Observable<LeadPriceCalendarDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Flight/GetLeadPriceCalendar?";
        if (origin !== undefined && origin !== null)
            url_ += "Origin=" + encodeURIComponent("" + origin) + "&";
        if (destination !== undefined && destination !== null)
            url_ += "Destination=" + encodeURIComponent("" + destination) + "&";
        if (pointOfSaleCountry !== undefined && pointOfSaleCountry !== null)
            url_ += "PointOfSaleCountry=" + encodeURIComponent("" + pointOfSaleCountry) + "&";
        if (lengthOfStay !== undefined && lengthOfStay !== null)
            url_ += "LengthOfStay=" + encodeURIComponent("" + lengthOfStay) + "&";
        if (minFare !== undefined && minFare !== null)
            url_ += "MinFare=" + encodeURIComponent("" + minFare) + "&";
        if (maxFare !== undefined && maxFare !== null)
            url_ += "MaxFare=" + encodeURIComponent("" + maxFare) + "&";
        if (departureDate !== undefined && departureDate !== null)
            url_ += "DepartureDate=" + encodeURIComponent(departureDate ? "" + departureDate.toJSON() : "") + "&";
        if (numOfdays === null)
            throw new Error("The parameter 'numOfdays' cannot be null.");
        else if (numOfdays !== undefined)
            url_ += "NumOfdays=" + encodeURIComponent("" + numOfdays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLeadPriceCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeadPriceCalendar(<any>response_);
                } catch (e) {
                    return <Observable<LeadPriceCalendarDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LeadPriceCalendarDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLeadPriceCalendar(response: HttpResponseBase): Observable<LeadPriceCalendarDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LeadPriceCalendarDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LeadPriceCalendarDTO[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    fareRules(body: AirBookRequestBaseDTO | undefined): Observable<FareRuleResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Flight/FareRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFareRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFareRules(<any>response_);
                } catch (e) {
                    return <Observable<FareRuleResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FareRuleResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processFareRules(response: HttpResponseBase): Observable<FareRuleResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FareRuleResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FareRuleResponseDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    fareDescription(body: AirBookRequestBaseDTO | undefined): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Flight/FareDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFareDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFareDescription(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFareDescription(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfNameValueDto>(<any>null);
    }
}

@Injectable()
export class FlightSerpShareServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendToCustomer(body: MessageToCustomerInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlightSerpShare/SendToCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToCustomer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendToCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createShareSerpLink(body: MessageToCustomerInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FlightSerpShare/CreateShareSerpLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShareSerpLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShareSerpLink(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateShareSerpLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    searchMulticity(body: FlightShareSerpItemsInput | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/FlightSerpShare/SearchMulticity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchMulticity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMulticity(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processSearchMulticity(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendToAgent(body: MessageToAgentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlightSerpShare/SendToAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToAgent(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendToAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resolveFlightShareParams(body: MessageToAgentInput | undefined): Observable<FieldsEmailInput> {
        let url_ = this.baseUrl + "/api/services/app/FlightSerpShare/ResolveFlightShareParams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveFlightShareParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveFlightShareParams(<any>response_);
                } catch (e) {
                    return <Observable<FieldsEmailInput>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldsEmailInput>><any>_observableThrow(response_);
        }));
    }

    protected processResolveFlightShareParams(response: HttpResponseBase): Observable<FieldsEmailInput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldsEmailInput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldsEmailInput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createCheckoutLink(body: MessageToAgentInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FlightSerpShare/CreateCheckoutLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCheckoutLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCheckoutLink(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCheckoutLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getTopStatsData(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(<any>response_);
                } catch (e) {
                    return <Observable<TopStatsData>><any>_observableThrow(e);
                }
            } else
                return <Observable<TopStatsData>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopStatsData>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(<any>response_);
                } catch (e) {
                    return <Observable<GetRecentTenantsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRecentTenantsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRecentTenantsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(<any>response_);
                } catch (e) {
                    return <Observable<GetExpiringTenantsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetExpiringTenantsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExpiringTenantsOutput>(<any>null);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(<any>response_);
                } catch (e) {
                    return <Observable<GetIncomeStatisticsDataOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetIncomeStatisticsDataOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncomeStatisticsDataOutput>(<any>null);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    getEditionTenantStatistics(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(<any>response_);
                } catch (e) {
                    return <Observable<GetEditionTenantStatisticsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEditionTenantStatisticsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionTenantStatisticsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getFilesDownload(): Observable<FileDownloadLinksOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetFilesDownload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilesDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilesDownload(<any>response_);
                } catch (e) {
                    return <Observable<FileDownloadLinksOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDownloadLinksOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilesDownload(response: HttpResponseBase): Observable<FileDownloadLinksOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadLinksOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDownloadLinksOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setFilesDownload(body: FileDownloadLinkDTO[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/SetFilesDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFilesDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFilesDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetFilesDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setNews(body: NewsDTO | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/SetNews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNews(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetNews(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNews(): Observable<GetNewsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetNews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNews(<any>response_);
                } catch (e) {
                    return <Observable<GetNewsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNewsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNews(response: HttpResponseBase): Observable<GetNewsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNewsOutput>(<any>null);
    }

    /**
     * @param newsID (optional)
     * @return Success
     */
    removeNews(newsID: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/RemoveNews?";
        if (newsID !== undefined && newsID !== null)
            url_ += "newsID=" + encodeURIComponent("" + newsID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveNews(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveNews(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<HostSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HostSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostSettingsEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginSettingsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginSettingsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginSettingsDto>(<any>null);
    }
}

@Injectable()
export class HotelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param query (optional)
     * @return Success
     */
    getDestinationAutocomplete(query: string | null | undefined): Observable<DestinationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/GetDestinationAutocomplete?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinationAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinationAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<DestinationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DestinationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDestinationAutocomplete(response: HttpResponseBase): Observable<DestinationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DestinationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<DestinationDto[]>(<any>null));
    }

    /**
     * @param query (optional)
     * @return Success
     */
    getDestinationCityAutocomplete(query: string | null | undefined): Observable<DestinationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/GetDestinationCityAutocomplete?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinationCityAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinationCityAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<DestinationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DestinationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDestinationCityAutocomplete(response: HttpResponseBase): Observable<DestinationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DestinationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<DestinationDto[]>(<any>null));
    }

    /**
     * @param query (optional)
     * @param destinationId (optional)
     * @param availabilityId (optional)
     * @return Success
     */
    getDestinationStructureAutocomplete(query: string | null | undefined, destinationId: string | null | undefined, availabilityId: string | null | undefined): Observable<DestinationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/GetDestinationStructureAutocomplete?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (destinationId !== undefined && destinationId !== null)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinationStructureAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinationStructureAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<DestinationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DestinationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDestinationStructureAutocomplete(response: HttpResponseBase): Observable<DestinationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DestinationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<DestinationDto[]>(<any>null));
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getDestinationById(id: string | null | undefined): Observable<DestinationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/GetDestinationById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinationById(<any>response_);
                } catch (e) {
                    return <Observable<DestinationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DestinationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDestinationById(response: HttpResponseBase): Observable<DestinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DestinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DestinationDto>(<any>null);
    }

    /**
     * @param latitude (optional)
     * @param longitude (optional)
     * @param ray (optional)
     * @return Success
     */
    getNearStructures(latitude: number | undefined, longitude: number | undefined, ray: number | null | undefined): Observable<StructureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/GetNearStructures?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ray !== undefined && ray !== null)
            url_ += "ray=" + encodeURIComponent("" + ray) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNearStructures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNearStructures(<any>response_);
                } catch (e) {
                    return <Observable<StructureDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StructureDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNearStructures(response: HttpResponseBase): Observable<StructureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StructureDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<StructureDto[]>(<any>null));
    }

    /**
     * @param latitude (optional)
     * @param longitude (optional)
     * @param ray (optional)
     * @param body (optional)
     * @return Success
     */
    nearAvailableStructures(latitude: number | undefined, longitude: number | undefined, ray: number | undefined, body: AvailabilityStructureDetailRequestDto | undefined): Observable<SearchAvailabilityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/NearAvailableStructures?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ray === null)
            throw new Error("The parameter 'ray' cannot be null.");
        else if (ray !== undefined)
            url_ += "ray=" + encodeURIComponent("" + ray) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNearAvailableStructures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNearAvailableStructures(<any>response_);
                } catch (e) {
                    return <Observable<SearchAvailabilityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchAvailabilityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processNearAvailableStructures(response: HttpResponseBase): Observable<SearchAvailabilityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchAvailabilityDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<SearchAvailabilityDto[]>(<any>null));
    }

    /**
     * @param structureId (optional)
     * @param body (optional)
     * @param availabilityId (optional)
     * @param isPackagePricesSearch (optional)
     * @return Success
     */
    roomsDetailGrouped(
        structureId: string | null | undefined,
        body: AvailabilityStructureDetailRequestDto | undefined,
        availabilityId: string | null | undefined,
        isPackagePricesSearch: boolean | null | undefined
    ): Observable<AvailabilityCacheDetail> {
        console.log('isPackagePricesSearch', isPackagePricesSearch);

        let url_ = this.baseUrl + "/api/services/app/Hotel/RoomsDetailGrouped?";
        if (structureId !== undefined && structureId !== null)
            url_ += "structureId=" + encodeURIComponent("" + structureId) + "&";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        if (isPackagePricesSearch !== undefined && isPackagePricesSearch !== null)
            url_ += "isPackagePricesSearch=" + (isPackagePricesSearch ? "true" : "false") + "&";

        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoomsDetailGrouped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoomsDetailGrouped(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityCacheDetail>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityCacheDetail>><any>_observableThrow(response_);
        }));
    }

    protected processRoomsDetailGrouped(response: HttpResponseBase): Observable<AvailabilityCacheDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityCacheDetail.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityCacheDetail>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @param body (optional)
     * @return Success
     */
    cancellationPolicy(availabilityId: string | null | undefined, body: string[] | null | undefined): Observable<CancellationPolicyRoomsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/CancellationPolicy?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancellationPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancellationPolicy(<any>response_);
                } catch (e) {
                    return <Observable<CancellationPolicyRoomsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CancellationPolicyRoomsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCancellationPolicy(response: HttpResponseBase): Observable<CancellationPolicyRoomsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CancellationPolicyRoomsDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<CancellationPolicyRoomsDto[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    startSearch(body: AvailabilityStructuresRequestDto | undefined): Observable<AvailabilityCache> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/StartSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartSearch(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityCache>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityCache>><any>_observableThrow(response_);
        }));
    }

    protected processStartSearch(response: HttpResponseBase): Observable<AvailabilityCache> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityCache.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityCache>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @return Success
     */
    checkResults(availabilityId: string | null | undefined, isPackagePricesSearch: boolean | null | undefined): Observable<AvailabilityCache> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/CheckResults?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        if (isPackagePricesSearch !== undefined && isPackagePricesSearch !== null)
            url_ += "isPackagePricesSearch=" + encodeURIComponent("" + isPackagePricesSearch) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckResults(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityCache>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityCache>><any>_observableThrow(response_);
        }));
    }

    protected processCheckResults(response: HttpResponseBase): Observable<AvailabilityCache> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityCache.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityCache>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @param body (optional)
     * @return Success
     */
    searchResults(availabilityId: string | null | undefined, body: AvailabilityStructuresPagedRequestDto | undefined): Observable<PaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/SearchResults?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchResults(<any>response_);
                } catch (e) {
                    return <Observable<PaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchResults(response: HttpResponseBase): Observable<PaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param body (optional)
     * @return Success
     */
    markerResults(id: string | null | undefined, body: AvailabilityStructuresPagedRequestDto | undefined): Observable<StructureMarkerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/MarkerResults?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkerResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkerResults(<any>response_);
                } catch (e) {
                    return <Observable<StructureMarkerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StructureMarkerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processMarkerResults(response: HttpResponseBase): Observable<StructureMarkerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StructureMarkerDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<StructureMarkerDto[]>(<any>null));
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    startBooking(orderId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/StartBooking?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartBooking(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processStartBooking(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    checkBooking(orderId: string | null | undefined): Observable<ReservationStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/CheckBooking?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckBooking(<any>response_);
                } catch (e) {
                    return <Observable<ReservationStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckBooking(response: HttpResponseBase): Observable<ReservationStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationStatusDto>(<any>null);
    }

    /**
     * @param isoCountry (optional)
     * @param slugHotelName (optional)
     * @param body (optional)
     * @return Success
     */
    details(isoCountry: string | null | undefined, slugHotelName: string | null | undefined, body: AvailabilityStructureDetailRequestDto | undefined): Observable<SearchAvailabilityStructureDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/Details?";
        if (isoCountry !== undefined && isoCountry !== null)
            url_ += "isoCountry=" + encodeURIComponent("" + isoCountry) + "&";
        if (slugHotelName !== undefined && slugHotelName !== null)
            url_ += "slugHotelName=" + encodeURIComponent("" + slugHotelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetails(<any>response_);
                } catch (e) {
                    return <Observable<SearchAvailabilityStructureDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SearchAvailabilityStructureDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processDetails(response: HttpResponseBase): Observable<SearchAvailabilityStructureDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchAvailabilityStructureDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchAvailabilityStructureDetailDto>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @param optionId (optional)
     * @return Success
     */
    getCheckoutData(availabilityId: string | null | undefined, optionId: string | null | undefined): Observable<HotelBookResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/GetCheckoutData?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        if (optionId !== undefined && optionId !== null)
            url_ += "optionId=" + encodeURIComponent("" + optionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutData(<any>response_);
                } catch (e) {
                    return <Observable<HotelBookResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HotelBookResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCheckoutData(response: HttpResponseBase): Observable<HotelBookResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBookResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HotelBookResponseDto>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    getCheckoutDataByReservationId(reservationId: string | null | undefined): Observable<HotelBookResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/GetCheckoutDataByReservationId?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutDataByReservationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutDataByReservationId(<any>response_);
                } catch (e) {
                    return <Observable<HotelBookResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HotelBookResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCheckoutDataByReservationId(response: HttpResponseBase): Observable<HotelBookResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotelBookResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HotelBookResponseDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bookAndPay(body: BookStructureRequestDto | undefined): Observable<AjaxResponseOfReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/BookAndPay";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookAndPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookAndPay(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processBookAndPay(response: HttpResponseBase): Observable<AjaxResponseOfReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfReservationDto>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    getReservation(orderId: string | null | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/GetReservation?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservation(<any>response_);
                } catch (e) {
                    return <Observable<ReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservation(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getStructureById(id: string | null | undefined): Observable<StructureDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotel/GetStructureById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStructureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStructureById(<any>response_);
                } catch (e) {
                    return <Observable<StructureDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StructureDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStructureById(response: HttpResponseBase): Observable<StructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StructureDto>(<any>null);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(<any>response_);
                } catch (e) {
                    return <Observable<AppSettingsJsonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppSettingsJsonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppSettingsJsonDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(<any>response_);
                } catch (e) {
                    return <Observable<CheckDatabaseOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckDatabaseOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckDatabaseOutput>(<any>null);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(<any>response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguagesOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getLanguageForEdit(id: number | null | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLanguageForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLanguageForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguageForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @param baseLanguageName (optional)
     * @param targetValueFilter (optional)
     * @param filterText (optional)
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | null | undefined, sourceName: string, baseLanguageName: string | null | undefined, targetLanguageName: string, targetValueFilter: string | null | undefined, filterText: string | null | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName !== undefined && baseLanguageName !== null)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter !== undefined && targetValueFilter !== null)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLanguageTextListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLanguageTextListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLanguageTextListDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param state (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUserNotifications(state: UserNotificationState | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationSettingsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationSettingsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationSettingsOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param state (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param searchKey (optional)
     * @return Success
     */
    getOrganizationUnitsAutocomplete(searchKey: string | null | undefined): Observable<OrganizationUnitSimpleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitsAutocomplete?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "searchKey=" + encodeURIComponent("" + searchKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitsAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitsAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitSimpleDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitSimpleDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitsAutocomplete(response: HttpResponseBase): Observable<OrganizationUnitSimpleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitSimpleDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<OrganizationUnitSimpleDto[]>(<any>null));
    }

    /**
     * @param organizationUnitId (optional)
     * @return Success
     */
    getOrganizationUnitById(organizationUnitId: string | null | undefined): Observable<OrganizationUnitSimpleDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitById?";
        if (organizationUnitId !== undefined && organizationUnitId !== null)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitById(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitSimpleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitSimpleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitById(response: HttpResponseBase): Observable<OrganizationUnitSimpleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitSimpleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitSimpleDto>(<any>null);
    }

    /**
     * @param organizationUnitId (optional)
     * @return Success
     */
    getUsersInOrganizationUnit(organizationUnitId: string | null | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetUsersInOrganizationUnit?";
        if (organizationUnitId !== undefined && organizationUnitId !== null)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersInOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersInOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersInOrganizationUnit(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param unitCode (optional)
     * @param typeId (optional)
     * @return Success
     */
    getOrganizationUnitsByCodeUnit(unitCode: string | null | undefined, typeId: number | null | undefined): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitsByCodeUnit?";
        if (unitCode !== undefined && unitCode !== null)
            url_ += "unitCode=" + encodeURIComponent("" + unitCode) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitsByCodeUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitsByCodeUnit(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitsByCodeUnit(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param typeId (optional)
     * @param body (optional)
     * @return Success
     */
    getOrganizationUnitsByCodeUnitList(typeId: number | null | undefined, body: string[] | null | undefined): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitsByCodeUnitList?";
        if (typeId !== undefined && typeId !== null)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitsByCodeUnitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitsByCodeUnitList(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitsByCodeUnitList(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getOrganizationUnitUsers(id: number | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrganizationUnitUserListDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrganizationUnitRoleListDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateOrganizationUnit(body: CreateOrUpdateOrganizationUnitInput | undefined): Observable<AjaxResponseOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrUpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateOrganizationUnit(response: HttpResponseBase): Observable<AjaxResponseOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param groupId (optional)
     * @return Success
     */
    getAuthorizersByGroupId(groupId: string | undefined): Observable<AjaxResponseOfListOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAuthorizersByGroupId?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizersByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizersByGroupId(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfListOfUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfListOfUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuthorizersByGroupId(response: HttpResponseBase): Observable<AjaxResponseOfListOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfListOfUserListDto>(<any>null);
    }

    /**
     * @param organizationUnitId (optional)
     * @return Success
     */
    getOrganizationUnitUsersById(organizationUnitId: number | undefined): Observable<AjaxResponseOfListResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsersById?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsersById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsersById(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfListResultDtoOfUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfListResultDtoOfUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitUsersById(response: HttpResponseBase): Observable<AjaxResponseOfListResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfListResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @param groupId (optional)
     * @param body (optional)
     * @return Success
     */
    createOrUpdateAuthorizers(groupId: string | undefined, body: UserListDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrUpdateAuthorizers?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAuthorizers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAuthorizers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateAuthorizers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param groupId (optional)
     * @param userId (optional)
     * @return Success
     */
    deleteAuthorizer(groupId: string | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteAuthorizer?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAuthorizer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAuthorizer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAuthorizer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional)
     * @param organizationUnitId (optional)
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param roleId (optional)
     * @param organizationUnitId (optional)
     * @return Success
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param codeType (optional)
     * @return Success
     */
    getIdByCodeType(codeType: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnitTypes/GetIdByCodeType?";
        if (codeType !== undefined && codeType !== null)
            url_ += "CodeType=" + encodeURIComponent("" + codeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdByCodeType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdByCodeType(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetIdByCodeType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getTypes(): Observable<AjaxResponseOfListOfOrganizationUntiTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnitTypes/GetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypes(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfListOfOrganizationUntiTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfListOfOrganizationUntiTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTypes(response: HttpResponseBase): Observable<AjaxResponseOfListOfOrganizationUntiTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfOrganizationUntiTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfListOfOrganizationUntiTypeDto>(<any>null);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param upgradeEditionId (optional)
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number | null | undefined): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined && upgradeEditionId !== null)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfo(<any>response_);
                } catch (e) {
                    return <Observable<PaymentInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentInfoDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createPayment(body: CreatePaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    cancelPayment(body: CancelPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getPaymentHistory(sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentHistory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSubscriptionPaymentListDto>(<any>null);
    }

    /**
     * @param recurringPaymentsEnabled (optional)
     * @return Success
     */
    getActiveGateways(recurringPaymentsEnabled: boolean | null | undefined): Observable<PaymentGatewayModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
        if (recurringPaymentsEnabled !== undefined && recurringPaymentsEnabled !== null)
            url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveGateways(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveGateways(<any>response_);
                } catch (e) {
                    return <Observable<PaymentGatewayModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentGatewayModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveGateways(response: HttpResponseBase): Observable<PaymentGatewayModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentGatewayModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<PaymentGatewayModel[]>(<any>null));
    }

    /**
     * @param paymentId (optional)
     * @return Success
     */
    getPayment(paymentId: number | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLastCompletedPayment(): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCompletedPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCompletedPayment(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastCompletedPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(<any>null);
    }

    /**
     * @param paymentId (optional)
     * @return Success
     */
    buyNowSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/BuyNowSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyNowSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyNowSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBuyNowSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional)
     * @return Success
     */
    newRegistrationSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/NewRegistrationSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewRegistrationSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewRegistrationSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNewRegistrationSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional)
     * @return Success
     */
    upgradeSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpgradeSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional)
     * @return Success
     */
    extendSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExtendSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExtendSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional)
     * @return Success
     */
    paymentFailed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFailed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPaymentFailed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param upgradeEditionId (optional)
     * @return Success
     */
    switchBetweenFreeEditions(upgradeEditionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/SwitchBetweenFreeEditions?";
        if (upgradeEditionId === null)
            throw new Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchBetweenFreeEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchBetweenFreeEditions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSwitchBetweenFreeEditions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param editionId (optional)
     * @return Success
     */
    upgradeSubscriptionCostsLessThenMinAmount(editionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSubscriptionCostsLessThenMinAmount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSubscriptionCostsLessThenMinAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSubscriptionCostsLessThenMinAmount(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpgradeSubscriptionCostsLessThenMinAmount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    hasAnyPayment(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Payment/HasAnyPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAnyPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAnyPayment(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHasAnyPayment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class PaymentNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param trackid (optional)
     * @return Success
     */
    trivenetoFeedback(trackid: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/PaymentNotification/TrivenetoFeedback?";
        if (trackid !== undefined && trackid !== null)
            url_ += "trackid=" + encodeURIComponent("" + trackid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrivenetoFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrivenetoFeedback(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTrivenetoFeedback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PaymentProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional)
     * @param isOnlyProfilesNotExpired (optional)
     * @param airlineFilter (optional)
     * @param selectedAgencies (optional)
     * @param cardHolderNameFilter (optional)
     * @param code (optional)
     * @param displayNumberFilter (optional)
     * @param expirationMonthFilter (optional)
     * @param expirationYearFilter (optional)
     * @param isEnabledFilter (optional)
     * @param supplierFilterFilter (optional)
     * @param agencyId (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getPaymentsToExcel(filter: string | null | undefined, isOnlyProfilesNotExpired: boolean | undefined, airlineFilter: string[] | null | undefined, selectedAgencies: string[] | null | undefined, cardHolderNameFilter: string | null | undefined, code: string | null | undefined, displayNumberFilter: string | null | undefined, expirationMonthFilter: string | null | undefined, expirationYearFilter: string | null | undefined, isEnabledFilter: boolean | null | undefined, supplierFilterFilter: string | null | undefined, agencyId: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentProfile/GetPaymentsToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isOnlyProfilesNotExpired === null)
            throw new Error("The parameter 'isOnlyProfilesNotExpired' cannot be null.");
        else if (isOnlyProfilesNotExpired !== undefined)
            url_ += "IsOnlyProfilesNotExpired=" + encodeURIComponent("" + isOnlyProfilesNotExpired) + "&";
        if (airlineFilter !== undefined && airlineFilter !== null)
            airlineFilter && airlineFilter.forEach(item => { url_ += "AirlineFilter=" + encodeURIComponent("" + item) + "&"; });
        if (selectedAgencies !== undefined && selectedAgencies !== null)
            selectedAgencies && selectedAgencies.forEach(item => { url_ += "SelectedAgencies=" + encodeURIComponent("" + item) + "&"; });
        if (cardHolderNameFilter !== undefined && cardHolderNameFilter !== null)
            url_ += "CardHolderNameFilter=" + encodeURIComponent("" + cardHolderNameFilter) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (displayNumberFilter !== undefined && displayNumberFilter !== null)
            url_ += "DisplayNumberFilter=" + encodeURIComponent("" + displayNumberFilter) + "&";
        if (expirationMonthFilter !== undefined && expirationMonthFilter !== null)
            url_ += "ExpirationMonthFilter=" + encodeURIComponent("" + expirationMonthFilter) + "&";
        if (expirationYearFilter !== undefined && expirationYearFilter !== null)
            url_ += "ExpirationYearFilter=" + encodeURIComponent("" + expirationYearFilter) + "&";
        if (isEnabledFilter !== undefined && isEnabledFilter !== null)
            url_ += "IsEnabledFilter=" + encodeURIComponent("" + isEnabledFilter) + "&";
        if (supplierFilterFilter !== undefined && supplierFilterFilter !== null)
            url_ += "SupplierFilterFilter=" + encodeURIComponent("" + supplierFilterFilter) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param isOnlyProfilesNotExpired (optional)
     * @param airlineFilter (optional)
     * @param selectedAgencies (optional)
     * @param cardHolderNameFilter (optional)
     * @param code (optional)
     * @param displayNumberFilter (optional)
     * @param expirationMonthFilter (optional)
     * @param expirationYearFilter (optional)
     * @param isEnabledFilter (optional)
     * @param supplierFilterFilter (optional)
     * @param agencyId (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(filter: string | null | undefined, isOnlyProfilesNotExpired: boolean | undefined, airlineFilter: string[] | null | undefined, selectedAgencies: string[] | null | undefined, cardHolderNameFilter: string | null | undefined, code: string | null | undefined, displayNumberFilter: string | null | undefined, expirationMonthFilter: string | null | undefined, expirationYearFilter: string | null | undefined, isEnabledFilter: boolean | null | undefined, supplierFilterFilter: string | null | undefined, agencyId: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPaymentProfileForView> {
        let url_ = this.baseUrl + "/api/services/app/PaymentProfile/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isOnlyProfilesNotExpired === null)
            throw new Error("The parameter 'isOnlyProfilesNotExpired' cannot be null.");
        else if (isOnlyProfilesNotExpired !== undefined)
            url_ += "IsOnlyProfilesNotExpired=" + encodeURIComponent("" + isOnlyProfilesNotExpired) + "&";
        if (airlineFilter !== undefined && airlineFilter !== null)
            airlineFilter && airlineFilter.forEach(item => { url_ += "AirlineFilter=" + encodeURIComponent("" + item) + "&"; });
        if (selectedAgencies !== undefined && selectedAgencies !== null)
            selectedAgencies && selectedAgencies.forEach(item => { url_ += "SelectedAgencies=" + encodeURIComponent("" + item) + "&"; });
        if (cardHolderNameFilter !== undefined && cardHolderNameFilter !== null)
            url_ += "CardHolderNameFilter=" + encodeURIComponent("" + cardHolderNameFilter) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (displayNumberFilter !== undefined && displayNumberFilter !== null)
            url_ += "DisplayNumberFilter=" + encodeURIComponent("" + displayNumberFilter) + "&";
        if (expirationMonthFilter !== undefined && expirationMonthFilter !== null)
            url_ += "ExpirationMonthFilter=" + encodeURIComponent("" + expirationMonthFilter) + "&";
        if (expirationYearFilter !== undefined && expirationYearFilter !== null)
            url_ += "ExpirationYearFilter=" + encodeURIComponent("" + expirationYearFilter) + "&";
        if (isEnabledFilter !== undefined && isEnabledFilter !== null)
            url_ += "IsEnabledFilter=" + encodeURIComponent("" + isEnabledFilter) + "&";
        if (supplierFilterFilter !== undefined && supplierFilterFilter !== null)
            url_ += "SupplierFilterFilter=" + encodeURIComponent("" + supplierFilterFilter) + "&";
        if (agencyId !== undefined && agencyId !== null)
            url_ += "AgencyId=" + encodeURIComponent("" + agencyId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPaymentProfileForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPaymentProfileForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPaymentProfileForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPaymentProfileForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPaymentProfileForView>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getPaymentProfileForEdit(id: string | null | undefined): Observable<GetPaymentProfileForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PaymentProfile/GetPaymentProfileForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentProfileForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentProfileForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentProfileForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentProfileForEdit(response: HttpResponseBase): Observable<GetPaymentProfileForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentProfileForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentProfileForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createPaymentProfile(body: CreatePaymentProfileInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentProfile/CreatePaymentProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    editPaymentProfile(body: EditPaymentProfileInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentProfile/EditPaymentProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditPaymentProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditPaymentProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditPaymentProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentProfile/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setEnabled(body: ChangeEnabledDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentProfile/SetEnabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEnabled(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetEnabled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PayPalPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param paymentId (optional)
     * @param paypalOrderId (optional)
     * @return Success
     */
    confirmPayment(paymentId: number | undefined, paypalOrderId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (paypalOrderId !== undefined && paypalOrderId !== null)
            url_ += "paypalOrderId=" + encodeURIComponent("" + paypalOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<PayPalConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<PayPalConfigurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PayPalConfigurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<PayPalConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayPalConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayPalConfigurationDto>(<any>null);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfFlatPermissionWithLevelDto>(<any>null);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CurrentUserProfileEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrentUserProfileEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentUserProfileEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    disableGoogleAuthenticator(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(<any>response_);
                } catch (e) {
                    return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateGoogleAuthenticatorKeyOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(<any>response_);
                } catch (e) {
                    return <Observable<GetPasswordComplexitySettingOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPasswordComplexitySettingOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPasswordComplexitySettingOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param username (optional)
     * @return Success
     */
    getProfilePictureByUserName(username: string | null | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserName?";
        if (username !== undefined && username !== null)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUserName(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePictureByUserName(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    getProfilePictureByUser(userId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUser(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePictureByUser(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ReasonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrEdit(body: CreateOrEditReasonDto | undefined): Observable<ReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/Reason/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<ReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<ReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReasonDto>(<any>null);
    }

    /**
     * @param reasonId (optional)
     * @return Success
     */
    delete(reasonId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reason/Delete?";
        if (reasonId !== undefined && reasonId !== null)
            url_ += "reasonId=" + encodeURIComponent("" + reasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param reasonId (optional)
     * @return Success
     */
    get(reasonId: string | null | undefined): Observable<ReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/Reason/Get?";
        if (reasonId !== undefined && reasonId !== null)
            url_ += "reasonId=" + encodeURIComponent("" + reasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReasonDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ReasonDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reason/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ReasonDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReasonDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReasonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReasonDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ReasonDto[]>(<any>null));
    }
}

@Injectable()
export class RegionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyWord (optional)
     * @param enabled (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getList(keyWord: string | null | undefined, enabled: boolean | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfRegionDto> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetList?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (enabled !== undefined && enabled !== null)
            url_ += "Enabled=" + encodeURIComponent("" + enabled) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRegionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRegionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfRegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRegionDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getRegion(id: string | null | undefined): Observable<RegionDto> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetRegion?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegion(<any>response_);
                } catch (e) {
                    return <Observable<RegionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegion(response: HttpResponseBase): Observable<RegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegionDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    edit(body: RegionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Region/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyWord (optional)
     * @param enabled (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getRegionToExcel(keyWord: string | null | undefined, enabled: boolean | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Region/GetRegionToExcel?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (enabled !== undefined && enabled !== null)
            url_ += "Enabled=" + encodeURIComponent("" + enabled) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegionToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class RegistrationAgenciesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    register(body: RegisterAgencyDto | undefined): Observable<RegisterAgencyOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/RegistrationAgencies/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterAgencyOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterAgencyOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterAgencyOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterAgencyOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterAgencyOutputDto>(<any>null);
    }

    /**
     * @param vat (optional)
     * @return Success
     */
    checkIfVatExists(vat: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RegistrationAgencies/CheckIfVatExists?";
        if (vat !== undefined && vat !== null)
            url_ += "vat=" + encodeURIComponent("" + vat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfVatExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfVatExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIfVatExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class ReservationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param reservationId (optional)
     * @param description (optional)
     * @return Success
     */
    addLog(reservationId: string | null | undefined, description: string | null | undefined): Observable<LogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/AddLog?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLog(<any>response_);
                } catch (e) {
                    return <Observable<LogDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LogDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processAddLog(response: HttpResponseBase): Observable<LogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LogDto[]>(<any>null));
    }

    /**
     * @param reservationId (optional)
     * @param body (optional)
     * @return Success
     */
    changeStatus(reservationId: string | null | undefined, body: ReservationStatusDto | undefined): Observable<LogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/ChangeStatus?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeStatus(<any>response_);
                } catch (e) {
                    return <Observable<LogDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LogDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<LogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LogDto[]>(<any>null));
    }

    /**
     * @param id (optional)
     * @param refreshTripStatus (optional)
     * @return Success
     */
    getReservationById(id: string | null | undefined, refreshTripStatus: boolean | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetReservationById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (refreshTripStatus === null)
            throw new Error("The parameter 'refreshTripStatus' cannot be null.");
        else if (refreshTripStatus !== undefined)
            url_ += "refreshTripStatus=" + encodeURIComponent("" + refreshTripStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationById(<any>response_);
                } catch (e) {
                    return <Observable<ReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationById(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteReservation(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/DeleteReservation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReservation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteReservation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    updateReservation(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/UpdateReservation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReservation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateReservation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reservationsListToExcel(body: GetReservationsInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/ReservationsListToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReservationsListToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReservationsListToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processReservationsListToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reservationsListToExcelSegmentsProduction(body: GetReservationsInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/ReservationsListToExcelSegmentsProduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReservationsListToExcelSegmentsProduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReservationsListToExcelSegmentsProduction(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processReservationsListToExcelSegmentsProduction(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reservationsListToZucchetti(body: GetReservationsInput | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/ReservationsListToZucchetti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReservationsListToZucchetti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReservationsListToZucchetti(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processReservationsListToZucchetti(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reservationsList(body: GetReservationsInput | undefined): Observable<PagedResultDtoOfReservationListDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/ReservationsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReservationsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReservationsList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfReservationListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfReservationListDto>><any>_observableThrow(response_);
        }));
    }

    protected processReservationsList(response: HttpResponseBase): Observable<PagedResultDtoOfReservationListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReservationListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReservationListDto>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    queueAndIssue(reservationId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/QueueAndIssue?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueueAndIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueueAndIssue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processQueueAndIssue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendReservationToQueueForAssistance(body: RequestQueueForAssistanceInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/SendReservationToQueueForAssistance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendReservationToQueueForAssistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReservationToQueueForAssistance(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendReservationToQueueForAssistance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    issue(body: IssueReservationInput | undefined): Observable<AjaxResponseOfIssueReservationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/Issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIssue(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfIssueReservationOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfIssueReservationOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIssue(response: HttpResponseBase): Observable<AjaxResponseOfIssueReservationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIssueReservationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfIssueReservationOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updatePassengersData(body: UpdatePassengersReservationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/UpdatePassengersData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePassengersData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePassengersData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePassengersData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    updatePriceQuotation(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/UpdatePriceQuotation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePriceQuotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePriceQuotation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePriceQuotation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changePaymentProfile(body: ChangePaymentProfileInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/ChangePaymentProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePaymentProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePaymentProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePaymentProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    getPaymentProfileForChange(reservationId: string | null | undefined): Observable<GetChangePaymentProfileOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetPaymentProfileForChange?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentProfileForChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentProfileForChange(<any>response_);
                } catch (e) {
                    return <Observable<GetChangePaymentProfileOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetChangePaymentProfileOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentProfileForChange(response: HttpResponseBase): Observable<GetChangePaymentProfileOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetChangePaymentProfileOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetChangePaymentProfileOutput>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    getPaymentInfo(reservationId: string | null | undefined): Observable<GetPaymentInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetPaymentInfo?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "ReservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentInfoOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentInfoOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<GetPaymentInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentInfoOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    payReservation(body: PayReservationInput | undefined): Observable<AjaxResponseOfPayReservationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/PayReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayReservation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayReservation(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfPayReservationOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfPayReservationOutput>><any>_observableThrow(response_);
        }));
    }

    protected processPayReservation(response: HttpResponseBase): Observable<AjaxResponseOfPayReservationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfPayReservationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfPayReservationOutput>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @param body (optional)
     * @return Success
     */
    voidAirTicket(reservationId: string | null | undefined, body: string[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/VoidAirTicket?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoidAirTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoidAirTicket(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVoidAirTicket(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    getCancellationDetails(reservationId: string | null | undefined): Observable<FlightCancellationDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetCancellationDetails?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancellationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancellationDetails(<any>response_);
                } catch (e) {
                    return <Observable<FlightCancellationDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlightCancellationDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCancellationDetails(response: HttpResponseBase): Observable<FlightCancellationDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlightCancellationDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlightCancellationDetailsDto>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    getPostSaleActions(reservationId: string | null | undefined): Observable<PostSaleActionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetPostSaleActions?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostSaleActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostSaleActions(<any>response_);
                } catch (e) {
                    return <Observable<PostSaleActionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PostSaleActionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPostSaleActions(response: HttpResponseBase): Observable<PostSaleActionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostSaleActionDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<PostSaleActionDto[]>(<any>null));
    }

    /**
     * @param reservationId (optional)
     * @param confirmDelete (optional)
     * @param body (optional)
     * @return Success
     */
    refundTrainTicket(reservationId: string | null | undefined, confirmDelete: boolean | undefined, body: string[] | null | undefined): Observable<ModifyResult> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/RefundTrainTicket?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (confirmDelete === null)
            throw new Error("The parameter 'confirmDelete' cannot be null.");
        else if (confirmDelete !== undefined)
            url_ += "confirmDelete=" + encodeURIComponent("" + confirmDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefundTrainTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefundTrainTicket(<any>response_);
                } catch (e) {
                    return <Observable<ModifyResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModifyResult>><any>_observableThrow(response_);
        }));
    }

    protected processRefundTrainTicket(response: HttpResponseBase): Observable<ModifyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModifyResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModifyResult>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @param confirmDelete (optional)
     * @param body (optional)
     * @return Success
     */
    cancellationTrainTicket(reservationId: string | null | undefined, confirmDelete: boolean | undefined, body: string[] | null | undefined): Observable<ModifyResult> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/CancellationTrainTicket?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (confirmDelete === null)
            throw new Error("The parameter 'confirmDelete' cannot be null.");
        else if (confirmDelete !== undefined)
            url_ += "confirmDelete=" + encodeURIComponent("" + confirmDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancellationTrainTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancellationTrainTicket(<any>response_);
                } catch (e) {
                    return <Observable<ModifyResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModifyResult>><any>_observableThrow(response_);
        }));
    }

    protected processCancellationTrainTicket(response: HttpResponseBase): Observable<ModifyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModifyResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModifyResult>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    cancellationHotelVoucher(reservationId: string | null | undefined, confirmDelete: boolean | undefined): Observable<ModifyResult> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/CancellationHotelVoucher?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (confirmDelete === null)
            throw new Error("The parameter 'confirmDelete' cannot be null.");
        else if (confirmDelete !== undefined)
            url_ += "confirmDelete=" + encodeURIComponent("" + confirmDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancellationHotelVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancellationHotelVoucher(<any>response_);
                } catch (e) {
                    return <Observable<ModifyResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModifyResult>><any>_observableThrow(response_);
        }));
    }

    protected processCancellationHotelVoucher(response: HttpResponseBase): Observable<ModifyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ModifyResult.fromJS(resultData200);
                return _observableOf(result200);
                }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModifyResult>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @param startingDate (optional)
     * @param body (optional)
     * @return Success
     */
    trainSearchSimilar(reservationId: string | null | undefined, startingDate: moment.Moment | undefined, body: string[] | null | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/TrainSearchSimilar?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (startingDate === null)
            throw new Error("The parameter 'startingDate' cannot be null.");
        else if (startingDate !== undefined)
            url_ += "startingDate=" + encodeURIComponent(startingDate ? "" + startingDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainSearchSimilar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainSearchSimilar(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processTrainSearchSimilar(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @param travelSolutionId (optional)
     * @param ticketIds (optional)
     * @param hold (optional)
     * @param confirmPayment (optional)
     * @param body (optional)
     * @return Success
     */
    trainChangeBookingTrenitalia(reservationId: string | null | undefined, travelSolutionId: string | null | undefined, ticketIds: string | null | undefined, hold: boolean | undefined, confirmPayment: boolean | undefined, body: PersonNameDataDTO[] | null | undefined): Observable<ModifyResult> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/TrainChangeBookingTrenitalia?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (travelSolutionId !== undefined && travelSolutionId !== null)
            url_ += "travelSolutionId=" + encodeURIComponent("" + travelSolutionId) + "&";
        if (ticketIds !== undefined && ticketIds !== null)
            url_ += "ticketIds=" + encodeURIComponent("" + ticketIds) + "&";
        if (hold === null)
            throw new Error("The parameter 'hold' cannot be null.");
        else if (hold !== undefined)
            url_ += "hold=" + encodeURIComponent("" + hold) + "&";
        if (confirmPayment === null)
            throw new Error("The parameter 'confirmPayment' cannot be null.");
        else if (confirmPayment !== undefined)
            url_ += "confirmPayment=" + encodeURIComponent("" + confirmPayment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainChangeBookingTrenitalia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainChangeBookingTrenitalia(<any>response_);
                } catch (e) {
                    return <Observable<ModifyResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModifyResult>><any>_observableThrow(response_);
        }));
    }

    protected processTrainChangeBookingTrenitalia(response: HttpResponseBase): Observable<ModifyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModifyResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModifyResult>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @param travelSolutionId (optional)
     * @param ticketIds (optional)
     * @param hold (optional)
     * @param confirmPayment (optional)
     * @return Success
     */
    trainChangeBooking(reservationId: string | null | undefined, travelSolutionId: string | null | undefined, ticketIds: string | null | undefined, hold: boolean | undefined, confirmPayment: boolean | undefined): Observable<ModifyResult> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/TrainChangeBooking?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (travelSolutionId !== undefined && travelSolutionId !== null)
            url_ += "travelSolutionId=" + encodeURIComponent("" + travelSolutionId) + "&";
        if (ticketIds !== undefined && ticketIds !== null)
            url_ += "ticketIds=" + encodeURIComponent("" + ticketIds) + "&";
        if (hold === null)
            throw new Error("The parameter 'hold' cannot be null.");
        else if (hold !== undefined)
            url_ += "hold=" + encodeURIComponent("" + hold) + "&";
        if (confirmPayment === null)
            throw new Error("The parameter 'confirmPayment' cannot be null.");
        else if (confirmPayment !== undefined)
            url_ += "confirmPayment=" + encodeURIComponent("" + confirmPayment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainChangeBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainChangeBooking(<any>response_);
                } catch (e) {
                    return <Observable<ModifyResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModifyResult>><any>_observableThrow(response_);
        }));
    }

    protected processTrainChangeBooking(response: HttpResponseBase): Observable<ModifyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModifyResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModifyResult>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    getTrainPDFTicket(reservationId: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetTrainPDFTicket?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainPDFTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainPDFTicket(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTrainPDFTicket(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    trainSearchWithReattach(body: TrainAvailabilityRequestDTOExtended | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/TrainSearchWithReattach";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainSearchWithReattach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainSearchWithReattach(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processTrainSearchWithReattach(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    trainSearchNewAvailability(body: TrainAvailabilityRequestDTOExtended | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/TrainSearchNewAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainSearchNewAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainSearchNewAvailability(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processTrainSearchNewAvailability(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @param body (optional)
     * @return Success
     */
    trainEvaluateTravel(reservationId: string | null | undefined, body: EvaluateTravelRequestDto | undefined): Observable<EvaluateTravelResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/TrainEvaluateTravel?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainEvaluateTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainEvaluateTravel(<any>response_);
                } catch (e) {
                    return <Observable<EvaluateTravelResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EvaluateTravelResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processTrainEvaluateTravel(response: HttpResponseBase): Observable<EvaluateTravelResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EvaluateTravelResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EvaluateTravelResponseDto>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @param ticketIds (optional)
     * @param body (optional)
     * @return Success
     */
    seatMapData(reservationId: string | null | undefined, ticketIds: string | null | undefined, body: EvaluateTravelRequestDto | undefined): Observable<ApiResponseOfTrainLayoutDTO> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/SeatMapData?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (ticketIds !== undefined && ticketIds !== null)
            url_ += "ticketIds=" + encodeURIComponent("" + ticketIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeatMapData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeatMapData(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfTrainLayoutDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfTrainLayoutDTO>><any>_observableThrow(response_);
        }));
    }

    protected processSeatMapData(response: HttpResponseBase): Observable<ApiResponseOfTrainLayoutDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfTrainLayoutDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfTrainLayoutDTO>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    trainModifyTravel(reservationId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/TrainModifyTravel?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainModifyTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainModifyTravel(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processTrainModifyTravel(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @param totalPrice (optional)
     * @param callbackData (optional)
     * @param body (optional)
     * @return Success
     */
    trainPayAndModifyTravel(reservationId: string | null | undefined, totalPrice: number | undefined, callbackData: string | null | undefined, body: TrainBookRequestDto | undefined): Observable<ApiResponseOfReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/TrainPayAndModifyTravel?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (totalPrice === null)
            throw new Error("The parameter 'totalPrice' cannot be null.");
        else if (totalPrice !== undefined)
            url_ += "totalPrice=" + encodeURIComponent("" + totalPrice) + "&";
        if (callbackData !== undefined && callbackData !== null)
            url_ += "callbackData=" + encodeURIComponent("" + callbackData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainPayAndModifyTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainPayAndModifyTravel(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processTrainPayAndModifyTravel(response: HttpResponseBase): Observable<ApiResponseOfReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfReservationDto>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @param availabilityId (optional)
     * @param body (optional)
     * @return Success
     */
    assignSeatsAndModify(orderId: string | null | undefined, availabilityId: string | null | undefined, body: SeatsDTO[] | null | undefined): Observable<ApiResponseOfReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/AssignSeatsAndModify?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignSeatsAndModify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignSeatsAndModify(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processAssignSeatsAndModify(response: HttpResponseBase): Observable<ApiResponseOfReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfReservationDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addSpecialServices(body: AddSpecialServicesInputDto | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/AddSpecialServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSpecialServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSpecialServices(<any>response_);
                } catch (e) {
                    return <Observable<ReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddSpecialServices(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    getPersonNameSsr(reservationId: string | null | undefined): Observable<PersonNameSsrDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/GetPersonNameSsr?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonNameSsr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonNameSsr(<any>response_);
                } catch (e) {
                    return <Observable<PersonNameSsrDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonNameSsrDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonNameSsr(response: HttpResponseBase): Observable<PersonNameSsrDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonNameSsrDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<PersonNameSsrDto[]>(<any>null));
    }

    /**
     * @param reservationId (optional)
     * @return Success
     */
    sendInCapture(reservationId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reservation/SendInCapture?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInCapture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInCapture(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendInCapture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

        /**
     * @param reservationId (optional)
     * @return Success
     */
        getSiapErrorLogs(reservationId: string | null | undefined): Observable<SiapReservationErrorDto[]> {
            let url_ = this.baseUrl + "/api/services/app/Reservation/GetSiapErrorLogs?";
            if (reservationId !== undefined && reservationId !== null)
                url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
            url_ = url_.replace(/[?&]$/, "");
    
            let options_ : any = {
                observe: "response",
                responseType: "blob",
                headers: new HttpHeaders({
                    "Accept": "application/json"
                })
            };
    
            return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
                return this.processGetSiapErrorLogs(response_);
            })).pipe(_observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetSiapErrorLogs(<any>response_);
                    } catch (e) {
                        return <Observable<SiapReservationErrorDto[]>><any>_observableThrow(e);
                    }
                } else
                    return <Observable<SiapReservationErrorDto[]>><any>_observableThrow(response_);
            }));
        }

        protected processGetSiapErrorLogs(response: HttpResponseBase): Observable<SiapReservationErrorDto[]> {
            const status = response.status;
            const responseBlob =
                response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;
    
            let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
            if (status === 200) {
                return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SiapReservationErrorDto.fromJS(item));
                }
                return _observableOf(result200);
                }));
            } else if (status !== 200 && status !== 204) {
                return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                }));
            }
            return of(<SiapReservationErrorDto[]>(<any>null));
        }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param permissions (optional)
     * @return Success
     */
    getRoles(permissions: string[] | null | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permissions !== undefined && permissions !== null)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getRoleForEdit(id: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SelfAgencyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateLogoPicture(body: UpdateLogoPictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SelfAgency/UpdateLogoPicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogoPicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogoPicture(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLogoPicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param agencyId (optional)
     * @return Success
     */
    clearLogoPicture(agencyId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SelfAgency/ClearLogoPicture?";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogoPicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogoPicture(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearLogoPicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(<any>response_);
                } catch (e) {
                    return <Observable<UpdateUserSignInTokenOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateUserSignInTokenOutput>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserSignInTokenOutput>(<any>null);
    }
}

@Injectable()
export class StateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllStates(): Observable<StateListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/State/GetAllStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStates(<any>response_);
                } catch (e) {
                    return <Observable<StateListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StateListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllStates(response: HttpResponseBase): Observable<StateListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StateListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<StateListDto[]>(<any>null));
    }

    /**
     * @param code (optional)
     * @return Success
     */
    getStateByCode(code: string | null | undefined): Observable<StateDto> {
        let url_ = this.baseUrl + "/api/services/app/State/GetStateByCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateByCode(<any>response_);
                } catch (e) {
                    return <Observable<StateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStateByCode(response: HttpResponseBase): Observable<StateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StateDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getStateById(id: string | null | undefined): Observable<StateDto> {
        let url_ = this.baseUrl + "/api/services/app/State/GetStateById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateById(<any>response_);
                } catch (e) {
                    return <Observable<StateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStateById(response: HttpResponseBase): Observable<StateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StateDto>(<any>null);
    }

    /**
     * @param name (optional)
     * @param code (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getStates(name: string | null | undefined, code: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfStateListDto> {
        let url_ = this.baseUrl + "/api/services/app/State/GetStates?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStates(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStateListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStateListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStates(response: HttpResponseBase): Observable<PagedResultDtoOfStateListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStateListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStateListDto>(<any>null);
    }
}

@Injectable()
export class StationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyWord (optional)
     * @param isBlackList (optional)
     * @param isMultiCity (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getList(keyWord: string | null | undefined, isBlackList: boolean | null | undefined, isMultiCity: boolean | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfStationDTO> {
        let url_ = this.baseUrl + "/api/services/app/Stations/GetList?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (isBlackList !== undefined && isBlackList !== null)
            url_ += "IsBlackList=" + encodeURIComponent("" + isBlackList) + "&";
        if (isMultiCity !== undefined && isMultiCity !== null)
            url_ += "IsMultiCity=" + encodeURIComponent("" + isMultiCity) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStationDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStationDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfStationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStationDTO>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getStation(id: string | null | undefined): Observable<StationDTO> {
        let url_ = this.baseUrl + "/api/services/app/Stations/GetStation?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStation(<any>response_);
                } catch (e) {
                    return <Observable<StationDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<StationDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetStation(response: HttpResponseBase): Observable<StationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StationDTO>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrEdit(body: StationDTO | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stations/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    enable(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stations/Enable?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnable(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEnable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    disable(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Stations/Disable?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisable(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyWord (optional)
     * @param isBlackList (optional)
     * @param isMultiCity (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getStationsToExcel(keyWord: string | null | undefined, isBlackList: boolean | null | undefined, isMultiCity: boolean | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Stations/GetStationsToExcel?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (isBlackList !== undefined && isBlackList !== null)
            url_ += "IsBlackList=" + encodeURIComponent("" + isBlackList) + "&";
        if (isMultiCity !== undefined && isMultiCity !== null)
            url_ += "IsMultiCity=" + encodeURIComponent("" + isMultiCity) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStationsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param slug (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getStationBySlug(slug: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfStationDTO> {
        let url_ = this.baseUrl + "/api/services/app/Stations/GetStationBySlug?";
        if (slug !== undefined && slug !== null)
            url_ += "Slug=" + encodeURIComponent("" + slug) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStationBySlug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStationBySlug(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStationDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStationDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetStationBySlug(response: HttpResponseBase): Observable<PagedResultDtoOfStationDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStationDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStationDTO>(<any>null);
    }
}

@Injectable()
export class StripePaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<StripeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<StripeConfigurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StripeConfigurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<StripeConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StripeConfigurationDto>(<any>null);
    }

    /**
     * @param stripeSessionId (optional)
     * @return Success
     */
    getPayment(stripeSessionId: string | null | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPayment?";
        if (stripeSessionId !== undefined && stripeSessionId !== null)
            url_ += "StripeSessionId=" + encodeURIComponent("" + stripeSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createPaymentSession(body: StripeCreatePaymentSessionInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/CreatePaymentSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentSession(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentSession(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param paymentId (optional)
     * @return Success
     */
    getPaymentResult(paymentId: number | undefined): Observable<StripePaymentResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPaymentResult?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "PaymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentResult(<any>response_);
                } catch (e) {
                    return <Observable<StripePaymentResultOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<StripePaymentResultOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentResult(response: HttpResponseBase): Observable<StripePaymentResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripePaymentResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StripePaymentResultOutput>(<any>null);
    }
}

@Injectable()
export class StructuresServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param name (optional)
     * @param destinationId (optional)
     * @param isoCountry (optional)
     * @param categories (optional)
     * @param scores (optional)
     * @param isBlacklist (optional)
     * @param types (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getList(name: string | null | undefined, destinationId: string | null | undefined, isoCountry: string | null | undefined, categories: string[] | null | undefined, scores: string[] | null | undefined, isBlacklist: boolean | null | undefined, types: string[] | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfStructureRootMasterDto> {
        let url_ = this.baseUrl + "/api/services/app/Structures/GetList?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (destinationId !== undefined && destinationId !== null)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (isoCountry !== undefined && isoCountry !== null)
            url_ += "IsoCountry=" + encodeURIComponent("" + isoCountry) + "&";
        if (categories !== undefined && categories !== null)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        if (scores !== undefined && scores !== null)
            scores && scores.forEach(item => { url_ += "Scores=" + encodeURIComponent("" + item) + "&"; });
        if (isBlacklist !== undefined && isBlacklist !== null)
            url_ += "IsBlacklist=" + encodeURIComponent("" + isBlacklist) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStructureRootMasterDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStructureRootMasterDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfStructureRootMasterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStructureRootMasterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStructureRootMasterDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    edit(id: string | null | undefined): Observable<StructureRootMasterDto> {
        let url_ = this.baseUrl + "/api/services/app/Structures/Edit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(<any>response_);
                } catch (e) {
                    return <Observable<StructureRootMasterDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StructureRootMasterDto>><any>_observableThrow(response_);
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<StructureRootMasterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureRootMasterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StructureRootMasterDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getByCityId(id: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfStructureRootMasterDto> {
        let url_ = this.baseUrl + "/api/services/app/Structures/GetByCityId?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCityId(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStructureRootMasterDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStructureRootMasterDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCityId(response: HttpResponseBase): Observable<PagedResultDtoOfStructureRootMasterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStructureRootMasterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStructureRootMasterDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: StructureRootMasterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Structures/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param name (optional)
     * @param destinationId (optional)
     * @param isoCountry (optional)
     * @param categories (optional)
     * @param scores (optional)
     * @param isBlacklist (optional)
     * @param types (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getStructuresToExcel(name: string | null | undefined, destinationId: string | null | undefined, isoCountry: string | null | undefined, categories: string[] | null | undefined, scores: string[] | null | undefined, isBlacklist: boolean | null | undefined, types: string[] | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Structures/GetStructuresToExcel?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (destinationId !== undefined && destinationId !== null)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (isoCountry !== undefined && isoCountry !== null)
            url_ += "IsoCountry=" + encodeURIComponent("" + isoCountry) + "&";
        if (categories !== undefined && categories !== null)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        if (scores !== undefined && scores !== null)
            scores && scores.forEach(item => { url_ += "Scores=" + encodeURIComponent("" + item) + "&"; });
        if (isBlacklist !== undefined && isBlacklist !== null)
            url_ += "IsBlacklist=" + encodeURIComponent("" + isBlacklist) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStructuresToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStructuresToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStructuresToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional)
     * @param subscriptionEndDateStart (optional)
     * @param subscriptionEndDateEnd (optional)
     * @param creationDateStart (optional)
     * @param creationDateEnd (optional)
     * @param editionId (optional)
     * @param editionIdSpecified (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getTenants(filter: string | null | undefined, subscriptionEndDateStart: moment.Moment | null | undefined, subscriptionEndDateEnd: moment.Moment | null | undefined, creationDateStart: moment.Moment | null | undefined, creationDateEnd: moment.Moment | null | undefined, editionId: number | null | undefined, editionIdSpecified: boolean | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart !== undefined && subscriptionEndDateStart !== null)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&";
        if (subscriptionEndDateEnd !== undefined && subscriptionEndDateEnd !== null)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&";
        if (creationDateStart !== undefined && creationDateStart !== null)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd !== undefined && creationDateEnd !== null)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (editionId !== undefined && editionId !== null)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantListDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(<any>response_);
                } catch (e) {
                    return <Observable<TenantEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTenantFeaturesEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTenantFeaturesEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantFeaturesEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getNews(): Observable<GetNewsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNews(<any>response_);
                } catch (e) {
                    return <Observable<GetNewsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNewsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNews(response: HttpResponseBase): Observable<GetNewsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNewsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getFilesDownload(): Observable<FileDownloadLinksOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetFilesDownload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilesDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilesDownload(<any>response_);
                } catch (e) {
                    return <Observable<FileDownloadLinksOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDownloadLinksOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilesDownload(response: HttpResponseBase): Observable<FileDownloadLinksOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadLinksOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDownloadLinksOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setFilesDownload(body: FileDownloadLinkDTO[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/SetFilesDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFilesDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFilesDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetFilesDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setNews(body: NewsDTO | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/SetNews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNews(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetNews(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(<any>response_);
                } catch (e) {
                    return <Observable<GetMemberActivityOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMemberActivityOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberActivityOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(<any>response_);
                } catch (e) {
                    return <Observable<GetDashboardDataOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDashboardDataOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDashboardDataOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getTopStats(): Observable<GetTopStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStats(<any>response_);
                } catch (e) {
                    return <Observable<GetTopStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTopStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopStats(response: HttpResponseBase): Observable<GetTopStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTopStatsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfitShare(): Observable<GetProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfitShare(<any>response_);
                } catch (e) {
                    return <Observable<GetProfitShareOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfitShareOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfitShare(response: HttpResponseBase): Observable<GetProfitShareOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfitShareOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getDailySales(): Observable<GetDailySalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailySales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailySales(<any>response_);
                } catch (e) {
                    return <Observable<GetDailySalesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDailySalesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailySales(response: HttpResponseBase): Observable<GetDailySalesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDailySalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDailySalesOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesSummaryOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesSummaryOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesSummaryOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getRegionalStats(): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(<any>response_);
                } catch (e) {
                    return <Observable<GetRegionalStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRegionalStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionalStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegionalStatsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getGeneralStats(): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralStatsOutput>(<any>null);
    }

    /**
     * @param newsID (optional)
     * @return Success
     */
    removeNews(newsID: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/RemoveNews?";
        if (newsID !== undefined && newsID !== null)
            url_ += "newsID=" + encodeURIComponent("" + newsID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveNews(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveNews(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(<any>response_);
                } catch (e) {
                    return <Observable<RegisterTenantOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterTenantOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterTenantOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(<any>response_);
                } catch (e) {
                    return <Observable<EditionsSelectOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionsSelectOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionsSelectOutput>(<any>null);
    }

    /**
     * @param editionId (optional)
     * @return Success
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(<any>response_);
                } catch (e) {
                    return <Observable<EditionSelectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionSelectDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionSelectDto>(<any>null);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<TenantSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginSettingsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginSettingsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginSettingsDto>(<any>null);
    }
}

@Injectable()
export class TerminalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param pnr (optional)
     * @return Success
     */
    getPnr(pnr: string | null | undefined): Observable<CommandMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Terminal/GetPnr?";
        if (pnr !== undefined && pnr !== null)
            url_ += "pnr=" + encodeURIComponent("" + pnr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPnr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPnr(<any>response_);
                } catch (e) {
                    return <Observable<CommandMessageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommandMessageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPnr(response: HttpResponseBase): Observable<CommandMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommandMessageDto>(<any>null);
    }

    /**
     * @return Success
     */
    startSession(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Terminal/StartSession";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartSession(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processStartSession(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param conversationId (optional)
     * @return Success
     */
    releaseSession(conversationId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Terminal/ReleaseSession?";
        if (conversationId !== undefined && conversationId !== null)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseSession(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReleaseSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendCommand(body: CommandMessageDto | undefined): Observable<CommandMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Terminal/SendCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCommand(<any>response_);
                } catch (e) {
                    return <Observable<CommandMessageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommandMessageDto>><any>_observableThrow(response_);
        }));
    }

    protected processSendCommand(response: HttpResponseBase): Observable<CommandMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommandMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommandMessageDto>(<any>null);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param selectedTimezoneId (optional)
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | null | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined && selectedTimezoneId !== null)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<ComboboxItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComboboxItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ComboboxItemDto[]>(<any>null));
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param refreshToken (optional)
     * @return Success
     */
    refreshToken(refreshToken: string | null | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken !== undefined && refreshToken !== null)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(<any>response_);
                } catch (e) {
                    return <Observable<RefreshTokenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefreshTokenResult>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefreshTokenResult>(<any>null);
    }

    /**
     * @return Success
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param impersonationToken (optional)
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | null | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined && impersonationToken !== null)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonatedAuthenticateResultModel>(<any>null);
    }

    /**
     * @param userDelegationId (optional)
     * @param impersonationToken (optional)
     * @return Success
     */
    delegatedImpersonatedAuthenticate(userDelegationId: number | undefined, impersonationToken: string | null | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/DelegatedImpersonatedAuthenticate?";
        if (userDelegationId === null)
            throw new Error("The parameter 'userDelegationId' cannot be null.");
        else if (userDelegationId !== undefined)
            url_ += "userDelegationId=" + encodeURIComponent("" + userDelegationId) + "&";
        if (impersonationToken !== undefined && impersonationToken !== null)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonatedAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processDelegatedImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonatedAuthenticateResultModel>(<any>null);
    }

    /**
     * @param switchAccountToken (optional)
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | null | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined && switchAccountToken !== null)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<SwitchedAccountAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwitchedAccountAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchedAccountAuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ExternalLoginProviderInfoModel[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * @param message (optional)
     * @param severity (optional)
     * @return Success
     */
    testNotification(message: string | null | undefined, severity: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity !== undefined && severity !== null)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TrainServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTrainPassengerAge(): Observable<TrainPaxClientDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Train/GetTrainPassengerAge";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainPassengerAge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainPassengerAge(<any>response_);
                } catch (e) {
                    return <Observable<TrainPaxClientDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TrainPaxClientDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTrainPassengerAge(response: HttpResponseBase): Observable<TrainPaxClientDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainPaxClientDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<TrainPaxClientDTO[]>(<any>null));
    }

    /**
     * @param query (optional)
     * @return Success
     */
    getDestinationAutocomplete(query: string | null | undefined): Observable<LocationDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Train/GetDestinationAutocomplete?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinationAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinationAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<LocationDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDestinationAutocomplete(response: HttpResponseBase): Observable<LocationDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LocationDTO[]>(<any>null));
    }

    /**
     * @param airportCode (optional)
     * @return Success
     */
    getStationByAirportCode(airportCode: string | null | undefined): Observable<LocationDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Train/GetStationByAirportCode?";
        if (airportCode !== undefined && airportCode !== null)
            url_ += "airportCode=" + encodeURIComponent("" + airportCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStationByAirportCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStationByAirportCode(<any>response_);
                } catch (e) {
                    return <Observable<LocationDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStationByAirportCode(response: HttpResponseBase): Observable<LocationDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LocationDTO[]>(<any>null));
    }

    /**
     * @param latitude (optional)
     * @param longitude (optional)
     * @param ray (optional)
     * @return Success
     */
    getStationNearTo(latitude: number | undefined, longitude: number | undefined, ray: number | undefined): Observable<LocationDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Train/GetStationNearTo?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (ray === null)
            throw new Error("The parameter 'ray' cannot be null.");
        else if (ray !== undefined)
            url_ += "ray=" + encodeURIComponent("" + ray) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStationNearTo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStationNearTo(<any>response_);
                } catch (e) {
                    return <Observable<LocationDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStationNearTo(response: HttpResponseBase): Observable<LocationDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LocationDTO[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    search(body: TrainAvailabilityRequestDTO | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Train/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    startSearch(body: TrainAvailabilityRequestDTO | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Train/StartSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartSearch(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processStartSearch(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param availabilityId (optional)
     * @return Success
     */
    checkSearch(availabilityId: string | null | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/Train/CheckSearch?";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSearch(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCheckSearch(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param postSale (optional)
     * @param body (optional)
     * @return Success
     */
    fareOffers(postSale: boolean | undefined, body: TrainBookRequestBaseDto | undefined): Observable<FareOfferDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Train/FareOffers?";
        if (postSale === null)
            throw new Error("The parameter 'postSale' cannot be null.");
        else if (postSale !== undefined)
            url_ += "postSale=" + encodeURIComponent("" + postSale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFareOffers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFareOffers(<any>response_);
                } catch (e) {
                    return <Observable<FareOfferDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FareOfferDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processFareOffers(response: HttpResponseBase): Observable<FareOfferDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FareOfferDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<FareOfferDto[]>(<any>null));
    }

    /**
     * @param segmentId (optional)
     * @param body (optional)
     * @return Success
     */
    trainStops(segmentId: string | null | undefined, body: TrainBookRequestBaseDto | undefined): Observable<HiddenStopDTO[]> {
        let url_ = this.baseUrl + "/api/services/app/Train/TrainStops?";
        if (segmentId !== undefined && segmentId !== null)
            url_ += "segmentId=" + encodeURIComponent("" + segmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainStops(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainStops(<any>response_);
                } catch (e) {
                    return <Observable<HiddenStopDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<HiddenStopDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processTrainStops(response: HttpResponseBase): Observable<HiddenStopDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HiddenStopDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<HiddenStopDTO[]>(<any>null));
    }

    /**
     * @param postSale (optional)
     * @param body (optional)
     * @return Success
     */
    checkoutData(postSale: boolean | undefined, body: TrainBookRequestBaseDto | undefined): Observable<TrainBookResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Train/CheckoutData?";
        if (postSale === null)
            throw new Error("The parameter 'postSale' cannot be null.");
        else if (postSale !== undefined)
            url_ += "postSale=" + encodeURIComponent("" + postSale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckoutData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckoutData(<any>response_);
                } catch (e) {
                    return <Observable<TrainBookResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TrainBookResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckoutData(response: HttpResponseBase): Observable<TrainBookResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainBookResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrainBookResponseDto>(<any>null);
    }

    /**
     * @param reservationId (optional)
     * @param postSale (optional)
     * @return Success
     */
    getCheckoutDataByReservationId(reservationId: string | null | undefined, postSale: boolean | undefined): Observable<TrainBookResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Train/GetCheckoutDataByReservationId?";
        if (reservationId !== undefined && reservationId !== null)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        if (postSale === null)
            throw new Error("The parameter 'postSale' cannot be null.");
        else if (postSale !== undefined)
            url_ += "postSale=" + encodeURIComponent("" + postSale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutDataByReservationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutDataByReservationId(<any>response_);
                } catch (e) {
                    return <Observable<TrainBookResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TrainBookResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCheckoutDataByReservationId(response: HttpResponseBase): Observable<TrainBookResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainBookResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrainBookResponseDto>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @param postSale (optional)
     * @param body (optional)
     * @return Success
     */
    seatMapData(orderId: string | null | undefined, postSale: boolean | undefined, body: TrainBookRequestBaseDto | undefined): Observable<ApiResponseOfTrainLayoutDTO> {
        let url_ = this.baseUrl + "/api/services/app/Train/SeatMapData?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (postSale === null)
            throw new Error("The parameter 'postSale' cannot be null.");
        else if (postSale !== undefined)
            url_ += "postSale=" + encodeURIComponent("" + postSale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeatMapData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeatMapData(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfTrainLayoutDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfTrainLayoutDTO>><any>_observableThrow(response_);
        }));
    }

    protected processSeatMapData(response: HttpResponseBase): Observable<ApiResponseOfTrainLayoutDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfTrainLayoutDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfTrainLayoutDTO>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @param tripId (optional)
     * @param availabilityId (optional)
     * @return Success
     */
    seatMapDataItalo(orderId: string | null | undefined, tripId: string | null | undefined, availabilityId: string | null | undefined): Observable<TrainSeatsResponse> {
        let url_ = this.baseUrl + "/api/services/app/Train/SeatMapDataItalo?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeatMapDataItalo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeatMapDataItalo(<any>response_);
                } catch (e) {
                    return <Observable<TrainSeatsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<TrainSeatsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSeatMapDataItalo(response: HttpResponseBase): Observable<TrainSeatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainSeatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrainSeatsResponse>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @param body (optional)
     * @return Success
     */
    updatePassengers(orderId: string | null | undefined, body: UpdatePassengersDTO | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Train/UpdatePassengers?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePassengers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePassengers(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePassengers(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    book(body: TrainBookRequestDto | undefined): Observable<ApiResponseOfReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Train/Book";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBook(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processBook(response: HttpResponseBase): Observable<ApiResponseOfReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfReservationDto>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    issue(orderId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Train/Issue?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIssue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processIssue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @param availabilityId (optional)
     * @param isTrip (optional)
     * @param body (optional)
     * @return Success
     */
    assignSeats(orderId: string | null | undefined, availabilityId: string | null | undefined, isTrip: boolean | undefined, body: SeatsDTO[] | null | undefined): Observable<ApiResponseOfReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Train/AssignSeats?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        if (isTrip === null)
            throw new Error("The parameter 'isTrip' cannot be null.");
        else if (isTrip !== undefined)
            url_ += "isTrip=" + encodeURIComponent("" + isTrip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignSeats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignSeats(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processAssignSeats(response: HttpResponseBase): Observable<ApiResponseOfReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfReservationDto>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @param availabilityId (optional)
     * @param body (optional)
     * @return Success
     */
    assignSeatsAndIssue(orderId: string | null | undefined, availabilityId: string | null | undefined, body: SeatsDTO[] | null | undefined): Observable<ApiResponseOfReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Train/AssignSeatsAndIssue?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignSeatsAndIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignSeatsAndIssue(<any>response_);
                } catch (e) {
                    return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiResponseOfReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processAssignSeatsAndIssue(response: HttpResponseBase): Observable<ApiResponseOfReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponseOfReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfReservationDto>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @param availabilityId (optional)
     * @param travelSolutionId (optional)
     * @param ticketIds (optional)
     * @param confirmPayment (optional)
     * @param body (optional)
     * @return Success
     */
    assignSeatsAndMove(orderId: string | null | undefined, availabilityId: string | null | undefined, travelSolutionId: string | null | undefined, ticketIds: string | null | undefined, confirmPayment: boolean | undefined, body: SeatsDTO[] | null | undefined): Observable<ModifyResult> {
        let url_ = this.baseUrl + "/api/services/app/Train/AssignSeatsAndMove?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
        if (travelSolutionId !== undefined && travelSolutionId !== null)
            url_ += "travelSolutionId=" + encodeURIComponent("" + travelSolutionId) + "&";
        if (ticketIds !== undefined && ticketIds !== null)
            url_ += "ticketIds=" + encodeURIComponent("" + ticketIds) + "&";
        if (confirmPayment === null)
            throw new Error("The parameter 'confirmPayment' cannot be null.");
        else if (confirmPayment !== undefined)
            url_ += "confirmPayment=" + encodeURIComponent("" + confirmPayment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignSeatsAndMove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignSeatsAndMove(<any>response_);
                } catch (e) {
                    return <Observable<ModifyResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModifyResult>><any>_observableThrow(response_);
        }));
    }

    protected processAssignSeatsAndMove(response: HttpResponseBase): Observable<ModifyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModifyResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModifyResult>(<any>null);
    }

    /**
     * @param orderId (optional)
     * @return Success
     */
    confirm(orderId: string | null | undefined): Observable<ReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/Train/Confirm?";
        if (orderId !== undefined && orderId !== null)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(<any>response_);
                } catch (e) {
                    return <Observable<ReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ReservationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReservationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationDto>(<any>null);
    }

            /**
     * @param assistedBookingId (optional)
     * @param body (optional)
     * @return Success
     */
    checkCarnetStationsValidity(
      id?: string,
      originCode?: string,
      destinationCode?: string,
    ): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Train/CheckCarnetStationsValidity?";
        if (id !== undefined)
            url_ += "carnetId=" + encodeURIComponent("" + id) + "&";
        if (originCode !== null)
            url_ += "originCode=" + encodeURIComponent("" + originCode) + "&";
        if (destinationCode !== null)
            url_ += "destinationCode=" + encodeURIComponent("" + destinationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        //const content_ = JSON.stringify(body);

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCarnetStationsValidity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCarnetStationsValidity(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCarnetStationsValidity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            /*return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<boolean>(<any>null);
            }));*/
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class TrainSerpShareServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendToCustomer(body: TrainMessageToCustomerInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainSerpShare/SendToCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToCustomer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendToCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createShareSerpLink(body: TrainMessageToCustomerInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TrainSerpShare/CreateShareSerpLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateShareSerpLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateShareSerpLink(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateShareSerpLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendToAgent(body: TrainMessageToAgentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainSerpShare/SendToAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendToAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendToAgent(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendToAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resolveTrainShareParams(body: TrainMessageToAgentInput | undefined): Observable<FieldsEmailInput> {
        let url_ = this.baseUrl + "/api/services/app/TrainSerpShare/ResolveTrainShareParams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTrainShareParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTrainShareParams(<any>response_);
                } catch (e) {
                    return <Observable<FieldsEmailInput>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldsEmailInput>><any>_observableThrow(response_);
        }));
    }

    protected processResolveTrainShareParams(response: HttpResponseBase): Observable<FieldsEmailInput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldsEmailInput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FieldsEmailInput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    search(body: TrainShareSerpItemsInput | undefined): Observable<AvailabilityResponseMulticityDTO> {
        let url_ = this.baseUrl + "/api/services/app/TrainSerpShare/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailabilityResponseMulticityDTO>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<AvailabilityResponseMulticityDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailabilityResponseMulticityDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailabilityResponseMulticityDTO>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createCheckoutLink(body: TrainMessageToAgentInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TrainSerpShare/CreateCheckoutLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCheckoutLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCheckoutLink(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCheckoutLink(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class TrainSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getSettings(): Observable<TrainsSettingsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainSettings/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(<any>response_);
                } catch (e) {
                    return <Observable<TrainsSettingsOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TrainsSettingsOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<TrainsSettingsOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainsSettingsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrainsSettingsOutputDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateSettings(body: TrainsSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainSettings/UpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TripServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTripById(id: string | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/GetTripById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTripById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTripById(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTripById(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripStatus (optional)
     * @param tripDateRange_Start (optional)
     * @param tripDateRange_End (optional)
     * @param departureDateRange_Start (optional)
     * @param departureDateRange_End (optional)
     * @param isTripDateRangeEnabled (optional)
     * @param isDepartureDateRangeEnabled (optional)
     * @param tripCode (optional)
     * @param surname (optional)
     * @param name (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAllUsersTrips(tripStatus: number[] | null | undefined, tripDateRange_Start: moment.Moment | null | undefined, tripDateRange_End: moment.Moment | null | undefined, departureDateRange_Start: moment.Moment | null | undefined, departureDateRange_End: moment.Moment | null | undefined, isTripDateRangeEnabled: boolean | undefined, isDepartureDateRangeEnabled: boolean | undefined, tripCode: string | null | undefined, surname: string | null | undefined, name: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTripListDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/GetAllUsersTrips?";
        if (tripStatus !== undefined && tripStatus !== null)
            tripStatus && tripStatus.forEach(item => { url_ += "TripStatus=" + encodeURIComponent("" + item) + "&"; });
        if (tripDateRange_Start !== undefined && tripDateRange_Start !== null)
            url_ += "TripDateRange.Start=" + encodeURIComponent(tripDateRange_Start ? "" + tripDateRange_Start.toJSON() : "") + "&";
        if (tripDateRange_End !== undefined && tripDateRange_End !== null)
            url_ += "TripDateRange.End=" + encodeURIComponent(tripDateRange_End ? "" + tripDateRange_End.toJSON() : "") + "&";
        if (departureDateRange_Start !== undefined && departureDateRange_Start !== null)
            url_ += "DepartureDateRange.Start=" + encodeURIComponent(departureDateRange_Start ? "" + departureDateRange_Start.toJSON() : "") + "&";
        if (departureDateRange_End !== undefined && departureDateRange_End !== null)
            url_ += "DepartureDateRange.End=" + encodeURIComponent(departureDateRange_End ? "" + departureDateRange_End.toJSON() : "") + "&";
        if (isTripDateRangeEnabled === null)
            throw new Error("The parameter 'isTripDateRangeEnabled' cannot be null.");
        else if (isTripDateRangeEnabled !== undefined)
            url_ += "IsTripDateRangeEnabled=" + encodeURIComponent("" + isTripDateRangeEnabled) + "&";
        if (isDepartureDateRangeEnabled === null)
            throw new Error("The parameter 'isDepartureDateRangeEnabled' cannot be null.");
        else if (isDepartureDateRangeEnabled !== undefined)
            url_ += "IsDepartureDateRangeEnabled=" + encodeURIComponent("" + isDepartureDateRangeEnabled) + "&";
        if (tripCode !== undefined && tripCode !== null)
            url_ += "TripCode=" + encodeURIComponent("" + tripCode) + "&";
        if (surname !== undefined && surname !== null)
            url_ += "Surname=" + encodeURIComponent("" + surname) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersTrips(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersTrips(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTripListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTripListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUsersTrips(response: HttpResponseBase): Observable<PagedResultDtoOfTripListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTripListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTripListDto>(<any>null);
    }

    /**
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getTripsForUser(tripsFilter: TripFilterDto, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTripListDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/GetTripsForUser?";
        if (tripsFilter === undefined || tripsFilter === null)
            throw new Error("The parameter 'tripsFilter' must be defined and cannot be null.");
        else
            url_ += "TripsFilter=" + encodeURIComponent("" + tripsFilter) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTripsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTripsForUser(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTripListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTripListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTripsForUser(response: HttpResponseBase): Observable<PagedResultDtoOfTripListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTripListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTripListDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    discardTrip(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trip/DiscardTrip?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiscardTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscardTrip(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDiscardTrip(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTrip(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trip/DeleteTrip?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrip(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTrip(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param query (optional)
     * @return Success
     */
    getLabelAutocomplete(query: string | null | undefined): Observable<LabelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trip/GetLabelAutocomplete?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabelAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabelAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<LabelDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LabelDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLabelAutocomplete(response: HttpResponseBase): Observable<LabelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabelDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LabelDto[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateTraveler(body: UpdateTravelerInputDto | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/UpdateTraveler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTraveler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTraveler(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTraveler(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param tripName (optional)
     * @return Success
     */
    setTripName(tripId: string | null | undefined, tripName: string | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/SetTripName?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        if (tripName !== undefined && tripName !== null)
            url_ += "tripName=" + encodeURIComponent("" + tripName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTripName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTripName(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processSetTripName(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @return Success
     */
    checkTripData(tripId: string | null | undefined): Observable<CheckTripDataOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/CheckTripData?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTripData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTripData(<any>response_);
                } catch (e) {
                    return <Observable<CheckTripDataOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckTripDataOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckTripData(response: HttpResponseBase): Observable<CheckTripDataOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckTripDataOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckTripDataOutputDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @return Success
     */
    getLabels(tripId: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Trip/GetLabels?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabels(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLabels(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<string[]>(<any>null));
    }

    /**
     * @param tripId (optional)
     * @param body (optional)
     * @return Success
     */
    setLabels(tripId: string | null | undefined, body: string[] | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/SetLabels?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetLabels(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processSetLabels(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    crateAssistedTrip(body: CreateTripInput | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/CrateAssistedTrip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCrateAssistedTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCrateAssistedTrip(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processCrateAssistedTrip(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param name (optional)
     * @param hqId (optional)
     * @param cdcId (optional)
     * @param body (optional)
     * @return Success
     */
    initTrip(name: string | null | undefined, hqId: number | null | undefined, cdcId: number | null | undefined, body: UserProfileDto[] | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/InitTrip?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (hqId !== undefined && hqId !== null)
            url_ += "hqId=" + encodeURIComponent("" + hqId) + "&";
        if (cdcId !== undefined && cdcId !== null)
            url_ += "cdcId=" + encodeURIComponent("" + cdcId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitTrip(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processInitTrip(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param body (optional)
     * @return Success
     */
    addFlightItem(tripId: string | null | undefined, body: AirBookRequestDTO | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/AddFlightItem?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFlightItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFlightItem(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddFlightItem(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param structureAvailabilityId (optional)
     * @param optionId (optional)
     * @param hotelAvailabilityId (optional)
     * @return Success
     */
    addHotelItem(tripId: string | null | undefined, availabilityDetailId: string | null | undefined, optionId: string | null | undefined, availabilityId: string | null |undefined = null): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/AddHotelItem?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        if (availabilityDetailId !== undefined && availabilityDetailId !== null)
            url_ += "availabilityDetailId=" + encodeURIComponent("" + availabilityDetailId) + "&";
        if (optionId !== undefined && optionId !== null)
            url_ += "optionId=" + encodeURIComponent("" + optionId) + "&";
        if (availabilityId !== undefined && availabilityId !== null)
            url_ += "availabilityId=" + encodeURIComponent("" + availabilityId) + "&";
    url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddHotelItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddHotelItem(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddHotelItem(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param body (optional)
     * @return Success
     */
    addTrainItem(tripId: string | null | undefined, body: TrainBookRequestBaseDto | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/AddTrainItem?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTrainItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTrainItem(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddTrainItem(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param body (optional)
     * @return Success
     */
    addCarItem(tripId: string | null | undefined, body: CarBookRequestBaseDto | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/AddCarItem?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCarItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCarItem(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddCarItem(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param tripItemId (optional)
     * @return Success
     */
    removeTripItem(tripId: string | null | undefined, tripItemId: string | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/RemoveTripItem?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        if (tripItemId !== undefined && tripItemId !== null)
            url_ += "tripItemId=" + encodeURIComponent("" + tripItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveTripItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveTripItem(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveTripItem(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @return Success
     */
    getItineraryData(tripId: string | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/GetItineraryData?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItineraryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItineraryData(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetItineraryData(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    saveTripSearch(body: SaveTripSearchInput | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/SaveTripSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTripSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTripSearch(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processSaveTripSearch(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param body (optional)
     * @return Success
     */
    authorizeTrip(tripId: string | null | undefined, body: AuthorizationResponseDto | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/AuthorizeTrip?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorizeTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorizeTrip(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processAuthorizeTrip(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @return Success
     */
    switchTripToAgency(tripId: string | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/SwitchTripToAgency?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchTripToAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchTripToAgency(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processSwitchTripToAgency(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @return Success
     */
    getCheckoutData(tripId: string | null | undefined): Observable<BookTripResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/GetCheckoutData?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckoutData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckoutData(<any>response_);
                } catch (e) {
                    return <Observable<BookTripResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BookTripResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCheckoutData(response: HttpResponseBase): Observable<BookTripResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookTripResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookTripResponseDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    approvalRequest(body: ApprovalRequestInputDto | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/ApprovalRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovalRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovalRequest(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processApprovalRequest(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    startApprovalProcessFlow(body: ApprovalRequestInputDto | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/StartApprovalProcessFlow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartApprovalProcessFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartApprovalProcessFlow(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processStartApprovalProcessFlow(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @return Success
     */
    sendMailTripToSupervisor(tripId: string | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/Pdf/SendTripMailToSupervisor?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTripMailToSupervisor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalProcessFlow(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processSendTripMailToSupervisor(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            //result200 = String.fromJS(resultData200);
            return _observableOf("");
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param message (optional)
     * @param reasonId (optional)
     * @param approvalProcessId (optional)
     * @return Success
     */
    approve(tripId: string | null | undefined, message: string | null | undefined, reasonId: string | null | undefined, approvalProcessId: string | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/Approve?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (reasonId !== undefined && reasonId !== null)
            url_ += "reasonId=" + encodeURIComponent("" + reasonId) + "&";
        if (approvalProcessId !== undefined && approvalProcessId !== null)
            url_ += "approvalProcessId=" + encodeURIComponent("" + approvalProcessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param message (optional)
     * @param reasonId (optional)
     * @param approvalProcessId (optional)
     * @return Success
     */
    decline(tripId: string | null | undefined, message: string | null | undefined, reasonId: string | null | undefined, approvalProcessId: string | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/Decline?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (reasonId !== undefined && reasonId !== null)
            url_ += "reasonId=" + encodeURIComponent("" + reasonId) + "&";
        if (approvalProcessId !== undefined && approvalProcessId !== null)
            url_ += "approvalProcessId=" + encodeURIComponent("" + approvalProcessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDecline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecline(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processDecline(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    hold(body: BookTripRequestDto | undefined): Observable<TrainBookResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/Hold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHold(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHold(<any>response_);
                } catch (e) {
                    return <Observable<TrainBookResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TrainBookResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processHold(response: HttpResponseBase): Observable<TrainBookResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainBookResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrainBookResponseDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    book(body: BookTripRequestDto | undefined): Observable<AjaxResponseOfTripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/Book";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBook(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfTripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfTripDto>><any>_observableThrow(response_);
        }));
    }

    protected processBook(response: HttpResponseBase): Observable<AjaxResponseOfTripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfTripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfTripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @return Success
     */
    issue(tripId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trip/Issue?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIssue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIssue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processIssue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @return Success
     */
    confirm(tripId: string | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/Confirm?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }

    /**
     * @param tripId (optional)
     * @param description (optional)
     * @return Success
     */
    addLog(tripId: string | null | undefined, description: string | null | undefined): Observable<LogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trip/AddLog?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLog(<any>response_);
                } catch (e) {
                    return <Observable<LogDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LogDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processAddLog(response: HttpResponseBase): Observable<LogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LogDto[]>(<any>null));
    }

    /**
     * @param tripId (optional)
     * @param body (optional)
     * @return Success
     */
    changeStatus(tripId: string | null | undefined, body: TripStatusDto | undefined): Observable<LogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trip/ChangeStatus?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeStatus(<any>response_);
                } catch (e) {
                    return <Observable<LogDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LogDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<LogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<LogDto[]>(<any>null));
    }

    /**
     * @param tripId (optional)
     * @return Success
     */
    getApprovalProcessFlow(tripId: string | null | undefined): Observable<ApprovalProcessFlowDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/GetApprovalProcessFlow?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalProcessFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalProcessFlow(<any>response_);
                } catch (e) {
                    return <Observable<ApprovalProcessFlowDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApprovalProcessFlowDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetApprovalProcessFlow(response: HttpResponseBase): Observable<ApprovalProcessFlowDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalProcessFlowDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovalProcessFlowDto>(<any>null);
    }

    /**
     * @param flowId (optional)
     * @param processId (optional)
     * @param body (optional)
     * @return Success
     */
    setCostDivisionsCenters(flowId: string | null | undefined, processId: string | null | undefined, body: CostDivisionElementDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Trip/SetCostDivisionsCenters?";
        if (flowId !== undefined && flowId !== null)
            url_ += "flowId=" + encodeURIComponent("" + flowId) + "&";
        if (processId !== undefined && processId !== null)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCostDivisionsCenters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCostDivisionsCenters(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetCostDivisionsCenters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getFieldsConfig(): Observable<FieldConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trip/GetFieldsConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldsConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldsConfig(<any>response_);
                } catch (e) {
                    return <Observable<FieldConfigDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldConfigDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFieldsConfig(response: HttpResponseBase): Observable<FieldConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldConfigDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<FieldConfigDto[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateFieldConfig(body: FieldConfigInputDto | undefined): Observable<FieldConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Trip/CreateOrUpdateFieldConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateFieldConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateFieldConfig(<any>response_);
                } catch (e) {
                    return <Observable<FieldConfigDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldConfigDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateFieldConfig(response: HttpResponseBase): Observable<FieldConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldConfigDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<FieldConfigDto[]>(<any>null));
    }

    /**
     * @param tripId (optional)
     * @param body (optional)
     * @return Success
     */
    setCustomFields(tripId: string | null | undefined, body: CustomFieldDto[] | null | undefined): Observable<TripDto> {
        let url_ = this.baseUrl + "/api/services/app/Trip/SetCustomFields?";
        if (tripId !== undefined && tripId !== null)
            url_ += "tripId=" + encodeURIComponent("" + tripId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCustomFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCustomFields(<any>response_);
                } catch (e) {
                    return <Observable<TripDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TripDto>><any>_observableThrow(response_);
        }));
    }

    protected processSetCustomFields(response: HttpResponseBase): Observable<TripDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TripDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TripDto>(<any>null);
    }
}

@Injectable()
export class TripExternalApprovalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param encriptedLink (optional)
     * @return Success
     */
    tripApprovalOutcome(encriptedLink: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TripExternalApproval/TripApprovalOutcome?";
        if (encriptedLink !== undefined && encriptedLink !== null)
            url_ += "encriptedLink=" + encodeURIComponent("" + encriptedLink) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTripApprovalOutcome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTripApprovalOutcome(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTripApprovalOutcome(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<ThemeSettingsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ThemeSettingsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ThemeSettingsDto[]>(<any>null));
    }

    /**
     * @param themeName (optional)
     * @return Success
     */
    changeThemeWithDefaultValues(themeName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName !== undefined && themeName !== null)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional)
     * @param permissions (optional)
     * @param role (optional)
     * @param onlyLockedUsers (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUsers(filter: string | null | undefined, permissions: string[] | null | undefined, role: number | null | undefined, onlyLockedUsers: boolean | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions !== undefined && permissions !== null)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @param filter (optional)
     * @param permissions (optional)
     * @param role (optional)
     * @param onlyLockedUsers (optional)
     * @param sorting (optional)
     * @return Success
     */
    getUsersToExcel(filter: string | null | undefined, permissions: string[] | null | undefined, role: number | null | undefined, onlyLockedUsers: boolean | undefined, sorting: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions !== undefined && permissions !== null)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserForEdit(id: number | null | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserForEditOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserPermissionsForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    checkIfUserIsAdmin(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/CheckIfUserIsAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfUserIsAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfUserIsAdmin(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIfUserIsAdmin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class UserDelegationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @return Success
     */
    getDelegatedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | null | undefined): Observable<PagedResultDtoOfUserDelegationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetDelegatedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegatedUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserDelegationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserDelegationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDelegatedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserDelegationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDelegationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserDelegationDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    delegateNewUser(body: CreateUserDelegationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/DelegateNewUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateNewUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateNewUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelegateNewUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    removeDelegation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/RemoveDelegation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDelegation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getActiveUserDelegations(): Observable<UserDelegationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetActiveUserDelegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUserDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUserDelegations(<any>response_);
                } catch (e) {
                    return <Observable<UserDelegationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDelegationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveUserDelegations(response: HttpResponseBase): Observable<UserDelegationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDelegationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<UserDelegationDto[]>(<any>null));
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional)
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | null | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLinkedUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLinkedUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLinkedUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfLinkedUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentUserLoginAttempts(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfUserLoginAttemptDto>(<any>null);
    }
}

@Injectable()
export class UserProfilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param uniqueEmailPerAgency (optional)
     * @param body (optional)
     * @return Success
     */
    createOrUpdateUserProfile(uniqueEmailPerAgency: boolean | undefined, body: CreateOrEditUserProfileInputDto | undefined): Observable<UserProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/CreateOrUpdateUserProfile?";
        if (uniqueEmailPerAgency === null)
            throw new Error("The parameter 'uniqueEmailPerAgency' cannot be null.");
        else if (uniqueEmailPerAgency !== undefined)
            url_ += "uniqueEmailPerAgency=" + encodeURIComponent("" + uniqueEmailPerAgency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUserProfile(<any>response_);
                } catch (e) {
                    return <Observable<UserProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateUserProfile(response: HttpResponseBase): Observable<UserProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfileDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteUserProfile(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/DeleteUserProfile?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    getUserProfileAutocomplete(input: string | null | undefined): Observable<UserProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/GetUserProfileAutocomplete?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfileAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfileAutocomplete(<any>response_);
                } catch (e) {
                    return <Observable<UserProfileDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProfileDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfileAutocomplete(response: HttpResponseBase): Observable<UserProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserProfileDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<UserProfileDto[]>(<any>null));
    }

    /**
     * @param keyWord (optional)
     * @param selectedAgenciesId (optional)
     * @param onlyActive (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUserProfiles(keyWord: string | null | undefined, selectedAgenciesId: string[] | null | undefined, onlyActive: boolean | undefined, sorting: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/GetUserProfiles?";
        if (keyWord !== undefined && keyWord !== null)
            url_ += "KeyWord=" + encodeURIComponent("" + keyWord) + "&";
        if (selectedAgenciesId !== undefined && selectedAgenciesId !== null)
            selectedAgenciesId && selectedAgenciesId.forEach(item => { url_ += "SelectedAgenciesId=" + encodeURIComponent("" + item) + "&"; });
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "OnlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfiles(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfiles(response: HttpResponseBase): Observable<PagedResultDtoOfUserProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserProfileDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserProfileById(id: string | null | undefined): Observable<UserProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/GetUserProfileById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfileById(<any>response_);
                } catch (e) {
                    return <Observable<UserProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfileById(response: HttpResponseBase): Observable<UserProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfileDto>(<any>null);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    getUserProfileByUserId(userId: string | null | undefined): Observable<UserProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/GetUserProfileByUserId?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfileByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfileByUserId(<any>response_);
                } catch (e) {
                    return <Observable<UserProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfileByUserId(response: HttpResponseBase): Observable<UserProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfileDto>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getUserProfilesToExcel(filter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/GetUserProfilesToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfilesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfilesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProfilesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param userProfileId (optional)
     * @return Success
     */
    disableProfile(userProfileId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/DisableProfile?";
        if (userProfileId !== undefined && userProfileId !== null)
            url_ += "userProfileId=" + encodeURIComponent("" + userProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableProfile(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDisableProfile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userProfileId (optional)
     * @return Success
     */
    enableProfile(userProfileId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/EnableProfile?";
        if (userProfileId !== undefined && userProfileId !== null)
            url_ += "userProfileId=" + encodeURIComponent("" + userProfileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableProfile(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processEnableProfile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param uniqueEmailPerAgency (optional)
     * @param body (optional)
     * @return Success
     */
    registerUserProfiles(uniqueEmailPerAgency: boolean | undefined, body: CreateUserProfilesInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/RegisterUserProfiles?";
        if (uniqueEmailPerAgency === null)
            throw new Error("The parameter 'uniqueEmailPerAgency' cannot be null.");
        else if (uniqueEmailPerAgency !== undefined)
            url_ += "uniqueEmailPerAgency=" + encodeURIComponent("" + uniqueEmailPerAgency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterUserProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterUserProfiles(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterUserProfiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getFieldsConfig(): Observable<FieldConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/GetFieldsConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldsConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldsConfig(<any>response_);
                } catch (e) {
                    return <Observable<FieldConfigDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldConfigDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFieldsConfig(response: HttpResponseBase): Observable<FieldConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldConfigDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<FieldConfigDto[]>(<any>null));
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateFieldConfig(body: FieldConfigInputDto | undefined): Observable<FieldConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserProfiles/CreateOrUpdateFieldConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateFieldConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateFieldConfig(<any>response_);
                } catch (e) {
                    return <Observable<FieldConfigDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FieldConfigDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateFieldConfig(response: HttpResponseBase): Observable<FieldConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FieldConfigDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<FieldConfigDto[]>(<any>null));
    }
}

@Injectable()
export class ValidatingCarrierServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/Delete?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createValidatingCarrier(body: ValidatingCarrierDto | undefined): Observable<ValidatingCarrierRoot> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/CreateValidatingCarrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateValidatingCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateValidatingCarrier(<any>response_);
                } catch (e) {
                    return <Observable<ValidatingCarrierRoot>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidatingCarrierRoot>><any>_observableThrow(response_);
        }));
    }

    protected processCreateValidatingCarrier(response: HttpResponseBase): Observable<ValidatingCarrierRoot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidatingCarrierRoot.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidatingCarrierRoot>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    filterValidatingCarrier(filter: string | null | undefined): Observable<ValidatingCarrierDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/FilterValidatingCarrier?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterValidatingCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterValidatingCarrier(<any>response_);
                } catch (e) {
                    return <Observable<ValidatingCarrierDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidatingCarrierDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilterValidatingCarrier(response: HttpResponseBase): Observable<ValidatingCarrierDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValidatingCarrierDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return of(<ValidatingCarrierDto[]>(<any>null));
    }

    /**
     * @param filterText (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(filterText: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfValidatingCarrierDto> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/GetAll?";
        if (filterText !== undefined && filterText !== null)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfValidatingCarrierDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfValidatingCarrierDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfValidatingCarrierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfValidatingCarrierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfValidatingCarrierDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @param value (optional)
     * @return Success
     */
    setIsEnabled(id: string | null | undefined, value: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/SetIsEnabled?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIsEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIsEnabled(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetIsEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional)
     * @param value (optional)
     * @return Success
     */
    setIsValidatingCarrier(id: string | null | undefined, value: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/SetIsValidatingCarrier?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIsValidatingCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIsValidatingCarrier(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetIsValidatingCarrier(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional)
     * @param value (optional)
     * @return Success
     */
    setIsTravelFusionCarrier(id: string | null | undefined, value: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/SetIsTravelFusionCarrier?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIsTravelFusionCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIsTravelFusionCarrier(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetIsTravelFusionCarrier(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional)
     * @param value (optional)
     * @return Success
     */
    setIsTravelPortCarrier(id: string | null | undefined, value: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/SetIsTravelPortCarrier?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIsTravelPortCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIsTravelPortCarrier(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetIsTravelPortCarrier(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param filter (optional)
     * @return Success
     */
    getValidatingCarrierToExcel(filter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/GetValidatingCarrierToExcel?";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidatingCarrierToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidatingCarrierToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetValidatingCarrierToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrEditValidatingCarrier(body: CreateOrEditValidatingCarrierInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/CreateOrEditValidatingCarrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditValidatingCarrier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditValidatingCarrier(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditValidatingCarrier(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getForEdit(id: string | null | undefined): Observable<GetValidatingCarrierForView> {
        let url_ = this.baseUrl + "/api/services/app/ValidatingCarrier/GetForEdit?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetValidatingCarrierForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetValidatingCarrierForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetForEdit(response: HttpResponseBase): Observable<GetValidatingCarrierForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetValidatingCarrierForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetValidatingCarrierForView>(<any>null);
    }
}

@Injectable()
export class WebhookEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: string | null | undefined): Observable<WebhookEvent> {
        let url_ = this.baseUrl + "/api/services/app/WebhookEvent/Get?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<WebhookEvent>><any>_observableThrow(e);
                }
            } else
                return <Observable<WebhookEvent>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WebhookEvent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookEvent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebhookEvent>(<any>null);
    }
}

@Injectable()
export class WebhookSendAttemptServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param subscriptionId (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAllSendAttempts(subscriptionId: string | null | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttempts?";
        if (subscriptionId !== undefined && subscriptionId !== null)
            url_ += "SubscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSendAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSendAttempts(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSendAttemptsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSendAttemptsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSendAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllSendAttemptsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSendAttemptsOutput>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getAllSendAttemptsOfWebhookEvent(id: string | null | undefined): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/GetAllSendAttemptsOfWebhookEvent?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSendAttemptsOfWebhookEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSendAttemptsOfWebhookEvent(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSendAttemptsOfWebhookEvent(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>(<any>null);
    }

    /**
     * @param sendAttemptId (optional)
     * @return Success
     */
    resend(sendAttemptId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSendAttempt/Resend?";
        if (sendAttemptId !== undefined && sendAttemptId !== null)
            url_ += "sendAttemptId=" + encodeURIComponent("" + sendAttemptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResend(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class WebhookSubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    publishTestWebhook(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/PublishTestWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishTestWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishTestWebhook(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPublishTestWebhook(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSubscriptions(): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllSubscriptionsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllSubscriptionsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSubscriptions(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGetAllSubscriptionsOutput>(<any>null);
    }

    /**
     * @param subscriptionId (optional)
     * @return Success
     */
    getSubscription(subscriptionId: string | null | undefined): Observable<WebhookSubscription> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetSubscription?";
        if (subscriptionId !== undefined && subscriptionId !== null)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscription(<any>response_);
                } catch (e) {
                    return <Observable<WebhookSubscription>><any>_observableThrow(e);
                }
            } else
                return <Observable<WebhookSubscription>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubscription(response: HttpResponseBase): Observable<WebhookSubscription> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebhookSubscription.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebhookSubscription>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addSubscription(body: WebhookSubscription | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/AddSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSubscription(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateSubscription(body: WebhookSubscription | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscription(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    activateWebhookSubscription(body: ActivateWebhookSubscriptionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/ActivateWebhookSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateWebhookSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateWebhookSubscription(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActivateWebhookSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param webhookName (optional)
     * @return Success
     */
    isSubscribed(webhookName: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/IsSubscribed?";
        if (webhookName !== undefined && webhookName !== null)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSubscribed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSubscribed(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsSubscribed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param webhookName (optional)
     * @return Success
     */
    getAllSubscriptionsIfFeaturesGranted(webhookName: string | null | undefined): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllSubscriptionsIfFeaturesGranted?";
        if (webhookName !== undefined && webhookName !== null)
            url_ += "webhookName=" + encodeURIComponent("" + webhookName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscriptionsIfFeaturesGranted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscriptionsIfFeaturesGranted(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllSubscriptionsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllSubscriptionsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSubscriptionsIfFeaturesGranted(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGetAllSubscriptionsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getAllAvailableWebhooks(): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebhookSubscription/GetAllAvailableWebhooks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableWebhooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableWebhooks(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAvailableWebhooks(response: HttpResponseBase): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGetAllAvailableWebhooksOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGetAllAvailableWebhooksOutput>(<any>null);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(<any>response_);
                } catch (e) {
                    return <Observable<GetLatestWebLogsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLatestWebLogsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestWebLogsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
    userDelegationId!: number;

    constructor(data?: IDelegatedImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDelegationId = _data["userDelegationId"];
        }
    }

    static fromJS(data: any): DelegatedImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDelegationId"] = this.userDelegationId;
        return data;
    }
}

export interface IDelegatedImpersonateInput {
    userDelegationId: number;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class AgencyDto implements IAgencyDto {
    companyName!: string | undefined;
    reference!: string | undefined;
    country!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    address!: string | undefined;
    zipCode!: string | undefined;
    phoneNumber!: string | undefined;
    mobileNumber!: string | undefined;
    fax!: string | undefined;
    vatNumber!: string | undefined;
    cciaa!: string | undefined;
    email!: string | undefined;
    accountingCode!: string | undefined;
    isActive!: boolean;
    logoId!: string | undefined;
    id!: string;

    constructor(data?: IAgencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.reference = _data["reference"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.fax = _data["fax"];
            this.vatNumber = _data["vatNumber"];
            this.cciaa = _data["cciaa"];
            this.email = _data["email"];
            this.accountingCode = _data["accountingCode"];
            this.isActive = _data["isActive"];
            this.logoId = _data["logoId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AgencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["reference"] = this.reference;
        data["country"] = this.country;
        data["city"] = this.city;
        data["state"] = this.state;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["fax"] = this.fax;
        data["vatNumber"] = this.vatNumber;
        data["cciaa"] = this.cciaa;
        data["email"] = this.email;
        data["accountingCode"] = this.accountingCode;
        data["isActive"] = this.isActive;
        data["logoId"] = this.logoId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAgencyDto {
    companyName: string | undefined;
    reference: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    address: string | undefined;
    zipCode: string | undefined;
    phoneNumber: string | undefined;
    mobileNumber: string | undefined;
    fax: string | undefined;
    vatNumber: string | undefined;
    cciaa: string | undefined;
    email: string | undefined;
    accountingCode: string | undefined;
    isActive: boolean;
    logoId: string | undefined;
    id: string;
}

export class GetAgencyForView implements IGetAgencyForView {
    agency!: AgencyDto;

    constructor(data?: IGetAgencyForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] ? AgencyDto.fromJS(_data["agency"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAgencyForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgencyForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency ? this.agency.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAgencyForView {
    agency: AgencyDto;
}

export class PagedResultDtoOfGetAgencyForView implements IPagedResultDtoOfGetAgencyForView {
    totalCount!: number;
    items!: GetAgencyForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAgencyForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAgencyForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAgencyForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAgencyForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAgencyForView {
    totalCount: number;
    items: GetAgencyForView[] | undefined;
}

export class CreateOrEditAgencyDto implements ICreateOrEditAgencyDto {
    companyName!: string;
    reference!: string;
    country!: string;
    city!: string;
    state!: string;
    address!: string;
    zipCode!: string;
    phoneNumber!: string;
    mobileNumber!: string | undefined;
    fax!: string | undefined;
    vatNumber!: string;
    cciaa!: string | undefined;
    email!: string;
    accountingCode!: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: string | undefined;
    externalSBTCode: string | undefined;
    constructor(data?: ICreateOrEditAgencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.reference = _data["reference"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.fax = _data["fax"];
            this.vatNumber = _data["vatNumber"];
            this.cciaa = _data["cciaa"];
            this.email = _data["email"];
            this.accountingCode = _data["accountingCode"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
            this.externalSBTCode = _data["externalSBTCode"];
        }
    }

    static fromJS(data: any): CreateOrEditAgencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAgencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["reference"] = this.reference;
        data["country"] = this.country;
        data["city"] = this.city;
        data["state"] = this.state;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["fax"] = this.fax;
        data["vatNumber"] = this.vatNumber;
        data["cciaa"] = this.cciaa;
        data["email"] = this.email;
        data["accountingCode"] = this.accountingCode;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        data["externalSBTCode"] = this.externalSBTCode;
        return data;
    }
}

export interface ICreateOrEditAgencyDto {
    companyName: string;
    reference: string;
    country: string;
    city: string;
    state: string;
    address: string;
    zipCode: string;
    phoneNumber: string;
    mobileNumber: string | undefined;
    fax: string | undefined;
    vatNumber: string;
    cciaa: string | undefined;
    email: string;
    accountingCode: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string | undefined;
    externalSBTCode: string | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class CreateOrEditAgencyPaymentProfileDto implements ICreateOrEditAgencyPaymentProfileDto {
    id!: string | undefined;
    displayNumber!: string | undefined;
    number!: string | undefined;
    cvv!: string | undefined;
    airlineFilter!: NameValueDto[] | undefined;
    cardHolderName!: string | undefined;
    code!: string | undefined;
    expirationMonth!: string | undefined;
    expirationYear!: string | undefined;
    isEnabled!: boolean;
    priority!: number;
    supplierFilter!: null | Array<string>;
    isEnabledVerificationCodeValidation!: boolean;

    constructor(data?: ICreateOrEditAgencyPaymentProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayNumber = _data["displayNumber"];
            this.number = _data["number"];
            this.cvv = _data["cvv"];
            if (Array.isArray(_data["airlineFilter"])) {
                this.airlineFilter = [] as any;
                for (let item of _data["airlineFilter"])
                    this.airlineFilter!.push(NameValueDto.fromJS(item));
            }
            this.cardHolderName = _data["cardHolderName"];
            this.code = _data["code"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            this.isEnabled = _data["isEnabled"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["supplierFilter"])) {
                this.supplierFilter = [] as any;
                for (let item of _data["supplierFilter"])
                    this.supplierFilter!.push(item);
            }
            this.isEnabledVerificationCodeValidation = _data["isEnabledVerificationCodeValidation"];
        }
    }

    static fromJS(data: any): CreateOrEditAgencyPaymentProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAgencyPaymentProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayNumber"] = this.displayNumber;
        data["number"] = this.number;
        data["cvv"] = this.cvv;
        if (Array.isArray(this.airlineFilter)) {
            data["airlineFilter"] = [];
            for (let item of this.airlineFilter)
                data["airlineFilter"].push(item.toJSON());
        }
        data["cardHolderName"] = this.cardHolderName;
        data["code"] = this.code;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["isEnabled"] = this.isEnabled;
        data["priority"] = this.priority;
        if (Array.isArray(this.supplierFilter)) {
            data["supplierFilter"] = [];
            for (let item of this.supplierFilter)
                data["supplierFilter"].push(item);
        }
        data["isEnabledVerificationCodeValidation"] = this.isEnabledVerificationCodeValidation;
        return data;
    }
}

export interface ICreateOrEditAgencyPaymentProfileDto {
    id: string | undefined;
    displayNumber: string | undefined;
    number: string | undefined;
    cvv: string | undefined;
    airlineFilter: NameValueDto[] | undefined;
    cardHolderName: string | undefined;
    code: string | undefined;
    expirationMonth: string | undefined;
    expirationYear: string | undefined;
    isEnabled: boolean;
    priority: number;
    supplierFilter: null | Array<string>;
    isEnabledVerificationCodeValidation: boolean;
}

export class GetAgencyForEditOutput implements IGetAgencyForEditOutput {
    agency!: CreateOrEditAgencyDto;
    assignedUsers!: NameValueDto[];
    paymentProfiles!: CreateOrEditAgencyPaymentProfileDto[];

    constructor(data?: IGetAgencyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agency = new CreateOrEditAgencyDto();
            this.assignedUsers = [];
            this.paymentProfiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] ? CreateOrEditAgencyDto.fromJS(_data["agency"]) : new CreateOrEditAgencyDto();
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["paymentProfiles"])) {
                this.paymentProfiles = [] as any;
                for (let item of _data["paymentProfiles"])
                    this.paymentProfiles!.push(CreateOrEditAgencyPaymentProfileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAgencyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgencyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency ? this.agency.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentProfiles)) {
            data["paymentProfiles"] = [];
            for (let item of this.paymentProfiles)
                data["paymentProfiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAgencyForEditOutput {
    agency: CreateOrEditAgencyDto;
    assignedUsers: NameValueDto[];
    paymentProfiles: CreateOrEditAgencyPaymentProfileDto[];
}

export class CreateOrEditAgencyInputDto implements ICreateOrEditAgencyInputDto {
    agency!: CreateOrEditAgencyDto;
    assignedUsers!: number[] | undefined;
    paymentProfiles!: CreateOrEditAgencyPaymentProfileDto[] | undefined;

    constructor(data?: ICreateOrEditAgencyInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agency = _data["agency"] ? CreateOrEditAgencyDto.fromJS(_data["agency"]) : <any>undefined;
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers!.push(item);
            }
            if (Array.isArray(_data["paymentProfiles"])) {
                this.paymentProfiles = [] as any;
                for (let item of _data["paymentProfiles"])
                    this.paymentProfiles!.push(CreateOrEditAgencyPaymentProfileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditAgencyInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAgencyInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agency"] = this.agency ? this.agency.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item);
        }
        if (Array.isArray(this.paymentProfiles)) {
            data["paymentProfiles"] = [];
            for (let item of this.paymentProfiles)
                data["paymentProfiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrEditAgencyInputDto {
    agency: CreateOrEditAgencyDto;
    assignedUsers: number[] | undefined;
    paymentProfiles: CreateOrEditAgencyPaymentProfileDto[] | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
}

export enum ReservationTypeDto {
    Undefined = 0,
    Hotel = 10,
    Flight = 20,
    Train = 30,
    Car = 40,
    Carnet = 50
}

export enum ReservationStatusDto {
    Created = 0,
    Booked = 10,
    Pending = 20,
    Confirmed = 30,
    Deleted = 40,
    Error = 50,
    Queued = 60,
}

export enum PaymentStatusDto {
    Undefined = 0,
    Created = 1,
    Processing = 5,
    Cancelled = 10,
    Failed = 20,
    Successful = 30,
}

export enum ReservationAssistedTicketTypeDto {
    Undefined = 0,
    Hotel = 10,
    Flight = 20,
    Train = 30,
    Car = 40,
}

export class ReservationListDto implements IReservationListDto {
    id!: string | undefined;
    reservationCode!: string | undefined;
    provider!: string | undefined;
    providerReference!: string | undefined;
    airlineReference!: string | undefined;
    validatingCarrierCode!: string | undefined;
    validatingCarrierDisplayName!: string | undefined;
    username!: string | undefined;
    buyer!: string | undefined;
    reference!: string | undefined;
    pax!: string[] | undefined;
    reservationType!: ReservationTypeDto;
    reservationStatus!: ReservationStatusDto;
    paymentStatus!: PaymentStatusDto;
    reservationDate!: moment.Moment;
    travelDate!: moment.Moment | undefined;
    timeLimit!: moment.Moment | undefined;
    product!: string | undefined;
    destination!: string | undefined;
    totalPax!: number;
    totalDue!: number;
    agencyId!: string | undefined;
    agencyName!: string | undefined;
    itinerarySegmentsCount!: number;
    totalSegments!: number;
    adultsPaxCount!: number;
    childrenPaxCount!: number;
    infantPaxCount!: number;
    iata!: boolean;

    constructor(data?: IReservationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reservationCode = _data["reservationCode"];
            this.provider = _data["provider"];
            this.providerReference = _data["providerReference"];
            this.airlineReference = _data["airlineReference"];
            this.validatingCarrierCode = _data["validatingCarrierCode"];
            this.validatingCarrierDisplayName = _data["validatingCarrierDisplayName"];
            this.username = _data["username"];
            this.buyer = _data["buyer"];
            this.reference = _data["reference"];
            if (Array.isArray(_data["pax"])) {
                this.pax = [] as any;
                for (let item of _data["pax"])
                    this.pax!.push(item);
            }
            this.reservationType = _data["reservationType"];
            this.reservationStatus = _data["reservationStatus"];
            this.paymentStatus = _data["paymentStatus"];
            this.reservationDate = _data["reservationDate"] ? moment(_data["reservationDate"].toString()) : <any>undefined;
            this.travelDate = _data["travelDate"] ? moment(_data["travelDate"].toString()) : <any>undefined;
            this.timeLimit = _data["timeLimit"] ? moment(_data["timeLimit"].toString()) : <any>undefined;
            this.product = _data["product"];
            this.destination = _data["destination"];
            this.totalPax = _data["totalPax"];
            this.totalDue = _data["totalDue"];
            this.agencyId = _data["agencyId"];
            this.agencyName = _data["agencyName"];
            this.itinerarySegmentsCount = _data["itinerarySegmentsCount"];
            this.totalSegments = _data["totalSegments"];
            this.adultsPaxCount = _data["adultsPaxCount"];
            this.childrenPaxCount = _data["childrenPaxCount"];
            this.infantPaxCount = _data["infantPaxCount"];
            this.iata = _data["iata"];
        }
    }

    static fromJS(data: any): ReservationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reservationCode"] = this.reservationCode;
        data["provider"] = this.provider;
        data["providerReference"] = this.providerReference;
        data["airlineReference"] = this.airlineReference;
        data["validatingCarrierCode"] = this.validatingCarrierCode;
        data["validatingCarrierDisplayName"] = this.validatingCarrierDisplayName;
        data["username"] = this.username;
        data["buyer"] = this.buyer;
        data["reference"] = this.reference;
        if (Array.isArray(this.pax)) {
            data["pax"] = [];
            for (let item of this.pax)
                data["pax"].push(item);
        }
        data["reservationType"] = this.reservationType;
        data["reservationStatus"] = this.reservationStatus;
        data["paymentStatus"] = this.paymentStatus;
        data["reservationDate"] = this.reservationDate ? this.reservationDate.toISOString() : <any>undefined;
        data["travelDate"] = this.travelDate ? this.travelDate.toISOString() : <any>undefined;
        data["timeLimit"] = this.timeLimit ? this.timeLimit.toISOString() : <any>undefined;
        data["product"] = this.product;
        data["destination"] = this.destination;
        data["totalPax"] = this.totalPax;
        data["totalDue"] = this.totalDue;
        data["agencyId"] = this.agencyId;
        data["agencyName"] = this.agencyName;
        data["itinerarySegmentsCount"] = this.itinerarySegmentsCount;
        data["totalSegments"] = this.totalSegments;
        data["adultsPaxCount"] = this.adultsPaxCount;
        data["childrenPaxCount"] = this.childrenPaxCount;
        data["infantPaxCount"] = this.infantPaxCount;
        data["iata"] = this.iata;
        return data;
    }
}

export interface IReservationListDto {
    id: string | undefined;
    reservationCode: string | undefined;
    provider: string | undefined;
    providerReference: string | undefined;
    airlineReference: string | undefined;
    validatingCarrierCode: string | undefined;
    validatingCarrierDisplayName: string | undefined;
    username: string | undefined;
    buyer: string | undefined;
    reference: string | undefined;
    pax: string[] | undefined;
    reservationType: ReservationTypeDto;
    reservationStatus: ReservationStatusDto;
    paymentStatus: PaymentStatusDto;
    reservationDate: moment.Moment;
    travelDate: moment.Moment | undefined;
    timeLimit: moment.Moment | undefined;
    product: string | undefined;
    destination: string | undefined;
    totalPax: number;
    totalDue: number;
    agencyId: string | undefined;
    agencyName: string | undefined;
    itinerarySegmentsCount: number;
    totalSegments: number;
    adultsPaxCount: number;
    childrenPaxCount: number;
    infantPaxCount: number;
    iata: boolean;
}

export enum FeeProductType {
    Hotel = 0,
    Flight = 1,
    Car = 2,
    Train = 3,
    Undefined = 4,
}

export enum FeeApplicationType {
    Markup = 0,
    Fee = 1,
}

export enum FeeValueType {
    Fixed = 0,
    Percentage = 1,
}

export class FlightFeeValueDto implements IFlightFeeValueDto {
    domesticValue!: number;
    domesticValueType!: FeeValueType;
    internationalValue!: number;
    internationalValueType!: FeeValueType;
    intercontinentalValue!: number;
    intercontinentalValueType!: FeeValueType;

    constructor(data?: IFlightFeeValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domesticValue = _data["domesticValue"];
            this.domesticValueType = _data["domesticValueType"];
            this.internationalValue = _data["internationalValue"];
            this.internationalValueType = _data["internationalValueType"];
            this.intercontinentalValue = _data["intercontinentalValue"];
            this.intercontinentalValueType = _data["intercontinentalValueType"];
        }
    }

    static fromJS(data: any): FlightFeeValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFeeValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domesticValue"] = this.domesticValue;
        data["domesticValueType"] = this.domesticValueType;
        data["internationalValue"] = this.internationalValue;
        data["internationalValueType"] = this.internationalValueType;
        data["intercontinentalValue"] = this.intercontinentalValue;
        data["intercontinentalValueType"] = this.intercontinentalValueType;
        return data;
    }
}

export interface IFlightFeeValueDto {
    domesticValue: number;
    domesticValueType: FeeValueType;
    internationalValue: number;
    internationalValueType: FeeValueType;
    intercontinentalValue: number;
    intercontinentalValueType: FeeValueType;
}

export enum FeeType {
    Product = 0,
    Agency = 1,
    Payment = 2,
}

export class StructureFeeFilterDto implements IStructureFeeFilterDto {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IStructureFeeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StructureFeeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureFeeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IStructureFeeFilterDto {
    id: string | undefined;
    name: string | undefined;
}

export class CityFeeFilterDto implements ICityFeeFilterDto {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: ICityFeeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CityFeeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityFeeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICityFeeFilterDto {
    id: string | undefined;
    name: string | undefined;
}

export class CountryFeeFilterDto implements ICountryFeeFilterDto {
    id!: string | undefined;
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: ICountryFeeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryFeeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryFeeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ICountryFeeFilterDto {
    id: string | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class HotelFeeFilterDto implements IHotelFeeFilterDto {
    structure!: StructureFeeFilterDto;
    city!: CityFeeFilterDto;
    country!: CountryFeeFilterDto;
    category!: string | undefined;

    constructor(data?: IHotelFeeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structure = _data["structure"] ? StructureFeeFilterDto.fromJS(_data["structure"]) : <any>undefined;
            this.city = _data["city"] ? CityFeeFilterDto.fromJS(_data["city"]) : <any>undefined;
            this.country = _data["country"] ? CountryFeeFilterDto.fromJS(_data["country"]) : <any>undefined;
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): HotelFeeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelFeeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structure"] = this.structure ? this.structure.toJSON() : <any>undefined;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["category"] = this.category;
        return data;
    }
}

export interface IHotelFeeFilterDto {
    structure: StructureFeeFilterDto;
    city: CityFeeFilterDto;
    country: CountryFeeFilterDto;
    category: string | undefined;
}

export class AirportFeeFilterDto implements IAirportFeeFilterDto {
    airportCode!: string | undefined;
    airportName!: string | undefined;

    constructor(data?: IAirportFeeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airportCode = _data["airportCode"];
            this.airportName = _data["airportName"];
        }
    }

    static fromJS(data: any): AirportFeeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AirportFeeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportCode"] = this.airportCode;
        data["airportName"] = this.airportName;
        return data;
    }
}

export interface IAirportFeeFilterDto {
    airportCode: string | undefined;
    airportName: string | undefined;
}

export class AirlineFeeFilterDto implements IAirlineFeeFilterDto {
    id!: string | undefined;
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IAirlineFeeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AirlineFeeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineFeeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IAirlineFeeFilterDto {
    id: string | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class FareFeeFilterDto implements IFareFeeFilterDto {
    public!: boolean;
    private!: boolean;
    negotiated!: boolean;

    constructor(data?: IFareFeeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.public = _data["public"];
            this.private = _data["private"];
            this.negotiated = _data["negotiated"];
        }
    }

    static fromJS(data: any): FareFeeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FareFeeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["public"] = this.public;
        data["private"] = this.private;
        data["negotiated"] = this.negotiated;
        return data;
    }
}

export interface IFareFeeFilterDto {
    public: boolean;
    private: boolean;
    negotiated: boolean;
}

export class FlightFeeFilterDto implements IFlightFeeFilterDto {
    originAirport!: AirportFeeFilterDto;
    destinationAirport!: AirportFeeFilterDto;
    airline!: AirlineFeeFilterDto;
    destinationCountry!: CountryFeeFilterDto;
    fare!: FareFeeFilterDto;

    constructor(data?: IFlightFeeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originAirport = _data["originAirport"] ? AirportFeeFilterDto.fromJS(_data["originAirport"]) : <any>undefined;
            this.destinationAirport = _data["destinationAirport"] ? AirportFeeFilterDto.fromJS(_data["destinationAirport"]) : <any>undefined;
            this.airline = _data["airline"] ? AirlineFeeFilterDto.fromJS(_data["airline"]) : <any>undefined;
            this.destinationCountry = _data["destinationCountry"] ? CountryFeeFilterDto.fromJS(_data["destinationCountry"]) : <any>undefined;
            this.fare = _data["fare"] ? FareFeeFilterDto.fromJS(_data["fare"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlightFeeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFeeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originAirport"] = this.originAirport ? this.originAirport.toJSON() : <any>undefined;
        data["destinationAirport"] = this.destinationAirport ? this.destinationAirport.toJSON() : <any>undefined;
        data["airline"] = this.airline ? this.airline.toJSON() : <any>undefined;
        data["destinationCountry"] = this.destinationCountry ? this.destinationCountry.toJSON() : <any>undefined;
        data["fare"] = this.fare ? this.fare.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlightFeeFilterDto {
    originAirport: AirportFeeFilterDto;
    destinationAirport: AirportFeeFilterDto;
    airline: AirlineFeeFilterDto;
    destinationCountry: CountryFeeFilterDto;
    fare: FareFeeFilterDto;
}

export class AgencyFeeDto implements IAgencyFeeDto {
    id!: string | undefined;
    enabled!: boolean;
    productFeeType!: FeeProductType;
    applicationType!: FeeApplicationType;
    agencyFilterId!: string | undefined;
    agencyFilterName!: string | undefined;
    supplierFilterId!: string | undefined;
    supplierFilterName!: string | undefined;
    name!: string | undefined;
    value!: number;
    valueType!: FeeValueType;
    flightFeeValues!: FlightFeeValueDto;
    feeType!: FeeType;
    description!: string | undefined;
    validFrom!: moment.Moment | undefined;
    validTo!: moment.Moment | undefined;
    hotelFeeFilter!: HotelFeeFilterDto;
    flightFeeFilter!: FlightFeeFilterDto;

    constructor(data?: IAgencyFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enabled = _data["enabled"];
            this.productFeeType = _data["productFeeType"];
            this.applicationType = _data["applicationType"];
            this.agencyFilterId = _data["agencyFilterId"];
            this.agencyFilterName = _data["agencyFilterName"];
            this.supplierFilterId = _data["supplierFilterId"];
            this.supplierFilterName = _data["supplierFilterName"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
            this.flightFeeValues = _data["flightFeeValues"] ? FlightFeeValueDto.fromJS(_data["flightFeeValues"]) : <any>undefined;
            this.feeType = _data["feeType"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : <any>undefined;
            this.hotelFeeFilter = _data["hotelFeeFilter"] ? HotelFeeFilterDto.fromJS(_data["hotelFeeFilter"]) : <any>undefined;
            this.flightFeeFilter = _data["flightFeeFilter"] ? FlightFeeFilterDto.fromJS(_data["flightFeeFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AgencyFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enabled"] = this.enabled;
        data["productFeeType"] = this.productFeeType;
        data["applicationType"] = this.applicationType;
        data["agencyFilterId"] = this.agencyFilterId;
        data["agencyFilterName"] = this.agencyFilterName;
        data["supplierFilterId"] = this.supplierFilterId;
        data["supplierFilterName"] = this.supplierFilterName;
        data["name"] = this.name;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["flightFeeValues"] = this.flightFeeValues ? this.flightFeeValues.toJSON() : <any>undefined;
        data["feeType"] = this.feeType;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["hotelFeeFilter"] = this.hotelFeeFilter ? this.hotelFeeFilter.toJSON() : <any>undefined;
        data["flightFeeFilter"] = this.flightFeeFilter ? this.flightFeeFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAgencyFeeDto {
    id: string | undefined;
    enabled: boolean;
    productFeeType: FeeProductType;
    applicationType: FeeApplicationType;
    agencyFilterId: string | undefined;
    agencyFilterName: string | undefined;
    supplierFilterId: string | undefined;
    supplierFilterName: string | undefined;
    name: string | undefined;
    value: number;
    valueType: FeeValueType;
    flightFeeValues: FlightFeeValueDto;
    feeType: FeeType;
    description: string | undefined;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    hotelFeeFilter: HotelFeeFilterDto;
    flightFeeFilter: FlightFeeFilterDto;
}

export class FlightFeeValue implements IFlightFeeValue {
    domesticValue!: number;
    domesticValueType!: FeeValueType;
    internationalValue!: number;
    internationalValueType!: FeeValueType;
    intercontinentalValue!: number;
    intercontinentalValueType!: FeeValueType;

    constructor(data?: IFlightFeeValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domesticValue = _data["domesticValue"];
            this.domesticValueType = _data["domesticValueType"];
            this.internationalValue = _data["internationalValue"];
            this.internationalValueType = _data["internationalValueType"];
            this.intercontinentalValue = _data["intercontinentalValue"];
            this.intercontinentalValueType = _data["intercontinentalValueType"];
        }
    }

    static fromJS(data: any): FlightFeeValue {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFeeValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domesticValue"] = this.domesticValue;
        data["domesticValueType"] = this.domesticValueType;
        data["internationalValue"] = this.internationalValue;
        data["internationalValueType"] = this.internationalValueType;
        data["intercontinentalValue"] = this.intercontinentalValue;
        data["intercontinentalValueType"] = this.intercontinentalValueType;
        return data;
    }
}

export interface IFlightFeeValue {
    domesticValue: number;
    domesticValueType: FeeValueType;
    internationalValue: number;
    internationalValueType: FeeValueType;
    intercontinentalValue: number;
    intercontinentalValueType: FeeValueType;
}

export class StructureFeeFilter implements IStructureFeeFilter {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IStructureFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StructureFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new StructureFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IStructureFeeFilter {
    id: string | undefined;
    name: string | undefined;
}

export class CityFeeFilter implements ICityFeeFilter {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: ICityFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CityFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CityFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICityFeeFilter {
    id: string | undefined;
    name: string | undefined;
}

export class CountryFeeFilter implements ICountryFeeFilter {
    id!: string | undefined;
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: ICountryFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CountryFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ICountryFeeFilter {
    id: string | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class HotelFeeFilter implements IHotelFeeFilter {
    structure!: StructureFeeFilter;
    city!: CityFeeFilter;
    country!: CountryFeeFilter;
    category!: string | undefined;

    constructor(data?: IHotelFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structure = _data["structure"] ? StructureFeeFilter.fromJS(_data["structure"]) : <any>undefined;
            this.city = _data["city"] ? CityFeeFilter.fromJS(_data["city"]) : <any>undefined;
            this.country = _data["country"] ? CountryFeeFilter.fromJS(_data["country"]) : <any>undefined;
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): HotelFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new HotelFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structure"] = this.structure ? this.structure.toJSON() : <any>undefined;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["category"] = this.category;
        return data;
    }
}

export interface IHotelFeeFilter {
    structure: StructureFeeFilter;
    city: CityFeeFilter;
    country: CountryFeeFilter;
    category: string | undefined;
}

export class AirportFeeFilter implements IAirportFeeFilter {
    airportCode!: string | undefined;
    airportName!: string | undefined;

    constructor(data?: IAirportFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airportCode = _data["airportCode"];
            this.airportName = _data["airportName"];
        }
    }

    static fromJS(data: any): AirportFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AirportFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportCode"] = this.airportCode;
        data["airportName"] = this.airportName;
        return data;
    }
}

export interface IAirportFeeFilter {
    airportCode: string | undefined;
    airportName: string | undefined;
}

export class AirlineFeeFilter implements IAirlineFeeFilter {
    id!: string | undefined;
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IAirlineFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AirlineFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IAirlineFeeFilter {
    id: string | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class FareFeeFilter implements IFareFeeFilter {
    public!: boolean;
    private!: boolean;
    negotiated!: boolean;

    constructor(data?: IFareFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.public = _data["public"];
            this.private = _data["private"];
            this.negotiated = _data["negotiated"];
        }
    }

    static fromJS(data: any): FareFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new FareFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["public"] = this.public;
        data["private"] = this.private;
        data["negotiated"] = this.negotiated;
        return data;
    }
}

export interface IFareFeeFilter {
    public: boolean;
    private: boolean;
    negotiated: boolean;
}

export class FlightFeeFilter implements IFlightFeeFilter {
    originAirport!: AirportFeeFilter;
    destinationAirport!: AirportFeeFilter;
    airline!: AirlineFeeFilter;
    destinationCountry!: CountryFeeFilter;
    fare!: FareFeeFilter;

    constructor(data?: IFlightFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originAirport = _data["originAirport"] ? AirportFeeFilter.fromJS(_data["originAirport"]) : <any>undefined;
            this.destinationAirport = _data["destinationAirport"] ? AirportFeeFilter.fromJS(_data["destinationAirport"]) : <any>undefined;
            this.airline = _data["airline"] ? AirlineFeeFilter.fromJS(_data["airline"]) : <any>undefined;
            this.destinationCountry = _data["destinationCountry"] ? CountryFeeFilter.fromJS(_data["destinationCountry"]) : <any>undefined;
            this.fare = _data["fare"] ? FareFeeFilter.fromJS(_data["fare"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlightFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new FlightFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originAirport"] = this.originAirport ? this.originAirport.toJSON() : <any>undefined;
        data["destinationAirport"] = this.destinationAirport ? this.destinationAirport.toJSON() : <any>undefined;
        data["airline"] = this.airline ? this.airline.toJSON() : <any>undefined;
        data["destinationCountry"] = this.destinationCountry ? this.destinationCountry.toJSON() : <any>undefined;
        data["fare"] = this.fare ? this.fare.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlightFeeFilter {
    originAirport: AirportFeeFilter;
    destinationAirport: AirportFeeFilter;
    airline: AirlineFeeFilter;
    destinationCountry: CountryFeeFilter;
    fare: FareFeeFilter;
}

export class RailwayCompanyFeeFilter implements IRailwayCompanyFeeFilter {
    id!: string | undefined;
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IRailwayCompanyFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RailwayCompanyFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RailwayCompanyFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IRailwayCompanyFeeFilter {
    id: string | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class TrainFeeFilter implements ITrainFeeFilter {
    railwayCompany!: RailwayCompanyFeeFilter;

    constructor(data?: ITrainFeeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.railwayCompany = _data["railwayCompany"] ? RailwayCompanyFeeFilter.fromJS(_data["railwayCompany"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrainFeeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TrainFeeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["railwayCompany"] = this.railwayCompany ? this.railwayCompany.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrainFeeFilter {
    railwayCompany: RailwayCompanyFeeFilter;
}

export class AgencyFeeRoot implements IAgencyFeeRoot {
    agencyId!: string | undefined;
    agencyName!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    value!: number;
    valueType!: FeeValueType;
    feeType!: FeeType;
    productType!: FeeProductType;
    applicationType!: FeeApplicationType;
    flightFeeValues!: FlightFeeValue;
    enabled!: boolean;
    validFrom!: moment.Moment | undefined;
    validTo!: moment.Moment | undefined;
    hotelFeeFilter!: HotelFeeFilter;
    flightFeeFilter!: FlightFeeFilter;
    trainFeeFilter!: TrainFeeFilter;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: IAgencyFeeRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyId = _data["agencyId"];
            this.agencyName = _data["agencyName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
            this.feeType = _data["feeType"];
            this.productType = _data["productType"];
            this.applicationType = _data["applicationType"];
            this.flightFeeValues = _data["flightFeeValues"] ? FlightFeeValue.fromJS(_data["flightFeeValues"]) : <any>undefined;
            this.enabled = _data["enabled"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : <any>undefined;
            this.hotelFeeFilter = _data["hotelFeeFilter"] ? HotelFeeFilter.fromJS(_data["hotelFeeFilter"]) : <any>undefined;
            this.flightFeeFilter = _data["flightFeeFilter"] ? FlightFeeFilter.fromJS(_data["flightFeeFilter"]) : <any>undefined;
            this.trainFeeFilter = _data["trainFeeFilter"] ? TrainFeeFilter.fromJS(_data["trainFeeFilter"]) : <any>undefined;
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AgencyFeeRoot {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyFeeRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId;
        data["agencyName"] = this.agencyName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["feeType"] = this.feeType;
        data["productType"] = this.productType;
        data["applicationType"] = this.applicationType;
        data["flightFeeValues"] = this.flightFeeValues ? this.flightFeeValues.toJSON() : <any>undefined;
        data["enabled"] = this.enabled;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["hotelFeeFilter"] = this.hotelFeeFilter ? this.hotelFeeFilter.toJSON() : <any>undefined;
        data["flightFeeFilter"] = this.flightFeeFilter ? this.flightFeeFilter.toJSON() : <any>undefined;
        data["trainFeeFilter"] = this.trainFeeFilter ? this.trainFeeFilter.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAgencyFeeRoot {
    agencyId: string | undefined;
    agencyName: string | undefined;
    name: string | undefined;
    description: string | undefined;
    value: number;
    valueType: FeeValueType;
    feeType: FeeType;
    productType: FeeProductType;
    applicationType: FeeApplicationType;
    flightFeeValues: FlightFeeValue;
    enabled: boolean;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    hotelFeeFilter: HotelFeeFilter;
    flightFeeFilter: FlightFeeFilter;
    trainFeeFilter: TrainFeeFilter;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class FeeListDto implements IFeeListDto {
    id!: string | undefined;
    enabled!: boolean;
    productFeeType!: FeeProductType;
    name!: string | undefined;
    validFrom!: moment.Moment | undefined;
    validTo!: moment.Moment | undefined;
    value!: number;
    valueType!: FeeValueType;
    agencyFilterId!: string | undefined;
    agencyFilterName!: string | undefined;
    supplierFilterId!: string | undefined;
    supplierFilterName!: string | undefined;

    constructor(data?: IFeeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enabled = _data["enabled"];
            this.productFeeType = _data["productFeeType"];
            this.name = _data["name"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.valueType = _data["valueType"];
            this.agencyFilterId = _data["agencyFilterId"];
            this.agencyFilterName = _data["agencyFilterName"];
            this.supplierFilterId = _data["supplierFilterId"];
            this.supplierFilterName = _data["supplierFilterName"];
        }
    }

    static fromJS(data: any): FeeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enabled"] = this.enabled;
        data["productFeeType"] = this.productFeeType;
        data["name"] = this.name;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["agencyFilterId"] = this.agencyFilterId;
        data["agencyFilterName"] = this.agencyFilterName;
        data["supplierFilterId"] = this.supplierFilterId;
        data["supplierFilterName"] = this.supplierFilterName;
        return data;
    }
}

export interface IFeeListDto {
    id: string | undefined;
    enabled: boolean;
    productFeeType: FeeProductType;
    name: string | undefined;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    value: number;
    valueType: FeeValueType;
    agencyFilterId: string | undefined;
    agencyFilterName: string | undefined;
    supplierFilterId: string | undefined;
    supplierFilterName: string | undefined;
}

export class PagedResultDtoOfFeeListDto implements IPagedResultDtoOfFeeListDto {
    totalCount!: number;
    items!: FeeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFeeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFeeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFeeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfFeeListDto {
    totalCount: number;
    items: FeeListDto[] | undefined;
}

export class GetCountDaySalesOutput implements IGetCountDaySalesOutput {
    reservationDate!: moment.Moment;
    salesNumber!: number;
    status!: number;

    constructor(data?: IGetCountDaySalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationDate = _data["reservationDate"] ? moment(_data["reservationDate"].toString()) : <any>undefined;
            this.salesNumber = _data["salesNumber"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetCountDaySalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountDaySalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationDate"] = this.reservationDate ? this.reservationDate.toISOString() : <any>undefined;
        data["salesNumber"] = this.salesNumber;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetCountDaySalesOutput {
    reservationDate: moment.Moment;
    salesNumber: number;
    status: number;
}

export enum SalesSummaryDatePeriod {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number;
    profit!: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.sales = _data["sales"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number;
    profit: number;
}

export class SalesSummaryOutput implements ISalesSummaryOutput {
    data!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    growth!: number;

    constructor(data?: ISalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.growth = _data["growth"];
        }
    }

    static fromJS(data: any): SalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["growth"] = this.growth;
        return data;
    }
}

export interface ISalesSummaryOutput {
    data: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    growth: number;
}

export class Aircraft implements IAircraft {
    icao!: string | undefined;
    iata!: string | undefined;
    description!: string | undefined;
    id!: string | undefined;
    ts!: moment.Moment;

    constructor(data?: IAircraft) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icao = _data["icao"];
            this.iata = _data["iata"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Aircraft {
        data = typeof data === 'object' ? data : {};
        let result = new Aircraft();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icao"] = this.icao;
        data["iata"] = this.iata;
        data["description"] = this.description;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAircraft {
    icao: string | undefined;
    iata: string | undefined;
    description: string | undefined;
    id: string | undefined;
    ts: moment.Moment;
}

export class PagedResultDtoOfAircraft implements IPagedResultDtoOfAircraft {
    totalCount!: number;
    items!: Aircraft[] | undefined;

    constructor(data?: IPagedResultDtoOfAircraft) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Aircraft.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAircraft {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAircraft();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAircraft {
    totalCount: number;
    items: Aircraft[] | undefined;
}

export class AirlineDTO implements IAirlineDTO {
    airlineCode!: string | undefined;
    airlineName!: string | undefined;
    alternativeBusinessName!: string | undefined;

    constructor(data?: IAirlineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airlineCode = _data["airlineCode"];
            this.airlineName = _data["airlineName"];
            this.alternativeBusinessName = _data["alternativeBusinessName"];
        }
    }

    static fromJS(data: any): AirlineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineCode"] = this.airlineCode;
        data["airlineName"] = this.airlineName;
        data["alternativeBusinessName"] = this.alternativeBusinessName;
        return data;
    }
}

export interface IAirlineDTO {
    airlineCode: string | undefined;
    airlineName: string | undefined;
    alternativeBusinessName: string | undefined;
}

export class GetUpdateAirlineRoutesInput implements IGetUpdateAirlineRoutesInput {
    airlineIdentifiers!: string[] | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetUpdateAirlineRoutesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["airlineIdentifiers"])) {
                this.airlineIdentifiers = [] as any;
                for (let item of _data["airlineIdentifiers"])
                    this.airlineIdentifiers!.push(item);
            }
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetUpdateAirlineRoutesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUpdateAirlineRoutesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.airlineIdentifiers)) {
            data["airlineIdentifiers"] = [];
            for (let item of this.airlineIdentifiers)
                data["airlineIdentifiers"].push(item);
        }
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetUpdateAirlineRoutesInput {
    airlineIdentifiers: string[] | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class AirlineRouteDto implements IAirlineRouteDto {
    airlineIdentifier!: string | undefined;
    routes!: string[] | undefined;
    routesCount!: number;

    constructor(data?: IAirlineRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airlineIdentifier = _data["airlineIdentifier"];
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(item);
            }
            this.routesCount = _data["routesCount"];
        }
    }

    static fromJS(data: any): AirlineRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineIdentifier"] = this.airlineIdentifier;
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item);
        }
        data["routesCount"] = this.routesCount;
        return data;
    }
}

export interface IAirlineRouteDto {
    airlineIdentifier: string | undefined;
    routes: string[] | undefined;
    routesCount: number;
}

export class PagedResultDtoOfAirlineRouteDto implements IPagedResultDtoOfAirlineRouteDto {
    totalCount!: number;
    items!: AirlineRouteDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAirlineRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AirlineRouteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAirlineRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAirlineRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAirlineRouteDto {
    totalCount: number;
    items: AirlineRouteDto[] | undefined;
}

export class AirportDTO implements IAirportDTO {
    airportCode!: string | undefined;
    cityName!: string | undefined;
    poiName!: string | undefined;
    countryCode!: string | undefined;
    countryName!: string | undefined;
    displayName!: string | undefined;
    longitude!: number;
    latitude!: number;
    isMultiCity!: boolean;

    constructor(data?: IAirportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airportCode = _data["airportCode"];
            this.cityName = _data["cityName"];
            this.poiName = _data["poiName"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.displayName = _data["displayName"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.isMultiCity = _data["isMultiCity"];
        }
    }

    static fromJS(data: any): AirportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airportCode"] = this.airportCode;
        data["cityName"] = this.cityName;
        data["poiName"] = this.poiName;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["displayName"] = this.displayName;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["isMultiCity"] = this.isMultiCity;
        return data;
    }
}

export interface IAirportDTO {
    airportCode: string | undefined;
    cityName: string | undefined;
    poiName: string | undefined;
    countryCode: string | undefined;
    countryName: string | undefined;
    displayName: string | undefined;
    longitude: number;
    latitude: number;
    isMultiCity: boolean;
}

export class AirlineRouteFlatDTO implements IAirlineRouteFlatDTO {
    supplier!: string | undefined;
    departureAirportCode!: string | undefined;
    arrivalAirportCode!: string | undefined;
    departureAirport!: AirportDTO;
    arrivalAirport!: AirportDTO;

    constructor(data?: IAirlineRouteFlatDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"];
            this.departureAirportCode = _data["departureAirportCode"];
            this.arrivalAirportCode = _data["arrivalAirportCode"];
            this.departureAirport = _data["departureAirport"] ? AirportDTO.fromJS(_data["departureAirport"]) : <any>undefined;
            this.arrivalAirport = _data["arrivalAirport"] ? AirportDTO.fromJS(_data["arrivalAirport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AirlineRouteFlatDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineRouteFlatDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier;
        data["departureAirportCode"] = this.departureAirportCode;
        data["arrivalAirportCode"] = this.arrivalAirportCode;
        data["departureAirport"] = this.departureAirport ? this.departureAirport.toJSON() : <any>undefined;
        data["arrivalAirport"] = this.arrivalAirport ? this.arrivalAirport.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAirlineRouteFlatDTO {
    supplier: string | undefined;
    departureAirportCode: string | undefined;
    arrivalAirportCode: string | undefined;
    departureAirport: AirportDTO;
    arrivalAirport: AirportDTO;
}

export class PagedResultDtoOfAirlineRouteFlatDTO implements IPagedResultDtoOfAirlineRouteFlatDTO {
    totalCount!: number;
    items!: AirlineRouteFlatDTO[] | undefined;

    constructor(data?: IPagedResultDtoOfAirlineRouteFlatDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AirlineRouteFlatDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAirlineRouteFlatDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAirlineRouteFlatDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAirlineRouteFlatDTO {
    totalCount: number;
    items: AirlineRouteFlatDTO[] | undefined;
}

export class AirlineModelDto implements IAirlineModelDto {
    id!: string | undefined;
    ts!: moment.Moment;
    priority!: number;
    airlineCode!: string | undefined;
    airlineName!: string | undefined;
    alternativeBusinessName!: string | undefined;

    constructor(data?: IAirlineModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.priority = _data["priority"];
            this.airlineCode = _data["airlineCode"];
            this.airlineName = _data["airlineName"];
            this.alternativeBusinessName = _data["alternativeBusinessName"];
        }
    }

    static fromJS(data: any): AirlineModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["priority"] = this.priority;
        data["airlineCode"] = this.airlineCode;
        data["airlineName"] = this.airlineName;
        data["alternativeBusinessName"] = this.alternativeBusinessName;
        return data;
    }
}

export interface IAirlineModelDto {
    id: string | undefined;
    ts: moment.Moment;
    priority: number;
    airlineCode: string | undefined;
    airlineName: string | undefined;
    alternativeBusinessName: string | undefined;
}

export class PagedResultDtoOfAirlineModelDto implements IPagedResultDtoOfAirlineModelDto {
    totalCount!: number;
    items!: AirlineModelDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAirlineModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AirlineModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAirlineModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAirlineModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAirlineModelDto {
    totalCount: number;
    items: AirlineModelDto[] | undefined;
}

export class CultureValuePair implements ICultureValuePair {
    c!: string | undefined;
    v!: string | undefined;

    constructor(data?: ICultureValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
            this.v = _data["v"];
        }
    }

    static fromJS(data: any): CultureValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new CultureValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        data["v"] = this.v;
        return data;
    }
}

export interface ICultureValuePair {
    c: string | undefined;
    v: string | undefined;
}

export class LocalizedString implements ILocalizedString {
    value!: string | undefined;
    languages!: CultureValuePair[] | undefined;

    constructor(data?: ILocalizedString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(CultureValuePair.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizedString {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizedString {
    value: string | undefined;
    languages: CultureValuePair[] | undefined;
}

export class PositionDTO implements IPositionDTO {
    latitude!: number;
    longitude!: number;

    constructor(data?: IPositionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): PositionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IPositionDTO {
    latitude: number;
    longitude: number;
}

export class AirportModel implements IAirportModel {
    id!: string | undefined;
    airportCode!: string | undefined;
    cityName!: LocalizedString;
    poiName!: LocalizedString;
    position!: PositionDTO;
    countryCode!: string | undefined;
    countryName!: LocalizedString;
    displayName!: string | undefined;
    isBlackList!: boolean;
    priority!: number;
    isMultiCity!: boolean;
    groupCode!: string | undefined;
    alias!: string[] | undefined;
    ts!: moment.Moment;

    constructor(data?: IAirportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.airportCode = _data["airportCode"];
            this.cityName = _data["cityName"] ? LocalizedString.fromJS(_data["cityName"]) : <any>undefined;
            this.poiName = _data["poiName"] ? LocalizedString.fromJS(_data["poiName"]) : <any>undefined;
            this.position = _data["position"] ? PositionDTO.fromJS(_data["position"]) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"] ? LocalizedString.fromJS(_data["countryName"]) : <any>undefined;
            this.displayName = _data["displayName"];
            this.isBlackList = _data["isBlackList"];
            this.priority = _data["priority"];
            this.isMultiCity = _data["isMultiCity"];
            this.groupCode = _data["groupCode"];
            if (Array.isArray(_data["alias"])) {
                this.alias = [] as any;
                for (let item of _data["alias"])
                    this.alias!.push(item);
            }
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AirportModel {
        data = typeof data === 'object' ? data : {};
        let result = new AirportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["airportCode"] = this.airportCode;
        data["cityName"] = this.cityName ? this.cityName.toJSON() : <any>undefined;
        data["poiName"] = this.poiName ? this.poiName.toJSON() : <any>undefined;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName ? this.countryName.toJSON() : <any>undefined;
        data["displayName"] = this.displayName;
        data["isBlackList"] = this.isBlackList;
        data["priority"] = this.priority;
        data["isMultiCity"] = this.isMultiCity;
        data["groupCode"] = this.groupCode;
        if (Array.isArray(this.alias)) {
            data["alias"] = [];
            for (let item of this.alias)
                data["alias"].push(item);
        }
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAirportModel {
    id: string | undefined;
    airportCode: string | undefined;
    cityName: LocalizedString;
    poiName: LocalizedString;
    position: PositionDTO;
    countryCode: string | undefined;
    countryName: LocalizedString;
    displayName: string | undefined;
    isBlackList: boolean;
    priority: number;
    isMultiCity: boolean;
    groupCode: string | undefined;
    alias: string[] | undefined;
    ts: moment.Moment;
}

export class PagedResultDtoOfAirportModel implements IPagedResultDtoOfAirportModel {
    totalCount!: number;
    items!: AirportModel[] | undefined;

    constructor(data?: IPagedResultDtoOfAirportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AirportModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAirportModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAirportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAirportModel {
    totalCount: number;
    items: AirportModel[] | undefined;
}

export class ExtraChartDto implements IExtraChartDto {
    code!: string | undefined;

    constructor(data?: IExtraChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ExtraChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IExtraChartDto {
    code: string | undefined;
}

export class LinearChartDto implements ILinearChartDto {
    name!: string | undefined;
    value!: number;
    extra!: ExtraChartDto;

    constructor(data?: ILinearChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.extra = _data["extra"] ? ExtraChartDto.fromJS(_data["extra"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LinearChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinearChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["extra"] = this.extra ? this.extra.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILinearChartDto {
    name: string | undefined;
    value: number;
    extra: ExtraChartDto;
}

export enum ApprovalProcessType {
    User = 1,
    Group = 2,
    Company = 3,
}

export class ApplicantDto implements IApplicantDto {
    id!: string | undefined;
    description!: string | undefined;
    email!: string | undefined;
    type!: ApprovalProcessType;

    constructor(data?: IApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.email = _data["email"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["email"] = this.email;
        data["type"] = this.type;
        return data;
    }
}

export interface IApplicantDto {
    id: string | undefined;
    description: string | undefined;
    email: string | undefined;
    type: ApprovalProcessType;
}

export class ApprovalSettingsDto implements IApprovalSettingsDto {
    needsApproval!: boolean;
    onlyOutOfPolicy!: boolean | undefined;

    constructor(data?: IApprovalSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.needsApproval = _data["needsApproval"];
            this.onlyOutOfPolicy = _data["onlyOutOfPolicy"];
        }
    }

    static fromJS(data: any): ApprovalSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["needsApproval"] = this.needsApproval;
        data["onlyOutOfPolicy"] = this.onlyOutOfPolicy;
        return data;
    }
}

export interface IApprovalSettingsDto {
    needsApproval: boolean;
    onlyOutOfPolicy: boolean | undefined;
}

export class ApproverDto implements IApproverDto {
    userId!: string | undefined;
    approvalProcessId!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    isAdmin!: boolean;

    constructor(data?: IApproverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.approvalProcessId = _data["approvalProcessId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): ApproverDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["approvalProcessId"] = this.approvalProcessId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IApproverDto {
    userId: string | undefined;
    approvalProcessId: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    isAdmin: boolean;
}

export class ApprovalProcessDto implements IApprovalProcessDto {
    id!: string | undefined;
    applicant!: ApplicantDto;
    excludeApplicant!: ApplicantDto;
    approvalSetting!: ApprovalSettingsDto;
    approvers!: ApproverDto[] | undefined;
    isForAll!: boolean;
    importanceOrder!: number;
    isBudgetProcessType!: boolean;
    divideOnCostsCenters!: boolean;
    userCanSkip!: ApplicantDto;

    constructor(data?: IApprovalProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicant = _data["applicant"] ? ApplicantDto.fromJS(_data["applicant"]) : <any>undefined;
            this.excludeApplicant = _data["excludeApplicant"] ? ApplicantDto.fromJS(_data["excludeApplicant"]) : <any>undefined;
            this.approvalSetting = _data["approvalSetting"] ? ApprovalSettingsDto.fromJS(_data["approvalSetting"]) : <any>undefined;
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(ApproverDto.fromJS(item));
            }
            this.isForAll = _data["isForAll"];
            this.importanceOrder = _data["importanceOrder"];
            this.isBudgetProcessType = _data["isBudgetProcessType"];
            this.divideOnCostsCenters = _data["divideOnCostsCenters"];
            this.userCanSkip = _data["userCanSkip"] ? ApplicantDto.fromJS(_data["userCanSkip"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApprovalProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["excludeApplicant"] = this.excludeApplicant ? this.excludeApplicant.toJSON() : <any>undefined;
        data["approvalSetting"] = this.approvalSetting ? this.approvalSetting.toJSON() : <any>undefined;
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        data["isForAll"] = this.isForAll;
        data["importanceOrder"] = this.importanceOrder;
        data["isBudgetProcessType"] = this.isBudgetProcessType;
        data["divideOnCostsCenters"] = this.divideOnCostsCenters;
        data["userCanSkip"] = this.userCanSkip ? this.userCanSkip.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApprovalProcessDto {
    id: string | undefined;
    applicant: ApplicantDto;
    excludeApplicant: ApplicantDto;
    approvalSetting: ApprovalSettingsDto;
    approvers: ApproverDto[] | undefined;
    isForAll: boolean;
    importanceOrder: number;
    isBudgetProcessType: boolean;
    divideOnCostsCenters: boolean;
    userCanSkip: ApplicantDto;
}

export enum GuestGenderDto {
    M = 0,
    F = 1,
}

export class DriverDto implements IDriverDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    age!: number;
    gender!: GuestGenderDto;

    constructor(data?: IDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.age = _data["age"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): DriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new DriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["age"] = this.age;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IDriverDto {
    firstName: string | undefined;
    lastName: string | undefined;
    age: number;
    gender: GuestGenderDto;
}

export class ApplicationUserDto implements IApplicationUserDto {
    id!: string | undefined;
    givenName!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    gender!: string | undefined;
    fiscalCode!: string | undefined;
    businessName!: string | undefined;
    vatNumber!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    zipCode!: string | undefined;
    state!: string | undefined;
    country!: string | undefined;
    phoneNumber!: string | undefined;
    email!: string | undefined;
    nationality!: string | undefined;
    hasNewsletterConsent!: boolean;
    phoneNumberOther!: string | undefined;
    personIdSuSabre!: string | undefined;

    constructor(data?: IApplicationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.fiscalCode = _data["fiscalCode"];
            this.businessName = _data["businessName"];
            this.vatNumber = _data["vatNumber"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.nationality = _data["nationality"];
            this.hasNewsletterConsent = _data["hasNewsletterConsent"];
            this.phoneNumberOther = _data["phoneNumberOther"];
        }
    }

    static fromJS(data: any): ApplicationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["fiscalCode"] = this.fiscalCode;
        data["businessName"] = this.businessName;
        data["vatNumber"] = this.vatNumber;
        data["address"] = this.address;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["state"] = this.state;
        data["country"] = this.country;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["nationality"] = this.nationality;
        data["hasNewsletterConsent"] = this.hasNewsletterConsent;
        data["phoneNumberOther"] = this.phoneNumberOther;
        return data;
    }
}

export interface IApplicationUserDto {
    id: string | undefined;
    givenName: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    gender: string | undefined;
    fiscalCode: string | undefined;
    businessName: string | undefined;
    vatNumber: string | undefined;
    address: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    state: string | undefined;
    country: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    nationality: string | undefined;
    hasNewsletterConsent: boolean;
    phoneNumberOther: string | undefined;
    personIdSuSabre: string | undefined;
}

export enum PaymentGatewayDto {
    Undefined = 0,
    Provider = 1,
    Paypal = 2,
    DataTrans = 3,
    Triveneto = 4,
    Nexi = 5,
}

export enum CarBookingConfirmationTypeDto {
    Book = 1,
    BookAndPay = 2,
    AssistedBooking = 3,
}

export class PaymentDataDto implements IPaymentDataDto {
    code!: string | undefined;
    number!: string | undefined;
    expirationYear!: string | undefined;
    expirationMonth!: string | undefined;
    cvv!: string | undefined;
    cardHolderName!: string | undefined;

    constructor(data?: IPaymentDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.number = _data["number"];
            this.expirationYear = _data["expirationYear"];
            this.expirationMonth = _data["expirationMonth"];
            this.cvv = _data["cvv"];
            this.cardHolderName = _data["cardHolderName"];
        }
    }

    static fromJS(data: any): PaymentDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["number"] = this.number;
        data["expirationYear"] = this.expirationYear;
        data["expirationMonth"] = this.expirationMonth;
        data["cvv"] = this.cvv;
        data["cardHolderName"] = this.cardHolderName;
        return data;
    }
}

export interface IPaymentDataDto {
    code: string | undefined;
    number: string | undefined;
    expirationYear: string | undefined;
    expirationMonth: string | undefined;
    cvv: string | undefined;
    cardHolderName: string | undefined;
}

export class PaymentDataProfileDto implements IPaymentDataProfileDto {
    paymentProfileId!: string | undefined;
    code!: string | undefined;
    displayNumber!: string | undefined;
    cvv!: string | undefined;
    expirationMonth!: string | undefined;
    expirationYear!: string | undefined;

    constructor(data?: IPaymentDataProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfileId = _data["paymentProfileId"];
            this.code = _data["code"];
            this.displayNumber = _data["displayNumber"];
            this.cvv = _data["cvv"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
        }
    }

    static fromJS(data: any): PaymentDataProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDataProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfileId"] = this.paymentProfileId;
        data["code"] = this.code;
        data["displayNumber"] = this.displayNumber;
        data["cvv"] = this.cvv;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        return data;
    }
}

export interface IPaymentDataProfileDto {
    paymentProfileId: string | undefined;
    code: string | undefined;
    displayNumber: string | undefined;
    cvv: string | undefined;
    expirationMonth: string | undefined;
    expirationYear: string | undefined;
}

export class AdditionalServiceDto implements IAdditionalServiceDto {
    serviceId!: string | undefined;
    serviceName!: string | undefined;
    supplierCode!: string | undefined;
    supplierName!: string | undefined;
    price!: number;
    currency!: string | undefined;
    period!: string | undefined;
    maxAmount!: number;
    information!: string | undefined;
    requiredAmount!: number | undefined;

    constructor(data?: IAdditionalServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.price = _data["price"];
            this.currency = _data["currency"];
            this.period = _data["period"];
            this.maxAmount = _data["maxAmount"];
            this.information = _data["information"];
            this.requiredAmount = _data["requiredAmount"];
        }
    }

    static fromJS(data: any): AdditionalServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["price"] = this.price;
        data["currency"] = this.currency;
        data["period"] = this.period;
        data["maxAmount"] = this.maxAmount;
        data["information"] = this.information;
        data["requiredAmount"] = this.requiredAmount;
        return data;
    }
}

export interface IAdditionalServiceDto {
    serviceId: string | undefined;
    serviceName: string | undefined;
    supplierCode: string | undefined;
    supplierName: string | undefined;
    price: number;
    currency: string | undefined;
    period: string | undefined;
    maxAmount: number;
    information: string | undefined;
    requiredAmount: number | undefined;
}

export class CarBookRequestDto implements ICarBookRequestDto {
    driver!: DriverDto;
    user!: ApplicationUserDto;
    paymentGateway!: PaymentGatewayDto;
    carBookingConfirmationType!: CarBookingConfirmationTypeDto;
    paymentData!: PaymentDataDto;
    paymentProfile!: PaymentDataProfileDto;
    flightNumber!: string | undefined;
    selectedExtras!: AdditionalServiceDto[] | undefined;
    reservationId!: string | undefined;
    erp!: boolean | undefined;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;
    availabilityId!: string;
    carId!: string;
    packageId!: string;
    pricingInformationId!: string;

    constructor(data?: ICarBookRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.user = _data["user"] ? ApplicationUserDto.fromJS(_data["user"]) : <any>undefined;
            this.paymentGateway = _data["paymentGateway"];
            this.carBookingConfirmationType = _data["carBookingConfirmationType"];
            this.paymentData = _data["paymentData"] ? PaymentDataDto.fromJS(_data["paymentData"]) : <any>undefined;
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
            this.flightNumber = _data["flightNumber"];
            if (Array.isArray(_data["selectedExtras"])) {
                this.selectedExtras = [] as any;
                for (let item of _data["selectedExtras"])
                    this.selectedExtras!.push(AdditionalServiceDto.fromJS(item));
            }
            this.reservationId = _data["reservationId"];
            this.erp = _data["erp"];
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
            this.availabilityId = _data["availabilityId"];
            this.carId = _data["carId"];
            this.packageId = _data["packageId"];
            this.pricingInformationId = _data["pricingInformationId"];
        }
    }

    static fromJS(data: any): CarBookRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarBookRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["paymentGateway"] = this.paymentGateway;
        data["carBookingConfirmationType"] = this.carBookingConfirmationType;
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        data["flightNumber"] = this.flightNumber;
        if (Array.isArray(this.selectedExtras)) {
            data["selectedExtras"] = [];
            for (let item of this.selectedExtras)
                data["selectedExtras"].push(item.toJSON());
        }
        data["reservationId"] = this.reservationId;
        data["erp"] = this.erp;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        data["availabilityId"] = this.availabilityId;
        data["carId"] = this.carId;
        data["packageId"] = this.packageId;
        data["pricingInformationId"] = this.pricingInformationId;
        return data;
    }
}

export interface ICarBookRequestDto {
    driver: DriverDto;
    user: ApplicationUserDto;
    paymentGateway: PaymentGatewayDto;
    carBookingConfirmationType: CarBookingConfirmationTypeDto;
    paymentData: PaymentDataDto;
    paymentProfile: PaymentDataProfileDto;
    flightNumber: string | undefined;
    selectedExtras: AdditionalServiceDto[] | undefined;
    reservationId: string | undefined;
    erp: boolean | undefined;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
    availabilityId: string;
    carId: string;
    packageId: string;
    pricingInformationId: string;
}

export class CarTotalFareDTO implements ICarTotalFareDTO {
    readonly totalPriceValueAmount!: number;
    readonly feeValueAmount!: number | undefined;
    readonly agencyFeeValueAmount!: number | undefined;
    readonly totalDue!: number;

    constructor(data?: ICarTotalFareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).totalPriceValueAmount = _data["totalPriceValueAmount"];
            (<any>this).feeValueAmount = _data["feeValueAmount"];
            (<any>this).agencyFeeValueAmount = _data["agencyFeeValueAmount"];
            (<any>this).totalDue = _data["totalDue"];
        }
    }

    static fromJS(data: any): CarTotalFareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CarTotalFareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPriceValueAmount"] = this.totalPriceValueAmount;
        data["feeValueAmount"] = this.feeValueAmount;
        data["agencyFeeValueAmount"] = this.agencyFeeValueAmount;
        data["totalDue"] = this.totalDue;
        return data;
    }
}

export interface ICarTotalFareDTO {
    totalPriceValueAmount: number;
    feeValueAmount: number | undefined;
    agencyFeeValueAmount: number | undefined;
    totalDue: number;
}

export class CarFareDTO implements ICarFareDTO {
    name!: string | undefined;
    totalFare!: CarTotalFareDTO;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;

    constructor(data?: ICarFareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.totalFare = _data["totalFare"] ? CarTotalFareDTO.fromJS(_data["totalFare"]) : <any>undefined;
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
        }
    }

    static fromJS(data: any): CarFareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CarFareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalFare"] = this.totalFare ? this.totalFare.toJSON() : <any>undefined;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        return data;
    }
}

export interface ICarFareDTO {
    name: string | undefined;
    totalFare: CarTotalFareDTO;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
}

export class CarPricingInformationDto implements ICarPricingInformationDto {
    product!: string | undefined;
    id!: string | undefined;
    fare!: CarFareDTO;
    pricingSubsource!: string | undefined;

    constructor(data?: ICarPricingInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"];
            this.id = _data["id"];
            this.fare = _data["fare"] ? CarFareDTO.fromJS(_data["fare"]) : <any>undefined;
            this.pricingSubsource = _data["pricingSubsource"];
        }
    }

    static fromJS(data: any): CarPricingInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarPricingInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["id"] = this.id;
        data["fare"] = this.fare ? this.fare.toJSON() : <any>undefined;
        data["pricingSubsource"] = this.pricingSubsource;
        return data;
    }
}

export interface ICarPricingInformationDto {
    product: string | undefined;
    id: string | undefined;
    fare: CarFareDTO;
    pricingSubsource: string | undefined;
}

export class ProductInclusionsDto implements IProductInclusionsDto {
    product!: string | undefined;
    insuranceInclusions!: string[] | undefined;
    servicesInclusions!: string[] | undefined;
    mileageInclusions!: string[] | undefined;
    feeInclusions!: string[] | undefined;
    additionalDriver!: string | undefined;
    other!: string[] | undefined;

    constructor(data?: IProductInclusionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"];
            if (Array.isArray(_data["insuranceInclusions"])) {
                this.insuranceInclusions = [] as any;
                for (let item of _data["insuranceInclusions"])
                    this.insuranceInclusions!.push(item);
            }
            if (Array.isArray(_data["servicesInclusions"])) {
                this.servicesInclusions = [] as any;
                for (let item of _data["servicesInclusions"])
                    this.servicesInclusions!.push(item);
            }
            if (Array.isArray(_data["mileageInclusions"])) {
                this.mileageInclusions = [] as any;
                for (let item of _data["mileageInclusions"])
                    this.mileageInclusions!.push(item);
            }
            if (Array.isArray(_data["feeInclusions"])) {
                this.feeInclusions = [] as any;
                for (let item of _data["feeInclusions"])
                    this.feeInclusions!.push(item);
            }
            this.additionalDriver = _data["additionalDriver"];
            if (Array.isArray(_data["other"])) {
                this.other = [] as any;
                for (let item of _data["other"])
                    this.other!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductInclusionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInclusionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        if (Array.isArray(this.insuranceInclusions)) {
            data["insuranceInclusions"] = [];
            for (let item of this.insuranceInclusions)
                data["insuranceInclusions"].push(item);
        }
        if (Array.isArray(this.servicesInclusions)) {
            data["servicesInclusions"] = [];
            for (let item of this.servicesInclusions)
                data["servicesInclusions"].push(item);
        }
        if (Array.isArray(this.mileageInclusions)) {
            data["mileageInclusions"] = [];
            for (let item of this.mileageInclusions)
                data["mileageInclusions"].push(item);
        }
        if (Array.isArray(this.feeInclusions)) {
            data["feeInclusions"] = [];
            for (let item of this.feeInclusions)
                data["feeInclusions"].push(item);
        }
        data["additionalDriver"] = this.additionalDriver;
        if (Array.isArray(this.other)) {
            data["other"] = [];
            for (let item of this.other)
                data["other"].push(item);
        }
        return data;
    }
}

export interface IProductInclusionsDto {
    product: string | undefined;
    insuranceInclusions: string[] | undefined;
    servicesInclusions: string[] | undefined;
    mileageInclusions: string[] | undefined;
    feeInclusions: string[] | undefined;
    additionalDriver: string | undefined;
    other: string[] | undefined;
}

export class AmountDto implements IAmountDto {
    value!: number | undefined;
    currency!: string | undefined;
    description!: string | undefined;

    constructor(data?: IAmountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.currency = _data["currency"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AmountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["currency"] = this.currency;
        data["description"] = this.description;
        return data;
    }
}

export interface IAmountDto {
    value: number | undefined;
    currency: string | undefined;
    description: string | undefined;
}

export class InformationDto implements IInformationDto {
    fuel!: string | undefined;
    mandatoryCharges!: AmountDto[] | undefined;
    otherCosts!: AmountDto[] | undefined;
    otherInfo!: string[] | undefined;
    totalMandatoryCharges!: AmountDto;

    constructor(data?: IInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuel = _data["fuel"];
            if (Array.isArray(_data["mandatoryCharges"])) {
                this.mandatoryCharges = [] as any;
                for (let item of _data["mandatoryCharges"])
                    this.mandatoryCharges!.push(AmountDto.fromJS(item));
            }
            if (Array.isArray(_data["otherCosts"])) {
                this.otherCosts = [] as any;
                for (let item of _data["otherCosts"])
                    this.otherCosts!.push(AmountDto.fromJS(item));
            }
            if (Array.isArray(_data["otherInfo"])) {
                this.otherInfo = [] as any;
                for (let item of _data["otherInfo"])
                    this.otherInfo!.push(item);
            }
            this.totalMandatoryCharges = _data["totalMandatoryCharges"] ? AmountDto.fromJS(_data["totalMandatoryCharges"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuel"] = this.fuel;
        if (Array.isArray(this.mandatoryCharges)) {
            data["mandatoryCharges"] = [];
            for (let item of this.mandatoryCharges)
                data["mandatoryCharges"].push(item.toJSON());
        }
        if (Array.isArray(this.otherCosts)) {
            data["otherCosts"] = [];
            for (let item of this.otherCosts)
                data["otherCosts"].push(item.toJSON());
        }
        if (Array.isArray(this.otherInfo)) {
            data["otherInfo"] = [];
            for (let item of this.otherInfo)
                data["otherInfo"].push(item);
        }
        data["totalMandatoryCharges"] = this.totalMandatoryCharges ? this.totalMandatoryCharges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInformationDto {
    fuel: string | undefined;
    mandatoryCharges: AmountDto[] | undefined;
    otherCosts: AmountDto[] | undefined;
    otherInfo: string[] | undefined;
    totalMandatoryCharges: AmountDto;
}

export class PackageDto implements IPackageDto {
    id!: string | undefined;
    carCode!: string | undefined;
    rateQualifier!: string | undefined;
    carName!: string | undefined;
    name!: string | undefined;
    pricingInformations!: CarPricingInformationDto[] | undefined;
    selectedPricingInformation!: CarPricingInformationDto;
    inclusions!: ProductInclusionsDto[] | undefined;
    fuelPolicy!: string | undefined;
    franchisePolicy!: string | undefined;
    informations!: InformationDto;
    supplierCode!: string | undefined;
    supplierName!: string | undefined;
    pickUpLocationInformation!: string | undefined;
    dropOffLocationInformation!: string | undefined;
    workedSupplierName!: string | undefined;
    erp!: number | undefined;
    dropCharge!: AmountDto;

    constructor(data?: IPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carCode = _data["carCode"];
            this.rateQualifier = _data["rateQualifier"];
            this.carName = _data["carName"];
            this.name = _data["name"];
            if (Array.isArray(_data["pricingInformations"])) {
                this.pricingInformations = [] as any;
                for (let item of _data["pricingInformations"])
                    this.pricingInformations!.push(CarPricingInformationDto.fromJS(item));
            }
            this.selectedPricingInformation = _data["selectedPricingInformation"] ? CarPricingInformationDto.fromJS(_data["selectedPricingInformation"]) : <any>undefined;
            if (Array.isArray(_data["inclusions"])) {
                this.inclusions = [] as any;
                for (let item of _data["inclusions"])
                    this.inclusions!.push(ProductInclusionsDto.fromJS(item));
            }
            this.fuelPolicy = _data["fuelPolicy"];
            this.franchisePolicy = _data["franchisePolicy"];
            this.informations = _data["informations"] ? InformationDto.fromJS(_data["informations"]) : <any>undefined;
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.pickUpLocationInformation = _data["pickUpLocationInformation"];
            this.dropOffLocationInformation = _data["dropOffLocationInformation"];
            this.workedSupplierName = _data["workedSupplierName"];
            this.erp = _data["erp"];
            this.dropCharge = _data["dropCharge"] ? AmountDto.fromJS(_data["dropCharge"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carCode"] = this.carCode;
        data["rateQualifier"] = this.rateQualifier;
        data["carName"] = this.carName;
        data["name"] = this.name;
        if (Array.isArray(this.pricingInformations)) {
            data["pricingInformations"] = [];
            for (let item of this.pricingInformations)
                data["pricingInformations"].push(item.toJSON());
        }
        data["selectedPricingInformation"] = this.selectedPricingInformation ? this.selectedPricingInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.inclusions)) {
            data["inclusions"] = [];
            for (let item of this.inclusions)
                data["inclusions"].push(item.toJSON());
        }
        data["fuelPolicy"] = this.fuelPolicy;
        data["franchisePolicy"] = this.franchisePolicy;
        data["informations"] = this.informations ? this.informations.toJSON() : <any>undefined;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["pickUpLocationInformation"] = this.pickUpLocationInformation;
        data["dropOffLocationInformation"] = this.dropOffLocationInformation;
        data["workedSupplierName"] = this.workedSupplierName;
        data["erp"] = this.erp;
        data["dropCharge"] = this.dropCharge ? this.dropCharge.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPackageDto {
    id: string | undefined;
    carCode: string | undefined;
    rateQualifier: string | undefined;
    carName: string | undefined;
    name: string | undefined;
    pricingInformations: CarPricingInformationDto[] | undefined;
    selectedPricingInformation: CarPricingInformationDto;
    inclusions: ProductInclusionsDto[] | undefined;
    fuelPolicy: string | undefined;
    franchisePolicy: string | undefined;
    informations: InformationDto;
    supplierCode: string | undefined;
    supplierName: string | undefined;
    pickUpLocationInformation: string | undefined;
    dropOffLocationInformation: string | undefined;
    workedSupplierName: string | undefined;
    erp: number | undefined;
    dropCharge: AmountDto;
}

export class CarDto implements ICarDto {
    id!: string | undefined;
    availabilityStatus!: string | undefined;
    name!: string | undefined;
    imageUrl!: string | undefined;
    luggage!: number;
    passengers!: number;
    doors!: number;
    currency!: string | undefined;
    isAirCondition!: boolean | undefined;
    isAutomatic!: boolean | undefined;
    carDescription!: string | undefined;
    carSize!: string | undefined;
    carCode!: string | undefined;
    providerCode!: string | undefined;
    readonly supplierCode!: string | undefined;
    supplierName!: string | undefined;
    supplierImageUrl!: string | undefined;
    supplierLocationType!: string | undefined;
    packages!: PackageDto[] | undefined;
    selectedPackage!: PackageDto;

    constructor(data?: ICarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.availabilityStatus = _data["availabilityStatus"];
            this.name = _data["name"];
            this.imageUrl = _data["imageUrl"];
            this.luggage = _data["luggage"];
            this.passengers = _data["passengers"];
            this.doors = _data["doors"];
            this.currency = _data["currency"];
            this.isAirCondition = _data["isAirCondition"];
            this.isAutomatic = _data["isAutomatic"];
            this.carDescription = _data["carDescription"];
            this.carSize = _data["carSize"];
            this.carCode = _data["carCode"];
            this.providerCode = _data["providerCode"];
            (<any>this).supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.supplierImageUrl = _data["supplierImageUrl"];
            this.supplierLocationType = _data["supplierLocationType"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(PackageDto.fromJS(item));
            }
            this.selectedPackage = _data["selectedPackage"] ? PackageDto.fromJS(_data["selectedPackage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["availabilityStatus"] = this.availabilityStatus;
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        data["luggage"] = this.luggage;
        data["passengers"] = this.passengers;
        data["doors"] = this.doors;
        data["currency"] = this.currency;
        data["isAirCondition"] = this.isAirCondition;
        data["isAutomatic"] = this.isAutomatic;
        data["carDescription"] = this.carDescription;
        data["carSize"] = this.carSize;
        data["carCode"] = this.carCode;
        data["providerCode"] = this.providerCode;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["supplierImageUrl"] = this.supplierImageUrl;
        data["supplierLocationType"] = this.supplierLocationType;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["selectedPackage"] = this.selectedPackage ? this.selectedPackage.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICarDto {
    id: string | undefined;
    availabilityStatus: string | undefined;
    name: string | undefined;
    imageUrl: string | undefined;
    luggage: number;
    passengers: number;
    doors: number;
    currency: string | undefined;
    isAirCondition: boolean | undefined;
    isAutomatic: boolean | undefined;
    carDescription: string | undefined;
    carSize: string | undefined;
    carCode: string | undefined;
    providerCode: string | undefined;
    supplierCode: string | undefined;
    supplierName: string | undefined;
    supplierImageUrl: string | undefined;
    supplierLocationType: string | undefined;
    packages: PackageDto[] | undefined;
    selectedPackage: PackageDto;
}

export class LocationDto implements ILocationDto {
    id!: string | undefined;
    displayName!: string | undefined;
    country!: string | undefined;
    name!: string | undefined;
    region!: string | undefined;
    airportCode!: string | undefined;
    countryCode!: string | undefined;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.country = _data["country"];
            this.name = _data["name"];
            this.region = _data["region"];
            this.airportCode = _data["airportCode"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["country"] = this.country;
        data["name"] = this.name;
        data["region"] = this.region;
        data["airportCode"] = this.airportCode;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface ILocationDto {
    id: string | undefined;
    displayName: string | undefined;
    country: string | undefined;
    name: string | undefined;
    region: string | undefined;
    airportCode: string | undefined;
    countryCode: string | undefined;
}

export class CarBookDto implements ICarBookDto {
    car!: CarDto;
    pickUpLocation!: LocationDto;
    dropOffLocation!: LocationDto;
    pickUpDate!: moment.Moment;
    pickUpTime!: string;
    dropOffDate!: moment.Moment;
    dropOffTime!: string;
    totalRentDays!: number;

    constructor(data?: ICarBookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.car = _data["car"] ? CarDto.fromJS(_data["car"]) : <any>undefined;
            this.pickUpLocation = _data["pickUpLocation"] ? LocationDto.fromJS(_data["pickUpLocation"]) : <any>undefined;
            this.dropOffLocation = _data["dropOffLocation"] ? LocationDto.fromJS(_data["dropOffLocation"]) : <any>undefined;
            this.pickUpDate = _data["pickUpDate"] ? moment(_data["pickUpDate"].toString()) : <any>undefined;
            this.pickUpTime = _data["pickUpTime"];
            this.dropOffDate = _data["dropOffDate"] ? moment(_data["dropOffDate"].toString()) : <any>undefined;
            this.dropOffTime = _data["dropOffTime"];
            this.totalRentDays = _data["totalRentDays"];
        }
    }

    static fromJS(data: any): CarBookDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarBookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["car"] = this.car ? this.car.toJSON() : <any>undefined;
        data["pickUpLocation"] = this.pickUpLocation ? this.pickUpLocation.toJSON() : <any>undefined;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : <any>undefined;
        data["pickUpDate"] = this.pickUpDate ? this.pickUpDate.toISOString() : <any>undefined;
        data["pickUpTime"] = this.pickUpTime;
        data["dropOffDate"] = this.dropOffDate ? this.dropOffDate.toISOString() : <any>undefined;
        data["dropOffTime"] = this.dropOffTime;
        data["totalRentDays"] = this.totalRentDays;
        return data;
    }
}

export interface ICarBookDto {
    car: CarDto;
    pickUpLocation: LocationDto;
    dropOffLocation: LocationDto;
    pickUpDate: moment.Moment;
    pickUpTime: string;
    dropOffDate: moment.Moment;
    dropOffTime: string;
    totalRentDays: number;
}

export class GeoJson2DGeographicCoordinates implements IGeoJson2DGeographicCoordinates {
    readonly values!: number[] | undefined;
    longitude!: number;
    latitude!: number;

    constructor(data?: IGeoJson2DGeographicCoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                (<any>this).values = [] as any;
                for (let item of _data["values"])
                    (<any>this).values!.push(item);
            }
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
        }
    }

    static fromJS(data: any): GeoJson2DGeographicCoordinates {
        data = typeof data === 'object' ? data : {};
        let result = new GeoJson2DGeographicCoordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data;
    }
}

export interface IGeoJson2DGeographicCoordinates {
    values: number[] | undefined;
    longitude: number;
    latitude: number;
}

export enum GeoJsonObjectType {
    Feature = 0,
    FeatureCollection = 1,
    GeometryCollection = 2,
    LineString = 3,
    MultiLineString = 4,
    MultiPoint = 5,
    MultiPolygon = 6,
    Point = 7,
    Polygon = 8,
}

export class GeoJsonBoundingBoxOfGeoJson2DGeographicCoordinates implements IGeoJsonBoundingBoxOfGeoJson2DGeographicCoordinates {
    max!: GeoJson2DGeographicCoordinates;
    min!: GeoJson2DGeographicCoordinates;

    constructor(data?: IGeoJsonBoundingBoxOfGeoJson2DGeographicCoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.max = _data["max"] ? GeoJson2DGeographicCoordinates.fromJS(_data["max"]) : <any>undefined;
            this.min = _data["min"] ? GeoJson2DGeographicCoordinates.fromJS(_data["min"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeoJsonBoundingBoxOfGeoJson2DGeographicCoordinates {
        data = typeof data === 'object' ? data : {};
        let result = new GeoJsonBoundingBoxOfGeoJson2DGeographicCoordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["max"] = this.max ? this.max.toJSON() : <any>undefined;
        data["min"] = this.min ? this.min.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeoJsonBoundingBoxOfGeoJson2DGeographicCoordinates {
    max: GeoJson2DGeographicCoordinates;
    min: GeoJson2DGeographicCoordinates;
}

export class GeoJsonCoordinateReferenceSystem implements IGeoJsonCoordinateReferenceSystem {
    readonly type!: string | undefined;

    constructor(data?: IGeoJsonCoordinateReferenceSystem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
        }
    }

    static fromJS(data: any): GeoJsonCoordinateReferenceSystem {
        data = typeof data === 'object' ? data : {};
        let result = new GeoJsonCoordinateReferenceSystem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }
}

export interface IGeoJsonCoordinateReferenceSystem {
    type: string | undefined;
}

export class BsonElement implements IBsonElement {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: IBsonElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BsonElement {
        data = typeof data === 'object' ? data : {};
        let result = new BsonElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IBsonElement {
    name: string | undefined;
    value: string | undefined;
}

export class GeoJsonPointOfGeoJson2DGeographicCoordinates implements IGeoJsonPointOfGeoJson2DGeographicCoordinates {
    coordinates!: GeoJson2DGeographicCoordinates;
    type!: GeoJsonObjectType;
    boundingBox!: GeoJsonBoundingBoxOfGeoJson2DGeographicCoordinates;
    coordinateReferenceSystem!: GeoJsonCoordinateReferenceSystem;
    readonly extraMembers!: BsonElement[] | undefined;

    constructor(data?: IGeoJsonPointOfGeoJson2DGeographicCoordinates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coordinates = _data["coordinates"] ? GeoJson2DGeographicCoordinates.fromJS(_data["coordinates"]) : <any>undefined;
            this.type = _data["type"];
            this.boundingBox = _data["boundingBox"] ? GeoJsonBoundingBoxOfGeoJson2DGeographicCoordinates.fromJS(_data["boundingBox"]) : <any>undefined;
            this.coordinateReferenceSystem = _data["coordinateReferenceSystem"] ? GeoJsonCoordinateReferenceSystem.fromJS(_data["coordinateReferenceSystem"]) : <any>undefined;
            if (Array.isArray(_data["extraMembers"])) {
                (<any>this).extraMembers = [] as any;
                for (let item of _data["extraMembers"])
                    (<any>this).extraMembers!.push(BsonElement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeoJsonPointOfGeoJson2DGeographicCoordinates {
        data = typeof data === 'object' ? data : {};
        let result = new GeoJsonPointOfGeoJson2DGeographicCoordinates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["boundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        data["coordinateReferenceSystem"] = this.coordinateReferenceSystem ? this.coordinateReferenceSystem.toJSON() : <any>undefined;
        if (Array.isArray(this.extraMembers)) {
            data["extraMembers"] = [];
            for (let item of this.extraMembers)
                data["extraMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeoJsonPointOfGeoJson2DGeographicCoordinates {
    coordinates: GeoJson2DGeographicCoordinates;
    type: GeoJsonObjectType;
    boundingBox: GeoJsonBoundingBoxOfGeoJson2DGeographicCoordinates;
    coordinateReferenceSystem: GeoJsonCoordinateReferenceSystem;
    extraMembers: BsonElement[] | undefined;
}

export class SupplierAddressDto implements ISupplierAddressDto {
    address1!: string | undefined;
    address2!: string | undefined;
    address3!: string | undefined;
    city!: string | undefined;
    zipCode!: string | undefined;

    constructor(data?: ISupplierAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): SupplierAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

export interface ISupplierAddressDto {
    address1: string | undefined;
    address2: string | undefined;
    address3: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class OpeningHoursDto implements IOpeningHoursDto {
    weekDay!: DayOfWeek;
    openingHour!: string;
    closingHour!: string;

    constructor(data?: IOpeningHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekDay = _data["weekDay"];
            this.openingHour = _data["openingHour"];
            this.closingHour = _data["closingHour"];
        }
    }

    static fromJS(data: any): OpeningHoursDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpeningHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekDay"] = this.weekDay;
        data["openingHour"] = this.openingHour;
        data["closingHour"] = this.closingHour;
        return data;
    }
}

export interface IOpeningHoursDto {
    weekDay: DayOfWeek;
    openingHour: string;
    closingHour: string;
}

export class TermsAndConditionsItemDto implements ITermsAndConditionsItemDto {
    header!: string | undefined;
    paragraph!: string | undefined;

    constructor(data?: ITermsAndConditionsItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.paragraph = _data["paragraph"];
        }
    }

    static fromJS(data: any): TermsAndConditionsItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionsItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["paragraph"] = this.paragraph;
        return data;
    }
}

export interface ITermsAndConditionsItemDto {
    header: string | undefined;
    paragraph: string | undefined;
}

export class TermsAndConditionsDto implements ITermsAndConditionsDto {
    supplierCode!: string | undefined;
    supplierName!: string | undefined;
    termsAndConditions!: TermsAndConditionsItemDto[] | undefined;

    constructor(data?: ITermsAndConditionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            if (Array.isArray(_data["termsAndConditions"])) {
                this.termsAndConditions = [] as any;
                for (let item of _data["termsAndConditions"])
                    this.termsAndConditions!.push(TermsAndConditionsItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TermsAndConditionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        if (Array.isArray(this.termsAndConditions)) {
            data["termsAndConditions"] = [];
            for (let item of this.termsAndConditions)
                data["termsAndConditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITermsAndConditionsDto {
    supplierCode: string | undefined;
    supplierName: string | undefined;
    termsAndConditions: TermsAndConditionsItemDto[] | undefined;
}

export class SupplierInfoDto implements ISupplierInfoDto {
    supplierCode!: string | undefined;
    supplierName!: string | undefined;
    pickUpPosition!: GeoJsonPointOfGeoJson2DGeographicCoordinates;
    dropOffPosition!: GeoJsonPointOfGeoJson2DGeographicCoordinates;
    pickUpAddress!: SupplierAddressDto;
    dropOffAddress!: SupplierAddressDto;
    pickUpLocationInformation!: string | undefined;
    dropOffLocationInformation!: string | undefined;
    pickUpPhoneNumber!: string | undefined;
    dropOffPhoneNumber!: string | undefined;
    pickUpOpeningHours!: OpeningHoursDto[] | undefined;
    dropOffOpeningHours!: OpeningHoursDto[] | undefined;
    termsAndConditions!: TermsAndConditionsDto;
    isSamePickUpDropOffLocation!: boolean;
    pickUpLocationName!: string | undefined;
    dropOffLocationName!: string | undefined;

    constructor(data?: ISupplierInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.pickUpPosition = _data["pickUpPosition"] ? GeoJsonPointOfGeoJson2DGeographicCoordinates.fromJS(_data["pickUpPosition"]) : <any>undefined;
            this.dropOffPosition = _data["dropOffPosition"] ? GeoJsonPointOfGeoJson2DGeographicCoordinates.fromJS(_data["dropOffPosition"]) : <any>undefined;
            this.pickUpAddress = _data["pickUpAddress"] ? SupplierAddressDto.fromJS(_data["pickUpAddress"]) : <any>undefined;
            this.dropOffAddress = _data["dropOffAddress"] ? SupplierAddressDto.fromJS(_data["dropOffAddress"]) : <any>undefined;
            this.pickUpLocationInformation = _data["pickUpLocationInformation"];
            this.dropOffLocationInformation = _data["dropOffLocationInformation"];
            this.pickUpPhoneNumber = _data["pickUpPhoneNumber"];
            this.dropOffPhoneNumber = _data["dropOffPhoneNumber"];
            if (Array.isArray(_data["pickUpOpeningHours"])) {
                this.pickUpOpeningHours = [] as any;
                for (let item of _data["pickUpOpeningHours"])
                    this.pickUpOpeningHours!.push(OpeningHoursDto.fromJS(item));
            }
            if (Array.isArray(_data["dropOffOpeningHours"])) {
                this.dropOffOpeningHours = [] as any;
                for (let item of _data["dropOffOpeningHours"])
                    this.dropOffOpeningHours!.push(OpeningHoursDto.fromJS(item));
            }
            this.termsAndConditions = _data["termsAndConditions"] ? TermsAndConditionsDto.fromJS(_data["termsAndConditions"]) : <any>undefined;
            this.isSamePickUpDropOffLocation = _data["isSamePickUpDropOffLocation"];
            this.pickUpLocationName = _data["pickUpLocationName"];
            this.dropOffLocationName = _data["dropOffLocationName"];
        }
    }

    static fromJS(data: any): SupplierInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["pickUpPosition"] = this.pickUpPosition ? this.pickUpPosition.toJSON() : <any>undefined;
        data["dropOffPosition"] = this.dropOffPosition ? this.dropOffPosition.toJSON() : <any>undefined;
        data["pickUpAddress"] = this.pickUpAddress ? this.pickUpAddress.toJSON() : <any>undefined;
        data["dropOffAddress"] = this.dropOffAddress ? this.dropOffAddress.toJSON() : <any>undefined;
        data["pickUpLocationInformation"] = this.pickUpLocationInformation;
        data["dropOffLocationInformation"] = this.dropOffLocationInformation;
        data["pickUpPhoneNumber"] = this.pickUpPhoneNumber;
        data["dropOffPhoneNumber"] = this.dropOffPhoneNumber;
        if (Array.isArray(this.pickUpOpeningHours)) {
            data["pickUpOpeningHours"] = [];
            for (let item of this.pickUpOpeningHours)
                data["pickUpOpeningHours"].push(item.toJSON());
        }
        if (Array.isArray(this.dropOffOpeningHours)) {
            data["dropOffOpeningHours"] = [];
            for (let item of this.dropOffOpeningHours)
                data["dropOffOpeningHours"].push(item.toJSON());
        }
        data["termsAndConditions"] = this.termsAndConditions ? this.termsAndConditions.toJSON() : <any>undefined;
        data["isSamePickUpDropOffLocation"] = this.isSamePickUpDropOffLocation;
        data["pickUpLocationName"] = this.pickUpLocationName;
        data["dropOffLocationName"] = this.dropOffLocationName;
        return data;
    }
}

export interface ISupplierInfoDto {
    supplierCode: string | undefined;
    supplierName: string | undefined;
    pickUpPosition: GeoJsonPointOfGeoJson2DGeographicCoordinates;
    dropOffPosition: GeoJsonPointOfGeoJson2DGeographicCoordinates;
    pickUpAddress: SupplierAddressDto;
    dropOffAddress: SupplierAddressDto;
    pickUpLocationInformation: string | undefined;
    dropOffLocationInformation: string | undefined;
    pickUpPhoneNumber: string | undefined;
    dropOffPhoneNumber: string | undefined;
    pickUpOpeningHours: OpeningHoursDto[] | undefined;
    dropOffOpeningHours: OpeningHoursDto[] | undefined;
    termsAndConditions: TermsAndConditionsDto;
    isSamePickUpDropOffLocation: boolean;
    pickUpLocationName: string | undefined;
    dropOffLocationName: string | undefined;
}

export enum AssistedBookingStatus {
    Created = 0,
    Closed = 1,
    Updated = 2,
}

export class CarAssistedBooking implements ICarAssistedBooking {
    assistedBookingReservation!: CarBookRequestDto;
    carBookData!: CarBookDto;
    suppliersInfo!: SupplierInfoDto;
    userId!: string | undefined;
    username!: string | undefined;
    status!: AssistedBookingStatus;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: ICarAssistedBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistedBookingReservation = _data["assistedBookingReservation"] ? CarBookRequestDto.fromJS(_data["assistedBookingReservation"]) : <any>undefined;
            this.carBookData = _data["carBookData"] ? CarBookDto.fromJS(_data["carBookData"]) : <any>undefined;
            this.suppliersInfo = _data["suppliersInfo"] ? SupplierInfoDto.fromJS(_data["suppliersInfo"]) : <any>undefined;
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.status = _data["status"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CarAssistedBooking {
        data = typeof data === 'object' ? data : {};
        let result = new CarAssistedBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistedBookingReservation"] = this.assistedBookingReservation ? this.assistedBookingReservation.toJSON() : <any>undefined;
        data["carBookData"] = this.carBookData ? this.carBookData.toJSON() : <any>undefined;
        data["suppliersInfo"] = this.suppliersInfo ? this.suppliersInfo.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["status"] = this.status;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICarAssistedBooking {
    assistedBookingReservation: CarBookRequestDto;
    carBookData: CarBookDto;
    suppliersInfo: SupplierInfoDto;
    userId: string | undefined;
    username: string | undefined;
    status: AssistedBookingStatus;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class SeatOptionDTO implements ISeatOptionDTO {
    seatName!: string | undefined;
    price!: number;
    flightNumber!: string | undefined;

    constructor(data?: ISeatOptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seatName = _data["seatName"];
            this.price = _data["price"];
            this.flightNumber = _data["flightNumber"];
        }
    }

    static fromJS(data: any): SeatOptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeatOptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seatName"] = this.seatName;
        data["price"] = this.price;
        data["flightNumber"] = this.flightNumber;
        return data;
    }
}

export interface ISeatOptionDTO {
    seatName: string | undefined;
    price: number;
    flightNumber: string | undefined;
}

export class LuggageOptionsDTO implements ILuggageOptionsDTO {
    value!: string | undefined;
    description!: string | undefined;
    price!: number;
    perPassenger!: boolean;
    shortDescription!: string | undefined;
    xmlParameterName!: null | string;

    constructor(data?: ILuggageOptionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.perPassenger = _data["perPassenger"];
            this.shortDescription = _data["shortDescription"];
            this.xmlParameterName = _data["xmlParameterName"];
        }
    }

    static fromJS(data: any): LuggageOptionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LuggageOptionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        data["price"] = this.price;
        data["perPassenger"] = this.perPassenger;
        data["shortDescription"] = this.shortDescription;
        data["xmlParameterName"] = this.xmlParameterName;
        return data;
    }
}

export interface ILuggageOptionsDTO {
    value: string | undefined;
    description: string | undefined;
    price: number;
    perPassenger: boolean;
    shortDescription: string | undefined;
    xmlParameterName: null | string;
}

export class PersonNameDataDTO implements IPersonNameDataDTO {
    nameNumber!: string | undefined;
    type!: string | undefined;
    gender!: string | undefined;
    givenName!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    age!: number | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    frequentFlyerCarrierCode!: string | undefined;
    frequentFlyerMembershipId!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    countryOfResidence!: string | undefined;
    documentType!: string | undefined;
    documentNumber!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    nationalityCountry!: string | undefined;
    issueCountry!: string | undefined;
    seats!: SeatOptionDTO[] | undefined;
    personIdSuSabre!: string | undefined;
    flightExtra!: LuggageOptionsDTO;
    luggageOption!: LuggageOptionsDTO;
    handLuggageOption!: LuggageOptionsDTO;
    outwardLuggageOption!: LuggageOptionsDTO;
    returnLuggageOption!: LuggageOptionsDTO;
    outwardHandLuggageOption!: LuggageOptionsDTO;
    returnHandLuggageOption!: LuggageOptionsDTO;

    constructor(data?: IPersonNameDataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameNumber = _data["nameNumber"];
            this.type = _data["type"];
            this.gender = _data["gender"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.frequentFlyerCarrierCode = _data["frequentFlyerCarrierCode"];
            this.frequentFlyerMembershipId = _data["frequentFlyerMembershipId"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryOfResidence = _data["countryOfResidence"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.nationalityCountry = _data["nationalityCountry"];
            this.issueCountry = _data["issueCountry"];
            if (Array.isArray(_data["seats"])) {
                this.seats = [] as any;
                for (let item of _data["seats"])
                    this.seats!.push(SeatOptionDTO.fromJS(item));
            }
            this.personIdSuSabre = _data["personIdSuSabre"];
            this.flightExtra = _data["flightExtra"] ? LuggageOptionsDTO.fromJS(_data["flightExtra"]) : <any>undefined;
            this.luggageOption = _data["luggageOption"] ? LuggageOptionsDTO.fromJS(_data["luggageOption"]) : <any>undefined;
            this.handLuggageOption = _data["handLuggageOption"] ? LuggageOptionsDTO.fromJS(_data["handLuggageOption"]) : <any>undefined;
            this.outwardLuggageOption = _data["outwardLuggageOption"] ? LuggageOptionsDTO.fromJS(_data["outwardLuggageOption"]) : <any>undefined;
            this.returnLuggageOption = _data["returnLuggageOption"] ? LuggageOptionsDTO.fromJS(_data["returnLuggageOption"]) : <any>undefined;
            this.outwardHandLuggageOption = _data["outwardHandLuggageOption"] ? LuggageOptionsDTO.fromJS(_data["outwardHandLuggageOption"]) : <any>undefined;
            this.returnHandLuggageOption = _data["returnHandLuggageOption"] ? LuggageOptionsDTO.fromJS(_data["returnHandLuggageOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonNameDataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PersonNameDataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameNumber"] = this.nameNumber;
        data["type"] = this.type;
        data["gender"] = this.gender;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["frequentFlyerCarrierCode"] = this.frequentFlyerCarrierCode;
        data["frequentFlyerMembershipId"] = this.frequentFlyerMembershipId;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryOfResidence"] = this.countryOfResidence;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["nationalityCountry"] = this.nationalityCountry;
        data["issueCountry"] = this.issueCountry;
        if (Array.isArray(this.seats)) {
            data["seats"] = [];
            for (let item of this.seats)
                data["seats"].push(item.toJSON());
        }
        data["personIdSuSabre"] = this.personIdSuSabre;
        data["flightExtra"] = this.flightExtra ? this.flightExtra.toJSON() : <any>undefined;
        data["luggageOption"] = this.luggageOption ? this.luggageOption.toJSON() : <any>undefined;
        data["handLuggageOption"] = this.handLuggageOption ? this.handLuggageOption.toJSON() : <any>undefined;
        data["outwardLuggageOption"] = this.outwardLuggageOption ? this.outwardLuggageOption.toJSON() : <any>undefined;
        data["returnLuggageOption"] = this.returnLuggageOption ? this.returnLuggageOption.toJSON() : <any>undefined;
        data["outwardHandLuggageOption"] = this.outwardHandLuggageOption ? this.outwardHandLuggageOption.toJSON() : <any>undefined;
        data["returnHandLuggageOption"] = this.returnHandLuggageOption ? this.returnHandLuggageOption.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPersonNameDataDTO {
    nameNumber: string | undefined;
    type: string | undefined;
    gender: string | undefined;
    givenName: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    age: number | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    frequentFlyerCarrierCode: string | undefined;
    frequentFlyerMembershipId: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    countryOfResidence: string | undefined;
    documentType: string | undefined;
    documentNumber: string | undefined;
    expirationDate: moment.Moment | undefined;
    nationalityCountry: string | undefined;
    issueCountry: string | undefined;
    seats: SeatOptionDTO[] | undefined;
    personIdSuSabre: string | undefined;
    flightExtra: LuggageOptionsDTO;
    luggageOption: LuggageOptionsDTO;
    handLuggageOption: LuggageOptionsDTO;
    outwardLuggageOption: LuggageOptionsDTO;
    returnLuggageOption: LuggageOptionsDTO;
    outwardHandLuggageOption: LuggageOptionsDTO;
    returnHandLuggageOption: LuggageOptionsDTO;
}

export enum BookingConfirmationTypeDto {
    Book = 0,
    Issue = 1,
    QueueAndIssue = 2,
    AssistedBooking = 3,
    SeatsAndIssue = 4,
}

export class PersonNameSsrDto implements IPersonNameSsrDto {
    legsIds!: string[] | undefined;
    nameNumber!: string | undefined;
    meal!: string | undefined;
    wheelChair!: string | undefined;
    blind!: boolean;
    deaf!: boolean;

    constructor(data?: IPersonNameSsrDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["legsIds"])) {
                this.legsIds = [] as any;
                for (let item of _data["legsIds"])
                    this.legsIds!.push(item);
            }
            this.nameNumber = _data["nameNumber"];
            this.meal = _data["meal"];
            this.wheelChair = _data["wheelChair"];
            this.blind = _data["blind"];
            this.deaf = _data["deaf"];
        }
    }

    static fromJS(data: any): PersonNameSsrDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonNameSsrDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.legsIds)) {
            data["legsIds"] = [];
            for (let item of this.legsIds)
                data["legsIds"].push(item);
        }
        data["nameNumber"] = this.nameNumber;
        data["meal"] = this.meal;
        data["wheelChair"] = this.wheelChair;
        data["blind"] = this.blind;
        data["deaf"] = this.deaf;
        return data;
    }
}

export interface IPersonNameSsrDto {
    legsIds: string[] | undefined;
    nameNumber: string | undefined;
    meal: string | undefined;
    wheelChair: string | undefined;
    blind: boolean;
    deaf: boolean;
}

export class AirBookRequestDTO implements IAirBookRequestDTO {
    passengers!: PersonNameDataDTO[] | undefined;
    user!: ApplicationUserDto;
    orderId!: string | undefined;
    paymentGateway!: PaymentGatewayDto;
    discountCode!: string | undefined;
    bookingConfirmationType!: BookingConfirmationTypeDto;
    paymentData!: PaymentDataDto;
    paymentProfile!: PaymentDataProfileDto;
    personNameSsrs!: PersonNameSsrDto[] | undefined;
    luggageOption!: LuggageOptionsDTO;
    handLuggageOption!: LuggageOptionsDTO;
    remarks!: string | undefined;
    hideFareDetails!: boolean;
    skipAgeValidation!: boolean;
    availabilityId!: string | undefined;
    groupItineraryId!: string | undefined;
    itineraryId!: string | undefined;
    pricingInformationId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;

    constructor(data?: IAirBookRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PersonNameDataDTO.fromJS(item));
            }
            this.user = _data["user"] ? ApplicationUserDto.fromJS(_data["user"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.paymentGateway = _data["paymentGateway"];
            this.discountCode = _data["discountCode"];
            this.bookingConfirmationType = _data["bookingConfirmationType"];
            this.paymentData = _data["paymentData"] ? PaymentDataDto.fromJS(_data["paymentData"]) : <any>undefined;
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
            if (Array.isArray(_data["personNameSsrs"])) {
                this.personNameSsrs = [] as any;
                for (let item of _data["personNameSsrs"])
                    this.personNameSsrs!.push(PersonNameSsrDto.fromJS(item));
            }
            this.luggageOption = _data["luggageOption"] ? LuggageOptionsDTO.fromJS(_data["luggageOption"]) : <any>undefined;
            this.handLuggageOption = _data["handLuggageOption"] ? LuggageOptionsDTO.fromJS(_data["handLuggageOption"]) : <any>undefined;
            this.remarks = _data["remarks"];
            this.hideFareDetails = _data["hideFareDetails"];
            this.skipAgeValidation = _data["skipAgeValidation"];
            this.availabilityId = _data["availabilityId"];
            this.groupItineraryId = _data["groupItineraryId"];
            this.itineraryId = _data["itineraryId"];
            this.pricingInformationId = _data["pricingInformationId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
        }
    }

    static fromJS(data: any): AirBookRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirBookRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["paymentGateway"] = this.paymentGateway;
        data["discountCode"] = this.discountCode;
        data["bookingConfirmationType"] = this.bookingConfirmationType;
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        if (Array.isArray(this.personNameSsrs)) {
            data["personNameSsrs"] = [];
            for (let item of this.personNameSsrs)
                data["personNameSsrs"].push(item.toJSON());
        }
        data["luggageOption"] = this.luggageOption ? this.luggageOption.toJSON() : <any>undefined;
        data["handLuggageOption"] = this.handLuggageOption ? this.handLuggageOption.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["hideFareDetails"] = this.hideFareDetails;
        data["skipAgeValidation"] = this.skipAgeValidation;
        data["availabilityId"] = this.availabilityId;
        data["groupItineraryId"] = this.groupItineraryId;
        data["itineraryId"] = this.itineraryId;
        data["pricingInformationId"] = this.pricingInformationId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        return data;
    }
}

export interface IAirBookRequestDTO {
    passengers: PersonNameDataDTO[] | undefined;
    user: ApplicationUserDto;
    orderId: string | undefined;
    paymentGateway: PaymentGatewayDto;
    discountCode: string | undefined;
    bookingConfirmationType: BookingConfirmationTypeDto;
    paymentData: PaymentDataDto;
    paymentProfile: PaymentDataProfileDto;
    personNameSsrs: PersonNameSsrDto[] | undefined;
    luggageOption: LuggageOptionsDTO;
    handLuggageOption: LuggageOptionsDTO;
    remarks: string | undefined;
    hideFareDetails: boolean;
    skipAgeValidation: boolean;
    availabilityId: string | undefined;
    groupItineraryId: string | undefined;
    itineraryId: string | undefined;
    pricingInformationId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
}

export enum TripTypeDTO {
    OneWay = 0,
    RoundTrip = 1,
    Multicity = 2,
    None = 3,
}

export class DepartureDTO implements IDepartureDTO {
    airport!: AirportDTO;
    _Airport!: string | undefined;
    city!: string | undefined;
    country!: string | undefined;
    time!: string | undefined;
    departureDateTime!: moment.Moment;
    terminal!: string | undefined;

    constructor(data?: IDepartureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airport = _data["airport"] ? AirportDTO.fromJS(_data["airport"]) : <any>undefined;
            this._Airport = _data["_Airport"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.time = _data["time"];
            this.departureDateTime = _data["departureDateTime"] ? moment(_data["departureDateTime"].toString()) : <any>undefined;
            this.terminal = _data["terminal"];
        }
    }

    static fromJS(data: any): DepartureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DepartureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airport"] = this.airport ? this.airport.toJSON() : <any>undefined;
        data["_Airport"] = this._Airport;
        data["city"] = this.city;
        data["country"] = this.country;
        data["time"] = this.time;
        data["departureDateTime"] = this.departureDateTime ? this.departureDateTime.toISOString() : <any>undefined;
        data["terminal"] = this.terminal;
        return data;
    }
}

export interface IDepartureDTO {
    airport: AirportDTO;
    _Airport: string | undefined;
    city: string | undefined;
    country: string | undefined;
    time: string | undefined;
    departureDateTime: moment.Moment;
    terminal: string | undefined;
}

export class ArrivalDTO implements IArrivalDTO {
    airport!: AirportDTO;
    _Airport!: string | undefined;
    city!: string | undefined;
    country!: string | undefined;
    time!: string | undefined;
    arrivalDateTime!: moment.Moment;
    terminal!: string | undefined;
    dateAdjustment!: string | undefined;

    constructor(data?: IArrivalDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airport = _data["airport"] ? AirportDTO.fromJS(_data["airport"]) : <any>undefined;
            this._Airport = _data["_Airport"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.time = _data["time"];
            this.arrivalDateTime = _data["arrivalDateTime"] ? moment(_data["arrivalDateTime"].toString()) : <any>undefined;
            this.terminal = _data["terminal"];
            this.dateAdjustment = _data["dateAdjustment"];
        }
    }

    static fromJS(data: any): ArrivalDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ArrivalDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airport"] = this.airport ? this.airport.toJSON() : <any>undefined;
        data["_Airport"] = this._Airport;
        data["city"] = this.city;
        data["country"] = this.country;
        data["time"] = this.time;
        data["arrivalDateTime"] = this.arrivalDateTime ? this.arrivalDateTime.toISOString() : <any>undefined;
        data["terminal"] = this.terminal;
        data["dateAdjustment"] = this.dateAdjustment;
        return data;
    }
}

export interface IArrivalDTO {
    airport: AirportDTO;
    _Airport: string | undefined;
    city: string | undefined;
    country: string | undefined;
    time: string | undefined;
    arrivalDateTime: moment.Moment;
    terminal: string | undefined;
    dateAdjustment: string | undefined;
}

export class EquipmentDTO implements IEquipmentDTO {
    code!: string | undefined;
    change!: boolean;
    typeForFirstLeg!: string | undefined;
    typeForLastLeg!: string | undefined;
    description!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IEquipmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.change = _data["change"];
            this.typeForFirstLeg = _data["typeForFirstLeg"];
            this.typeForLastLeg = _data["typeForLastLeg"];
            this.description = _data["description"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): EquipmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["change"] = this.change;
        data["typeForFirstLeg"] = this.typeForFirstLeg;
        data["typeForLastLeg"] = this.typeForLastLeg;
        data["description"] = this.description;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IEquipmentDTO {
    code: string | undefined;
    change: boolean;
    typeForFirstLeg: string | undefined;
    typeForLastLeg: string | undefined;
    description: string | undefined;
    notes: string | undefined;
}

export class CarrierNameDTO implements ICarrierNameDTO {
    code!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: ICarrierNameDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CarrierNameDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierNameDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICarrierNameDTO {
    code: string | undefined;
    displayName: string | undefined;
}

export class CarrierDTO implements ICarrierDTO {
    equipment!: EquipmentDTO;
    marketing!: CarrierNameDTO;
    marketingFlightNumber!: string | undefined;
    operating!: CarrierNameDTO;
    operatingFlightNumber!: string | undefined;
    codeShared!: string | undefined;

    constructor(data?: ICarrierDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.equipment = _data["equipment"] ? EquipmentDTO.fromJS(_data["equipment"]) : <any>undefined;
            this.marketing = _data["marketing"] ? CarrierNameDTO.fromJS(_data["marketing"]) : <any>undefined;
            this.marketingFlightNumber = _data["marketingFlightNumber"];
            this.operating = _data["operating"] ? CarrierNameDTO.fromJS(_data["operating"]) : <any>undefined;
            this.operatingFlightNumber = _data["operatingFlightNumber"];
            this.codeShared = _data["codeShared"];
        }
    }

    static fromJS(data: any): CarrierDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["equipment"] = this.equipment ? this.equipment.toJSON() : <any>undefined;
        data["marketing"] = this.marketing ? this.marketing.toJSON() : <any>undefined;
        data["marketingFlightNumber"] = this.marketingFlightNumber;
        data["operating"] = this.operating ? this.operating.toJSON() : <any>undefined;
        data["operatingFlightNumber"] = this.operatingFlightNumber;
        data["codeShared"] = this.codeShared;
        return data;
    }
}

export interface ICarrierDTO {
    equipment: EquipmentDTO;
    marketing: CarrierNameDTO;
    marketingFlightNumber: string | undefined;
    operating: CarrierNameDTO;
    operatingFlightNumber: string | undefined;
    codeShared: string | undefined;
}

export class HiddenStopDTO implements IHiddenStopDTO {
    _Airport!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    country!: string | undefined;
    arrivalTime!: moment.Moment | undefined;
    arrivalDateAdjustment!: string | undefined;
    departureTime!: moment.Moment | undefined;
    departureDateAdjustment!: string | undefined;
    airMiles!: string | undefined;
    elapsedTime!: string | undefined;
    elapsedLayoverTime!: string | undefined;
    equipment!: string | undefined;
    airport!: AirportDTO;
    readonly elapsedLayoverTimeFormat!: string | undefined;

    constructor(data?: IHiddenStopDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._Airport = _data["_Airport"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.arrivalTime = _data["arrivalTime"] ? moment(_data["arrivalTime"].toString()) : <any>undefined;
            this.arrivalDateAdjustment = _data["arrivalDateAdjustment"];
            this.departureTime = _data["departureTime"] ? moment(_data["departureTime"].toString()) : <any>undefined;
            this.departureDateAdjustment = _data["departureDateAdjustment"];
            this.airMiles = _data["airMiles"];
            this.elapsedTime = _data["elapsedTime"];
            this.elapsedLayoverTime = _data["elapsedLayoverTime"];
            this.equipment = _data["equipment"];
            this.airport = _data["airport"] ? AirportDTO.fromJS(_data["airport"]) : <any>undefined;
            (<any>this).elapsedLayoverTimeFormat = _data["elapsedLayoverTimeFormat"];
        }
    }

    static fromJS(data: any): HiddenStopDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HiddenStopDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_Airport"] = this._Airport;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["arrivalTime"] = this.arrivalTime ? this.arrivalTime.toISOString() : <any>undefined;
        data["arrivalDateAdjustment"] = this.arrivalDateAdjustment;
        data["departureTime"] = this.departureTime ? this.departureTime.toISOString() : <any>undefined;
        data["departureDateAdjustment"] = this.departureDateAdjustment;
        data["airMiles"] = this.airMiles;
        data["elapsedTime"] = this.elapsedTime;
        data["elapsedLayoverTime"] = this.elapsedLayoverTime;
        data["equipment"] = this.equipment;
        data["airport"] = this.airport ? this.airport.toJSON() : <any>undefined;
        data["elapsedLayoverTimeFormat"] = this.elapsedLayoverTimeFormat;
        return data;
    }
}

export interface IHiddenStopDTO {
    _Airport: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    arrivalTime: moment.Moment | undefined;
    arrivalDateAdjustment: string | undefined;
    departureTime: moment.Moment | undefined;
    departureDateAdjustment: string | undefined;
    airMiles: string | undefined;
    elapsedTime: string | undefined;
    elapsedLayoverTime: string | undefined;
    equipment: string | undefined;
    airport: AirportDTO;
    elapsedLayoverTimeFormat: string | undefined;
}

export class ScheduleDescDTO implements IScheduleDescDTO {
    rph!: number;
    departureDateAdjustment!: string | undefined;
    duration!: string | undefined;
    readonly durationMinutes!: number;
    departure!: DepartureDTO;
    arrival!: ArrivalDTO;
    carrier!: CarrierDTO;
    hiddenStop!: HiddenStopDTO[] | undefined;
    id!: string | undefined;
    pricingSourceId!: string | undefined;
    frequency!: string | undefined;
    stops!: string | undefined;
    eTicketable!: string | undefined;
    isBaggageAllowed!: boolean;
    baggageInfo!: string | undefined;
    mealInfo!: string | undefined;
    connectionTime!: string | undefined;
    isConnectionAirportChanged!: boolean;
    travelClass!: string | undefined;
    travelClassDescription!: string | undefined;
    actionCode!: string | undefined;

    constructor(data?: IScheduleDescDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rph = _data["rph"];
            this.departureDateAdjustment = _data["departureDateAdjustment"];
            this.duration = _data["duration"];
            (<any>this).durationMinutes = _data["durationMinutes"];
            this.departure = _data["departure"] ? DepartureDTO.fromJS(_data["departure"]) : <any>undefined;
            this.arrival = _data["arrival"] ? ArrivalDTO.fromJS(_data["arrival"]) : <any>undefined;
            this.carrier = _data["carrier"] ? CarrierDTO.fromJS(_data["carrier"]) : <any>undefined;
            if (Array.isArray(_data["hiddenStop"])) {
                this.hiddenStop = [] as any;
                for (let item of _data["hiddenStop"])
                    this.hiddenStop!.push(HiddenStopDTO.fromJS(item));
            }
            this.id = _data["id"];
            this.pricingSourceId = _data["pricingSourceId"];
            this.frequency = _data["frequency"];
            this.stops = _data["stops"];
            this.eTicketable = _data["eTicketable"];
            this.isBaggageAllowed = _data["isBaggageAllowed"];
            this.baggageInfo = _data["baggageInfo"];
            this.mealInfo = _data["mealInfo"];
            this.connectionTime = _data["connectionTime"];
            this.isConnectionAirportChanged = _data["isConnectionAirportChanged"];
            this.travelClass = _data["travelClass"];
            this.travelClassDescription = _data["travelClassDescription"];
            this.actionCode = _data["actionCode"];
        }
    }

    static fromJS(data: any): ScheduleDescDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDescDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rph"] = this.rph;
        data["departureDateAdjustment"] = this.departureDateAdjustment;
        data["duration"] = this.duration;
        data["durationMinutes"] = this.durationMinutes;
        data["departure"] = this.departure ? this.departure.toJSON() : <any>undefined;
        data["arrival"] = this.arrival ? this.arrival.toJSON() : <any>undefined;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        if (Array.isArray(this.hiddenStop)) {
            data["hiddenStop"] = [];
            for (let item of this.hiddenStop)
                data["hiddenStop"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["pricingSourceId"] = this.pricingSourceId;
        data["frequency"] = this.frequency;
        data["stops"] = this.stops;
        data["eTicketable"] = this.eTicketable;
        data["isBaggageAllowed"] = this.isBaggageAllowed;
        data["baggageInfo"] = this.baggageInfo;
        data["mealInfo"] = this.mealInfo;
        data["connectionTime"] = this.connectionTime;
        data["isConnectionAirportChanged"] = this.isConnectionAirportChanged;
        data["travelClass"] = this.travelClass;
        data["travelClassDescription"] = this.travelClassDescription;
        data["actionCode"] = this.actionCode;
        return data;
    }
}

export interface IScheduleDescDTO {
    rph: number;
    departureDateAdjustment: string | undefined;
    duration: string | undefined;
    durationMinutes: number;
    departure: DepartureDTO;
    arrival: ArrivalDTO;
    carrier: CarrierDTO;
    hiddenStop: HiddenStopDTO[] | undefined;
    id: string | undefined;
    pricingSourceId: string | undefined;
    frequency: string | undefined;
    stops: string | undefined;
    eTicketable: string | undefined;
    isBaggageAllowed: boolean;
    baggageInfo: string | undefined;
    mealInfo: string | undefined;
    connectionTime: string | undefined;
    isConnectionAirportChanged: boolean;
    travelClass: string | undefined;
    travelClassDescription: string | undefined;
    actionCode: string | undefined;
}

export class LegDescDTO implements ILegDescDTO {
    schedule!: ScheduleDescDTO[] | undefined;
    id!: string | undefined;
    readonly duration!: string | undefined;
    readonly durationMinutes!: number;
    readonly durationDays!: number;
    readonly durationFormat!: string | undefined;
    readonly schedulesCount!: number;
    readonly isBaggageAllowed!: boolean;
    readonly isConnectionAirportChanged!: boolean;
    departureAirport!: AirportDTO;
    arrivalAirport!: AirportDTO;
    readonly departureDateTime!: moment.Moment;
    readonly arrivalDateTime!: moment.Moment;
    carrier!: CarrierDTO;
    governating!: CarrierNameDTO;

    constructor(data?: ILegDescDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["schedule"])) {
                this.schedule = [] as any;
                for (let item of _data["schedule"])
                    this.schedule!.push(ScheduleDescDTO.fromJS(item));
            }
            this.id = _data["id"];
            (<any>this).duration = _data["duration"];
            (<any>this).durationMinutes = _data["durationMinutes"];
            (<any>this).durationDays = _data["durationDays"];
            (<any>this).durationFormat = _data["durationFormat"];
            (<any>this).schedulesCount = _data["schedulesCount"];
            (<any>this).isBaggageAllowed = _data["isBaggageAllowed"];
            (<any>this).isConnectionAirportChanged = _data["isConnectionAirportChanged"];
            this.departureAirport = _data["departureAirport"] ? AirportDTO.fromJS(_data["departureAirport"]) : <any>undefined;
            this.arrivalAirport = _data["arrivalAirport"] ? AirportDTO.fromJS(_data["arrivalAirport"]) : <any>undefined;
            (<any>this).departureDateTime = _data["departureDateTime"] ? moment(_data["departureDateTime"].toString()) : <any>undefined;
            (<any>this).arrivalDateTime = _data["arrivalDateTime"] ? moment(_data["arrivalDateTime"].toString()) : <any>undefined;
            this.carrier = _data["carrier"] ? CarrierDTO.fromJS(_data["carrier"]) : <any>undefined;
            this.governating = _data["governating"] ? CarrierNameDTO.fromJS(_data["governating"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LegDescDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LegDescDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (let item of this.schedule)
                data["schedule"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["duration"] = this.duration;
        data["durationMinutes"] = this.durationMinutes;
        data["durationDays"] = this.durationDays;
        data["durationFormat"] = this.durationFormat;
        data["schedulesCount"] = this.schedulesCount;
        data["isBaggageAllowed"] = this.isBaggageAllowed;
        data["isConnectionAirportChanged"] = this.isConnectionAirportChanged;
        data["departureAirport"] = this.departureAirport ? this.departureAirport.toJSON() : <any>undefined;
        data["arrivalAirport"] = this.arrivalAirport ? this.arrivalAirport.toJSON() : <any>undefined;
        data["departureDateTime"] = this.departureDateTime ? this.departureDateTime.toISOString() : <any>undefined;
        data["arrivalDateTime"] = this.arrivalDateTime ? this.arrivalDateTime.toISOString() : <any>undefined;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        data["governating"] = this.governating ? this.governating.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILegDescDTO {
    schedule: ScheduleDescDTO[] | undefined;
    id: string | undefined;
    duration: string | undefined;
    durationMinutes: number;
    durationDays: number;
    durationFormat: string | undefined;
    schedulesCount: number;
    isBaggageAllowed: boolean;
    isConnectionAirportChanged: boolean;
    departureAirport: AirportDTO;
    arrivalAirport: AirportDTO;
    departureDateTime: moment.Moment;
    arrivalDateTime: moment.Moment;
    carrier: CarrierDTO;
    governating: CarrierNameDTO;
}

export class BrandFeatureDTO implements IBrandFeatureDTO {
    id!: string | undefined;
    application!: string | undefined;
    serviceType!: string | undefined;
    serviceGroup!: string | undefined;
    subCode!: string | undefined;
    vendor!: string | undefined;
    commercialName!: string | undefined;

    constructor(data?: IBrandFeatureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.application = _data["application"];
            this.serviceType = _data["serviceType"];
            this.serviceGroup = _data["serviceGroup"];
            this.subCode = _data["subCode"];
            this.vendor = _data["vendor"];
            this.commercialName = _data["commercialName"];
        }
    }

    static fromJS(data: any): BrandFeatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BrandFeatureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["application"] = this.application;
        data["serviceType"] = this.serviceType;
        data["serviceGroup"] = this.serviceGroup;
        data["subCode"] = this.subCode;
        data["vendor"] = this.vendor;
        data["commercialName"] = this.commercialName;
        return data;
    }
}

export interface IBrandFeatureDTO {
    id: string | undefined;
    application: string | undefined;
    serviceType: string | undefined;
    serviceGroup: string | undefined;
    subCode: string | undefined;
    vendor: string | undefined;
    commercialName: string | undefined;
}

export class BrandTypeDTO implements IBrandTypeDTO {
    code!: string | undefined;
    brandName!: string | undefined;
    programID!: string | undefined;
    programCode!: string | undefined;
    programDescription!: string | undefined;
    programSystemCode!: string | undefined;
    htmlDescription!: string | undefined;
    brandFeatures!: BrandFeatureDTO[] | undefined;

    constructor(data?: IBrandTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.brandName = _data["brandName"];
            this.programID = _data["programID"];
            this.programCode = _data["programCode"];
            this.programDescription = _data["programDescription"];
            this.programSystemCode = _data["programSystemCode"];
            this.htmlDescription = _data["htmlDescription"];
            if (Array.isArray(_data["brandFeatures"])) {
                this.brandFeatures = [] as any;
                for (let item of _data["brandFeatures"])
                    this.brandFeatures!.push(BrandFeatureDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrandTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BrandTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["brandName"] = this.brandName;
        data["programID"] = this.programID;
        data["programCode"] = this.programCode;
        data["programDescription"] = this.programDescription;
        data["programSystemCode"] = this.programSystemCode;
        data["htmlDescription"] = this.htmlDescription;
        if (Array.isArray(this.brandFeatures)) {
            data["brandFeatures"] = [];
            for (let item of this.brandFeatures)
                data["brandFeatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBrandTypeDTO {
    code: string | undefined;
    brandName: string | undefined;
    programID: string | undefined;
    programCode: string | undefined;
    programDescription: string | undefined;
    programSystemCode: string | undefined;
    htmlDescription: string | undefined;
    brandFeatures: BrandFeatureDTO[] | undefined;
}

export class FareComponentDescDTO implements IFareComponentDescDTO {
    fareBasisCode!: string | undefined;
    farePassengerType!: string | undefined;
    corporateIdMatched!: boolean;
    oneWayFare!: boolean;
    webBasedFare!: boolean;
    negotiatedFare!: boolean;
    privateFare!: boolean;
    matchedAccountCode!: string | undefined;
    brand!: BrandTypeDTO;

    constructor(data?: IFareComponentDescDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fareBasisCode = _data["fareBasisCode"];
            this.farePassengerType = _data["farePassengerType"];
            this.corporateIdMatched = _data["corporateIdMatched"];
            this.oneWayFare = _data["oneWayFare"];
            this.webBasedFare = _data["webBasedFare"];
            this.negotiatedFare = _data["negotiatedFare"];
            this.privateFare = _data["privateFare"];
            this.matchedAccountCode = _data["matchedAccountCode"];
            this.brand = _data["brand"] ? BrandTypeDTO.fromJS(_data["brand"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FareComponentDescDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FareComponentDescDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fareBasisCode"] = this.fareBasisCode;
        data["farePassengerType"] = this.farePassengerType;
        data["corporateIdMatched"] = this.corporateIdMatched;
        data["oneWayFare"] = this.oneWayFare;
        data["webBasedFare"] = this.webBasedFare;
        data["negotiatedFare"] = this.negotiatedFare;
        data["privateFare"] = this.privateFare;
        data["matchedAccountCode"] = this.matchedAccountCode;
        data["brand"] = this.brand ? this.brand.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFareComponentDescDTO {
    fareBasisCode: string | undefined;
    farePassengerType: string | undefined;
    corporateIdMatched: boolean;
    oneWayFare: boolean;
    webBasedFare: boolean;
    negotiatedFare: boolean;
    privateFare: boolean;
    matchedAccountCode: string | undefined;
    brand: BrandTypeDTO;
}

export class FareComponentDTO implements IFareComponentDTO {
    fareCalculation!: FareComponentDescDTO;

    constructor(data?: IFareComponentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fareCalculation = _data["fareCalculation"] ? FareComponentDescDTO.fromJS(_data["fareCalculation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FareComponentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FareComponentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fareCalculation"] = this.fareCalculation ? this.fareCalculation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFareComponentDTO {
    fareCalculation: FareComponentDescDTO;
}

export class OBFeeDescDTO implements IOBFeeDescDTO {
    id!: string | undefined;
    type!: string | undefined;
    amount!: number;
    currency!: string | undefined;
    description!: string | undefined;

    constructor(data?: IOBFeeDescDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): OBFeeDescDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OBFeeDescDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["description"] = this.description;
        return data;
    }
}

export interface IOBFeeDescDTO {
    id: string | undefined;
    type: string | undefined;
    amount: number;
    currency: string | undefined;
    description: string | undefined;
}

export class FareMessageDTO implements IFareMessageDTO {
    type!: string | undefined;
    code!: string | undefined;
    carrier!: string | undefined;
    info!: string | undefined;
    value!: string | undefined;

    constructor(data?: IFareMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.carrier = _data["carrier"];
            this.info = _data["info"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FareMessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FareMessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["carrier"] = this.carrier;
        data["info"] = this.info;
        data["value"] = this.value;
        return data;
    }
}

export interface IFareMessageDTO {
    type: string | undefined;
    code: string | undefined;
    carrier: string | undefined;
    info: string | undefined;
    value: string | undefined;
}

export class PassengerTotalFareDTO implements IPassengerTotalFareDTO {
    totalFare!: number;
    totalTaxes!: number;
    currency!: string | undefined;
    equivalentAmount!: number;

    constructor(data?: IPassengerTotalFareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalFare = _data["totalFare"];
            this.totalTaxes = _data["totalTaxes"];
            this.currency = _data["currency"];
            this.equivalentAmount = _data["equivalentAmount"];
        }
    }

    static fromJS(data: any): PassengerTotalFareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerTotalFareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalFare"] = this.totalFare;
        data["totalTaxes"] = this.totalTaxes;
        data["currency"] = this.currency;
        data["equivalentAmount"] = this.equivalentAmount;
        return data;
    }
}

export interface IPassengerTotalFareDTO {
    totalFare: number;
    totalTaxes: number;
    currency: string | undefined;
    equivalentAmount: number;
}

export class PassengerBaggageInfoDto implements IPassengerBaggageInfoDto {
    itinerary!: string | undefined;
    baggageInfo!: string | undefined;
    description!: string | undefined;

    constructor(data?: IPassengerBaggageInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerary = _data["itinerary"];
            this.baggageInfo = _data["baggageInfo"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PassengerBaggageInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerBaggageInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerary"] = this.itinerary;
        data["baggageInfo"] = this.baggageInfo;
        data["description"] = this.description;
        return data;
    }
}

export interface IPassengerBaggageInfoDto {
    itinerary: string | undefined;
    baggageInfo: string | undefined;
    description: string | undefined;
}

export class FarePenaltyInfoDto implements IFarePenaltyInfoDto {
    beforeApply!: boolean;
    afterApply!: boolean;
    beforeAmount!: number | undefined;
    afterAmount!: number | undefined;

    constructor(data?: IFarePenaltyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beforeApply = _data["beforeApply"];
            this.afterApply = _data["afterApply"];
            this.beforeAmount = _data["beforeAmount"];
            this.afterAmount = _data["afterAmount"];
        }
    }

    static fromJS(data: any): FarePenaltyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FarePenaltyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beforeApply"] = this.beforeApply;
        data["afterApply"] = this.afterApply;
        data["beforeAmount"] = this.beforeAmount;
        data["afterAmount"] = this.afterAmount;
        return data;
    }
}

export interface IFarePenaltyInfoDto {
    beforeApply: boolean;
    afterApply: boolean;
    beforeAmount: number | undefined;
    afterAmount: number | undefined;
}

export class PassengerInfoDTO implements IPassengerInfoDTO {
    fareComponent!: FareComponentDTO[] | undefined;
    obFee!: OBFeeDescDTO[] | undefined;
    fareMessage!: FareMessageDTO[] | undefined;
    passengerTotalFare!: PassengerTotalFareDTO;
    passengerType!: string | undefined;
    discountCode!: string | undefined;
    passengerNumber!: string | undefined;
    nonRefundable!: boolean;
    readonly isBaggageAllowed!: boolean;
    readonly baggageInformation: any | undefined;
    readonly passengerBaggageInfo!: PassengerBaggageInfoDto[] | undefined;
    readonly penaltiesInfoNotAvailable!: boolean;
    readonly isRefundable!: boolean;
    readonly isChangeable!: boolean;
    readonly refundConditions!: boolean;
    readonly changeConditions!: boolean;
    refundableInfo!: FarePenaltyInfoDto;
    changeableInfo!: FarePenaltyInfoDto;
    readonly fareBasis!: string[] | undefined;
    readonly isPrivateFare!: boolean;
    readonly isNegotiatedFare!: boolean;

    constructor(data?: IPassengerInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fareComponent"])) {
                this.fareComponent = [] as any;
                for (let item of _data["fareComponent"])
                    this.fareComponent!.push(FareComponentDTO.fromJS(item));
            }
            if (Array.isArray(_data["obFee"])) {
                this.obFee = [] as any;
                for (let item of _data["obFee"])
                    this.obFee!.push(OBFeeDescDTO.fromJS(item));
            }
            if (Array.isArray(_data["fareMessage"])) {
                this.fareMessage = [] as any;
                for (let item of _data["fareMessage"])
                    this.fareMessage!.push(FareMessageDTO.fromJS(item));
            }
            this.passengerTotalFare = _data["passengerTotalFare"] ? PassengerTotalFareDTO.fromJS(_data["passengerTotalFare"]) : <any>undefined;
            this.passengerType = _data["passengerType"];
            this.discountCode = _data["discountCode"];
            this.passengerNumber = _data["passengerNumber"];
            this.nonRefundable = _data["nonRefundable"];
            (<any>this).isBaggageAllowed = _data["isBaggageAllowed"];
            if (Array.isArray(_data["passengerBaggageInfo"])) {
                (<any>this).passengerBaggageInfo = [] as any;
                for (let item of _data["passengerBaggageInfo"])
                    (<any>this).passengerBaggageInfo!.push(PassengerBaggageInfoDto.fromJS(item));
            }
            (<any>this).penaltiesInfoNotAvailable = _data["penaltiesInfoNotAvailable"];
            (<any>this).isRefundable = _data["isRefundable"];
            (<any>this).isChangeable = _data["isChangeable"];
            (<any>this).refundConditions = _data["refundConditions"];
            (<any>this).changeConditions = _data["changeConditions"];
            this.refundableInfo = _data["refundableInfo"] ? FarePenaltyInfoDto.fromJS(_data["refundableInfo"]) : <any>undefined;
            this.changeableInfo = _data["changeableInfo"] ? FarePenaltyInfoDto.fromJS(_data["changeableInfo"]) : <any>undefined;
            if (Array.isArray(_data["fareBasis"])) {
                (<any>this).fareBasis = [] as any;
                for (let item of _data["fareBasis"])
                    (<any>this).fareBasis!.push(item);
            }
            (<any>this).isPrivateFare = _data["isPrivateFare"];
            (<any>this).isNegotiatedFare = _data["isNegotiatedFare"];
        }
    }

    static fromJS(data: any): PassengerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fareComponent)) {
            data["fareComponent"] = [];
            for (let item of this.fareComponent)
                data["fareComponent"].push(item.toJSON());
        }
        if (Array.isArray(this.obFee)) {
            data["obFee"] = [];
            for (let item of this.obFee)
                data["obFee"].push(item.toJSON());
        }
        if (Array.isArray(this.fareMessage)) {
            data["fareMessage"] = [];
            for (let item of this.fareMessage)
                data["fareMessage"].push(item.toJSON());
        }
        data["passengerTotalFare"] = this.passengerTotalFare ? this.passengerTotalFare.toJSON() : <any>undefined;
        data["passengerType"] = this.passengerType;
        data["discountCode"] = this.discountCode;
        data["passengerNumber"] = this.passengerNumber;
        data["nonRefundable"] = this.nonRefundable;
        data["isBaggageAllowed"] = this.isBaggageAllowed;
        if (Array.isArray(this.passengerBaggageInfo)) {
            data["passengerBaggageInfo"] = [];
            for (let item of this.passengerBaggageInfo)
                data["passengerBaggageInfo"].push(item.toJSON());
        }
        data["penaltiesInfoNotAvailable"] = this.penaltiesInfoNotAvailable;
        data["isRefundable"] = this.isRefundable;
        data["isChangeable"] = this.isChangeable;
        data["refundConditions"] = this.refundConditions;
        data["changeConditions"] = this.changeConditions;
        data["refundableInfo"] = this.refundableInfo ? this.refundableInfo.toJSON() : <any>undefined;
        data["changeableInfo"] = this.changeableInfo ? this.changeableInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.fareBasis)) {
            data["fareBasis"] = [];
            for (let item of this.fareBasis)
                data["fareBasis"].push(item);
        }
        data["isPrivateFare"] = this.isPrivateFare;
        data["isNegotiatedFare"] = this.isNegotiatedFare;
        return data;
    }
}

export interface IPassengerInfoDTO {
    fareComponent: FareComponentDTO[] | undefined;
    obFee: OBFeeDescDTO[] | undefined;
    fareMessage: FareMessageDTO[] | undefined;
    passengerTotalFare: PassengerTotalFareDTO;
    passengerType: string | undefined;
    discountCode: string | undefined;
    passengerNumber: string | undefined;
    nonRefundable: boolean;
    isBaggageAllowed: boolean;
    passengerBaggageInfo: PassengerBaggageInfoDto[] | undefined;
    penaltiesInfoNotAvailable: boolean;
    isRefundable: boolean;
    isChangeable: boolean;
    refundConditions: boolean;
    changeConditions: boolean;
    refundableInfo: FarePenaltyInfoDto;
    changeableInfo: FarePenaltyInfoDto;
    fareBasis: string[] | undefined;
    isPrivateFare: boolean;
    isNegotiatedFare: boolean;
}

export class TotalFareDTO implements ITotalFareDTO {
    readonly feeValueAmount!: number | undefined;
    readonly agencyFeeValueAmount!: number | undefined;
    discount!: number;
    readonly totalDue!: number;

    constructor(data?: ITotalFareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).feeValueAmount = _data["feeValueAmount"];
            (<any>this).agencyFeeValueAmount = _data["agencyFeeValueAmount"];
            this.discount = _data["discount"];
            (<any>this).totalDue = _data["totalDue"];
        }
    }

    static fromJS(data: any): TotalFareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TotalFareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeValueAmount"] = this.feeValueAmount;
        data["agencyFeeValueAmount"] = this.agencyFeeValueAmount;
        data["discount"] = this.discount;
        data["totalDue"] = this.totalDue;
        return data;
    }
}

export interface ITotalFareDTO {
    feeValueAmount: number | undefined;
    agencyFeeValueAmount: number | undefined;
    discount: number;
    totalDue: number;
}

export class FareDTO implements IFareDTO {
    passengerInfo!: PassengerInfoDTO[] | undefined;
    totalFare!: TotalFareDTO;
    validatingCarrier!: CarrierNameDTO[] | undefined;
    readonly cabinClass!: string | undefined;
    lastTicketDate!: moment.Moment | undefined;
    readonly name!: string | undefined;
    readonly isPrivateFare!: boolean;
    readonly isNegotiatedFare!: boolean;
    readonly htmlDescription!: string | undefined;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;

    constructor(data?: IFareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["passengerInfo"])) {
                this.passengerInfo = [] as any;
                for (let item of _data["passengerInfo"])
                    this.passengerInfo!.push(PassengerInfoDTO.fromJS(item));
            }
            this.totalFare = _data["totalFare"] ? TotalFareDTO.fromJS(_data["totalFare"]) : <any>undefined;
            if (Array.isArray(_data["validatingCarrier"])) {
                this.validatingCarrier = [] as any;
                for (let item of _data["validatingCarrier"])
                    this.validatingCarrier!.push(CarrierNameDTO.fromJS(item));
            }
            (<any>this).cabinClass = _data["cabinClass"];
            this.lastTicketDate = _data["lastTicketDate"] ? moment(_data["lastTicketDate"].toString()) : <any>undefined;
            (<any>this).name = _data["name"];
            (<any>this).isPrivateFare = _data["isPrivateFare"];
            (<any>this).isNegotiatedFare = _data["isNegotiatedFare"];
            (<any>this).htmlDescription = _data["htmlDescription"];
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
        }
    }

    static fromJS(data: any): FareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.passengerInfo)) {
            data["passengerInfo"] = [];
            for (let item of this.passengerInfo)
                data["passengerInfo"].push(item.toJSON());
        }
        data["totalFare"] = this.totalFare ? this.totalFare.toJSON() : <any>undefined;
        if (Array.isArray(this.validatingCarrier)) {
            data["validatingCarrier"] = [];
            for (let item of this.validatingCarrier)
                data["validatingCarrier"].push(item.toJSON());
        }
        data["cabinClass"] = this.cabinClass;
        data["lastTicketDate"] = this.lastTicketDate ? this.lastTicketDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["isPrivateFare"] = this.isPrivateFare;
        data["isNegotiatedFare"] = this.isNegotiatedFare;
        data["htmlDescription"] = this.htmlDescription;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        return data;
    }
}

export interface IFareDTO {
    passengerInfo: PassengerInfoDTO[] | undefined;
    totalFare: TotalFareDTO;
    validatingCarrier: CarrierNameDTO[] | undefined;
    cabinClass: string | undefined;
    lastTicketDate: moment.Moment | undefined;
    name: string | undefined;
    isPrivateFare: boolean;
    isNegotiatedFare: boolean;
    htmlDescription: string | undefined;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
}

export class TicketDTO implements ITicketDTO {
    ticketGroup!: string | undefined;
    availableCount!: number;
    leg!: LegDescDTO[] | undefined;
    pricingInformation!: PricingInformationDTO;
    isNotSaleable!: boolean;
    notSaleableMessages!: string[] | undefined;

    constructor(data?: ITicketDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketGroup = _data["ticketGroup"];
            this.availableCount = _data["availableCount"];
            if (Array.isArray(_data["leg"])) {
                this.leg = [] as any;
                for (let item of _data["leg"])
                    this.leg!.push(LegDescDTO.fromJS(item));
            }
            this.pricingInformation = _data["pricingInformation"] ? PricingInformationDTO.fromJS(_data["pricingInformation"]) : <any>undefined;
            this.isNotSaleable = _data["isNotSaleable"];
            if (Array.isArray(_data["notSaleableMessages"])) {
                this.notSaleableMessages = [] as any;
                for (let item of _data["notSaleableMessages"])
                    this.notSaleableMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): TicketDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TicketDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketGroup"] = this.ticketGroup;
        data["availableCount"] = this.availableCount;
        if (Array.isArray(this.leg)) {
            data["leg"] = [];
            for (let item of this.leg)
                data["leg"].push(item.toJSON());
        }
        data["pricingInformation"] = this.pricingInformation ? this.pricingInformation.toJSON() : <any>undefined;
        data["isNotSaleable"] = this.isNotSaleable;
        if (Array.isArray(this.notSaleableMessages)) {
            data["notSaleableMessages"] = [];
            for (let item of this.notSaleableMessages)
                data["notSaleableMessages"].push(item);
        }
        return data;
    }
}

export interface ITicketDTO {
    ticketGroup: string | undefined;
    availableCount: number;
    leg: LegDescDTO[] | undefined;
    pricingInformation: PricingInformationDTO;
    isNotSaleable: boolean;
    notSaleableMessages: string[] | undefined;
}

export class PricingInformationDTO implements IPricingInformationDTO {
    id!: string | undefined;
    fare!: FareDTO;
    ticket!: TicketDTO[] | undefined;
    pricingSubsource!: string | undefined;
    travelClass!: string | undefined;
    travelClassCode!: string | undefined;
    comfortClass!: string | undefined;
    comfortClassCode!: string | undefined;
    hasMoreFare!: boolean;

    constructor(data?: IPricingInformationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fare = _data["fare"] ? FareDTO.fromJS(_data["fare"]) : <any>undefined;
            if (Array.isArray(_data["ticket"])) {
                this.ticket = [] as any;
                for (let item of _data["ticket"])
                    this.ticket!.push(TicketDTO.fromJS(item));
            }
            this.pricingSubsource = _data["pricingSubsource"];
            this.travelClass = _data["travelClass"];
            this.travelClassCode = _data["travelClassCode"];
            this.comfortClass = _data["comfortClass"];
            this.comfortClassCode = _data["comfortClassCode"];
            this.hasMoreFare = _data["hasMoreFare"];
        }
    }

    static fromJS(data: any): PricingInformationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PricingInformationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fare"] = this.fare ? this.fare.toJSON() : <any>undefined;
        if (Array.isArray(this.ticket)) {
            data["ticket"] = [];
            for (let item of this.ticket)
                data["ticket"].push(item.toJSON());
        }
        data["pricingSubsource"] = this.pricingSubsource;
        data["travelClass"] = this.travelClass;
        data["travelClassCode"] = this.travelClassCode;
        data["comfortClass"] = this.comfortClass;
        data["comfortClassCode"] = this.comfortClassCode;
        data["hasMoreFare"] = this.hasMoreFare;
        return data;
    }
}

export interface IPricingInformationDTO {
    id: string | undefined;
    fare: FareDTO;
    ticket: TicketDTO[] | undefined;
    pricingSubsource: string | undefined;
    travelClass: string | undefined;
    travelClassCode: string | undefined;
    comfortClass: string | undefined;
    comfortClassCode: string | undefined;
    hasMoreFare: boolean;
}

export class CustomSupplierParametersDTO implements ICustomSupplierParametersDTO {
    seatMap!: string | undefined;
    bookingOnHoldAllowed!: boolean;
    luggageOptions!: LuggageOptionsDTO[] | undefined;
    handLuggageOptions!: LuggageOptionsDTO[] | undefined;
    flightExtrasOptions!: LuggageOptionsDTO[] | undefined;

    constructor(data?: ICustomSupplierParametersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seatMap = _data["seatMap"];
            this.bookingOnHoldAllowed = _data["bookingOnHoldAllowed"];
            if (Array.isArray(_data["luggageOptions"])) {
                this.luggageOptions = [] as any;
                for (let item of _data["luggageOptions"])
                    this.luggageOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["handLuggageOptions"])) {
                this.handLuggageOptions = [] as any;
                for (let item of _data["handLuggageOptions"])
                    this.handLuggageOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["flightExtrasOptions"])) {
                this.flightExtrasOptions = [] as any;
                for (let item of _data["flightExtrasOptions"])
                    this.flightExtrasOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomSupplierParametersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomSupplierParametersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seatMap"] = this.seatMap;
        data["bookingOnHoldAllowed"] = this.bookingOnHoldAllowed;
        if (Array.isArray(this.luggageOptions)) {
            data["luggageOptions"] = [];
            for (let item of this.luggageOptions)
                data["luggageOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.handLuggageOptions)) {
            data["handLuggageOptions"] = [];
            for (let item of this.handLuggageOptions)
                data["handLuggageOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.flightExtrasOptions)) {
            data["flightExtrasOptions"] = [];
            for (let item of this.flightExtrasOptions)
                data["flightExtrasOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomSupplierParametersDTO {
    seatMap: string | undefined;
    bookingOnHoldAllowed: boolean;
    luggageOptions: LuggageOptionsDTO[] | undefined;
    handLuggageOptions: LuggageOptionsDTO[] | undefined;
    flightExtrasOptions: LuggageOptionsDTO[] | undefined;
}

export class ItineraryDTO implements IItineraryDTO {
    requestDataMD5!: string | undefined;
    tripType!: TripTypeDTO;
    legs!: LegDescDTO[] | undefined;
    pricingInformation!: PricingInformationDTO[] | undefined;
    customSupplierParameters!: CustomSupplierParametersDTO;
    selectedPricingInformation!: PricingInformationDTO;
    id!: string | undefined;
    pricingSource!: string | undefined;
    supplier!: string | undefined;
    supplierRef!: string | undefined;
    departureLeg!: LegDescDTO;
    returnLeg!: LegDescDTO;
    readonly totalPrice!: number;
    readonly totalDue!: number;
    feeValue!: number;
    feeValueSpecified!: boolean;
    agencyFeeValue!: number;
    agencyFeeValueSpecified!: boolean;
    totalPax!: number;
    readonly validatingCarrier!: string | undefined;
    readonly cabinClass!: string | undefined;
    inPolicy!: boolean | undefined;
    hasMoreFare!: boolean;
    policyViolationDescription!: string | undefined;

    constructor(data?: IItineraryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestDataMD5 = _data["requestDataMD5"];
            this.tripType = _data["tripType"];
            if (Array.isArray(_data["legs"])) {
                this.legs = [] as any;
                for (let item of _data["legs"])
                    this.legs!.push(LegDescDTO.fromJS(item));
            }
            if (Array.isArray(_data["pricingInformation"])) {
                this.pricingInformation = [] as any;
                for (let item of _data["pricingInformation"])
                    this.pricingInformation!.push(PricingInformationDTO.fromJS(item));
            }
            this.customSupplierParameters = _data["customSupplierParameters"] ? CustomSupplierParametersDTO.fromJS(_data["customSupplierParameters"]) : <any>undefined;
            this.selectedPricingInformation = _data["selectedPricingInformation"] ? PricingInformationDTO.fromJS(_data["selectedPricingInformation"]) : <any>undefined;
            this.id = _data["id"];
            this.pricingSource = _data["pricingSource"];
            this.supplier = _data["supplier"];
            this.supplierRef = _data["supplierRef"];
            this.departureLeg = _data["departureLeg"] ? LegDescDTO.fromJS(_data["departureLeg"]) : <any>undefined;
            this.returnLeg = _data["returnLeg"] ? LegDescDTO.fromJS(_data["returnLeg"]) : <any>undefined;
            (<any>this).totalPrice = _data["totalPrice"];
            (<any>this).totalDue = _data["totalDue"];
            this.feeValue = _data["feeValue"];
            this.feeValueSpecified = _data["feeValueSpecified"];
            this.agencyFeeValue = _data["agencyFeeValue"];
            this.agencyFeeValueSpecified = _data["agencyFeeValueSpecified"];
            this.totalPax = _data["totalPax"];
            (<any>this).validatingCarrier = _data["validatingCarrier"];
            (<any>this).cabinClass = _data["cabinClass"];
            this.inPolicy = _data["inPolicy"];
            this.hasMoreFare = _data["hasMoreFare"];
            this.policyViolationDescription = _data["policyViolationDescription"];
        }
    }

    static fromJS(data: any): ItineraryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItineraryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestDataMD5"] = this.requestDataMD5;
        data["tripType"] = this.tripType;
        if (Array.isArray(this.legs)) {
            data["legs"] = [];
            for (let item of this.legs)
                data["legs"].push(item.toJSON());
        }
        if (Array.isArray(this.pricingInformation)) {
            data["pricingInformation"] = [];
            for (let item of this.pricingInformation)
                data["pricingInformation"].push(item.toJSON());
        }
        data["customSupplierParameters"] = this.customSupplierParameters ? this.customSupplierParameters.toJSON() : <any>undefined;
        data["selectedPricingInformation"] = this.selectedPricingInformation ? this.selectedPricingInformation.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["pricingSource"] = this.pricingSource;
        data["supplier"] = this.supplier;
        data["supplierRef"] = this.supplierRef;
        data["departureLeg"] = this.departureLeg ? this.departureLeg.toJSON() : <any>undefined;
        data["returnLeg"] = this.returnLeg ? this.returnLeg.toJSON() : <any>undefined;
        data["totalPrice"] = this.totalPrice;
        data["totalDue"] = this.totalDue;
        data["feeValue"] = this.feeValue;
        data["feeValueSpecified"] = this.feeValueSpecified;
        data["agencyFeeValue"] = this.agencyFeeValue;
        data["agencyFeeValueSpecified"] = this.agencyFeeValueSpecified;
        data["totalPax"] = this.totalPax;
        data["validatingCarrier"] = this.validatingCarrier;
        data["cabinClass"] = this.cabinClass;
        data["inPolicy"] = this.inPolicy;
        data["hasMoreFare"] = this.hasMoreFare;
        data["policyViolationDescription"] = this.policyViolationDescription;
        return data;
    }
}

export interface IItineraryDTO {
    requestDataMD5: string | undefined;
    tripType: TripTypeDTO;
    legs: LegDescDTO[] | undefined;
    pricingInformation: PricingInformationDTO[] | undefined;
    customSupplierParameters: CustomSupplierParametersDTO;
    selectedPricingInformation: PricingInformationDTO;
    id: string | undefined;
    pricingSource: string | undefined;
    supplier: string | undefined;
    supplierRef: string | undefined;
    departureLeg: LegDescDTO;
    returnLeg: LegDescDTO;
    totalPrice: number;
    totalDue: number;
    feeValue: number;
    feeValueSpecified: boolean;
    agencyFeeValue: number;
    agencyFeeValueSpecified: boolean;
    totalPax: number;
    validatingCarrier: string | undefined;
    cabinClass: string | undefined;
    inPolicy: boolean | undefined;
    hasMoreFare: boolean;
    policyViolationDescription: string | undefined;
}

export class ItineraryDetailDTO implements IItineraryDetailDTO {
    itinerary!: ItineraryDTO;
    tripType!: TripTypeDTO;

    constructor(data?: IItineraryDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerary = _data["itinerary"] ? ItineraryDTO.fromJS(_data["itinerary"]) : <any>undefined;
            this.tripType = _data["tripType"];
        }
    }

    static fromJS(data: any): ItineraryDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItineraryDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerary"] = this.itinerary ? this.itinerary.toJSON() : <any>undefined;
        data["tripType"] = this.tripType;
        return data;
    }
}

export interface IItineraryDetailDTO {
    itinerary: ItineraryDTO;
    tripType: TripTypeDTO;
}

export class FlightAssistedBooking implements IFlightAssistedBooking {
    assistedBookingReservation!: AirBookRequestDTO;
    assistedBookingItineraryDetail!: ItineraryDetailDTO;
    userId!: string | undefined;
    username!: string | undefined;
    status!: AssistedBookingStatus;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: IFlightAssistedBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistedBookingReservation = _data["assistedBookingReservation"] ? AirBookRequestDTO.fromJS(_data["assistedBookingReservation"]) : <any>undefined;
            this.assistedBookingItineraryDetail = _data["assistedBookingItineraryDetail"] ? ItineraryDetailDTO.fromJS(_data["assistedBookingItineraryDetail"]) : <any>undefined;
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.status = _data["status"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): FlightAssistedBooking {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAssistedBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistedBookingReservation"] = this.assistedBookingReservation ? this.assistedBookingReservation.toJSON() : <any>undefined;
        data["assistedBookingItineraryDetail"] = this.assistedBookingItineraryDetail ? this.assistedBookingItineraryDetail.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["status"] = this.status;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IFlightAssistedBooking {
    assistedBookingReservation: AirBookRequestDTO;
    assistedBookingItineraryDetail: ItineraryDetailDTO;
    userId: string | undefined;
    username: string | undefined;
    status: AssistedBookingStatus;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class GuestCompositionDto implements IGuestCompositionDto {
    adults!: number;
    children!: number;
    childAges!: number[] | undefined;

    constructor(data?: IGuestCompositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adults = _data["adults"];
            this.children = _data["children"];
            if (Array.isArray(_data["childAges"])) {
                this.childAges = [] as any;
                for (let item of _data["childAges"])
                    this.childAges!.push(item);
            }
        }
    }

    static fromJS(data: any): GuestCompositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestCompositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adults"] = this.adults;
        data["children"] = this.children;
        if (Array.isArray(this.childAges)) {
            data["childAges"] = [];
            for (let item of this.childAges)
                data["childAges"].push(item);
        }
        return data;
    }
}

export interface IGuestCompositionDto {
    adults: number;
    children: number;
    childAges: number[] | undefined;
}

export class AddressDto implements IAddressDto {
    address1!: string | undefined;
    address2!: string | undefined;
    zip!: string | undefined;
    city!: string | undefined;
    province!: string | undefined;
    country!: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        return data;
    }
}

export interface IAddressDto {
    address1: string | undefined;
    address2: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    province: string | undefined;
    country: string | undefined;
}

export enum GuestTypeDto {
    Adult = 0,
    Child = 1,
}

export enum DocumentTypeDto {
    Passport = 0,
    IdentityCard = 1,
}

export class DocumentDto implements IDocumentDto {
    type!: DocumentTypeDto;
    number!: string | undefined;
    expirationDate!: moment.Moment;
    countryOfIssue!: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.number = _data["number"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.countryOfIssue = _data["countryOfIssue"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["number"] = this.number;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["countryOfIssue"] = this.countryOfIssue;
        return data;
    }
}

export interface IDocumentDto {
    type: DocumentTypeDto;
    number: string | undefined;
    expirationDate: moment.Moment;
    countryOfIssue: string | undefined;
}

export class RefGuestDto implements IRefGuestDto {
    homePhone!: string | undefined;
    mobilePhone!: string | undefined;
    workPhone!: string | undefined;
    fax!: string | undefined;
    email!: string | undefined;
    address!: AddressDto;
    index!: number;
    firstName!: string | undefined;
    middleName!: string | undefined;
    lastName!: string | undefined;
    birthDate!: moment.Moment | undefined;
    age!: number | undefined;
    gender!: GuestGenderDto;
    type!: GuestTypeDto;
    document!: DocumentDto;
    citizenship!: string | undefined;

    constructor(data?: IRefGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.homePhone = _data["homePhone"];
            this.mobilePhone = _data["mobilePhone"];
            this.workPhone = _data["workPhone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.index = _data["index"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.gender = _data["gender"];
            this.type = _data["type"];
            this.document = _data["document"] ? DocumentDto.fromJS(_data["document"]) : <any>undefined;
            this.citizenship = _data["citizenship"];
        }
    }

    static fromJS(data: any): RefGuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefGuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homePhone"] = this.homePhone;
        data["mobilePhone"] = this.mobilePhone;
        data["workPhone"] = this.workPhone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["index"] = this.index;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["gender"] = this.gender;
        data["type"] = this.type;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["citizenship"] = this.citizenship;
        return data;
    }
}

export interface IRefGuestDto {
    homePhone: string | undefined;
    mobilePhone: string | undefined;
    workPhone: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    address: AddressDto;
    index: number;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    birthDate: moment.Moment | undefined;
    age: number | undefined;
    gender: GuestGenderDto;
    type: GuestTypeDto;
    document: DocumentDto;
    citizenship: string | undefined;
}

export class GuestDto implements IGuestDto {
    index!: number;
    firstName!: string | undefined;
    middleName!: string | undefined;
    lastName!: string | undefined;
    birthDate!: moment.Moment | undefined;
    age!: number | undefined;
    gender!: GuestGenderDto;
    type!: GuestTypeDto;
    document!: DocumentDto;
    citizenship!: string | undefined;

    constructor(data?: IGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.gender = _data["gender"];
            this.type = _data["type"];
            this.document = _data["document"] ? DocumentDto.fromJS(_data["document"]) : <any>undefined;
            this.citizenship = _data["citizenship"];
        }
    }

    static fromJS(data: any): GuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["gender"] = this.gender;
        data["type"] = this.type;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["citizenship"] = this.citizenship;
        return data;
    }
}

export interface IGuestDto {
    index: number;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    birthDate: moment.Moment | undefined;
    age: number | undefined;
    gender: GuestGenderDto;
    type: GuestTypeDto;
    document: DocumentDto;
    citizenship: string | undefined;
}

export class GuestsDto implements IGuestsDto {
    reference!: RefGuestDto;
    others!: GuestDto[] | undefined;

    constructor(data?: IGuestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"] ? RefGuestDto.fromJS(_data["reference"]) : <any>undefined;
            if (Array.isArray(_data["others"])) {
                this.others = [] as any;
                for (let item of _data["others"])
                    this.others!.push(GuestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GuestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
        if (Array.isArray(this.others)) {
            data["others"] = [];
            for (let item of this.others)
                data["others"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGuestsDto {
    reference: RefGuestDto;
    others: GuestDto[] | undefined;
}

export class BuyStructureRoomRequestDto implements IBuyStructureRoomRequestDto {
    name!: string | undefined;
    guestComposition!: GuestCompositionDto;
    guests!: GuestsDto;

    constructor(data?: IBuyStructureRoomRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.guestComposition = _data["guestComposition"] ? GuestCompositionDto.fromJS(_data["guestComposition"]) : <any>undefined;
            this.guests = _data["guests"] ? GuestsDto.fromJS(_data["guests"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BuyStructureRoomRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyStructureRoomRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["guestComposition"] = this.guestComposition ? this.guestComposition.toJSON() : <any>undefined;
        data["guests"] = this.guests ? this.guests.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBuyStructureRoomRequestDto {
    name: string | undefined;
    guestComposition: GuestCompositionDto;
    guests: GuestsDto;
}

export class AmountPercentDto implements IAmountPercentDto {
    basisType!: string | undefined;
    percent!: string | undefined;
    amount!: number;
    amountSpecified!: boolean;
    currencyCode!: string | undefined;
    nmbrOfNights!: number;
    nmbrOfNightsSpecified!: boolean;

    constructor(data?: IAmountPercentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.basisType = _data["basisType"];
            this.percent = _data["percent"];
            this.amount = _data["amount"];
            this.amountSpecified = _data["amountSpecified"];
            this.currencyCode = _data["currencyCode"];
            this.nmbrOfNights = _data["nmbrOfNights"];
            this.nmbrOfNightsSpecified = _data["nmbrOfNightsSpecified"];
        }
    }

    static fromJS(data: any): AmountPercentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmountPercentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["basisType"] = this.basisType;
        data["percent"] = this.percent;
        data["amount"] = this.amount;
        data["amountSpecified"] = this.amountSpecified;
        data["currencyCode"] = this.currencyCode;
        data["nmbrOfNights"] = this.nmbrOfNights;
        data["nmbrOfNightsSpecified"] = this.nmbrOfNightsSpecified;
        return data;
    }
}

export interface IAmountPercentDto {
    basisType: string | undefined;
    percent: string | undefined;
    amount: number;
    amountSpecified: boolean;
    currencyCode: string | undefined;
    nmbrOfNights: number;
    nmbrOfNightsSpecified: boolean;
}

export class DeadlineDto implements IDeadlineDto {
    offsetTimeUnit!: string | undefined;
    offsetUnitMultiplier!: number;
    offsetDropTime!: string | undefined;

    constructor(data?: IDeadlineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offsetTimeUnit = _data["offsetTimeUnit"];
            this.offsetUnitMultiplier = _data["offsetUnitMultiplier"];
            this.offsetDropTime = _data["offsetDropTime"];
        }
    }

    static fromJS(data: any): DeadlineDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeadlineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offsetTimeUnit"] = this.offsetTimeUnit;
        data["offsetUnitMultiplier"] = this.offsetUnitMultiplier;
        data["offsetDropTime"] = this.offsetDropTime;
        return data;
    }
}

export interface IDeadlineDto {
    offsetTimeUnit: string | undefined;
    offsetUnitMultiplier: number;
    offsetDropTime: string | undefined;
}

export class CancelPenaltyDto implements ICancelPenaltyDto {
    amountPercent!: AmountPercentDto;
    deadline!: DeadlineDto;
    start!: moment.Moment;
    end!: moment.Moment;
    roomTypeCode!: string | undefined;
    description!: string | undefined;

    constructor(data?: ICancelPenaltyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountPercent = _data["amountPercent"] ? AmountPercentDto.fromJS(_data["amountPercent"]) : <any>undefined;
            this.deadline = _data["deadline"] ? DeadlineDto.fromJS(_data["deadline"]) : <any>undefined;
            this.start = _data["start"] ? moment(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? moment(_data["end"].toString()) : <any>undefined;
            this.roomTypeCode = _data["roomTypeCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CancelPenaltyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPenaltyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountPercent"] = this.amountPercent ? this.amountPercent.toJSON() : <any>undefined;
        data["deadline"] = this.deadline ? this.deadline.toJSON() : <any>undefined;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["roomTypeCode"] = this.roomTypeCode;
        data["description"] = this.description;
        return data;
    }
}

export interface ICancelPenaltyDto {
    amountPercent: AmountPercentDto;
    deadline: DeadlineDto;
    start: moment.Moment;
    end: moment.Moment;
    roomTypeCode: string | undefined;
    description: string | undefined;
}

export class ArrayOfCancelPenaltiesDto implements IArrayOfCancelPenaltiesDto {
    remarks!: string | undefined;
    provider!: string | undefined;
    cancelPenalty!: CancelPenaltyDto[] | undefined;
    expirationDate!: moment.Moment;
    freePeriodDate!: moment.Moment;
    refundable!: boolean;

    constructor(data?: IArrayOfCancelPenaltiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remarks = _data["remarks"];
            this.provider = _data["provider"];
            if (Array.isArray(_data["cancelPenalty"])) {
                this.cancelPenalty = [] as any;
                for (let item of _data["cancelPenalty"])
                    this.cancelPenalty!.push(CancelPenaltyDto.fromJS(item));
            }
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.freePeriodDate = _data["freePeriodDate"] ? moment(_data["freePeriodDate"].toString()) : <any>undefined;
            this.refundable = _data["refundable"];
        }
    }

    static fromJS(data: any): ArrayOfCancelPenaltiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArrayOfCancelPenaltiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remarks"] = this.remarks;
        data["provider"] = this.provider;
        if (Array.isArray(this.cancelPenalty)) {
            data["cancelPenalty"] = [];
            for (let item of this.cancelPenalty)
                data["cancelPenalty"].push(item.toJSON());
        }
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["freePeriodDate"] = this.freePeriodDate ? this.freePeriodDate.toISOString() : <any>undefined;
        data["refundable"] = this.refundable;
        return data;
    }
}

export interface IArrayOfCancelPenaltiesDto {
    remarks: string | undefined;
    provider: string | undefined;
    cancelPenalty: CancelPenaltyDto[] | undefined;
    expirationDate: moment.Moment;
    freePeriodDate: moment.Moment;
    refundable: boolean;
}

export class AdditionalPropertyCosts implements IAdditionalPropertyCosts {
    name!: string | undefined;
    type!: string | undefined;
    scope!: string | undefined;
    frequency!: string | undefined;
    price!: number;

    constructor(data?: IAdditionalPropertyCosts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.scope = _data["scope"];
            this.frequency = _data["frequency"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): AdditionalPropertyCosts {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalPropertyCosts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["scope"] = this.scope;
        data["frequency"] = this.frequency;
        data["price"] = this.price;
        return data;
    }
}

export interface IAdditionalPropertyCosts {
    name: string | undefined;
    type: string | undefined;
    scope: string | undefined;
    frequency: string | undefined;
    price: number;
}

export class MealPlanDto implements IMealPlanDto {
    id!: string | undefined;
    code!: string | undefined;
    name!: string | undefined;
    price!: number;
    value!: string | undefined;

    constructor(data?: IMealPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MealPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new MealPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["price"] = this.price;
        data["value"] = this.value;
        return data;
    }
}

export interface IMealPlanDto {
    id: string | undefined;
    code: string | undefined;
    name: string | undefined;
    price: number;
    value: string | undefined;
}

export class TagOfStringString implements ITagOfStringString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: ITagOfStringString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TagOfStringString {
        data = typeof data === 'object' ? data : {};
        let result = new TagOfStringString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ITagOfStringString {
    name: string | undefined;
    value: string | undefined;
}

export class RoomCostItemBookedDto implements IRoomCostItemBookedDto {
    itemId!: number;
    status!: string | undefined;
    pricingRoomExclusiveValue!: number | undefined;
    pricingTotalDueValue!: number;
    bookingInfoArrayOfCancelPenalties!: ArrayOfCancelPenaltiesDto;
    additionalCosts!: AdditionalPropertyCosts[] | undefined;
    readonly pricingFeeValueAmount!: number | undefined;
    readonly pricingAgencyFeeValueAmount!: number | undefined;
    readonly pricingRoomValueAmount!: number;
    structureId!: string | undefined;
    checkIn!: moment.Moment;
    checkOut!: moment.Moment;
    sequence!: number;
    name!: string | undefined;
    mealPlan!: MealPlanDto;
    providerLink!: TagOfStringString;
    guestComposition!: GuestCompositionDto;
    productCode!: string | undefined;

    constructor(data?: IRoomCostItemBookedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.status = _data["status"];
            this.pricingRoomExclusiveValue = _data["pricingRoomExclusiveValue"];
            this.pricingTotalDueValue = _data["pricingTotalDueValue"];
            this.bookingInfoArrayOfCancelPenalties = _data["bookingInfoArrayOfCancelPenalties"] ? ArrayOfCancelPenaltiesDto.fromJS(_data["bookingInfoArrayOfCancelPenalties"]) : <any>undefined;
            if (Array.isArray(_data["additionalCosts"])) {
                this.additionalCosts = [] as any;
                for (let item of _data["additionalCosts"])
                    this.additionalCosts!.push(AdditionalPropertyCosts.fromJS(item));
            }
            (<any>this).pricingFeeValueAmount = _data["pricingFeeValueAmount"];
            (<any>this).pricingAgencyFeeValueAmount = _data["pricingAgencyFeeValueAmount"];
            (<any>this).pricingRoomValueAmount = _data["pricingRoomValueAmount"];
            this.structureId = _data["structureId"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : <any>undefined;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : <any>undefined;
            this.sequence = _data["sequence"];
            this.name = _data["name"];
            this.mealPlan = _data["mealPlan"] ? MealPlanDto.fromJS(_data["mealPlan"]) : <any>undefined;
            this.providerLink = _data["providerLink"] ? TagOfStringString.fromJS(_data["providerLink"]) : <any>undefined;
            this.guestComposition = _data["guestComposition"] ? GuestCompositionDto.fromJS(_data["guestComposition"]) : <any>undefined;
            this.productCode = _data["productCode"];
        }
    }

    static fromJS(data: any): RoomCostItemBookedDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomCostItemBookedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["status"] = this.status;
        data["pricingRoomExclusiveValue"] = this.pricingRoomExclusiveValue;
        data["pricingTotalDueValue"] = this.pricingTotalDueValue;
        data["bookingInfoArrayOfCancelPenalties"] = this.bookingInfoArrayOfCancelPenalties ? this.bookingInfoArrayOfCancelPenalties.toJSON() : <any>undefined;
        if (Array.isArray(this.additionalCosts)) {
            data["additionalCosts"] = [];
            for (let item of this.additionalCosts)
                data["additionalCosts"].push(item.toJSON());
        }
        data["pricingFeeValueAmount"] = this.pricingFeeValueAmount;
        data["pricingAgencyFeeValueAmount"] = this.pricingAgencyFeeValueAmount;
        data["pricingRoomValueAmount"] = this.pricingRoomValueAmount;
        data["structureId"] = this.structureId;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : <any>undefined;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : <any>undefined;
        data["sequence"] = this.sequence;
        data["name"] = this.name;
        data["mealPlan"] = this.mealPlan ? this.mealPlan.toJSON() : <any>undefined;
        data["providerLink"] = this.providerLink ? this.providerLink.toJSON() : <any>undefined;
        data["guestComposition"] = this.guestComposition ? this.guestComposition.toJSON() : <any>undefined;
        data["productCode"] = this.productCode;
        return data;
    }
}

export interface IRoomCostItemBookedDto {
    itemId: number;
    status: string | undefined;
    pricingRoomExclusiveValue: number | undefined;
    pricingTotalDueValue: number;
    bookingInfoArrayOfCancelPenalties: ArrayOfCancelPenaltiesDto;
    additionalCosts: AdditionalPropertyCosts[] | undefined;
    pricingFeeValueAmount: number | undefined;
    pricingAgencyFeeValueAmount: number | undefined;
    pricingRoomValueAmount: number;
    structureId: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    sequence: number;
    name: string | undefined;
    mealPlan: MealPlanDto;
    providerLink: TagOfStringString;
    guestComposition: GuestCompositionDto;
    productCode: string | undefined;
}

export class PaxParameterDto implements IPaxParameterDto {
    id!: number;
    name!: string | undefined;
    refPax!: boolean;
    adults!: boolean;
    children!: boolean;

    constructor(data?: IPaxParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.refPax = _data["refPax"];
            this.adults = _data["adults"];
            this.children = _data["children"];
        }
    }

    static fromJS(data: any): PaxParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaxParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["refPax"] = this.refPax;
        data["adults"] = this.adults;
        data["children"] = this.children;
        return data;
    }
}

export interface IPaxParameterDto {
    id: number;
    name: string | undefined;
    refPax: boolean;
    adults: boolean;
    children: boolean;
}

export class NightlyPricingDto implements INightlyPricingDto {
    type!: string | undefined;
    price!: string | undefined;
    currency!: string | undefined;

    constructor(data?: INightlyPricingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.price = _data["price"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): NightlyPricingDto {
        data = typeof data === 'object' ? data : {};
        let result = new NightlyPricingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["price"] = this.price;
        data["currency"] = this.currency;
        return data;
    }
}

export interface INightlyPricingDto {
    type: string | undefined;
    price: string | undefined;
    currency: string | undefined;
}

export class NightDto implements INightDto {
    date!: moment.Moment;
    price!: number;
    nightly!: NightlyPricingDto[] | undefined;
    status!: string | undefined;

    constructor(data?: INightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.price = _data["price"];
            if (Array.isArray(_data["nightly"])) {
                this.nightly = [] as any;
                for (let item of _data["nightly"])
                    this.nightly!.push(NightlyPricingDto.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): NightDto {
        data = typeof data === 'object' ? data : {};
        let result = new NightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["price"] = this.price;
        if (Array.isArray(this.nightly)) {
            data["nightly"] = [];
            for (let item of this.nightly)
                data["nightly"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data;
    }
}

export interface INightDto {
    date: moment.Moment;
    price: number;
    nightly: NightlyPricingDto[] | undefined;
    status: string | undefined;
}

export class StayDto implements IStayDto {
    type!: string | undefined;
    price!: string | undefined;
    currency!: string | undefined;

    constructor(data?: IStayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.price = _data["price"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): StayDto {
        data = typeof data === 'object' ? data : {};
        let result = new StayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["price"] = this.price;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IStayDto {
    type: string | undefined;
    price: string | undefined;
    currency: string | undefined;
}

export class FeesDto implements IFeesDto {
    scope!: string | undefined;
    frequency!: string | undefined;
    price!: number;
    currency!: string | undefined;

    constructor(data?: IFeesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.frequency = _data["frequency"];
            this.price = _data["price"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): FeesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["frequency"] = this.frequency;
        data["price"] = this.price;
        data["currency"] = this.currency;
        return data;
    }
}

export interface IFeesDto {
    scope: string | undefined;
    frequency: string | undefined;
    price: number;
    currency: string | undefined;
}

export class AdditionalInfoDto implements IAdditionalInfoDto {
    string!: string | undefined;

    constructor(data?: IAdditionalInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.string = _data["string"];
        }
    }

    static fromJS(data: any): AdditionalInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["string"] = this.string;
        return data;
    }
}

export interface IAdditionalInfoDto {
    string: string | undefined;
}

export enum AmenityType {
    General = 0,
    Top = 1,
    Hotel = 2,
    Room = 3,
    Other = 4,
}

export class AmenityDto implements IAmenityDto {
    id!: number;
    name!: string | undefined;
    icon!: string | undefined;
    amenityType!: AmenityType;

    constructor(data?: IAmenityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.amenityType = _data["amenityType"];
        }
    }

    static fromJS(data: any): AmenityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmenityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["amenityType"] = this.amenityType;
        return data;
    }
}

export interface IAmenityDto {
    id: number;
    name: string | undefined;
    icon: string | undefined;
    amenityType: AmenityType;
}

export class MaxAllowed implements IMaxAllowed {
    total!: number;
    children!: number;
    adults!: number;

    constructor(data?: IMaxAllowed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.children = _data["children"];
            this.adults = _data["adults"];
        }
    }

    static fromJS(data: any): MaxAllowed {
        data = typeof data === 'object' ? data : {};
        let result = new MaxAllowed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["children"] = this.children;
        data["adults"] = this.adults;
        return data;
    }
}

export interface IMaxAllowed {
    total: number;
    children: number;
    adults: number;
}

export class AgeCategory implements IAgeCategory {
    name!: string | undefined;
    minimumAge!: number;

    constructor(data?: IAgeCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.minimumAge = _data["minimumAge"];
        }
    }

    static fromJS(data: any): AgeCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AgeCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["minimumAge"] = this.minimumAge;
        return data;
    }
}

export interface IAgeCategory {
    name: string | undefined;
    minimumAge: number;
}

export class RoomStructureDetailDto implements IRoomStructureDetailDto {
    descriptions!: TagOfStringString[] | undefined;
    amenities!: AmenityDto[] | undefined;
    multimedia!: TagOfStringString[] | undefined;
    maxAllowed!: MaxAllowed;
    ageCategories!: AgeCategory[] | undefined;
    areaSquareMeters!: number;

    constructor(data?: IRoomStructureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(TagOfStringString.fromJS(item));
            }
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities!.push(AmenityDto.fromJS(item));
            }
            if (Array.isArray(_data["multimedia"])) {
                this.multimedia = [] as any;
                for (let item of _data["multimedia"])
                    this.multimedia!.push(TagOfStringString.fromJS(item));
            }
            this.maxAllowed = _data["maxAllowed"] ? MaxAllowed.fromJS(_data["maxAllowed"]) : <any>undefined;
            if (Array.isArray(_data["ageCategories"])) {
                this.ageCategories = [] as any;
                for (let item of _data["ageCategories"])
                    this.ageCategories!.push(AgeCategory.fromJS(item));
            }
            this.areaSquareMeters = _data["areaSquareMeters"];
        }
    }

    static fromJS(data: any): RoomStructureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomStructureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item.toJSON());
        }
        if (Array.isArray(this.multimedia)) {
            data["multimedia"] = [];
            for (let item of this.multimedia)
                data["multimedia"].push(item.toJSON());
        }
        data["maxAllowed"] = this.maxAllowed ? this.maxAllowed.toJSON() : <any>undefined;
        if (Array.isArray(this.ageCategories)) {
            data["ageCategories"] = [];
            for (let item of this.ageCategories)
                data["ageCategories"].push(item.toJSON());
        }
        data["areaSquareMeters"] = this.areaSquareMeters;
        return data;
    }
}

export interface IRoomStructureDetailDto {
    descriptions: TagOfStringString[] | undefined;
    amenities: AmenityDto[] | undefined;
    multimedia: TagOfStringString[] | undefined;
    maxAllowed: MaxAllowed;
    ageCategories: AgeCategory[] | undefined;
    areaSquareMeters: number;
}

export class CancellationPolicyDto implements ICancellationPolicyDto {
    amount!: number;
    from!: moment.Moment;
    description!: string | undefined;

    constructor(data?: ICancellationPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CancellationPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface ICancellationPolicyDto {
    amount: number;
    from: moment.Moment;
    description: string | undefined;
}

export class Link implements ILink {
    method!: string | undefined;
    href!: string | undefined;
    expires!: string | undefined;

    constructor(data?: ILink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
            this.href = _data["href"];
            this.expires = _data["expires"];
        }
    }

    static fromJS(data: any): Link {
        data = typeof data === 'object' ? data : {};
        let result = new Link();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        data["href"] = this.href;
        data["expires"] = this.expires;
        return data;
    }
}

export interface ILink {
    method: string | undefined;
    href: string | undefined;
    expires: string | undefined;
}

export class Links5 implements ILinks5 {
    price_check!: Link;

    constructor(data?: ILinks5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price_check = _data["price_check"] ? Link.fromJS(_data["price_check"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Links5 {
        data = typeof data === 'object' ? data : {};
        let result = new Links5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price_check"] = this.price_check ? this.price_check.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILinks5 {
    price_check: Link;
}

export class Configuration2 implements IConfiguration2 {
    type!: string | undefined;
    size!: string | undefined;
    quantity!: number | undefined;

    constructor(data?: IConfiguration2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.size = _data["size"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): Configuration2 {
        data = typeof data === 'object' ? data : {};
        let result = new Configuration2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["size"] = this.size;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IConfiguration2 {
    type: string | undefined;
    size: string | undefined;
    quantity: number | undefined;
}

export class BedGroupAvailability implements IBedGroupAvailability {
    links!: Links5;
    id!: string | undefined;
    description!: string | undefined;
    configuration!: Configuration2[] | undefined;

    constructor(data?: IBedGroupAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.links = _data["links"] ? Links5.fromJS(_data["links"]) : <any>undefined;
            this.id = _data["id"];
            this.description = _data["description"];
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(Configuration2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BedGroupAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new BedGroupAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["links"] = this.links ? this.links.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["description"] = this.description;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBedGroupAvailability {
    links: Links5;
    id: string | undefined;
    description: string | undefined;
    configuration: Configuration2[] | undefined;
}

export class RoomDetailDto implements IRoomDetailDto {
    nights!: NightDto[] | undefined;
    stay!: StayDto[] | undefined;
    mandatoryFees!: FeesDto;
    mandatoryTax!: FeesDto;
    resortFees!: FeesDto;
    inclusiveTotal!: number;
    exclusiveTotal!: number;
    mealPlans!: MealPlanDto[] | undefined;
    additionalInfo!: AdditionalInfoDto;
    structure!: RoomStructureDetailDto;
    seq!: number;
    product!: string | undefined;
    name!: string | undefined;
    currency!: string | undefined;
    status!: string | undefined;
    supplier!: string | undefined;
    cancellationPolicy!: CancellationPolicyDto[] | undefined;
    remarks!: string | undefined;
    idRoom!: string | undefined;
    idRate!: string | undefined;
    bedGroups!: BedGroupAvailability[] | undefined;
    linkPaymentOptions!: string | undefined;
    readonly refundable!: boolean | undefined;

    constructor(data?: IRoomDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nights"])) {
                this.nights = [] as any;
                for (let item of _data["nights"])
                    this.nights!.push(NightDto.fromJS(item));
            }
            if (Array.isArray(_data["stay"])) {
                this.stay = [] as any;
                for (let item of _data["stay"])
                    this.stay!.push(StayDto.fromJS(item));
            }
            this.mandatoryFees = _data["mandatoryFees"] ? FeesDto.fromJS(_data["mandatoryFees"]) : <any>undefined;
            this.mandatoryTax = _data["mandatoryTax"] ? FeesDto.fromJS(_data["mandatoryTax"]) : <any>undefined;
            this.resortFees = _data["resortFees"] ? FeesDto.fromJS(_data["resortFees"]) : <any>undefined;
            this.inclusiveTotal = _data["inclusiveTotal"];
            this.exclusiveTotal = _data["exclusiveTotal"];
            if (Array.isArray(_data["mealPlans"])) {
                this.mealPlans = [] as any;
                for (let item of _data["mealPlans"])
                    this.mealPlans!.push(MealPlanDto.fromJS(item));
            }
            this.additionalInfo = _data["additionalInfo"] ? AdditionalInfoDto.fromJS(_data["additionalInfo"]) : <any>undefined;
            this.structure = _data["structure"] ? RoomStructureDetailDto.fromJS(_data["structure"]) : <any>undefined;
            this.seq = _data["seq"];
            this.product = _data["product"];
            this.name = _data["name"];
            this.currency = _data["currency"];
            this.status = _data["status"];
            this.supplier = _data["supplier"];
            if (Array.isArray(_data["cancellationPolicy"])) {
                this.cancellationPolicy = [] as any;
                for (let item of _data["cancellationPolicy"])
                    this.cancellationPolicy!.push(CancellationPolicyDto.fromJS(item));
            }
            this.remarks = _data["remarks"];
            this.idRoom = _data["idRoom"];
            this.idRate = _data["idRate"];
            if (Array.isArray(_data["bedGroups"])) {
                this.bedGroups = [] as any;
                for (let item of _data["bedGroups"])
                    this.bedGroups!.push(BedGroupAvailability.fromJS(item));
            }
            this.linkPaymentOptions = _data["linkPaymentOptions"];
            (<any>this).refundable = _data["refundable"];
        }
    }

    static fromJS(data: any): RoomDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nights)) {
            data["nights"] = [];
            for (let item of this.nights)
                data["nights"].push(item.toJSON());
        }
        if (Array.isArray(this.stay)) {
            data["stay"] = [];
            for (let item of this.stay)
                data["stay"].push(item.toJSON());
        }
        data["mandatoryFees"] = this.mandatoryFees ? this.mandatoryFees.toJSON() : <any>undefined;
        data["mandatoryTax"] = this.mandatoryTax ? this.mandatoryTax.toJSON() : <any>undefined;
        data["resortFees"] = this.resortFees ? this.resortFees.toJSON() : <any>undefined;
        data["inclusiveTotal"] = this.inclusiveTotal;
        data["exclusiveTotal"] = this.exclusiveTotal;
        if (Array.isArray(this.mealPlans)) {
            data["mealPlans"] = [];
            for (let item of this.mealPlans)
                data["mealPlans"].push(item.toJSON());
        }
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : <any>undefined;
        data["structure"] = this.structure ? this.structure.toJSON() : <any>undefined;
        data["seq"] = this.seq;
        data["product"] = this.product;
        data["name"] = this.name;
        data["currency"] = this.currency;
        data["status"] = this.status;
        data["supplier"] = this.supplier;
        if (Array.isArray(this.cancellationPolicy)) {
            data["cancellationPolicy"] = [];
            for (let item of this.cancellationPolicy)
                data["cancellationPolicy"].push(item.toJSON());
        }
        data["remarks"] = this.remarks;
        data["idRoom"] = this.idRoom;
        data["idRate"] = this.idRate;
        if (Array.isArray(this.bedGroups)) {
            data["bedGroups"] = [];
            for (let item of this.bedGroups)
                data["bedGroups"].push(item.toJSON());
        }
        data["linkPaymentOptions"] = this.linkPaymentOptions;
        data["refundable"] = this.refundable;
        return data;
    }
}

export interface IRoomDetailDto {
    nights: NightDto[] | undefined;
    stay: StayDto[] | undefined;
    mandatoryFees: FeesDto;
    mandatoryTax: FeesDto;
    resortFees: FeesDto;
    inclusiveTotal: number;
    exclusiveTotal: number;
    mealPlans: MealPlanDto[] | undefined;
    additionalInfo: AdditionalInfoDto;
    structure: RoomStructureDetailDto;
    seq: number;
    product: string | undefined;
    name: string | undefined;
    currency: string | undefined;
    status: string | undefined;
    supplier: string | undefined;
    cancellationPolicy: CancellationPolicyDto[] | undefined;
    remarks: string | undefined;
    idRoom: string | undefined;
    idRate: string | undefined;
    bedGroups: BedGroupAvailability[] | undefined;
    linkPaymentOptions: string | undefined;
    refundable: boolean | undefined;
}

export class OptionsDetailDto implements IOptionsDetailDto {
    id!: string | undefined;
    rooms!: RoomDetailDto[] | undefined;
    providerLink!: TagOfStringString;
    readonly bestPrice!: number;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;
    negotiatedRate?: boolean;
    corporateDiscountIDs!: string[] | undefined;

    constructor(data?: IOptionsDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(RoomDetailDto.fromJS(item));
            }
            this.providerLink = _data["providerLink"] ? TagOfStringString.fromJS(_data["providerLink"]) : <any>undefined;
            (<any>this).bestPrice = _data["bestPrice"];
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
            this.negotiatedRate = _data["negotiatedRate"];
            if (Array.isArray(_data["corporateDiscountIDs"])) {
                this.corporateDiscountIDs = [] as any;
                for (let item of _data["corporateDiscountIDs"])
                    this.corporateDiscountIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): OptionsDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionsDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["providerLink"] = this.providerLink ? this.providerLink.toJSON() : <any>undefined;
        data["bestPrice"] = this.bestPrice;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        data["negotiatedRate"] = this.negotiatedRate;
        if (Array.isArray(this.corporateDiscountIDs)) {
            data["corporateDiscountIDs"] = [];
            for (let item of this.corporateDiscountIDs)
                data["corporateDiscountIDs"].push(item);
        }
        return data;
    }
}

export interface IOptionsDetailDto {
    id: string | undefined;
    rooms: RoomDetailDto[] | undefined;
    providerLink: TagOfStringString;
    bestPrice: number;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
    negotiatedRate?: boolean;
    corporateDiscountIDs: string[] | undefined;
}

export class QuotationDto implements IQuotationDto {
    orderId!: string | undefined;
    quotationId!: string | undefined;
    quotationExpires!: moment.Moment;
    arrayOfCostItem!: RoomCostItemBookedDto[] | undefined;
    paxParameters!: PaxParameterDto[] | undefined;
    discountCode!: string | undefined;
    discount!: number;
    availabilityId!: string | undefined;
    selectedOption!: OptionsDetailDto;

    constructor(data?: IQuotationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.quotationId = _data["quotationId"];
            this.quotationExpires = _data["quotationExpires"] ? moment(_data["quotationExpires"].toString()) : <any>undefined;
            if (Array.isArray(_data["arrayOfCostItem"])) {
                this.arrayOfCostItem = [] as any;
                for (let item of _data["arrayOfCostItem"])
                    this.arrayOfCostItem!.push(RoomCostItemBookedDto.fromJS(item));
            }
            if (Array.isArray(_data["paxParameters"])) {
                this.paxParameters = [] as any;
                for (let item of _data["paxParameters"])
                    this.paxParameters!.push(PaxParameterDto.fromJS(item));
            }
            this.discountCode = _data["discountCode"];
            this.discount = _data["discount"];
            this.availabilityId = _data["availabilityId"];
            this.selectedOption = _data["selectedOption"] ? OptionsDetailDto.fromJS(_data["selectedOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuotationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["quotationId"] = this.quotationId;
        data["quotationExpires"] = this.quotationExpires ? this.quotationExpires.toISOString() : <any>undefined;
        if (Array.isArray(this.arrayOfCostItem)) {
            data["arrayOfCostItem"] = [];
            for (let item of this.arrayOfCostItem)
                data["arrayOfCostItem"].push(item.toJSON());
        }
        if (Array.isArray(this.paxParameters)) {
            data["paxParameters"] = [];
            for (let item of this.paxParameters)
                data["paxParameters"].push(item.toJSON());
        }
        data["discountCode"] = this.discountCode;
        data["discount"] = this.discount;
        data["availabilityId"] = this.availabilityId;
        data["selectedOption"] = this.selectedOption ? this.selectedOption.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuotationDto {
    orderId: string | undefined;
    quotationId: string | undefined;
    quotationExpires: moment.Moment;
    arrayOfCostItem: RoomCostItemBookedDto[] | undefined;
    paxParameters: PaxParameterDto[] | undefined;
    discountCode: string | undefined;
    discount: number;
    availabilityId: string | undefined;
    selectedOption: OptionsDetailDto;
}

export enum HotelBookingConfirmationTypeDto {
    Book = 1,
    BookAndPay = 2,
    AssistedBooking = 3,
}

export class BookStructureRequestDto implements IBookStructureRequestDto {
    workflowId!: string;
    structureId!: string | undefined;
    checkIn!: moment.Moment;
    checkOut!: moment.Moment;
    rooms!: BuyStructureRoomRequestDto[] | undefined;
    quotation!: QuotationDto;
    discountCode!: string | undefined;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;
    readonly isInPenalty!: boolean;
    paymentProfile!: PaymentDataProfileDto;
    paymentGateway!: PaymentGatewayDto;
    bookingConfirmationType!: HotelBookingConfirmationTypeDto;
    user!: ApplicationUserDto;
    remarks!: string | undefined;

    constructor(data?: IBookStructureRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowId = _data["workflowId"];
            this.structureId = _data["structureId"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : <any>undefined;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : <any>undefined;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(BuyStructureRoomRequestDto.fromJS(item));
            }
            this.quotation = _data["quotation"] ? QuotationDto.fromJS(_data["quotation"]) : <any>undefined;
            this.discountCode = _data["discountCode"];
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
            (<any>this).isInPenalty = _data["isInPenalty"];
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
            this.paymentGateway = _data["paymentGateway"];
            this.bookingConfirmationType = _data["bookingConfirmationType"];
            this.user = _data["user"] ? ApplicationUserDto.fromJS(_data["user"]) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): BookStructureRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookStructureRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowId"] = this.workflowId;
        data["structureId"] = this.structureId;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : <any>undefined;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : <any>undefined;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["quotation"] = this.quotation ? this.quotation.toJSON() : <any>undefined;
        data["discountCode"] = this.discountCode;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        data["isInPenalty"] = this.isInPenalty;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        data["paymentGateway"] = this.paymentGateway;
        data["bookingConfirmationType"] = this.bookingConfirmationType;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IBookStructureRequestDto {
    workflowId: string;
    structureId: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    rooms: BuyStructureRoomRequestDto[] | undefined;
    quotation: QuotationDto;
    discountCode: string | undefined;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
    isInPenalty: boolean;
    paymentProfile: PaymentDataProfileDto;
    paymentGateway: PaymentGatewayDto;
    bookingConfirmationType: HotelBookingConfirmationTypeDto;
    user: ApplicationUserDto;
    remarks: string | undefined;
}

export class Airport implements IAirport {
    name!: string | undefined;
    iata!: string | undefined;
    icao!: string | undefined;
    km!: number;
    altitude!: number;

    constructor(data?: IAirport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.iata = _data["iata"];
            this.icao = _data["icao"];
            this.km = _data["km"];
            this.altitude = _data["altitude"];
        }
    }

    static fromJS(data: any): Airport {
        data = typeof data === 'object' ? data : {};
        let result = new Airport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["iata"] = this.iata;
        data["icao"] = this.icao;
        data["km"] = this.km;
        data["altitude"] = this.altitude;
        return data;
    }
}

export interface IAirport {
    name: string | undefined;
    iata: string | undefined;
    icao: string | undefined;
    km: number;
    altitude: number;
}

export class TagOfStringLocalizedString implements ITagOfStringLocalizedString {
    name!: string | undefined;
    value!: LocalizedString;

    constructor(data?: ITagOfStringLocalizedString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"] ? LocalizedString.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TagOfStringLocalizedString {
        data = typeof data === 'object' ? data : {};
        let result = new TagOfStringLocalizedString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITagOfStringLocalizedString {
    name: string | undefined;
    value: LocalizedString;
}

export class Address implements IAddress {
    address1!: string | undefined;
    address2!: string | undefined;
    zip!: string | undefined;
    city!: string | undefined;
    province!: string | undefined;
    country!: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["province"] = this.province;
        data["country"] = this.country;
        return data;
    }
}

export interface IAddress {
    address1: string | undefined;
    address2: string | undefined;
    zip: string | undefined;
    city: string | undefined;
    province: string | undefined;
    country: string | undefined;
}

export class UserScoreDto implements IUserScoreDto {
    source!: string | undefined;
    overall!: number;
    breakdown!: { [key: string]: number; } | undefined;

    constructor(data?: IUserScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.overall = _data["overall"];
            if (_data["breakdown"]) {
                this.breakdown = {} as any;
                for (let key in _data["breakdown"]) {
                    if (_data["breakdown"].hasOwnProperty(key))
                        this.breakdown![key] = _data["breakdown"][key];
                }
            }
        }
    }

    static fromJS(data: any): UserScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["overall"] = this.overall;
        if (this.breakdown) {
            data["breakdown"] = {};
            for (let key in this.breakdown) {
                if (this.breakdown.hasOwnProperty(key))
                    data["breakdown"][key] = this.breakdown[key];
            }
        }
        return data;
    }
}

export interface IUserScoreDto {
    source: string | undefined;
    overall: number;
    breakdown: { [key: string]: number; } | undefined;
}

export class StructureDto implements IStructureDto {
    amenities!: AmenityDto[] | undefined;
    info!: TagOfStringString[] | undefined;
    multimedia!: TagOfStringString[] | undefined;
    airports!: Airport[] | undefined;
    checkInTime!: string | undefined;
    checkOutTime!: string | undefined;
    isBlacklist!: boolean;
    descriptions!: TagOfStringLocalizedString[] | undefined;
    id!: string | undefined;
    ts!: moment.Moment;
    name!: string | undefined;
    thumb!: string | undefined;
    category!: TagOfStringString;
    address!: Address;
    contacts!: TagOfStringString[] | undefined;
    position!: GeoJsonPointOfGeoJson2DGeographicCoordinates;
    locations!: TagOfStringString[] | undefined;
    userScore!: UserScoreDto;
    amenityIds!: number[] | undefined;
    type!: TagOfStringString;
    isoCountry!: string | undefined;
    slug!: string | undefined;
    highRate!: number;
    lowRate!: number;
    destinationId!: string | undefined;

    constructor(data?: IStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities!.push(AmenityDto.fromJS(item));
            }
            if (Array.isArray(_data["info"])) {
                this.info = [] as any;
                for (let item of _data["info"])
                    this.info!.push(TagOfStringString.fromJS(item));
            }
            if (Array.isArray(_data["multimedia"])) {
                this.multimedia = [] as any;
                for (let item of _data["multimedia"])
                    this.multimedia!.push(TagOfStringString.fromJS(item));
            }
            if (Array.isArray(_data["airports"])) {
                this.airports = [] as any;
                for (let item of _data["airports"])
                    this.airports!.push(Airport.fromJS(item));
            }
            this.checkInTime = _data["checkInTime"];
            this.checkOutTime = _data["checkOutTime"];
            this.isBlacklist = _data["isBlacklist"];
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(TagOfStringLocalizedString.fromJS(item));
            }
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.thumb = _data["thumb"];
            this.category = _data["category"] ? TagOfStringString.fromJS(_data["category"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(TagOfStringString.fromJS(item));
            }
            this.position = _data["position"] ? GeoJsonPointOfGeoJson2DGeographicCoordinates.fromJS(_data["position"]) : <any>undefined;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(TagOfStringString.fromJS(item));
            }
            this.userScore = _data["userScore"] ? UserScoreDto.fromJS(_data["userScore"]) : <any>undefined;
            if (Array.isArray(_data["amenityIds"])) {
                this.amenityIds = [] as any;
                for (let item of _data["amenityIds"])
                    this.amenityIds!.push(item);
            }
            this.type = _data["type"] ? TagOfStringString.fromJS(_data["type"]) : <any>undefined;
            this.isoCountry = _data["isoCountry"];
            this.slug = _data["slug"];
            this.highRate = _data["highRate"];
            this.lowRate = _data["lowRate"];
            this.destinationId = _data["destinationId"];
        }
    }

    static fromJS(data: any): StructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item.toJSON());
        }
        if (Array.isArray(this.info)) {
            data["info"] = [];
            for (let item of this.info)
                data["info"].push(item.toJSON());
        }
        if (Array.isArray(this.multimedia)) {
            data["multimedia"] = [];
            for (let item of this.multimedia)
                data["multimedia"].push(item.toJSON());
        }
        if (Array.isArray(this.airports)) {
            data["airports"] = [];
            for (let item of this.airports)
                data["airports"].push(item.toJSON());
        }
        data["checkInTime"] = this.checkInTime;
        data["checkOutTime"] = this.checkOutTime;
        data["isBlacklist"] = this.isBlacklist;
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["thumb"] = this.thumb;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["userScore"] = this.userScore ? this.userScore.toJSON() : <any>undefined;
        if (Array.isArray(this.amenityIds)) {
            data["amenityIds"] = [];
            for (let item of this.amenityIds)
                data["amenityIds"].push(item);
        }
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["isoCountry"] = this.isoCountry;
        data["slug"] = this.slug;
        data["highRate"] = this.highRate;
        data["lowRate"] = this.lowRate;
        data["destinationId"] = this.destinationId;
        return data;
    }
}

export interface IStructureDto {
    amenities: AmenityDto[] | undefined;
    info: TagOfStringString[] | undefined;
    multimedia: TagOfStringString[] | undefined;
    airports: Airport[] | undefined;
    checkInTime: string | undefined;
    checkOutTime: string | undefined;
    isBlacklist: boolean;
    descriptions: TagOfStringLocalizedString[] | undefined;
    id: string | undefined;
    ts: moment.Moment;
    name: string | undefined;
    thumb: string | undefined;
    category: TagOfStringString;
    address: Address;
    contacts: TagOfStringString[] | undefined;
    position: GeoJsonPointOfGeoJson2DGeographicCoordinates;
    locations: TagOfStringString[] | undefined;
    userScore: UserScoreDto;
    amenityIds: number[] | undefined;
    type: TagOfStringString;
    isoCountry: string | undefined;
    slug: string | undefined;
    highRate: number;
    lowRate: number;
    destinationId: string | undefined;
}

export class HotelAssistedBooking implements IHotelAssistedBooking {
    assistedBookingReservation!: BookStructureRequestDto;
    assistedBookingStructure!: StructureDto;
    userId!: string | undefined;
    username!: string | undefined;
    status!: AssistedBookingStatus;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: IHotelAssistedBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistedBookingReservation = _data["assistedBookingReservation"] ? BookStructureRequestDto.fromJS(_data["assistedBookingReservation"]) : <any>undefined;
            this.assistedBookingStructure = _data["assistedBookingStructure"] ? StructureDto.fromJS(_data["assistedBookingStructure"]) : <any>undefined;
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.status = _data["status"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): HotelAssistedBooking {
        data = typeof data === 'object' ? data : {};
        let result = new HotelAssistedBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistedBookingReservation"] = this.assistedBookingReservation ? this.assistedBookingReservation.toJSON() : <any>undefined;
        data["assistedBookingStructure"] = this.assistedBookingStructure ? this.assistedBookingStructure.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["status"] = this.status;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IHotelAssistedBooking {
    assistedBookingReservation: BookStructureRequestDto;
    assistedBookingStructure: StructureDto;
    userId: string | undefined;
    username: string | undefined;
    status: AssistedBookingStatus;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class TrainBookRequestDto implements ITrainBookRequestDto {
    passengers!: PersonNameDataDTO[] | undefined;
    user!: ApplicationUserDto;
    orderId!: string | undefined;
    paymentGateway!: PaymentGatewayDto;
    bookingConfirmationType!: BookingConfirmationTypeDto;
    paymentData!: PaymentDataDto;
    paymentProfile!: PaymentDataProfileDto;
    isHold!: boolean;
    availabilityId!: string | undefined;
    outwardGroupItineraryId!: string | undefined;
    returnGroupItineraryId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;
    outwardPricingInformationIds!: string[] | undefined;
    returnPricingInformationIds!: string[] | undefined;

    constructor(data?: ITrainBookRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PersonNameDataDTO.fromJS(item));
            }
            this.user = _data["user"] ? ApplicationUserDto.fromJS(_data["user"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.paymentGateway = _data["paymentGateway"];
            this.bookingConfirmationType = _data["bookingConfirmationType"];
            this.paymentData = _data["paymentData"] ? PaymentDataDto.fromJS(_data["paymentData"]) : <any>undefined;
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
            this.isHold = _data["isHold"];
            this.availabilityId = _data["availabilityId"];
            this.outwardGroupItineraryId = _data["outwardGroupItineraryId"];
            this.returnGroupItineraryId = _data["returnGroupItineraryId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
            if (Array.isArray(_data["outwardPricingInformationIds"])) {
                this.outwardPricingInformationIds = [] as any;
                for (let item of _data["outwardPricingInformationIds"])
                    this.outwardPricingInformationIds!.push(item);
            }
            if (Array.isArray(_data["returnPricingInformationIds"])) {
                this.returnPricingInformationIds = [] as any;
                for (let item of _data["returnPricingInformationIds"])
                    this.returnPricingInformationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TrainBookRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainBookRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["paymentGateway"] = this.paymentGateway;
        data["bookingConfirmationType"] = this.bookingConfirmationType;
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        data["isHold"] = this.isHold;
        data["availabilityId"] = this.availabilityId;
        data["outwardGroupItineraryId"] = this.outwardGroupItineraryId;
        data["returnGroupItineraryId"] = this.returnGroupItineraryId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        if (Array.isArray(this.outwardPricingInformationIds)) {
            data["outwardPricingInformationIds"] = [];
            for (let item of this.outwardPricingInformationIds)
                data["outwardPricingInformationIds"].push(item);
        }
        if (Array.isArray(this.returnPricingInformationIds)) {
            data["returnPricingInformationIds"] = [];
            for (let item of this.returnPricingInformationIds)
                data["returnPricingInformationIds"].push(item);
        }
        return data;
    }
}

export interface ITrainBookRequestDto {
    passengers: PersonNameDataDTO[] | undefined;
    user: ApplicationUserDto;
    orderId: string | undefined;
    paymentGateway: PaymentGatewayDto;
    bookingConfirmationType: BookingConfirmationTypeDto;
    paymentData: PaymentDataDto;
    paymentProfile: PaymentDataProfileDto;
    isHold: boolean;
    availabilityId: string | undefined;
    outwardGroupItineraryId: string | undefined;
    returnGroupItineraryId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
    outwardPricingInformationIds: string[] | undefined;
    returnPricingInformationIds: string[] | undefined;
}

export class TrainAssistedBooking implements ITrainAssistedBooking {
    assistedBookingReservation!: TrainBookRequestDto;
    assistedBookingItineraryDetail!: ItineraryDetailDTO;
    userId!: string | undefined;
    username!: string | undefined;
    status!: AssistedBookingStatus;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: ITrainAssistedBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistedBookingReservation = _data["assistedBookingReservation"] ? TrainBookRequestDto.fromJS(_data["assistedBookingReservation"]) : <any>undefined;
            this.assistedBookingItineraryDetail = _data["assistedBookingItineraryDetail"] ? ItineraryDetailDTO.fromJS(_data["assistedBookingItineraryDetail"]) : <any>undefined;
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.status = _data["status"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): TrainAssistedBooking {
        data = typeof data === 'object' ? data : {};
        let result = new TrainAssistedBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistedBookingReservation"] = this.assistedBookingReservation ? this.assistedBookingReservation.toJSON() : <any>undefined;
        data["assistedBookingItineraryDetail"] = this.assistedBookingItineraryDetail ? this.assistedBookingItineraryDetail.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["status"] = this.status;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ITrainAssistedBooking {
    assistedBookingReservation: TrainBookRequestDto;
    assistedBookingItineraryDetail: ItineraryDetailDTO;
    userId: string | undefined;
    username: string | undefined;
    status: AssistedBookingStatus;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class TripAssistedBooking implements ITripAssistedBooking {
    tripRootId!: string | undefined;
    lastAgencyAdminUpdateUserId!: string | undefined;
    userId!: string | undefined;
    username!: string | undefined;
    status!: AssistedBookingStatus;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: ITripAssistedBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripRootId = _data["tripRootId"];
            this.lastAgencyAdminUpdateUserId = _data["lastAgencyAdminUpdateUserId"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.status = _data["status"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): TripAssistedBooking {
        data = typeof data === 'object' ? data : {};
        let result = new TripAssistedBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripRootId"] = this.tripRootId;
        data["lastAgencyAdminUpdateUserId"] = this.lastAgencyAdminUpdateUserId;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["status"] = this.status;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ITripAssistedBooking {
    tripRootId: string | undefined;
    lastAgencyAdminUpdateUserId: string | undefined;
    userId: string | undefined;
    username: string | undefined;
    status: AssistedBookingStatus;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: moment.Moment;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: moment.Moment;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? moment(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: moment.Moment;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class PointOfSaleSettingsEditDto implements IPointOfSaleSettingsEditDto {
    pointOfSaleCountry!: string | undefined;
    internationalCountries!: string | undefined;

    constructor(data?: IPointOfSaleSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pointOfSaleCountry = _data["pointOfSaleCountry"];
            this.internationalCountries = _data["internationalCountries"];
        }
    }

    static fromJS(data: any): PointOfSaleSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointOfSaleSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pointOfSaleCountry"] = this.pointOfSaleCountry;
        data["internationalCountries"] = this.internationalCountries;
        return data;
    }
}

export interface IPointOfSaleSettingsEditDto {
    pointOfSaleCountry: string | undefined;
    internationalCountries: string | undefined;
}

export class CacheManagementSettingsEditDto implements ICacheManagementSettingsEditDto {
    availabilityRequestHourLimit!: number;
    availabilityFlightCacheExpirationMinutes!: number;
    availabilityHotelCacheExpirationMinutes!: number;
    availabilityHotelCacheDetailExpirationMinutes!: number;
    availabilityTrainCacheExpirationMinutes!: number;
    availabilityCarCacheExpirationMinutes!: number;

    constructor(data?: ICacheManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityRequestHourLimit = _data["availabilityRequestHourLimit"];
            this.availabilityFlightCacheExpirationMinutes = _data["availabilityFlightCacheExpirationMinutes"];
            this.availabilityHotelCacheExpirationMinutes = _data["availabilityHotelCacheExpirationMinutes"];
            this.availabilityHotelCacheDetailExpirationMinutes = _data["availabilityHotelCacheDetailExpirationMinutes"];
            this.availabilityTrainCacheExpirationMinutes = _data["availabilityTrainCacheExpirationMinutes"];
            this.availabilityCarCacheExpirationMinutes = _data["availabilityCarCacheExpirationMinutes"];
        }
    }

    static fromJS(data: any): CacheManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityRequestHourLimit"] = this.availabilityRequestHourLimit;
        data["availabilityFlightCacheExpirationMinutes"] = this.availabilityFlightCacheExpirationMinutes;
        data["availabilityHotelCacheExpirationMinutes"] = this.availabilityHotelCacheExpirationMinutes;
        data["availabilityHotelCacheDetailExpirationMinutes"] = this.availabilityHotelCacheDetailExpirationMinutes;
        data["availabilityTrainCacheExpirationMinutes"] = this.availabilityTrainCacheExpirationMinutes;
        data["availabilityCarCacheExpirationMinutes"] = this.availabilityCarCacheExpirationMinutes;
        return data;
    }
}

export interface ICacheManagementSettingsEditDto {
    availabilityRequestHourLimit: number;
    availabilityFlightCacheExpirationMinutes: number;
    availabilityHotelCacheExpirationMinutes: number;
    availabilityHotelCacheDetailExpirationMinutes: number;
    availabilityTrainCacheExpirationMinutes: number;
    availabilityCarCacheExpirationMinutes: number;
}

export class BookingToolTenantSettingsEditDto implements IBookingToolTenantSettingsEditDto {
    pointOfSale!: PointOfSaleSettingsEditDto;
    cacheManagement!: CacheManagementSettingsEditDto;

    constructor(data?: IBookingToolTenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pointOfSale = _data["pointOfSale"] ? PointOfSaleSettingsEditDto.fromJS(_data["pointOfSale"]) : <any>undefined;
            this.cacheManagement = _data["cacheManagement"] ? CacheManagementSettingsEditDto.fromJS(_data["cacheManagement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BookingToolTenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingToolTenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pointOfSale"] = this.pointOfSale ? this.pointOfSale.toJSON() : <any>undefined;
        data["cacheManagement"] = this.cacheManagement ? this.cacheManagement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBookingToolTenantSettingsEditDto {
    pointOfSale: PointOfSaleSettingsEditDto;
    cacheManagement: CacheManagementSettingsEditDto;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class AvailabilityCarLocationTypeFilterItemDto implements IAvailabilityCarLocationTypeFilterItemDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityCarLocationTypeFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityCarLocationTypeFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarLocationTypeFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityCarLocationTypeFilterItemDto {
    active: boolean;
    count: number;
}

export class AvailabilityCarLocationTypeFilterDto implements IAvailabilityCarLocationTypeFilterDto {
    airport!: AvailabilityCarLocationTypeFilterItemDto;
    shuttle!: AvailabilityCarLocationTypeFilterItemDto;
    port!: AvailabilityCarLocationTypeFilterItemDto;
    city!: AvailabilityCarLocationTypeFilterItemDto;

    constructor(data?: IAvailabilityCarLocationTypeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airport = _data["airport"] ? AvailabilityCarLocationTypeFilterItemDto.fromJS(_data["airport"]) : <any>undefined;
            this.shuttle = _data["shuttle"] ? AvailabilityCarLocationTypeFilterItemDto.fromJS(_data["shuttle"]) : <any>undefined;
            this.port = _data["port"] ? AvailabilityCarLocationTypeFilterItemDto.fromJS(_data["port"]) : <any>undefined;
            this.city = _data["city"] ? AvailabilityCarLocationTypeFilterItemDto.fromJS(_data["city"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityCarLocationTypeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarLocationTypeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airport"] = this.airport ? this.airport.toJSON() : <any>undefined;
        data["shuttle"] = this.shuttle ? this.shuttle.toJSON() : <any>undefined;
        data["port"] = this.port ? this.port.toJSON() : <any>undefined;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityCarLocationTypeFilterDto {
    airport: AvailabilityCarLocationTypeFilterItemDto;
    shuttle: AvailabilityCarLocationTypeFilterItemDto;
    port: AvailabilityCarLocationTypeFilterItemDto;
    city: AvailabilityCarLocationTypeFilterItemDto;
}

export class AvailabilityCarAirConditionFilterItemDto implements IAvailabilityCarAirConditionFilterItemDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityCarAirConditionFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityCarAirConditionFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarAirConditionFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityCarAirConditionFilterItemDto {
    active: boolean;
    count: number;
}

export class AvailabilityCarAirConditionFilterDto implements IAvailabilityCarAirConditionFilterDto {
    airCondition!: AvailabilityCarAirConditionFilterItemDto;
    noAirCondition!: AvailabilityCarAirConditionFilterItemDto;

    constructor(data?: IAvailabilityCarAirConditionFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airCondition = _data["airCondition"] ? AvailabilityCarAirConditionFilterItemDto.fromJS(_data["airCondition"]) : <any>undefined;
            this.noAirCondition = _data["noAirCondition"] ? AvailabilityCarAirConditionFilterItemDto.fromJS(_data["noAirCondition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityCarAirConditionFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarAirConditionFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airCondition"] = this.airCondition ? this.airCondition.toJSON() : <any>undefined;
        data["noAirCondition"] = this.noAirCondition ? this.noAirCondition.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityCarAirConditionFilterDto {
    airCondition: AvailabilityCarAirConditionFilterItemDto;
    noAirCondition: AvailabilityCarAirConditionFilterItemDto;
}

export class AvailabilityCarTransmissionFilterItemDto implements IAvailabilityCarTransmissionFilterItemDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityCarTransmissionFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityCarTransmissionFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarTransmissionFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityCarTransmissionFilterItemDto {
    active: boolean;
    count: number;
}

export class AvailabilityCarTransmissionFilterDto implements IAvailabilityCarTransmissionFilterDto {
    automatic!: AvailabilityCarTransmissionFilterItemDto;
    manual!: AvailabilityCarTransmissionFilterItemDto;

    constructor(data?: IAvailabilityCarTransmissionFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.automatic = _data["automatic"] ? AvailabilityCarTransmissionFilterItemDto.fromJS(_data["automatic"]) : <any>undefined;
            this.manual = _data["manual"] ? AvailabilityCarTransmissionFilterItemDto.fromJS(_data["manual"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityCarTransmissionFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarTransmissionFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["automatic"] = this.automatic ? this.automatic.toJSON() : <any>undefined;
        data["manual"] = this.manual ? this.manual.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityCarTransmissionFilterDto {
    automatic: AvailabilityCarTransmissionFilterItemDto;
    manual: AvailabilityCarTransmissionFilterItemDto;
}

export class AvailabilityCarSuppliersFilterItemDto implements IAvailabilityCarSuppliersFilterItemDto {
    supplierCode!: string | undefined;
    supplierName!: string | undefined;
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityCarSuppliersFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityCarSuppliersFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarSuppliersFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityCarSuppliersFilterItemDto {
    supplierCode: string | undefined;
    supplierName: string | undefined;
    active: boolean;
    count: number;
}

export class AvailabilityCarSuppliersFilterDto implements IAvailabilityCarSuppliersFilterDto {
    suppliers!: AvailabilityCarSuppliersFilterItemDto[] | undefined;

    constructor(data?: IAvailabilityCarSuppliersFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(AvailabilityCarSuppliersFilterItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailabilityCarSuppliersFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarSuppliersFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailabilityCarSuppliersFilterDto {
    suppliers: AvailabilityCarSuppliersFilterItemDto[] | undefined;
}

export class AvailabilityCarSizeFilterItemDto implements IAvailabilityCarSizeFilterItemDto {
    carSize!: string | undefined;
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityCarSizeFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carSize = _data["carSize"];
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityCarSizeFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarSizeFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carSize"] = this.carSize;
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityCarSizeFilterItemDto {
    carSize: string | undefined;
    active: boolean;
    count: number;
}

export class AvailabilityCarSizeFilterDto implements IAvailabilityCarSizeFilterDto {
    carSizes!: AvailabilityCarSizeFilterItemDto[] | undefined;

    constructor(data?: IAvailabilityCarSizeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["carSizes"])) {
                this.carSizes = [] as any;
                for (let item of _data["carSizes"])
                    this.carSizes!.push(AvailabilityCarSizeFilterItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailabilityCarSizeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarSizeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.carSizes)) {
            data["carSizes"] = [];
            for (let item of this.carSizes)
                data["carSizes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailabilityCarSizeFilterDto {
    carSizes: AvailabilityCarSizeFilterItemDto[] | undefined;
}

export class AvailabilityCarDoorsFilterItemDto implements IAvailabilityCarDoorsFilterItemDto {
    doorsNumber!: number;
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityCarDoorsFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doorsNumber = _data["doorsNumber"];
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityCarDoorsFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarDoorsFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doorsNumber"] = this.doorsNumber;
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityCarDoorsFilterItemDto {
    doorsNumber: number;
    active: boolean;
    count: number;
}

export class AvailabilityCarDoorsFilterDto implements IAvailabilityCarDoorsFilterDto {
    doorsNumberCategories!: AvailabilityCarDoorsFilterItemDto[] | undefined;

    constructor(data?: IAvailabilityCarDoorsFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["doorsNumberCategories"])) {
                this.doorsNumberCategories = [] as any;
                for (let item of _data["doorsNumberCategories"])
                    this.doorsNumberCategories!.push(AvailabilityCarDoorsFilterItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailabilityCarDoorsFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarDoorsFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.doorsNumberCategories)) {
            data["doorsNumberCategories"] = [];
            for (let item of this.doorsNumberCategories)
                data["doorsNumberCategories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailabilityCarDoorsFilterDto {
    doorsNumberCategories: AvailabilityCarDoorsFilterItemDto[] | undefined;
}

export class AvailabilityCarPriceFilterDto implements IAvailabilityCarPriceFilterDto {
    active!: boolean;
    start!: number;
    end!: number;
    min!: number | undefined;
    max!: number | undefined;
    count!: number;

    constructor(data?: IAvailabilityCarPriceFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityCarPriceFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarPriceFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["start"] = this.start;
        data["end"] = this.end;
        data["min"] = this.min;
        data["max"] = this.max;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityCarPriceFilterDto {
    active: boolean;
    start: number;
    end: number;
    min: number | undefined;
    max: number | undefined;
    count: number;
}

export class AvailabilityCarOnlyInPolicyFilterDto implements IAvailabilityCarOnlyInPolicyFilterDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityCarOnlyInPolicyFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityCarOnlyInPolicyFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarOnlyInPolicyFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityCarOnlyInPolicyFilterDto {
    active: boolean;
    count: number;
}

export class AvailabilityFiltersDto implements IAvailabilityFiltersDto {
    locationTypeFilter!: AvailabilityCarLocationTypeFilterDto;
    airConditionFilter!: AvailabilityCarAirConditionFilterDto;
    transmissionFilter!: AvailabilityCarTransmissionFilterDto;
    suppliersFilter!: AvailabilityCarSuppliersFilterDto;
    carSizeFilter!: AvailabilityCarSizeFilterDto;
    doorsFilter!: AvailabilityCarDoorsFilterDto;
    priceFilter!: AvailabilityCarPriceFilterDto;
    onlyInPolicy!: AvailabilityCarOnlyInPolicyFilterDto;

    constructor(data?: IAvailabilityFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationTypeFilter = _data["locationTypeFilter"] ? AvailabilityCarLocationTypeFilterDto.fromJS(_data["locationTypeFilter"]) : <any>undefined;
            this.airConditionFilter = _data["airConditionFilter"] ? AvailabilityCarAirConditionFilterDto.fromJS(_data["airConditionFilter"]) : <any>undefined;
            this.transmissionFilter = _data["transmissionFilter"] ? AvailabilityCarTransmissionFilterDto.fromJS(_data["transmissionFilter"]) : <any>undefined;
            this.suppliersFilter = _data["suppliersFilter"] ? AvailabilityCarSuppliersFilterDto.fromJS(_data["suppliersFilter"]) : <any>undefined;
            this.carSizeFilter = _data["carSizeFilter"] ? AvailabilityCarSizeFilterDto.fromJS(_data["carSizeFilter"]) : <any>undefined;
            this.doorsFilter = _data["doorsFilter"] ? AvailabilityCarDoorsFilterDto.fromJS(_data["doorsFilter"]) : <any>undefined;
            this.priceFilter = _data["priceFilter"] ? AvailabilityCarPriceFilterDto.fromJS(_data["priceFilter"]) : <any>undefined;
            this.onlyInPolicy = _data["onlyInPolicy"] ? AvailabilityCarOnlyInPolicyFilterDto.fromJS(_data["onlyInPolicy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationTypeFilter"] = this.locationTypeFilter ? this.locationTypeFilter.toJSON() : <any>undefined;
        data["airConditionFilter"] = this.airConditionFilter ? this.airConditionFilter.toJSON() : <any>undefined;
        data["transmissionFilter"] = this.transmissionFilter ? this.transmissionFilter.toJSON() : <any>undefined;
        data["suppliersFilter"] = this.suppliersFilter ? this.suppliersFilter.toJSON() : <any>undefined;
        data["carSizeFilter"] = this.carSizeFilter ? this.carSizeFilter.toJSON() : <any>undefined;
        data["doorsFilter"] = this.doorsFilter ? this.doorsFilter.toJSON() : <any>undefined;
        data["priceFilter"] = this.priceFilter ? this.priceFilter.toJSON() : <any>undefined;
        data["onlyInPolicy"] = this.onlyInPolicy ? this.onlyInPolicy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityFiltersDto {
    locationTypeFilter: AvailabilityCarLocationTypeFilterDto;
    airConditionFilter: AvailabilityCarAirConditionFilterDto;
    transmissionFilter: AvailabilityCarTransmissionFilterDto;
    suppliersFilter: AvailabilityCarSuppliersFilterDto;
    carSizeFilter: AvailabilityCarSizeFilterDto;
    doorsFilter: AvailabilityCarDoorsFilterDto;
    priceFilter: AvailabilityCarPriceFilterDto;
    onlyInPolicy: AvailabilityCarOnlyInPolicyFilterDto;
}

export enum OrderType {
    Undefined = 0,
    Asc = 1,
    Desc = 2,
}

export class AvailabilitySortingDto implements IAvailabilitySortingDto {
    price!: OrderType;

    constructor(data?: IAvailabilitySortingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): AvailabilitySortingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilitySortingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        return data;
    }
}

export interface IAvailabilitySortingDto {
    price: OrderType;
}

export class CarAvailabilityRequestDto implements ICarAvailabilityRequestDto {
    filters!: AvailabilityFiltersDto;
    sorting!: AvailabilitySortingDto;
    pickUpLocation!: LocationDto;
    dropOffLocation!: LocationDto;
    pickUpDate!: moment.Moment;
    pickUpTime!: string;
    dropOffDate!: moment.Moment;
    dropOffTime!: string;
    driverAge!: number;
    negotiatedRate!: boolean;
    readonly totalRentDays!: number;

    constructor(data?: ICarAvailabilityRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pickUpLocation = new LocationDto();
            this.dropOffLocation = new LocationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"] ? AvailabilityFiltersDto.fromJS(_data["filters"]) : <any>undefined;
            this.sorting = _data["sorting"] ? AvailabilitySortingDto.fromJS(_data["sorting"]) : <any>undefined;
            this.pickUpLocation = _data["pickUpLocation"] ? LocationDto.fromJS(_data["pickUpLocation"]) : new LocationDto();
            this.dropOffLocation = _data["dropOffLocation"] ? LocationDto.fromJS(_data["dropOffLocation"]) : new LocationDto();
            this.pickUpDate = _data["pickUpDate"] ? moment(_data["pickUpDate"].toString()) : <any>undefined;
            this.pickUpTime = _data["pickUpTime"];
            this.dropOffDate = _data["dropOffDate"] ? moment(_data["dropOffDate"].toString()) : <any>undefined;
            this.dropOffTime = _data["dropOffTime"];
            this.driverAge = _data["driverAge"];
            this.negotiatedRate = _data["negotiatedRate"];
            (<any>this).totalRentDays = _data["totalRentDays"];
        }
    }

    static fromJS(data: any): CarAvailabilityRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarAvailabilityRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        data["sorting"] = this.sorting ? this.sorting.toJSON() : <any>undefined;
        data["pickUpLocation"] = this.pickUpLocation ? this.pickUpLocation.toJSON() : <any>undefined;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : <any>undefined;
        data["pickUpDate"] = this.pickUpDate ? this.pickUpDate.format('YYYY-MM-DD') : <any>undefined;
        data["pickUpTime"] = this.pickUpTime;
        data["dropOffDate"] = this.dropOffDate ? this.dropOffDate.format('YYYY-MM-DD') : <any>undefined;
        data["dropOffTime"] = this.dropOffTime;
        data["driverAge"] = this.driverAge;
        data["negotiatedRate"] = this.negotiatedRate;
        data["totalRentDays"] = this.totalRentDays;
        return data;
    }
}

export interface ICarAvailabilityRequestDto {
    filters: AvailabilityFiltersDto;
    sorting: AvailabilitySortingDto;
    pickUpLocation: LocationDto;
    dropOffLocation: LocationDto;
    pickUpDate: moment.Moment;
    pickUpTime: string;
    dropOffDate: moment.Moment;
    dropOffTime: string;
    driverAge: number;
    negotiatedRate: boolean;
    totalRentDays: number;
}

export class CarAvailabilityRequestBaseDto implements ICarAvailabilityRequestBaseDto {
    pickUpLocation!: LocationDto;
    dropOffLocation!: LocationDto;
    pickUpDate!: moment.Moment;
    pickUpTime!: string;
    dropOffDate!: moment.Moment;
    dropOffTime!: string;
    driverAge!: number;
    negotiatedRate!: boolean;
    readonly totalRentDays!: number;

    constructor(data?: ICarAvailabilityRequestBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pickUpLocation = new LocationDto();
            this.dropOffLocation = new LocationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickUpLocation = _data["pickUpLocation"] ? LocationDto.fromJS(_data["pickUpLocation"]) : new LocationDto();
            this.dropOffLocation = _data["dropOffLocation"] ? LocationDto.fromJS(_data["dropOffLocation"]) : new LocationDto();
            this.pickUpDate = _data["pickUpDate"] ? moment(_data["pickUpDate"].toString()) : <any>undefined;
            this.pickUpTime = _data["pickUpTime"];
            this.dropOffDate = _data["dropOffDate"] ? moment(_data["dropOffDate"].toString()) : <any>undefined;
            this.dropOffTime = _data["dropOffTime"];
            this.driverAge = _data["driverAge"];
            this.negotiatedRate = _data["negotiatedRate"];
            (<any>this).totalRentDays = _data["totalRentDays"];
        }
    }

    static fromJS(data: any): CarAvailabilityRequestBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarAvailabilityRequestBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickUpLocation"] = this.pickUpLocation ? this.pickUpLocation.toJSON() : <any>undefined;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : <any>undefined;
        data["pickUpDate"] = this.pickUpDate ? this.pickUpDate.format('YYYY-MM-DD') : <any>undefined;
        data["pickUpTime"] = this.pickUpTime;
        data["dropOffDate"] = this.dropOffDate ? this.dropOffDate.format('YYYY-MM-DD') : <any>undefined;
        data["dropOffTime"] = this.dropOffTime;
        data["driverAge"] = this.driverAge;
        data["negotiatedRate"] = this.negotiatedRate;
        data["totalRentDays"] = this.totalRentDays;
        return data;
    }
}

export interface ICarAvailabilityRequestBaseDto {
    pickUpLocation: LocationDto;
    dropOffLocation: LocationDto;
    pickUpDate: moment.Moment;
    pickUpTime: string;
    dropOffDate: moment.Moment;
    dropOffTime: string;
    driverAge: number;
    totalRentDays: number;
    negotiatedRate: boolean;
}

export class ProviderInfoDto implements IProviderInfoDto {
    title!: string | undefined;
    information!: string[] | undefined;

    constructor(data?: IProviderInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (Array.isArray(_data["information"])) {
                this.information = [] as any;
                for (let item of _data["information"])
                    this.information!.push(item);
            }
        }
    }

    static fromJS(data: any): ProviderInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.information)) {
            data["information"] = [];
            for (let item of this.information)
                data["information"].push(item);
        }
        return data;
    }
}

export interface IProviderInfoDto {
    title: string | undefined;
    information: string[] | undefined;
}

export class CarAvailabilityResponseDto implements ICarAvailabilityResponseDto {
    cars!: CarDto[] | undefined;
    suppliersInfo!: SupplierInfoDto[] | undefined;
    providerInfo!: ProviderInfoDto[] | undefined;

    constructor(data?: ICarAvailabilityResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cars"])) {
                this.cars = [] as any;
                for (let item of _data["cars"])
                    this.cars!.push(CarDto.fromJS(item));
            }
            if (Array.isArray(_data["suppliersInfo"])) {
                this.suppliersInfo = [] as any;
                for (let item of _data["suppliersInfo"])
                    this.suppliersInfo!.push(SupplierInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["providerInfo"])) {
                this.providerInfo = [] as any;
                for (let item of _data["providerInfo"])
                    this.providerInfo!.push(ProviderInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarAvailabilityResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarAvailabilityResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cars)) {
            data["cars"] = [];
            for (let item of this.cars)
                data["cars"].push(item.toJSON());
        }
        if (Array.isArray(this.suppliersInfo)) {
            data["suppliersInfo"] = [];
            for (let item of this.suppliersInfo)
                data["suppliersInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.providerInfo)) {
            data["providerInfo"] = [];
            for (let item of this.providerInfo)
                data["providerInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICarAvailabilityResponseDto {
    cars: CarDto[] | undefined;
    suppliersInfo: SupplierInfoDto[] | undefined;
    providerInfo: ProviderInfoDto[] | undefined;
}

export class AvailabilityCarCache implements IAvailabilityCarCache {
    requestData!: CarAvailabilityRequestBaseDto;
    data!: CarAvailabilityResponseDto;
    requestDataMD5!: string | undefined;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: IAvailabilityCarCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestData = _data["requestData"] ? CarAvailabilityRequestBaseDto.fromJS(_data["requestData"]) : <any>undefined;
            this.data = _data["data"] ? CarAvailabilityResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.requestDataMD5 = _data["requestDataMD5"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AvailabilityCarCache {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCarCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestData"] = this.requestData ? this.requestData.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["requestDataMD5"] = this.requestDataMD5;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAvailabilityCarCache {
    requestData: CarAvailabilityRequestBaseDto;
    data: CarAvailabilityResponseDto;
    requestDataMD5: string | undefined;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class CarAvailabilityPagedRequestDto implements ICarAvailabilityPagedRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    filters!: AvailabilityFiltersDto;
    sorting!: AvailabilitySortingDto;
    pickUpLocation!: LocationDto;
    dropOffLocation!: LocationDto;
    pickUpDate!: moment.Moment;
    pickUpTime!: string;
    dropOffDate!: moment.Moment;
    dropOffTime!: string;
    driverAge!: number;
    negotiatedRate!: boolean;
    readonly totalRentDays!: number;
    co2Data!: Co2DataDTO | undefined

    constructor(data?: ICarAvailabilityPagedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pickUpLocation = new LocationDto();
            this.dropOffLocation = new LocationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filters = _data["filters"] ? AvailabilityFiltersDto.fromJS(_data["filters"]) : <any>undefined;
            this.sorting = _data["sorting"] ? AvailabilitySortingDto.fromJS(_data["sorting"]) : <any>undefined;
            this.pickUpLocation = _data["pickUpLocation"] ? LocationDto.fromJS(_data["pickUpLocation"]) : new LocationDto();
            this.dropOffLocation = _data["dropOffLocation"] ? LocationDto.fromJS(_data["dropOffLocation"]) : new LocationDto();
            this.pickUpDate = _data["pickUpDate"] ? moment(_data["pickUpDate"].toString()) : <any>undefined;
            this.pickUpTime = _data["pickUpTime"];
            this.dropOffDate = _data["dropOffDate"] ? moment(_data["dropOffDate"].toString()) : <any>undefined;
            this.dropOffTime = _data["dropOffTime"];
            this.driverAge = _data["driverAge"];
            this.negotiatedRate = _data["negotiatedRate"];
            this.co2Data = _data["co2Data"];
            (<any>this).totalRentDays = _data["totalRentDays"];
        }
    }

    static fromJS(data: any): CarAvailabilityPagedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarAvailabilityPagedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        data["sorting"] = this.sorting ? this.sorting.toJSON() : <any>undefined;
        data["pickUpLocation"] = this.pickUpLocation ? this.pickUpLocation.toJSON() : <any>undefined;
        data["dropOffLocation"] = this.dropOffLocation ? this.dropOffLocation.toJSON() : <any>undefined;
        data["pickUpDate"] = this.pickUpDate ? this.pickUpDate.format('YYYY-MM-DD') : <any>undefined;
        data["pickUpTime"] = this.pickUpTime;
        data["dropOffDate"] = this.dropOffDate ? this.dropOffDate.format('YYYY-MM-DD') : <any>undefined;
        data["dropOffTime"] = this.dropOffTime;
        data["driverAge"] = this.driverAge;
        data["negotiatedRate"] = this.negotiatedRate;
        data["totalRentDays"] = this.totalRentDays;
        data["co2Data"] = this.co2Data;
        return data;
    }
}

export interface ICarAvailabilityPagedRequestDto {
    maxResultCount: number;
    skipCount: number;
    filters: AvailabilityFiltersDto;
    sorting: AvailabilitySortingDto;
    pickUpLocation: LocationDto;
    dropOffLocation: LocationDto;
    pickUpDate: moment.Moment;
    pickUpTime: string;
    dropOffDate: moment.Moment;
    dropOffTime: string;
    driverAge: number;
    negotiatedRate: boolean;
    totalRentDays: number;
    co2Data?: Co2DataDTO | undefined;
}

export class PagedResultDtoOfCarDto implements IPagedResultDtoOfCarDto {
    totalCount!: number;
    items!: CarDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CarDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCarDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCarDto {
    totalCount: number;
    items: CarDto[] | undefined;
}

export class PaginationOfCarAvailabilityRequestDtoCarDto implements IPaginationOfCarAvailabilityRequestDtoCarDto {
    request!: CarAvailabilityRequestDto;
    response!: PagedResultDtoOfCarDto;

    constructor(data?: IPaginationOfCarAvailabilityRequestDtoCarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? CarAvailabilityRequestDto.fromJS(_data["request"]) : <any>undefined;
            this.response = _data["response"] ? PagedResultDtoOfCarDto.fromJS(_data["response"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaginationOfCarAvailabilityRequestDtoCarDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationOfCarAvailabilityRequestDtoCarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaginationOfCarAvailabilityRequestDtoCarDto {
    request: CarAvailabilityRequestDto;
    response: PagedResultDtoOfCarDto;
}

export class CarBookRequestBaseDto implements ICarBookRequestBaseDto {
    availabilityId!: string;
    carId!: string;
    packageId!: string;
    pricingInformationId!: string;

    constructor(data?: ICarBookRequestBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityId = _data["availabilityId"];
            this.carId = _data["carId"];
            this.packageId = _data["packageId"];
            this.pricingInformationId = _data["pricingInformationId"];
        }
    }

    static fromJS(data: any): CarBookRequestBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarBookRequestBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityId"] = this.availabilityId;
        data["carId"] = this.carId;
        data["packageId"] = this.packageId;
        data["pricingInformationId"] = this.pricingInformationId;
        return data;
    }
}

export interface ICarBookRequestBaseDto {
    availabilityId: string;
    carId: string;
    packageId: string;
    pricingInformationId: string;
}

export class ListResultDtoOfPaymentDataProfileDto implements IListResultDtoOfPaymentDataProfileDto {
    items!: PaymentDataProfileDto[] | undefined;

    constructor(data?: IListResultDtoOfPaymentDataProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentDataProfileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPaymentDataProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfPaymentDataProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfPaymentDataProfileDto {
    items: PaymentDataProfileDto[] | undefined;
}

export class CarBookResponseDto implements ICarBookResponseDto {
    carBookData!: CarBookDto;
    paymentGateways!: PaymentGatewayDto[] | undefined;
    paymentProfiles!: ListResultDtoOfPaymentDataProfileDto;
    enableFopExtraPaymentProfile!: boolean;
    carBookingConfirmationTypes!: CarBookingConfirmationTypeDto[] | undefined;
    supplierInfo!: SupplierInfoDto;
    providerInfo!: ProviderInfoDto[] | undefined;
    extras!: AdditionalServiceDto[] | undefined;
    requestDataMD5!: string | undefined;
    driver!: DriverDto;
    user!: ApplicationUserDto;
    paymentGateway!: PaymentGatewayDto;
    carBookingConfirmationType!: CarBookingConfirmationTypeDto;
    paymentData!: PaymentDataDto;
    paymentProfile!: PaymentDataProfileDto;
    flightNumber!: string | undefined;
    selectedExtras!: AdditionalServiceDto[] | undefined;
    reservationId!: string | undefined;
    erp!: boolean | undefined;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;
    availabilityId!: string;
    carId!: string;
    packageId!: string;
    pricingInformationId!: string;

    constructor(data?: ICarBookResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carBookData = _data["carBookData"] ? CarBookDto.fromJS(_data["carBookData"]) : <any>undefined;
            if (Array.isArray(_data["paymentGateways"])) {
                this.paymentGateways = [] as any;
                for (let item of _data["paymentGateways"])
                    this.paymentGateways!.push(item);
            }
            this.paymentProfiles = _data["paymentProfiles"] ? ListResultDtoOfPaymentDataProfileDto.fromJS(_data["paymentProfiles"]) : <any>undefined;
            this.enableFopExtraPaymentProfile = _data["enableFopExtraPaymentProfile"];
            if (Array.isArray(_data["carBookingConfirmationTypes"])) {
                this.carBookingConfirmationTypes = [] as any;
                for (let item of _data["carBookingConfirmationTypes"])
                    this.carBookingConfirmationTypes!.push(item);
            }
            this.supplierInfo = _data["supplierInfo"] ? SupplierInfoDto.fromJS(_data["supplierInfo"]) : <any>undefined;
            if (Array.isArray(_data["providerInfo"])) {
                this.providerInfo = [] as any;
                for (let item of _data["providerInfo"])
                    this.providerInfo!.push(ProviderInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["extras"])) {
                this.extras = [] as any;
                for (let item of _data["extras"])
                    this.extras!.push(AdditionalServiceDto.fromJS(item));
            }
            this.requestDataMD5 = _data["requestDataMD5"];
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.user = _data["user"] ? ApplicationUserDto.fromJS(_data["user"]) : <any>undefined;
            this.paymentGateway = _data["paymentGateway"];
            this.carBookingConfirmationType = _data["carBookingConfirmationType"];
            this.paymentData = _data["paymentData"] ? PaymentDataDto.fromJS(_data["paymentData"]) : <any>undefined;
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
            this.flightNumber = _data["flightNumber"];
            if (Array.isArray(_data["selectedExtras"])) {
                this.selectedExtras = [] as any;
                for (let item of _data["selectedExtras"])
                    this.selectedExtras!.push(AdditionalServiceDto.fromJS(item));
            }
            this.reservationId = _data["reservationId"];
            this.erp = _data["erp"];
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
            this.availabilityId = _data["availabilityId"];
            this.carId = _data["carId"];
            this.packageId = _data["packageId"];
            this.pricingInformationId = _data["pricingInformationId"];
        }
    }

    static fromJS(data: any): CarBookResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarBookResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carBookData"] = this.carBookData ? this.carBookData.toJSON() : <any>undefined;
        if (Array.isArray(this.paymentGateways)) {
            data["paymentGateways"] = [];
            for (let item of this.paymentGateways)
                data["paymentGateways"].push(item);
        }
        data["paymentProfiles"] = this.paymentProfiles ? this.paymentProfiles.toJSON() : <any>undefined;
        data["enableFopExtraPaymentProfile"] = this.enableFopExtraPaymentProfile;
        if (Array.isArray(this.carBookingConfirmationTypes)) {
            data["carBookingConfirmationTypes"] = [];
            for (let item of this.carBookingConfirmationTypes)
                data["carBookingConfirmationTypes"].push(item);
        }
        data["supplierInfo"] = this.supplierInfo ? this.supplierInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.providerInfo)) {
            data["providerInfo"] = [];
            for (let item of this.providerInfo)
                data["providerInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.extras)) {
            data["extras"] = [];
            for (let item of this.extras)
                data["extras"].push(item.toJSON());
        }
        data["requestDataMD5"] = this.requestDataMD5;
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["paymentGateway"] = this.paymentGateway;
        data["carBookingConfirmationType"] = this.carBookingConfirmationType;
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        data["flightNumber"] = this.flightNumber;
        if (Array.isArray(this.selectedExtras)) {
            data["selectedExtras"] = [];
            for (let item of this.selectedExtras)
                data["selectedExtras"].push(item.toJSON());
        }
        data["reservationId"] = this.reservationId;
        data["erp"] = this.erp;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        data["availabilityId"] = this.availabilityId;
        data["carId"] = this.carId;
        data["packageId"] = this.packageId;
        data["pricingInformationId"] = this.pricingInformationId;
        return data;
    }
}

export interface ICarBookResponseDto {
    carBookData: CarBookDto;
    paymentGateways: PaymentGatewayDto[] | undefined;
    paymentProfiles: ListResultDtoOfPaymentDataProfileDto;
    enableFopExtraPaymentProfile: boolean;
    carBookingConfirmationTypes: CarBookingConfirmationTypeDto[] | undefined;
    supplierInfo: SupplierInfoDto;
    providerInfo: ProviderInfoDto[] | undefined;
    extras: AdditionalServiceDto[] | undefined;
    requestDataMD5: string | undefined;
    driver: DriverDto;
    user: ApplicationUserDto;
    paymentGateway: PaymentGatewayDto;
    carBookingConfirmationType: CarBookingConfirmationTypeDto;
    paymentData: PaymentDataDto;
    paymentProfile: PaymentDataProfileDto;
    flightNumber: string | undefined;
    selectedExtras: AdditionalServiceDto[] | undefined;
    reservationId: string | undefined;
    erp: boolean | undefined;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
    availabilityId: string;
    carId: string;
    packageId: string;
    pricingInformationId: string;
}

export class PaymentInfoDataDto implements IPaymentInfoDataDto {
    paymentId!: string | undefined;
    transactionId!: string | undefined;
    amount!: number;
    fee!: number;
    markup!: number;
    agencyFee!: number;
    agencyMarkup!: number;
    discount!: number;
    totalDue!: number;
    readonly total!: number;
    status!: PaymentStatusDto;
    gateway!: PaymentGatewayDto;
    description!: string | undefined;

    constructor(data?: IPaymentInfoDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.transactionId = _data["transactionId"];
            this.amount = _data["amount"];
            this.fee = _data["fee"];
            this.markup = _data["markup"];
            this.agencyFee = _data["agencyFee"];
            this.agencyMarkup = _data["agencyMarkup"];
            this.discount = _data["discount"];
            this.totalDue = _data["totalDue"];
            (<any>this).total = _data["total"];
            this.status = _data["status"];
            this.gateway = _data["gateway"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PaymentInfoDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["transactionId"] = this.transactionId;
        data["amount"] = this.amount;
        data["fee"] = this.fee;
        data["markup"] = this.markup;
        data["agencyFee"] = this.agencyFee;
        data["agencyMarkup"] = this.agencyMarkup;
        data["discount"] = this.discount;
        data["totalDue"] = this.totalDue;
        data["total"] = this.total;
        data["status"] = this.status;
        data["gateway"] = this.gateway;
        data["description"] = this.description;
        return data;
    }
}

export class Co2DataDTO implements ICo2DataDTO {
    airCo2: number;
    carCo2: number;
    trainCo2: number;
    msgCode: string;
    msgDescr: string;

    constructor(data?: ICo2DataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airCo2 = _data["airCo2"];
            this.carCo2 = _data["carCo2"];
            this.trainCo2 = _data["trainCo2"];
            this.msgCode = _data["msgCode"];
            this.msgDescr = _data["msgDescr"];
        }
    }

    static fromJS(data: any): Co2DataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new Co2DataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airCo2"] = this.airCo2;
        data["carCo2"] = this.carCo2;
        data["trainCo2"] = this.trainCo2;
        data["msgCode"] = this.msgCode;
        data["msgDescr"] = this.msgDescr;
        return data;
    }
}

export interface ICo2DataDTO {
    airCo2: number;
    carCo2: number;
    trainCo2: number;
    msgCode: string;
    msgDescr: string;
}

export interface IPaymentInfoDataDto {
    paymentId: string | undefined;
    transactionId: string | undefined;
    amount: number;
    fee: number;
    markup: number;
    agencyFee: number;
    agencyMarkup: number;
    discount: number;
    totalDue: number;
    total: number;
    status: PaymentStatusDto;
    gateway: PaymentGatewayDto;
    description: string | undefined;
}

export enum LogTypeDto {
    System = 0,
    User = 1,
    GdsError = 2,
    GdsWarning = 3,
}

export class LogDto implements ILogDto {
    username!: string | undefined;
    date!: moment.Moment;
    description!: string | undefined;
    type!: LogTypeDto;

    constructor(data?: ILogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): LogDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["type"] = this.type;
        return data;
    }
}

export interface ILogDto {
    username: string | undefined;
    date: moment.Moment;
    description: string | undefined;
    type: LogTypeDto;
}

export class SiapReservationErrorDto
{
    reservationId : string;
    reservationCode : string;
    errorMessage : string;
    errorTrace : string;
    sentTime : moment.Moment;
    errorTime : moment.Moment;
    actionType : string;

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.reservationCode = _data["reservationCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorTrace = _data["errorTrace"];
            this.sentTime = moment(_data["sentTime"].toString())
            this.errorTime = moment(_data["errorTime"].toString())
            this.actionType = _data["actionType"];
        }
    }

    static fromJS(data: any): SiapReservationErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SiapReservationErrorDto();
        result.init(data);
        return result;
    }
}

export enum SpecialRequestType {
    Generic = 0,
    Blind = 1,
    Deaf = 2,
    Meal = 3,
    Wheelchair = 4,
    OSI = 5,
    Infant = 6,
}

export class SSRData implements ISSRData {
    legsIds!: string[] | undefined;
    nameNumber!: string | undefined;
    type!: SpecialRequestType;
    code!: string | undefined;
    status!: string | undefined;
    fullText!: string | undefined;

    constructor(data?: ISSRData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["legsIds"])) {
                this.legsIds = [] as any;
                for (let item of _data["legsIds"])
                    this.legsIds!.push(item);
            }
            this.nameNumber = _data["nameNumber"];
            this.type = _data["type"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.fullText = _data["fullText"];
        }
    }

    static fromJS(data: any): SSRData {
        data = typeof data === 'object' ? data : {};
        let result = new SSRData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.legsIds)) {
            data["legsIds"] = [];
            for (let item of this.legsIds)
                data["legsIds"].push(item);
        }
        data["nameNumber"] = this.nameNumber;
        data["type"] = this.type;
        data["code"] = this.code;
        data["status"] = this.status;
        data["fullText"] = this.fullText;
        return data;
    }
}

export interface ISSRData {
    legsIds: string[] | undefined;
    nameNumber: string | undefined;
    type: SpecialRequestType;
    code: string | undefined;
    status: string | undefined;
    fullText: string | undefined;
}

export class SeatOption implements ISeatOption {
    seatName!: string | undefined;
    flightNumber!: string | undefined;
    price!: number;

    constructor(data?: ISeatOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seatName = _data["seatName"];
            this.flightNumber = _data["flightNumber"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): SeatOption {
        data = typeof data === 'object' ? data : {};
        let result = new SeatOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seatName"] = this.seatName;
        data["flightNumber"] = this.flightNumber;
        data["price"] = this.price;
        return data;
    }
}

export interface ISeatOption {
    seatName: string | undefined;
    flightNumber: string | undefined;
    price: number;
}

export class LuggageOptions implements ILuggageOptions {
    value!: string | undefined;
    description!: string | undefined;
    price!: number;
    shortDescription!: string | undefined;
    xmlParameterName!: null | string;

    constructor(data?: ILuggageOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.shortDescription = _data["shortDescription"];
            this.xmlParameterName = _data["xmlParameterName"];
        }
    }

    static fromJS(data: any): LuggageOptions {
        data = typeof data === 'object' ? data : {};
        let result = new LuggageOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        data["price"] = this.price;
        data["shortDescription"] = this.shortDescription;
        data["xmlParameterName"] = this.xmlParameterName;
        return data;
    }
}

export interface ILuggageOptions {
    value: string | undefined;
    description: string | undefined;
    price: number;
    shortDescription: string | undefined;
    xmlParameterName: null | string;
}

export class PassengerData implements IPassengerData {
    nameNumber!: string | undefined;
    type!: string | undefined;
    gender!: string | undefined;
    givenName!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    age!: number | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    frequentFlyerCarrierCode!: string | undefined;
    frequentFlyerMembershipId!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    countryOfResidence!: string | undefined;
    documentType!: string | undefined;
    documentNumber!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    nationalityCountry!: string | undefined;
    issueCountry!: string | undefined;
    specialRequests!: SSRData[] | undefined;
    infoAPISValid!: boolean | undefined;
    infoSecureFlightValid!: boolean | undefined;
    providerRef!: string | undefined;
    seats!: SeatOption[] | undefined;
    flightExtra!: LuggageOptions;
    luggageOption!: LuggageOptions;
    handLuggageOption!: LuggageOptions;
    outwardLuggageOption!: LuggageOptions;
    returnLuggageOption!: LuggageOptions;
    outwardHandLuggageOption!: LuggageOptions;
    returnHandLuggageOption!: LuggageOptions;
    linkedNameNumber!: string | undefined;

    constructor(data?: IPassengerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameNumber = _data["nameNumber"];
            this.type = _data["type"];
            this.gender = _data["gender"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.frequentFlyerCarrierCode = _data["frequentFlyerCarrierCode"];
            this.frequentFlyerMembershipId = _data["frequentFlyerMembershipId"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.countryOfResidence = _data["countryOfResidence"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.nationalityCountry = _data["nationalityCountry"];
            this.issueCountry = _data["issueCountry"];
            if (Array.isArray(_data["specialRequests"])) {
                this.specialRequests = [] as any;
                for (let item of _data["specialRequests"])
                    this.specialRequests!.push(SSRData.fromJS(item));
            }
            this.infoAPISValid = _data["infoAPISValid"];
            this.infoSecureFlightValid = _data["infoSecureFlightValid"];
            this.providerRef = _data["providerRef"];
            if (Array.isArray(_data["seats"])) {
                this.seats = [] as any;
                for (let item of _data["seats"])
                    this.seats!.push(SeatOption.fromJS(item));
            }
            this.flightExtra = _data["flightExtra"] ? LuggageOptions.fromJS(_data["flightExtra"]) : <any>undefined;
            this.luggageOption = _data["luggageOption"] ? LuggageOptions.fromJS(_data["luggageOption"]) : <any>undefined;
            this.handLuggageOption = _data["handLuggageOption"] ? LuggageOptions.fromJS(_data["handLuggageOption"]) : <any>undefined;
            this.outwardLuggageOption = _data["outwardLuggageOption"] ? LuggageOptions.fromJS(_data["outwardLuggageOption"]) : <any>undefined;
            this.returnLuggageOption = _data["returnLuggageOption"] ? LuggageOptions.fromJS(_data["returnLuggageOption"]) : <any>undefined;
            this.outwardHandLuggageOption = _data["outwardHandLuggageOption"] ? LuggageOptions.fromJS(_data["outwardHandLuggageOption"]) : <any>undefined;
            this.returnHandLuggageOption = _data["returnHandLuggageOption"] ? LuggageOptions.fromJS(_data["returnHandLuggageOption"]) : <any>undefined;
            this.linkedNameNumber = _data["linkedNameNumber"];
        }
    }

    static fromJS(data: any): PassengerData {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameNumber"] = this.nameNumber;
        data["type"] = this.type;
        data["gender"] = this.gender;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["frequentFlyerCarrierCode"] = this.frequentFlyerCarrierCode;
        data["frequentFlyerMembershipId"] = this.frequentFlyerMembershipId;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["countryOfResidence"] = this.countryOfResidence;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["nationalityCountry"] = this.nationalityCountry;
        data["issueCountry"] = this.issueCountry;
        if (Array.isArray(this.specialRequests)) {
            data["specialRequests"] = [];
            for (let item of this.specialRequests)
                data["specialRequests"].push(item.toJSON());
        }
        data["infoAPISValid"] = this.infoAPISValid;
        data["infoSecureFlightValid"] = this.infoSecureFlightValid;
        data["providerRef"] = this.providerRef;
        if (Array.isArray(this.seats)) {
            data["seats"] = [];
            for (let item of this.seats)
                data["seats"].push(item.toJSON());
        }
        data["flightExtra"] = this.flightExtra ? this.flightExtra.toJSON() : <any>undefined;
        data["luggageOption"] = this.luggageOption ? this.luggageOption.toJSON() : <any>undefined;
        data["handLuggageOption"] = this.handLuggageOption ? this.handLuggageOption.toJSON() : <any>undefined;
        data["outwardLuggageOption"] = this.outwardLuggageOption ? this.outwardLuggageOption.toJSON() : <any>undefined;
        data["returnLuggageOption"] = this.returnLuggageOption ? this.returnLuggageOption.toJSON() : <any>undefined;
        data["outwardHandLuggageOption"] = this.outwardHandLuggageOption ? this.outwardHandLuggageOption.toJSON() : <any>undefined;
        data["returnHandLuggageOption"] = this.returnHandLuggageOption ? this.returnHandLuggageOption.toJSON() : <any>undefined;
        data["linkedNameNumber"] = this.linkedNameNumber;
        return data;
    }
}

export interface IPassengerData {
    nameNumber: string | undefined;
    type: string | undefined;
    gender: string | undefined;
    givenName: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    age: number | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    frequentFlyerCarrierCode: string | undefined;
    frequentFlyerMembershipId: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    countryOfResidence: string | undefined;
    documentType: string | undefined;
    documentNumber: string | undefined;
    expirationDate: moment.Moment | undefined;
    nationalityCountry: string | undefined;
    issueCountry: string | undefined;
    specialRequests: SSRData[] | undefined;
    infoAPISValid: boolean | undefined;
    infoSecureFlightValid: boolean | undefined;
    providerRef: string | undefined;
    seats: SeatOption[] | undefined;
    flightExtra: LuggageOptions;
    luggageOption: LuggageOptions;
    handLuggageOption: LuggageOptions;
    outwardLuggageOption: LuggageOptions;
    returnLuggageOption: LuggageOptions;
    outwardHandLuggageOption: LuggageOptions;
    returnHandLuggageOption: LuggageOptions;
    linkedNameNumber: string | undefined;
}

export class AccountingInfoDto implements IAccountingInfoDto {
    airlineCode!: string | undefined;
    documentNumber!: string | undefined;
    personName!: string | undefined;
    nameNumber!: string | undefined;
    eTicketNumber!: string | undefined;
    transactionIndicator!: string | undefined;
    pdcSeat!: string | undefined;

    constructor(data?: IAccountingInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airlineCode = _data["airlineCode"];
            this.documentNumber = _data["documentNumber"];
            this.personName = _data["personName"];
            this.nameNumber = _data["nameNumber"];
            this.eTicketNumber = _data["eTicketNumber"];
            this.transactionIndicator = _data["transactionIndicator"];
            this.pdcSeat = _data["pdcSeat"];
        }
    }

    static fromJS(data: any): AccountingInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineCode"] = this.airlineCode;
        data["documentNumber"] = this.documentNumber;
        data["personName"] = this.personName;
        data["nameNumber"] = this.nameNumber;
        data["eTicketNumber"] = this.eTicketNumber;
        data["transactionIndicator"] = this.transactionIndicator;
        data["pdcSeat"] = this.pdcSeat;
        return data;
    }
}

export interface IAccountingInfoDto {
    airlineCode: string | undefined;
    documentNumber: string | undefined;
    personName: string | undefined;
    nameNumber: string | undefined;
    eTicketNumber: string | undefined;
    transactionIndicator: string | undefined;
    pdcSeat: string | undefined;
}

export class GenericSpecialRequestDto implements IGenericSpecialRequestDto {
    type!: string | undefined;
    msgType!: string | undefined;
    airlineCode!: string | undefined;
    text!: string | undefined;

    constructor(data?: IGenericSpecialRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.msgType = _data["msgType"];
            this.airlineCode = _data["airlineCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): GenericSpecialRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenericSpecialRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["msgType"] = this.msgType;
        data["airlineCode"] = this.airlineCode;
        data["text"] = this.text;
        return data;
    }
}

export interface IGenericSpecialRequestDto {
    type: string | undefined;
    msgType: string | undefined;
    airlineCode: string | undefined;
    text: string | undefined;
}

export class RemarkDto implements IRemarkDto {
    type!: string | undefined;
    text!: string | undefined;

    constructor(data?: IRemarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): RemarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["text"] = this.text;
        return data;
    }
}

export interface IRemarkDto {
    type: string | undefined;
    text: string | undefined;
}

export class ReservationFlightDto implements IReservationFlightDto {
    airlineReference!: string | undefined;
    itineraryId!: string | undefined;
    availabilityId!: string | undefined;
    groupItineraryId!: string | undefined;
    passengers!: PassengerData[] | undefined;
    legs!: LegDescDTO[] | undefined;
    pricingInformation!: PricingInformationDTO[] | undefined;
    selectedPricingInformation!: PricingInformationDTO;
    ticketInfo!: AccountingInfoDto[] | undefined;
    genericSpecialRequests!: GenericSpecialRequestDto[] | undefined;
    remarks!: RemarkDto[] | undefined;
    bookingConfirmationType!: BookingConfirmationTypeDto;
    tripType!: TripTypeDTO;
    luggageOption!: LuggageOptionsDTO;
    handLuggageOption!: LuggageOptionsDTO;
    reserveSeatsError!: boolean;

    constructor(data?: IReservationFlightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airlineReference = _data["airlineReference"];
            this.itineraryId = _data["itineraryId"];
            this.availabilityId = _data["availabilityId"];
            this.groupItineraryId = _data["groupItineraryId"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PassengerData.fromJS(item));
            }
            if (Array.isArray(_data["legs"])) {
                this.legs = [] as any;
                for (let item of _data["legs"])
                    this.legs!.push(LegDescDTO.fromJS(item));
            }
            if (Array.isArray(_data["pricingInformation"])) {
                this.pricingInformation = [] as any;
                for (let item of _data["pricingInformation"])
                    this.pricingInformation!.push(PricingInformationDTO.fromJS(item));
            }
            this.selectedPricingInformation = _data["selectedPricingInformation"] ? PricingInformationDTO.fromJS(_data["selectedPricingInformation"]) : <any>undefined;
            if (Array.isArray(_data["ticketInfo"])) {
                this.ticketInfo = [] as any;
                for (let item of _data["ticketInfo"])
                    this.ticketInfo!.push(AccountingInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["genericSpecialRequests"])) {
                this.genericSpecialRequests = [] as any;
                for (let item of _data["genericSpecialRequests"])
                    this.genericSpecialRequests!.push(GenericSpecialRequestDto.fromJS(item));
            }
            if (Array.isArray(_data["remarks"])) {
                this.remarks = [] as any;
                for (let item of _data["remarks"])
                    this.remarks!.push(RemarkDto.fromJS(item));
            }
            this.bookingConfirmationType = _data["bookingConfirmationType"];
            this.tripType = _data["tripType"];
            this.luggageOption = _data["luggageOption"] ? LuggageOptionsDTO.fromJS(_data["luggageOption"]) : <any>undefined;
            this.handLuggageOption = _data["handLuggageOption"] ? LuggageOptionsDTO.fromJS(_data["handLuggageOption"]) : <any>undefined;
            this.reserveSeatsError = _data["reserveSeatsError"];
        }
    }

    static fromJS(data: any): ReservationFlightDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationFlightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineReference"] = this.airlineReference;
        data["itineraryId"] = this.itineraryId;
        data["availabilityId"] = this.availabilityId;
        data["groupItineraryId"] = this.groupItineraryId;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        if (Array.isArray(this.legs)) {
            data["legs"] = [];
            for (let item of this.legs)
                data["legs"].push(item.toJSON());
        }
        if (Array.isArray(this.pricingInformation)) {
            data["pricingInformation"] = [];
            for (let item of this.pricingInformation)
                data["pricingInformation"].push(item.toJSON());
        }
        data["selectedPricingInformation"] = this.selectedPricingInformation ? this.selectedPricingInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.ticketInfo)) {
            data["ticketInfo"] = [];
            for (let item of this.ticketInfo)
                data["ticketInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.genericSpecialRequests)) {
            data["genericSpecialRequests"] = [];
            for (let item of this.genericSpecialRequests)
                data["genericSpecialRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.remarks)) {
            data["remarks"] = [];
            for (let item of this.remarks)
                data["remarks"].push(item.toJSON());
        }
        data["bookingConfirmationType"] = this.bookingConfirmationType;
        data["tripType"] = this.tripType;
        data["luggageOption"] = this.luggageOption ? this.luggageOption.toJSON() : <any>undefined;
        data["handLuggageOption"] = this.handLuggageOption ? this.handLuggageOption.toJSON() : <any>undefined;
        data["reserveSeatsError"] = this.reserveSeatsError;
        return data;
    }
}

export interface IReservationFlightDto {
    airlineReference: string | undefined;
    itineraryId: string | undefined;
    availabilityId: string | undefined;
    groupItineraryId: string | undefined;
    passengers: PassengerData[] | undefined;
    legs: LegDescDTO[] | undefined;
    pricingInformation: PricingInformationDTO[] | undefined;
    selectedPricingInformation: PricingInformationDTO;
    ticketInfo: AccountingInfoDto[] | undefined;
    genericSpecialRequests: GenericSpecialRequestDto[] | undefined;
    remarks: RemarkDto[] | undefined;
    bookingConfirmationType: BookingConfirmationTypeDto;
    tripType: TripTypeDTO;
    luggageOption: LuggageOptionsDTO;
    handLuggageOption: LuggageOptionsDTO;
    reserveSeatsError: boolean;
}

export class RoomItemDto implements IRoomItemDto {
    departureDate!: moment.Moment;
    returnDate!: moment.Moment;
    roomType!: string | undefined;
    roomTypeName!: string | undefined;
    mealPlan!: string | undefined;
    guests!: GuestsDto;
    totalDue!: number;
    totalPrice!: number;
    arrayOfCancelPenalties!: ArrayOfCancelPenaltiesDto;

    constructor(data?: IRoomItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : <any>undefined;
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : <any>undefined;
            this.roomType = _data["roomType"];
            this.roomTypeName = _data["roomTypeName"];
            this.mealPlan = _data["mealPlan"];
            this.guests = _data["guests"] ? GuestsDto.fromJS(_data["guests"]) : <any>undefined;
            this.totalDue = _data["totalDue"];
            this.totalPrice = _data["totalPrice"];
            this.arrayOfCancelPenalties = _data["arrayOfCancelPenalties"] ? ArrayOfCancelPenaltiesDto.fromJS(_data["arrayOfCancelPenalties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RoomItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["roomType"] = this.roomType;
        data["roomTypeName"] = this.roomTypeName;
        data["mealPlan"] = this.mealPlan;
        data["guests"] = this.guests ? this.guests.toJSON() : <any>undefined;
        data["totalDue"] = this.totalDue;
        data["totalPrice"] = this.totalPrice;
        data["arrayOfCancelPenalties"] = this.arrayOfCancelPenalties ? this.arrayOfCancelPenalties.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRoomItemDto {
    departureDate: moment.Moment;
    returnDate: moment.Moment;
    roomType: string | undefined;
    roomTypeName: string | undefined;
    mealPlan: string | undefined;
    guests: GuestsDto;
    totalDue: number;
    totalPrice: number;
    arrayOfCancelPenalties: ArrayOfCancelPenaltiesDto;
}

export class ItemVoucherInfoPaidByDto implements IItemVoucherInfoPaidByDto {
    name!: string | undefined;
    country!: string | undefined;
    eMail!: string | undefined;
    vat!: string | undefined;

    constructor(data?: IItemVoucherInfoPaidByDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.country = _data["country"];
            this.eMail = _data["eMail"];
            this.vat = _data["vat"];
        }
    }

    static fromJS(data: any): ItemVoucherInfoPaidByDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemVoucherInfoPaidByDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["country"] = this.country;
        data["eMail"] = this.eMail;
        data["vat"] = this.vat;
        return data;
    }
}

export interface IItemVoucherInfoPaidByDto {
    name: string | undefined;
    country: string | undefined;
    eMail: string | undefined;
    vat: string | undefined;
}

export class ItemVoucherInfoDto implements IItemVoucherInfoDto {
    paidBy!: ItemVoucherInfoPaidByDto;
    remarks!: string | undefined;
    reference!: string | undefined;

    constructor(data?: IItemVoucherInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paidBy = _data["paidBy"] ? ItemVoucherInfoPaidByDto.fromJS(_data["paidBy"]) : <any>undefined;
            this.remarks = _data["remarks"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): ItemVoucherInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemVoucherInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidBy"] = this.paidBy ? this.paidBy.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IItemVoucherInfoDto {
    paidBy: ItemVoucherInfoPaidByDto;
    remarks: string | undefined;
    reference: string | undefined;
}

export class ReservationHotelDto implements IReservationHotelDto {
    structureInfo!: StructureDto;
    rooms!: RoomItemDto[] | undefined;
    voucherInfo!: ItemVoucherInfoDto[] | undefined;
    quotation!: QuotationDto;

    constructor(data?: IReservationHotelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureInfo = _data["structureInfo"] ? StructureDto.fromJS(_data["structureInfo"]) : <any>undefined;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(RoomItemDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherInfo"])) {
                this.voucherInfo = [] as any;
                for (let item of _data["voucherInfo"])
                    this.voucherInfo!.push(ItemVoucherInfoDto.fromJS(item));
            }
            this.quotation = _data["quotation"] ? QuotationDto.fromJS(_data["quotation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReservationHotelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationHotelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureInfo"] = this.structureInfo ? this.structureInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        if (Array.isArray(this.voucherInfo)) {
            data["voucherInfo"] = [];
            for (let item of this.voucherInfo)
                data["voucherInfo"].push(item.toJSON());
        }
        data["quotation"] = this.quotation ? this.quotation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReservationHotelDto {
    structureInfo: StructureDto;
    rooms: RoomItemDto[] | undefined;
    voucherInfo: ItemVoucherInfoDto[] | undefined;
    quotation: QuotationDto;
}

export class TrainTicketingInfo implements ITrainTicketingInfo {
    personName!: string | undefined;
    nameNumber!: string | undefined;
    eTicketNumber!: string | undefined;
    transactionIndicator!: string | undefined;
    bookingCode!: string | undefined;
    orderId!: string | undefined;
    trainRef!: string | undefined;
    trainDescription!: string | undefined;
    offerDescription!: string | undefined;
    offerServiceTravelId!: string | undefined;
    offerServiceTravelSolutionId!: string | undefined;
    offerServiceOfferId!: string | undefined;
    solutionNodeId!: string | undefined;
    wagon!: string | undefined;
    seat!: string | undefined;
    fidelity!: string | undefined;
    fidelityPoints!: string | undefined;
    priceAmount!: number;
    postSalePenaltyAmount!: number | undefined;

    constructor(data?: ITrainTicketingInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personName = _data["personName"];
            this.nameNumber = _data["nameNumber"];
            this.eTicketNumber = _data["eTicketNumber"];
            this.transactionIndicator = _data["transactionIndicator"];
            this.bookingCode = _data["bookingCode"];
            this.orderId = _data["orderId"];
            this.trainRef = _data["trainRef"];
            this.trainDescription = _data["trainDescription"];
            this.offerDescription = _data["offerDescription"];
            this.offerServiceTravelId = _data["offerServiceTravelId"];
            this.offerServiceTravelSolutionId = _data["offerServiceTravelSolutionId"];
            this.offerServiceOfferId = _data["offerServiceOfferId"];
            this.solutionNodeId = _data["solutionNodeId"];
            this.wagon = _data["wagon"];
            this.seat = _data["seat"];
            this.fidelity = _data["fidelity"];
            this.fidelityPoints = _data["fidelityPoints"];
            this.priceAmount = _data["priceAmount"];
            this.postSalePenaltyAmount = _data["postSalePenaltyAmount"];
        }
    }

    static fromJS(data: any): TrainTicketingInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TrainTicketingInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personName"] = this.personName;
        data["nameNumber"] = this.nameNumber;
        data["eTicketNumber"] = this.eTicketNumber;
        data["transactionIndicator"] = this.transactionIndicator;
        data["bookingCode"] = this.bookingCode;
        data["orderId"] = this.orderId;
        data["trainRef"] = this.trainRef;
        data["trainDescription"] = this.trainDescription;
        data["offerDescription"] = this.offerDescription;
        data["offerServiceTravelId"] = this.offerServiceTravelId;
        data["offerServiceTravelSolutionId"] = this.offerServiceTravelSolutionId;
        data["offerServiceOfferId"] = this.offerServiceOfferId;
        data["solutionNodeId"] = this.solutionNodeId;
        data["wagon"] = this.wagon;
        data["seat"] = this.seat;
        data["fidelity"] = this.fidelity;
        data["fidelityPoints"] = this.fidelityPoints;
        data["priceAmount"] = this.priceAmount;
        data["postSalePenaltyAmount"] = this.postSalePenaltyAmount;
        return data;
    }
}

export interface ITrainTicketingInfo {
    personName: string | undefined;
    nameNumber: string | undefined;
    eTicketNumber: string | undefined;
    transactionIndicator: string | undefined;
    bookingCode: string | undefined;
    orderId: string | undefined;
    trainRef: string | undefined;
    trainDescription: string | undefined;
    offerDescription: string | undefined;
    offerServiceTravelId: string | undefined;
    offerServiceTravelSolutionId: string | undefined;
    offerServiceOfferId: string | undefined;
    solutionNodeId: string | undefined;
    wagon: string | undefined;
    seat: string | undefined;
    fidelity: string | undefined;
    fidelityPoints: string | undefined;
    priceAmount: number;
    postSalePenaltyAmount: number | undefined;
}

export class ReservationTrainDto implements IReservationTrainDto {
    availabilityId!: string | undefined;
    outwardGroupItineraryId!: string | undefined;
    returnGroupItineraryId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;
    outwardPricingInformationIds!: string[] | undefined;
    returnPricingInformationIds!: string[] | undefined;
    providerOrderId!: string | undefined;
    providerTravelId!: string | undefined;
    passengers!: PassengerData[] | undefined;
    legs!: LegDescDTO[] | undefined;
    pricingInformation!: PricingInformationDTO[] | undefined;
    selectedPricingInformation!: PricingInformationDTO;
    ticketInfo!: TrainTicketingInfo[] | undefined;
    bookingConfirmationType!: BookingConfirmationTypeDto;
    tripType!: TripTypeDTO;

    constructor(data?: IReservationTrainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityId = _data["availabilityId"];
            this.outwardGroupItineraryId = _data["outwardGroupItineraryId"];
            this.returnGroupItineraryId = _data["returnGroupItineraryId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
            if (Array.isArray(_data["outwardPricingInformationIds"])) {
                this.outwardPricingInformationIds = [] as any;
                for (let item of _data["outwardPricingInformationIds"])
                    this.outwardPricingInformationIds!.push(item);
            }
            if (Array.isArray(_data["returnPricingInformationIds"])) {
                this.returnPricingInformationIds = [] as any;
                for (let item of _data["returnPricingInformationIds"])
                    this.returnPricingInformationIds!.push(item);
            }
            this.providerOrderId = _data["providerOrderId"];
            this.providerTravelId = _data["providerTravelId"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PassengerData.fromJS(item));
            }
            if (Array.isArray(_data["legs"])) {
                this.legs = [] as any;
                for (let item of _data["legs"])
                    this.legs!.push(LegDescDTO.fromJS(item));
            }
            if (Array.isArray(_data["pricingInformation"])) {
                this.pricingInformation = [] as any;
                for (let item of _data["pricingInformation"])
                    this.pricingInformation!.push(PricingInformationDTO.fromJS(item));
            }
            this.selectedPricingInformation = _data["selectedPricingInformation"] ? PricingInformationDTO.fromJS(_data["selectedPricingInformation"]) : <any>undefined;
            if (Array.isArray(_data["ticketInfo"])) {
                this.ticketInfo = [] as any;
                for (let item of _data["ticketInfo"])
                    this.ticketInfo!.push(TrainTicketingInfo.fromJS(item));
            }
            this.bookingConfirmationType = _data["bookingConfirmationType"];
            this.tripType = _data["tripType"];
        }
    }

    static fromJS(data: any): ReservationTrainDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationTrainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityId"] = this.availabilityId;
        data["outwardGroupItineraryId"] = this.outwardGroupItineraryId;
        data["returnGroupItineraryId"] = this.returnGroupItineraryId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        if (Array.isArray(this.outwardPricingInformationIds)) {
            data["outwardPricingInformationIds"] = [];
            for (let item of this.outwardPricingInformationIds)
                data["outwardPricingInformationIds"].push(item);
        }
        if (Array.isArray(this.returnPricingInformationIds)) {
            data["returnPricingInformationIds"] = [];
            for (let item of this.returnPricingInformationIds)
                data["returnPricingInformationIds"].push(item);
        }
        data["providerOrderId"] = this.providerOrderId;
        data["providerTravelId"] = this.providerTravelId;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        if (Array.isArray(this.legs)) {
            data["legs"] = [];
            for (let item of this.legs)
                data["legs"].push(item.toJSON());
        }
        if (Array.isArray(this.pricingInformation)) {
            data["pricingInformation"] = [];
            for (let item of this.pricingInformation)
                data["pricingInformation"].push(item.toJSON());
        }
        data["selectedPricingInformation"] = this.selectedPricingInformation ? this.selectedPricingInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.ticketInfo)) {
            data["ticketInfo"] = [];
            for (let item of this.ticketInfo)
                data["ticketInfo"].push(item.toJSON());
        }
        data["bookingConfirmationType"] = this.bookingConfirmationType;
        data["tripType"] = this.tripType;
        return data;
    }
}

export interface IReservationTrainDto {
    availabilityId: string | undefined;
    outwardGroupItineraryId: string | undefined;
    returnGroupItineraryId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
    outwardPricingInformationIds: string[] | undefined;
    returnPricingInformationIds: string[] | undefined;
    providerOrderId: string | undefined;
    providerTravelId: string | undefined;
    passengers: PassengerData[] | undefined;
    legs: LegDescDTO[] | undefined;
    pricingInformation: PricingInformationDTO[] | undefined;
    selectedPricingInformation: PricingInformationDTO;
    ticketInfo: TrainTicketingInfo[] | undefined;
    bookingConfirmationType: BookingConfirmationTypeDto;
    tripType: TripTypeDTO;
}

export class CarBookingData implements ICarBookingData {
    availabilityId!: string | undefined;
    carId!: string | undefined;
    packageId!: string | undefined;
    pricingInformationId!: string | undefined;
    carBookData!: CarBookDto;
    suppliersInfo!: SupplierInfoDto;
    providerInfo!: ProviderInfoDto[] | undefined;
    extras!: AdditionalServiceDto[] | undefined;
    driver!: DriverDto;
    erp!: boolean | undefined;

    constructor(data?: ICarBookingData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityId = _data["availabilityId"];
            this.carId = _data["carId"];
            this.packageId = _data["packageId"];
            this.pricingInformationId = _data["pricingInformationId"];
            this.carBookData = _data["carBookData"] ? CarBookDto.fromJS(_data["carBookData"]) : <any>undefined;
            this.suppliersInfo = _data["suppliersInfo"] ? SupplierInfoDto.fromJS(_data["suppliersInfo"]) : <any>undefined;
            if (Array.isArray(_data["providerInfo"])) {
                this.providerInfo = [] as any;
                for (let item of _data["providerInfo"])
                    this.providerInfo!.push(ProviderInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["extras"])) {
                this.extras = [] as any;
                for (let item of _data["extras"])
                    this.extras!.push(AdditionalServiceDto.fromJS(item));
            }
            this.driver = _data["driver"] ? DriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.erp = _data["erp"];
        }
    }

    static fromJS(data: any): CarBookingData {
        data = typeof data === 'object' ? data : {};
        let result = new CarBookingData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityId"] = this.availabilityId;
        data["carId"] = this.carId;
        data["packageId"] = this.packageId;
        data["pricingInformationId"] = this.pricingInformationId;
        data["carBookData"] = this.carBookData ? this.carBookData.toJSON() : <any>undefined;
        data["suppliersInfo"] = this.suppliersInfo ? this.suppliersInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.providerInfo)) {
            data["providerInfo"] = [];
            for (let item of this.providerInfo)
                data["providerInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.extras)) {
            data["extras"] = [];
            for (let item of this.extras)
                data["extras"].push(item.toJSON());
        }
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["erp"] = this.erp;
        return data;
    }
}

export interface ICarBookingData {
    availabilityId: string | undefined;
    carId: string | undefined;
    packageId: string | undefined;
    pricingInformationId: string | undefined;
    carBookData: CarBookDto;
    suppliersInfo: SupplierInfoDto;
    providerInfo: ProviderInfoDto[] | undefined;
    extras: AdditionalServiceDto[] | undefined;
    driver: DriverDto;
    erp: boolean | undefined;
}

export class ReservationCarDto implements IReservationCarDto {
    bookingNumber!: string | undefined;
    supplierReference!: string | undefined;
    flightNumber!: string | undefined;
    bookingData!: CarBookingData;
    bookingConfirmationType!: CarBookingConfirmationTypeDto;
    readonly isInPenalty!: boolean;

    constructor(data?: IReservationCarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingNumber = _data["bookingNumber"];
            this.supplierReference = _data["supplierReference"];
            this.flightNumber = _data["flightNumber"];
            this.bookingData = _data["bookingData"] ? CarBookingData.fromJS(_data["bookingData"]) : <any>undefined;
            this.bookingConfirmationType = _data["bookingConfirmationType"];
            (<any>this).isInPenalty = _data["isInPenalty"];
        }
    }

    static fromJS(data: any): ReservationCarDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationCarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingNumber"] = this.bookingNumber;
        data["supplierReference"] = this.supplierReference;
        data["flightNumber"] = this.flightNumber;
        data["bookingData"] = this.bookingData ? this.bookingData.toJSON() : <any>undefined;
        data["bookingConfirmationType"] = this.bookingConfirmationType;
        data["isInPenalty"] = this.isInPenalty;
        return data;
    }
}

export interface IReservationCarDto {
    bookingNumber: string | undefined;
    supplierReference: string | undefined;
    flightNumber: string | undefined;
    bookingData: CarBookingData;
    bookingConfirmationType: CarBookingConfirmationTypeDto;
    isInPenalty: boolean;
}

export class ReferenceDataModel implements IReferenceDataModel {
    id!: string;
    name!: string | undefined;
    country!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    address!: string | undefined;
    phoneNumber!: string | undefined;
    mobileNumber!: string | undefined;
    zipCode!: string | undefined;
    fax!: string | undefined;
    vatNumber!: string | undefined;
    cciaa!: string | undefined;
    email!: string | undefined;
    accountingCode!: string | undefined;
    logoId!: string;

    constructor(data?: IReferenceDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.zipCode = _data["zipCode"];
            this.fax = _data["fax"];
            this.vatNumber = _data["vatNumber"];
            this.cciaa = _data["cciaa"];
            this.email = _data["email"];
            this.accountingCode = _data["accountingCode"];
            this.logoId = _data["logoId"];
        }
    }

    static fromJS(data: any): ReferenceDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReferenceDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["country"] = this.country;
        data["city"] = this.city;
        data["state"] = this.state;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["zipCode"] = this.zipCode;
        data["fax"] = this.fax;
        data["vatNumber"] = this.vatNumber;
        data["cciaa"] = this.cciaa;
        data["email"] = this.email;
        data["accountingCode"] = this.accountingCode;
        data["logoId"] = this.logoId;
        return data;
    }
}

export interface IReferenceDataModel {
    id: string;
    name: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
    mobileNumber: string | undefined;
    zipCode: string | undefined;
    fax: string | undefined;
    vatNumber: string | undefined;
    cciaa: string | undefined;
    email: string | undefined;
    accountingCode: string | undefined;
    logoId: string;
}

export class ReservationDto implements IReservationDto {
    id!: string | undefined;
    buyer!: ApplicationUserDto;
    paymentInfo!: PaymentInfoDataDto;
    reservationCode!: string | undefined;
    provider!: string | undefined;
    providerReference!: string | undefined;
    reservationStatus!: ReservationStatusDto;
    reservationDate!: moment.Moment;
    logs!: LogDto[] | undefined;
    discountCode!: string | undefined;
    timeLimit!: moment.Moment | undefined;
    packageRateAvailabilityId!: string | undefined;
    reservationType!: ReservationTypeDto;
    reservationFlight!: ReservationFlightDto;
    reservationHotel!: ReservationHotelDto;
    reservationTrain!: ReservationTrainDto;
    reservationCar!: ReservationCarDto;
    ts!: moment.Moment;
    userId!: string | undefined;
    agencyId!: string | undefined;
    agencyName!: string | undefined;
    username!: string | undefined;
    referenceData!: ReferenceDataModel;

    constructor(data?: IReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.buyer = _data["buyer"] ? ApplicationUserDto.fromJS(_data["buyer"]) : <any>undefined;
            this.paymentInfo = _data["paymentInfo"] ? PaymentInfoDataDto.fromJS(_data["paymentInfo"]) : <any>undefined;
            this.reservationCode = _data["reservationCode"];
            this.provider = _data["provider"];
            this.providerReference = _data["providerReference"];
            this.reservationStatus = _data["reservationStatus"];
            this.reservationDate = _data["reservationDate"] ? moment(_data["reservationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(LogDto.fromJS(item));
            }
            this.discountCode = _data["discountCode"];
            this.timeLimit = _data["timeLimit"] ? moment(_data["timeLimit"].toString()) : <any>undefined;
            this.packageRateAvailabilityId = _data['packageRateAvailabilityId'];
            this.reservationType = _data['reservationType'];
            this.reservationFlight = _data["reservationFlight"] ? ReservationFlightDto.fromJS(_data["reservationFlight"]) : <any>undefined;
            this.reservationHotel = _data["reservationHotel"] ? ReservationHotelDto.fromJS(_data["reservationHotel"]) : <any>undefined;
            this.reservationTrain = _data["reservationTrain"] ? ReservationTrainDto.fromJS(_data["reservationTrain"]) : <any>undefined;
            this.reservationCar = _data["reservationCar"] ? ReservationCarDto.fromJS(_data["reservationCar"]) : <any>undefined;
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.agencyId = _data["agencyId"];
            this.agencyName = _data["agencyName"];
            this.username = _data["username"];
            this.referenceData = _data["referenceData"] ? ReferenceDataModel.fromJS(_data["referenceData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>undefined;
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        data["reservationCode"] = this.reservationCode;
        data["provider"] = this.provider;
        data["providerReference"] = this.providerReference;
        data["reservationStatus"] = this.reservationStatus;
        data["reservationDate"] = this.reservationDate ? this.reservationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        data["discountCode"] = this.discountCode;
        data["timeLimit"] = this.timeLimit ? this.timeLimit.toISOString() : <any>undefined;
        data['packageRateAvailabilityId'] = this.packageRateAvailabilityId;
        data['reservationType'] = this.reservationType;
        data["reservationFlight"] = this.reservationFlight ? this.reservationFlight.toJSON() : <any>undefined;
        data["reservationHotel"] = this.reservationHotel ? this.reservationHotel.toJSON() : <any>undefined;
        data["reservationTrain"] = this.reservationTrain ? this.reservationTrain.toJSON() : <any>undefined;
        data["reservationCar"] = this.reservationCar ? this.reservationCar.toJSON() : <any>undefined;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["agencyId"] = this.agencyId;
        data["agencyName"] = this.agencyName;
        data["username"] = this.username;
        data["referenceData"] = this.referenceData ? this.referenceData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReservationDto {
    id: string | undefined;
    buyer: ApplicationUserDto;
    paymentInfo: PaymentInfoDataDto;
    reservationCode: string | undefined;
    provider: string | undefined;
    providerReference: string | undefined;
    reservationStatus: ReservationStatusDto;
    reservationDate: moment.Moment;
    logs: LogDto[] | undefined;
    discountCode: string | undefined;
    timeLimit: moment.Moment | undefined;
    packageRateAvailabilityId: string | undefined;
    reservationFlight: ReservationFlightDto;
    reservationHotel: ReservationHotelDto;
    reservationTrain: ReservationTrainDto;
    reservationCar: ReservationCarDto;
    ts: moment.Moment;
    userId: string | undefined;
    agencyId: string | undefined;
    agencyName: string | undefined;
    username: string | undefined;
    referenceData: ReferenceDataModel;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message!: string | undefined;
    members!: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code!: number;
    message!: string | undefined;
    details!: string | undefined;
    validationErrors!: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IErrorInfo {
    code: number;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class AjaxResponseOfReservationDto implements IAjaxResponseOfReservationDto {
    result!: ReservationDto;
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;

    constructor(data?: IAjaxResponseOfReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ReservationDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IAjaxResponseOfReservationDto {
    result: ReservationDto;
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class AddressSupplier implements IAddressSupplier {
    address1!: string | undefined;
    address2!: string | undefined;
    address3!: string | undefined;
    city!: LocalizedString;
    zipCode!: string | undefined;

    constructor(data?: IAddressSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"] ? LocalizedString.fromJS(_data["city"]) : <any>undefined;
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): AddressSupplier {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSupplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

export interface IAddressSupplier {
    address1: string | undefined;
    address2: string | undefined;
    address3: string | undefined;
    city: LocalizedString;
    zipCode: string | undefined;
}

export class SupplierDto implements ISupplierDto {
    enabled!: boolean;
    supplierCode!: string | undefined;
    position!: PositionDTO;
    address!: AddressSupplier;
    phoneNumber!: string | undefined;
    locationType!: string | undefined;

    constructor(data?: ISupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.supplierCode = _data["supplierCode"];
            this.position = _data["position"] ? PositionDTO.fromJS(_data["position"]) : <any>undefined;
            this.address = _data["address"] ? AddressSupplier.fromJS(_data["address"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.locationType = _data["locationType"];
        }
    }

    static fromJS(data: any): SupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["supplierCode"] = this.supplierCode;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["locationType"] = this.locationType;
        return data;
    }
}

export interface ISupplierDto {
    enabled: boolean;
    supplierCode: string | undefined;
    position: PositionDTO;
    address: AddressSupplier;
    phoneNumber: string | undefined;
    locationType: string | undefined;
}

export class CarLocationDto implements ICarLocationDto {
    id!: string | undefined;
    ts!: moment.Moment;
    countryCode!: string | undefined;
    name!: LocalizedString;
    country!: LocalizedString;
    region!: LocalizedString;
    aliasNames!: string[] | undefined;
    supplier!: SupplierDto[] | undefined;
    providerLinks!: TagOfStringString[] | undefined;
    iata!: string | undefined;
    priority!: number;
    isBlackList!: boolean;

    constructor(data?: ICarLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.name = _data["name"] ? LocalizedString.fromJS(_data["name"]) : <any>undefined;
            this.country = _data["country"] ? LocalizedString.fromJS(_data["country"]) : <any>undefined;
            this.region = _data["region"] ? LocalizedString.fromJS(_data["region"]) : <any>undefined;
            if (Array.isArray(_data["aliasNames"])) {
                this.aliasNames = [] as any;
                for (let item of _data["aliasNames"])
                    this.aliasNames!.push(item);
            }
            if (Array.isArray(_data["supplier"])) {
                this.supplier = [] as any;
                for (let item of _data["supplier"])
                    this.supplier!.push(SupplierDto.fromJS(item));
            }
            if (Array.isArray(_data["providerLinks"])) {
                this.providerLinks = [] as any;
                for (let item of _data["providerLinks"])
                    this.providerLinks!.push(TagOfStringString.fromJS(item));
            }
            this.iata = _data["iata"];
            this.priority = _data["priority"];
            this.isBlackList = _data["isBlackList"];
        }
    }

    static fromJS(data: any): CarLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        if (Array.isArray(this.aliasNames)) {
            data["aliasNames"] = [];
            for (let item of this.aliasNames)
                data["aliasNames"].push(item);
        }
        if (Array.isArray(this.supplier)) {
            data["supplier"] = [];
            for (let item of this.supplier)
                data["supplier"].push(item.toJSON());
        }
        if (Array.isArray(this.providerLinks)) {
            data["providerLinks"] = [];
            for (let item of this.providerLinks)
                data["providerLinks"].push(item.toJSON());
        }
        data["iata"] = this.iata;
        data["priority"] = this.priority;
        data["isBlackList"] = this.isBlackList;
        return data;
    }
}

export interface ICarLocationDto {
    id: string | undefined;
    ts: moment.Moment;
    countryCode: string | undefined;
    name: LocalizedString;
    country: LocalizedString;
    region: LocalizedString;
    aliasNames: string[] | undefined;
    supplier: SupplierDto[] | undefined;
    providerLinks: TagOfStringString[] | undefined;
    iata: string | undefined;
    priority: number;
    isBlackList: boolean;
}

export class PagedResultDtoOfCarLocationDto implements IPagedResultDtoOfCarLocationDto {
    totalCount!: number;
    items!: CarLocationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCarLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CarLocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCarLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCarLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCarLocationDto {
    totalCount: number;
    items: CarLocationDto[] | undefined;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    codeUnit!: string | undefined;
    siapClientId!: string | undefined;
    displayName!: string | undefined;
    type!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    requirePreAuthorization!: boolean;
    preAuthorizerGroupId!: string | undefined;
    requireAuthorization!: boolean;
    authorizerGroupId!: string | undefined;
    requireBudgetAuthorization!: boolean;
    budgetAuthorizerGroupId!: string | undefined;
    requirePostAuthorization!: boolean;
    postAuthorizerGroupId!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.codeUnit = _data["codeUnit"];
            this.siapClientId = _data["siapClientId"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.requirePreAuthorization = _data["requirePreAuthorization"];
            this.preAuthorizerGroupId = _data["preAuthorizerGroupId"];
            this.requireAuthorization = _data["requireAuthorization"];
            this.authorizerGroupId = _data["authorizerGroupId"];
            this.requireBudgetAuthorization = _data["requireBudgetAuthorization"];
            this.budgetAuthorizerGroupId = _data["budgetAuthorizerGroupId"];
            this.requirePostAuthorization = _data["requirePostAuthorization"];
            this.postAuthorizerGroupId = _data["postAuthorizerGroupId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["codeUnit"] = this.codeUnit;
        data["siapClientId"] = this.siapClientId;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["requirePreAuthorization"] = this.requirePreAuthorization;
        data["preAuthorizerGroupId"] = this.preAuthorizerGroupId;
        data["requireAuthorization"] = this.requireAuthorization;
        data["authorizerGroupId"] = this.authorizerGroupId;
        data["requireBudgetAuthorization"] = this.requireBudgetAuthorization;
        data["budgetAuthorizerGroupId"] = this.budgetAuthorizerGroupId;
        data["requirePostAuthorization"] = this.requirePostAuthorization;
        data["postAuthorizerGroupId"] = this.postAuthorizerGroupId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    codeUnit: string | undefined;
    siapClientId: string | undefined;
    displayName: string | undefined;
    type: string | undefined;
    memberCount: number;
    roleCount: number;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    requirePreAuthorization: boolean;
    preAuthorizerGroupId: string | undefined;
    requireAuthorization: boolean;
    authorizerGroupId: string | undefined;
    requireBudgetAuthorization: boolean;
    budgetAuthorizerGroupId: string | undefined;
    requirePostAuthorization: boolean;
    postAuthorizerGroupId: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class GetUserChatConfigurationOutput implements IGetUserChatConfigurationOutput {
    userIdentifier!: string | undefined;
    identifierHash!: string | undefined;
    websiteToken!: string | undefined;

    constructor(data?: IGetUserChatConfigurationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentifier = _data["userIdentifier"];
            this.identifierHash = _data["identifierHash"];
            this.websiteToken = _data["websiteToken"];
        }
    }

    static fromJS(data: any): GetUserChatConfigurationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatConfigurationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIdentifier"] = this.userIdentifier;
        data["identifierHash"] = this.identifierHash;
        data["websiteToken"] = this.websiteToken;
        return data;
    }
}

export interface IGetUserChatConfigurationOutput {
    userIdentifier: string | undefined;
    identifierHash: string | undefined;
    websiteToken: string | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFree = _data["isFree"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    excludeCurrentUser!: boolean;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.excludeCurrentUser = _data["excludeCurrentUser"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["excludeCurrentUser"] = this.excludeCurrentUser;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    excludeCurrentUser: boolean;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export enum CabinClass {
    Economy = 1,
    PremiumEconomy = 2,
    Business = 3,
    First = 4,
}

export enum FlightItineraryType {
    Domestic = 0,
    International = 1,
    Intercontinental = 2,
}

export class CabinClassException implements ICabinClassException {
    flightLongerLegHours!: number | undefined;
    flightItineraryType!: FlightItineraryType;
    flightCabinClassExceptionValue!: CabinClass;

    constructor(data?: ICabinClassException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flightLongerLegHours = _data["flightLongerLegHours"];
            this.flightItineraryType = _data["flightItineraryType"];
            this.flightCabinClassExceptionValue = _data["flightCabinClassExceptionValue"];
        }
    }

    static fromJS(data: any): CabinClassException {
        data = typeof data === 'object' ? data : {};
        let result = new CabinClassException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flightLongerLegHours"] = this.flightLongerLegHours;
        data["flightItineraryType"] = this.flightItineraryType;
        data["flightCabinClassExceptionValue"] = this.flightCabinClassExceptionValue;
        return data;
    }
}

export interface ICabinClassException {
    flightLongerLegHours: number | undefined;
    flightItineraryType: FlightItineraryType;
    flightCabinClassExceptionValue: CabinClass;
}

export class FlightBudgetException implements IFlightBudgetException {
    flightLongHaulHours!: number | undefined;
    flightItineraryType!: FlightItineraryType;
    flightBudgetExceptionAmount!: number;

    constructor(data?: IFlightBudgetException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flightLongHaulHours = _data["flightLongHaulHours"];
            this.flightItineraryType = _data["flightItineraryType"];
            this.flightBudgetExceptionAmount = _data["flightBudgetExceptionAmount"];
        }
    }

    static fromJS(data: any): FlightBudgetException {
        data = typeof data === 'object' ? data : {};
        let result = new FlightBudgetException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flightLongHaulHours"] = this.flightLongHaulHours;
        data["flightItineraryType"] = this.flightItineraryType;
        data["flightBudgetExceptionAmount"] = this.flightBudgetExceptionAmount;
        return data;
    }
}

export interface IFlightBudgetException {
    flightLongHaulHours: number | undefined;
    flightItineraryType: FlightItineraryType;
    flightBudgetExceptionAmount: number;
}

export class FlightRouteRule implements IFlightRouteRule {
    origin!: string | undefined;
    originName!: string | undefined;
    destination!: string | undefined;
    destinationName!: string | undefined;
    roundTrip!: boolean;
    isOriginMulticity!: boolean;
    isDestinationMulticity!: boolean;
    amount!: number;

    constructor(data?: IFlightRouteRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"];
            this.originName = _data["originName"];
            this.destination = _data["destination"];
            this.destinationName = _data["destinationName"];
            this.roundTrip = _data["roundTrip"];
            this.isOriginMulticity = _data["isOriginMulticity"];
            this.isDestinationMulticity = _data["isDestinationMulticity"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): FlightRouteRule {
        data = typeof data === 'object' ? data : {};
        let result = new FlightRouteRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin;
        data["originName"] = this.originName;
        data["destination"] = this.destination;
        data["destinationName"] = this.destinationName;
        data["roundTrip"] = this.roundTrip;
        data["isOriginMulticity"] = this.isOriginMulticity;
        data["isDestinationMulticity"] = this.isDestinationMulticity;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IFlightRouteRule {
    origin: string | undefined;
    originName: string | undefined;
    destination: string | undefined;
    destinationName: string | undefined;
    roundTrip: boolean;
    isOriginMulticity: boolean;
    isDestinationMulticity: boolean;
    amount: number;
}

export class FlightPolicyDto implements IFlightPolicyDto {
    flightBookingWindow!: number;
    flightMaxCabinClass!: CabinClass;
    flightCabinClassException!: CabinClassException;
    flightBudgetAmount!: number;
    flightBudgetException!: FlightBudgetException;
    flightRouteRules!: FlightRouteRule[] | undefined;

    constructor(data?: IFlightPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flightBookingWindow = _data["flightBookingWindow"];
            this.flightMaxCabinClass = _data["flightMaxCabinClass"];
            this.flightCabinClassException = _data["flightCabinClassException"] ? CabinClassException.fromJS(_data["flightCabinClassException"]) : <any>undefined;
            this.flightBudgetAmount = _data["flightBudgetAmount"];
            this.flightBudgetException = _data["flightBudgetException"] ? FlightBudgetException.fromJS(_data["flightBudgetException"]) : <any>undefined;
            if (Array.isArray(_data["flightRouteRules"])) {
                this.flightRouteRules = [] as any;
                for (let item of _data["flightRouteRules"])
                    this.flightRouteRules!.push(FlightRouteRule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlightPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flightBookingWindow"] = this.flightBookingWindow;
        data["flightMaxCabinClass"] = this.flightMaxCabinClass;
        data["flightCabinClassException"] = this.flightCabinClassException ? this.flightCabinClassException.toJSON() : <any>undefined;
        data["flightBudgetAmount"] = this.flightBudgetAmount;
        data["flightBudgetException"] = this.flightBudgetException ? this.flightBudgetException.toJSON() : <any>undefined;
        if (Array.isArray(this.flightRouteRules)) {
            data["flightRouteRules"] = [];
            for (let item of this.flightRouteRules)
                data["flightRouteRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlightPolicyDto {
    flightBookingWindow: number;
    flightMaxCabinClass: CabinClass;
    flightCabinClassException: CabinClassException;
    flightBudgetAmount: number;
    flightBudgetException: FlightBudgetException;
    flightRouteRules: FlightRouteRule[] | undefined;
}

export class HotelDestinationRule implements IHotelDestinationRule {
    destinationName!: string | undefined;
    destinationId!: string | undefined;
    amount!: number;
    structureId!: string | undefined;

    constructor(data?: IHotelDestinationRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationName = _data["destinationName"];
            this.destinationId = _data["destinationId"];
            this.amount = _data["amount"];
            this.structureId = _data["structureId"];
        }
    }

    static fromJS(data: any): HotelDestinationRule {
        data = typeof data === 'object' ? data : {};
        let result = new HotelDestinationRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationName"] = this.destinationName;
        data["destinationId"] = this.destinationId;
        data["amount"] = this.amount;
        data["structureId"] = this.structureId;
        return data;
    }
}

export interface IHotelDestinationRule {
    destinationName: string | undefined;
    destinationId: string | undefined;
    amount: number;
    structureId: string | undefined;
}

export class HotelPolicyDto implements IHotelPolicyDto {
    hotelBookingWindow!: number;
    hotelMaxStars!: number;
    hotelBudgetAmount!: number;
    hotelDestinationRules!: HotelDestinationRule[] | undefined;

    constructor(data?: IHotelPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hotelBookingWindow = _data["hotelBookingWindow"];
            this.hotelMaxStars = _data["hotelMaxStars"];
            this.hotelBudgetAmount = _data["hotelBudgetAmount"];
            if (Array.isArray(_data["hotelDestinationRules"])) {
                this.hotelDestinationRules = [] as any;
                for (let item of _data["hotelDestinationRules"])
                    this.hotelDestinationRules!.push(HotelDestinationRule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HotelPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hotelBookingWindow"] = this.hotelBookingWindow;
        data["hotelMaxStars"] = this.hotelMaxStars;
        data["hotelBudgetAmount"] = this.hotelBudgetAmount;
        if (Array.isArray(this.hotelDestinationRules)) {
            data["hotelDestinationRules"] = [];
            for (let item of this.hotelDestinationRules)
                data["hotelDestinationRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHotelPolicyDto {
    hotelBookingWindow: number;
    hotelMaxStars: number;
    hotelBudgetAmount: number;
    hotelDestinationRules: HotelDestinationRule[] | undefined;
}

export class TrainPolicyDto implements ITrainPolicyDto {
    trainBookingWindow!: number;
    trainBudgetAmount!: number;

    constructor(data?: ITrainPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainBookingWindow = _data["trainBookingWindow"];
            this.trainBudgetAmount = _data["trainBudgetAmount"];
        }
    }

    static fromJS(data: any): TrainPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainBookingWindow"] = this.trainBookingWindow;
        data["trainBudgetAmount"] = this.trainBudgetAmount;
        return data;
    }
}

export interface ITrainPolicyDto {
    trainBookingWindow: number;
    trainBudgetAmount: number;
}

export class CarPolicyDto implements ICarPolicyDto {
    carBookingWindow!: number;
    carBudgetAmount!: number;

    constructor(data?: ICarPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carBookingWindow = _data["carBookingWindow"];
            this.carBudgetAmount = _data["carBudgetAmount"];
        }
    }

    static fromJS(data: any): CarPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carBookingWindow"] = this.carBookingWindow;
        data["carBudgetAmount"] = this.carBudgetAmount;
        return data;
    }
}

export interface ICarPolicyDto {
    carBookingWindow: number;
    carBudgetAmount: number;
}

export class TravelPolicyDto implements ITravelPolicyDto {
    id!: string | undefined;
    organizationUnitId!: string | undefined;
    organizationUnitName!: string | undefined;
    flightPolicy!: FlightPolicyDto;
    hotelPolicy!: HotelPolicyDto;
    trainPolicy!: TrainPolicyDto;
    carPolicy!: CarPolicyDto;

    constructor(data?: ITravelPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.flightPolicy = _data["flightPolicy"] ? FlightPolicyDto.fromJS(_data["flightPolicy"]) : <any>undefined;
            this.hotelPolicy = _data["hotelPolicy"] ? HotelPolicyDto.fromJS(_data["hotelPolicy"]) : <any>undefined;
            this.trainPolicy = _data["trainPolicy"] ? TrainPolicyDto.fromJS(_data["trainPolicy"]) : <any>undefined;
            this.carPolicy = _data["carPolicy"] ? CarPolicyDto.fromJS(_data["carPolicy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TravelPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TravelPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["flightPolicy"] = this.flightPolicy ? this.flightPolicy.toJSON() : <any>undefined;
        data["hotelPolicy"] = this.hotelPolicy ? this.hotelPolicy.toJSON() : <any>undefined;
        data["trainPolicy"] = this.trainPolicy ? this.trainPolicy.toJSON() : <any>undefined;
        data["carPolicy"] = this.carPolicy ? this.carPolicy.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITravelPolicyDto {
    id: string | undefined;
    organizationUnitId: string | undefined;
    organizationUnitName: string | undefined;
    flightPolicy: FlightPolicyDto;
    hotelPolicy: HotelPolicyDto;
    trainPolicy: TrainPolicyDto;
    carPolicy: CarPolicyDto;
}

export class PrimaryContactDto implements IPrimaryContactDto {
    email!: string | undefined;
    givenName!: string | undefined;
    surname!: string | undefined;

    constructor(data?: IPrimaryContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): PrimaryContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        return data;
    }
}

export interface IPrimaryContactDto {
    email: string | undefined;
    givenName: string | undefined;
    surname: string | undefined;
}

export class InvoiceAddressDto implements IInvoiceAddressDto {
    country!: string | undefined;
    description!: string | undefined;
    address1!: string | undefined;
    address2!: string | undefined;
    city!: string | undefined;
    postalCode!: string | undefined;
    phone!: string | undefined;

    constructor(data?: IInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.description = _data["description"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): InvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["description"] = this.description;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IInvoiceAddressDto {
    country: string | undefined;
    description: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    postalCode: string | undefined;
    phone: string | undefined;
}

export class EmergencyContactDto implements IEmergencyContactDto {
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IEmergencyContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): EmergencyContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmergencyContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IEmergencyContactDto {
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
}

export class FidelityCardDto implements IFidelityCardDto {
    programId!: string | undefined;
    membershipId!: string | undefined;

    constructor(data?: IFidelityCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programId = _data["programId"];
            this.membershipId = _data["membershipId"];
        }
    }

    static fromJS(data: any): FidelityCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new FidelityCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programId"] = this.programId;
        data["membershipId"] = this.membershipId;
        return data;
    }
}

export interface IFidelityCardDto {
    programId: string | undefined;
    membershipId: string | undefined;
}

export class TravelDocumentDto implements ITravelDocumentDto {
    id!: string | undefined;
    isDefault!: boolean;
    nationalityCountry!: string | undefined;
    documentNumber!: string | undefined;
    documentType!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    issueCountry!: string | undefined;
    issuingDate!: moment.Moment | undefined;

    constructor(data?: ITravelDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDefault = _data["isDefault"];
            this.nationalityCountry = _data["nationalityCountry"];
            this.documentNumber = _data["documentNumber"];
            this.documentType = _data["documentType"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.issueCountry = _data["issueCountry"];
            this.issuingDate = _data["issuingDate"] ? moment(_data["issuingDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TravelDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TravelDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDefault"] = this.isDefault;
        data["nationalityCountry"] = this.nationalityCountry;
        data["documentNumber"] = this.documentNumber;
        data["documentType"] = this.documentType;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["issueCountry"] = this.issueCountry;
        data["issuingDate"] = this.issuingDate ? this.issuingDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITravelDocumentDto {
    id: string | undefined;
    isDefault: boolean;
    nationalityCountry: string | undefined;
    documentNumber: string | undefined;
    documentType: string | undefined;
    expirationDate: moment.Moment | undefined;
    issueCountry: string | undefined;
    issuingDate: moment.Moment | undefined;
}

export class CustomFieldDto implements ICustomFieldDto {
    id!: string | undefined;
    field!: TagOfStringString;

    constructor(data?: ICustomFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.field = _data["field"] ? TagOfStringString.fromJS(_data["field"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["field"] = this.field ? this.field.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomFieldDto {
    id: string | undefined;
    field: TagOfStringString;
}

export class UserProfileDto implements IUserProfileDto {
    id!: string | undefined;
    userId!: string | undefined;
    agencyId!: string | undefined;
    agencyName!: string | undefined;
    username!: string | undefined;
    givenName!: string | undefined;
    surname!: string | undefined;
    userEmail!: string | undefined;
    email!: string | undefined;
    documentMail!: string | undefined;
    phoneNumber!: string | undefined;
    birthDate!: moment.Moment | undefined;
    gender!: string | undefined;
    fiscalCode!: string | undefined;
    businessName!: string | undefined;
    vatNumber!: string | undefined;
    specialNeeds!: string | undefined;
    birthPlace!: string | undefined;
    nationality!: string | undefined;
    mobilePhoneNumber!: string | undefined;
    isPrivate!: boolean;
    isActive!: boolean;
    creatorId!: string | undefined;
    centerOfCostsId!: number | undefined;
    centerOfCostsCode!: string | undefined;
    companyHeadquartersId!: number | undefined;
    companyHeadquartersCode!: string | undefined;
    workId!: string | undefined;
    title!: string | undefined;
    officeId!: string | undefined;
    officeName!: string | undefined;
    address!: AddressDto;
    emergencyContact!: EmergencyContactDto;
    fidelityCardPrograms!: FidelityCardDto[] | undefined;
    readonly travelDocumentExpired!: boolean | undefined;
    travelDocuments!: TravelDocumentDto[] | undefined;
    selectedCustomFields!: CustomFieldDto[] | undefined;
    siapPersonalID!: string | undefined;
    personIdSuSabre!: string | undefined;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.agencyId = _data["agencyId"];
            this.agencyName = _data["agencyName"];
            this.username = _data["username"];
            this.givenName = _data["givenName"];
            this.surname = _data["surname"];
            this.userEmail = _data["userEmail"];
            this.email = _data["email"];
            this.documentMail = _data["documentMail"];
            this.phoneNumber = _data["phoneNumber"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.fiscalCode = _data["fiscalCode"];
            this.businessName = _data["businessName"];
            this.vatNumber = _data["vatNumber"];
            this.specialNeeds = _data["specialNeeds"];
            this.birthPlace = _data["birthPlace"];
            this.nationality = _data["nationality"];
            this.mobilePhoneNumber = _data["mobilePhoneNumber"];
            this.isPrivate = _data["isPrivate"];
            this.isActive = _data["isActive"];
            this.creatorId = _data["creatorId"];
            this.centerOfCostsId = _data["centerOfCostsId"];
            this.centerOfCostsCode = _data["centerOfCostsCode"];
            this.companyHeadquartersId = _data["companyHeadquartersId"];
            this.companyHeadquartersCode = _data["companyHeadquartersCode"];
            this.workId = _data["workId"];
            this.title = _data["title"];
            this.officeId = _data["officeId"];
            this.officeName = _data["officeName"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.emergencyContact = _data["emergencyContact"] ? EmergencyContactDto.fromJS(_data["emergencyContact"]) : <any>undefined;
            if (Array.isArray(_data["fidelityCardPrograms"])) {
                this.fidelityCardPrograms = [] as any;
                for (let item of _data["fidelityCardPrograms"])
                    this.fidelityCardPrograms!.push(FidelityCardDto.fromJS(item));
            }
            (<any>this).travelDocumentExpired = _data["travelDocumentExpired"];
            if (Array.isArray(_data["travelDocuments"])) {
                this.travelDocuments = [] as any;
                for (let item of _data["travelDocuments"])
                    this.travelDocuments!.push(TravelDocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedCustomFields"])) {
                this.selectedCustomFields = [] as any;
                for (let item of _data["selectedCustomFields"])
                    this.selectedCustomFields!.push(CustomFieldDto.fromJS(item));
            }
            this.siapPersonalID = _data["siapPersonalID"];
            this.personIdSuSabre = _data["personIdSuSabre"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["agencyId"] = this.agencyId;
        data["agencyName"] = this.agencyName;
        data["username"] = this.username;
        data["givenName"] = this.givenName;
        data["surname"] = this.surname;
        data["userEmail"] = this.userEmail;
        data["email"] = this.email;
        data["documentMail"] = this.documentMail;
        data["phoneNumber"] = this.phoneNumber;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["fiscalCode"] = this.fiscalCode;
        data["businessName"] = this.businessName;
        data["vatNumber"] = this.vatNumber;
        data["specialNeeds"] = this.specialNeeds;
        data["birthPlace"] = this.birthPlace;
        data["nationality"] = this.nationality;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber;
        data["isPrivate"] = this.isPrivate;
        data["isActive"] = this.isActive;
        data["creatorId"] = this.creatorId;
        data["centerOfCostsId"] = this.centerOfCostsId;
        data["centerOfCostsCode"] = this.centerOfCostsCode;
        data["companyHeadquartersId"] = this.companyHeadquartersId;
        data["companyHeadquartersCode"] = this.companyHeadquartersCode;
        data["workId"] = this.workId;
        data["title"] = this.title;
        data["officeId"] = this.officeId;
        data["officeName"] = this.officeName;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["emergencyContact"] = this.emergencyContact ? this.emergencyContact.toJSON() : <any>undefined;
        if (Array.isArray(this.fidelityCardPrograms)) {
            data["fidelityCardPrograms"] = [];
            for (let item of this.fidelityCardPrograms)
                data["fidelityCardPrograms"].push(item.toJSON());
        }
        data["travelDocumentExpired"] = this.travelDocumentExpired;
        if (Array.isArray(this.travelDocuments)) {
            data["travelDocuments"] = [];
            for (let item of this.travelDocuments)
                data["travelDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedCustomFields)) {
            data["selectedCustomFields"] = [];
            for (let item of this.selectedCustomFields)
                data["selectedCustomFields"].push(item.toJSON());
        }
        data["siapPersonalID"] = this.siapPersonalID;
        data["personIdSuSabre"] = this.personIdSuSabre;
        return data;
    }
}

export interface IUserProfileDto {
    id: string | undefined;
    userId: string | undefined;
    agencyId: string | undefined;
    agencyName: string | undefined;
    username: string | undefined;
    givenName: string | undefined;
    surname: string | undefined;
    userEmail: string | undefined;
    email: string | undefined;
    documentMail: string | undefined;
    phoneNumber: string | undefined;
    birthDate: moment.Moment | undefined;
    gender: string | undefined;
    fiscalCode: string | undefined;
    businessName: string | undefined;
    vatNumber: string | undefined;
    specialNeeds: string | undefined;
    birthPlace: string | undefined;
    nationality: string | undefined;
    mobilePhoneNumber: string | undefined;
    isPrivate: boolean;
    isActive: boolean;
    creatorId: string | undefined;
    centerOfCostsId: number | undefined;
    centerOfCostsCode: string | undefined;
    companyHeadquartersId: number | undefined;
    companyHeadquartersCode: string | undefined;
    workId: string | undefined;
    title: string | undefined;
    officeId: string | undefined;
    officeName: string | undefined;
    address: AddressDto;
    emergencyContact: EmergencyContactDto;
    fidelityCardPrograms: FidelityCardDto[] | undefined;
    travelDocumentExpired: boolean | undefined;
    travelDocuments: TravelDocumentDto[] | undefined;
    selectedCustomFields: CustomFieldDto[] | undefined;
    siapPersonalID: string | undefined;
    personIdSuSabre: string | undefined;
}

export class InvoiceProfileDto implements IInvoiceProfileDto {
    id!: string | undefined;
    primaryContact!: PrimaryContactDto;
    address!: InvoiceAddressDto;
    travelers!: UserProfileDto[] | undefined;
    name!: string | undefined;
    vatNumber!: string | undefined;
    enabled!: boolean;
    isDefault!: boolean;

    constructor(data?: IInvoiceProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.primaryContact = _data["primaryContact"] ? PrimaryContactDto.fromJS(_data["primaryContact"]) : <any>undefined;
            this.address = _data["address"] ? InvoiceAddressDto.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["travelers"])) {
                this.travelers = [] as any;
                for (let item of _data["travelers"])
                    this.travelers!.push(UserProfileDto.fromJS(item));
            }
            this.name = _data["name"];
            this.vatNumber = _data["vatNumber"];
            this.enabled = _data["enabled"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): InvoiceProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryContact"] = this.primaryContact ? this.primaryContact.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.travelers)) {
            data["travelers"] = [];
            for (let item of this.travelers)
                data["travelers"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["vatNumber"] = this.vatNumber;
        data["enabled"] = this.enabled;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IInvoiceProfileDto {
    id: string | undefined;
    primaryContact: PrimaryContactDto;
    address: InvoiceAddressDto;
    travelers: UserProfileDto[] | undefined;
    name: string | undefined;
    vatNumber: string | undefined;
    enabled: boolean;
    isDefault: boolean;
}

export class LabelDto implements ILabelDto {
    id!: string | undefined;
    name!: string | undefined;
    enabled!: boolean;
    linkedTripsCount!: number;

    constructor(data?: ILabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.linkedTripsCount = _data["linkedTripsCount"];
        }
    }

    static fromJS(data: any): LabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new LabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["linkedTripsCount"] = this.linkedTripsCount;
        return data;
    }
}

export interface ILabelDto {
    id: string | undefined;
    name: string | undefined;
    enabled: boolean;
    linkedTripsCount: number;
}

export class CompanyDto implements ICompanyDto {
    id!: string | undefined;
    name!: string | undefined;
    address!: string | undefined;
    city!: string | undefined;
    country!: string | undefined;
    state!: string | undefined;
    zipCode!: string | undefined;
    vatNumber!: string | undefined;
    referent!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    mobileNumber!: string | undefined;
    fax!: string | undefined;
    travelPolicies!: TravelPolicyDto[] | undefined;
    invoiceProfiles!: InvoiceProfileDto[] | undefined;
    labels!: LabelDto[] | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.vatNumber = _data["vatNumber"];
            this.referent = _data["referent"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.fax = _data["fax"];
            if (Array.isArray(_data["travelPolicies"])) {
                this.travelPolicies = [] as any;
                for (let item of _data["travelPolicies"])
                    this.travelPolicies!.push(TravelPolicyDto.fromJS(item));
            }
            if (Array.isArray(_data["invoiceProfiles"])) {
                this.invoiceProfiles = [] as any;
                for (let item of _data["invoiceProfiles"])
                    this.invoiceProfiles!.push(InvoiceProfileDto.fromJS(item));
            }
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(LabelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["vatNumber"] = this.vatNumber;
        data["referent"] = this.referent;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["fax"] = this.fax;
        if (Array.isArray(this.travelPolicies)) {
            data["travelPolicies"] = [];
            for (let item of this.travelPolicies)
                data["travelPolicies"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceProfiles)) {
            data["invoiceProfiles"] = [];
            for (let item of this.invoiceProfiles)
                data["invoiceProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompanyDto {
    id: string | undefined;
    name: string | undefined;
    address: string | undefined;
    city: string | undefined;
    country: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    vatNumber: string | undefined;
    referent: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    mobileNumber: string | undefined;
    fax: string | undefined;
    travelPolicies: TravelPolicyDto[] | undefined;
    invoiceProfiles: InvoiceProfileDto[] | undefined;
    labels: LabelDto[] | undefined;
}

export enum TagTypeDto {
    Input = 1,
    Select = 2,
    TextArea = 3,
    RadioButton = 4,
    CheckBox = 5,
    DatePicker = 6,
    DateTimePicker = 7,
    Button = 8,
    MultiSelect = 9,
}

export enum InputTypeDto {
    Text = 1,
    Email = 2,
    Password = 3,
    Number = 4,
    Range = 5,
}

export enum MetaTypeDto {
    String = 1,
    Number = 2,
    Bool = 3,
    Object = 4,
}

export class FieldValueDto implements IFieldValueDto {
    text!: string | undefined;
    value!: string | undefined;
    metaValue!: string | undefined;
    metaType!: MetaTypeDto;

    constructor(data?: IFieldValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
            this.metaValue = _data["metaValue"];
            this.metaType = _data["metaType"];
        }
    }

    static fromJS(data: any): FieldValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        data["metaValue"] = this.metaValue;
        data["metaType"] = this.metaType;
        return data;
    }
}

export interface IFieldValueDto {
    text: string | undefined;
    value: string | undefined;
    metaValue: string | undefined;
    metaType: MetaTypeDto;
}

export enum ValidatorTypeDto {
    Required = 1,
    Min = 2,
    Max = 3,
    Email = 4,
    MinLength = 5,
    MaxLength = 6,
    Pattern = 7,
}

export class ValidatorDto implements IValidatorDto {
    type!: ValidatorTypeDto;
    value!: string | undefined;
    message!: string | undefined;

    constructor(data?: IValidatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ValidatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        data["message"] = this.message;
        return data;
    }
}

export interface IValidatorDto {
    type: ValidatorTypeDto;
    value: string | undefined;
    message: string | undefined;
}

export class FieldConfigDto implements IFieldConfigDto {
    id!: string | undefined;
    label!: string | undefined;
    type!: TagTypeDto;
    name!: string | undefined;
    inputType!: InputTypeDto;
    options!: FieldValueDto[] | undefined;
    values!: string[] | undefined;
    validations!: ValidatorDto[] | undefined;

    constructor(data?: IFieldConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.inputType = _data["inputType"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(FieldValueDto.fromJS(item));
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            if (Array.isArray(_data["validations"])) {
                this.validations = [] as any;
                for (let item of _data["validations"])
                    this.validations!.push(ValidatorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["type"] = this.type;
        data["name"] = this.name;
        data["inputType"] = this.inputType;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.validations)) {
            data["validations"] = [];
            for (let item of this.validations)
                data["validations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldConfigDto {
    id: string | undefined;
    label: string | undefined;
    type: TagTypeDto;
    name: string | undefined;
    inputType: InputTypeDto;
    options: FieldValueDto[] | undefined;
    values: string[] | undefined;
    validations: ValidatorDto[] | undefined;
}

export class FieldConfigInputDto implements IFieldConfigInputDto {
    fieldsConfig!: FieldConfigDto[] | undefined;

    constructor(data?: IFieldConfigInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fieldsConfig"])) {
                this.fieldsConfig = [] as any;
                for (let item of _data["fieldsConfig"])
                    this.fieldsConfig!.push(FieldConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FieldConfigInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FieldConfigInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldsConfig)) {
            data["fieldsConfig"] = [];
            for (let item of this.fieldsConfig)
                data["fieldsConfig"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFieldConfigInputDto {
    fieldsConfig: FieldConfigDto[] | undefined;
}

export class CountryListDto implements ICountryListDto {
    id!: string | undefined;
    code!: string | undefined;
    name!: string | undefined;
    shortName!: string | undefined;
    isBlacklist!: boolean;

    constructor(data?: ICountryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.isBlacklist = _data["isBlacklist"];
        }
    }

    static fromJS(data: any): CountryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isBlacklist"] = this.isBlacklist;
        return data;
    }
}

export interface ICountryListDto {
    id: string | undefined;
    code: string | undefined;
    name: string | undefined;
    shortName: string | undefined;
    isBlacklist: boolean;
}

export class PagedResultDtoOfCountryListDto implements IPagedResultDtoOfCountryListDto {
    totalCount!: number;
    items!: CountryListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCountryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CountryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCountryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCountryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCountryListDto {
    totalCount: number;
    items: CountryListDto[] | undefined;
}

export class CountryDto implements ICountryDto {
    id!: string | undefined;
    code!: string | undefined;
    name!: string | undefined;
    shortName!: string | undefined;
    alpha2!: string | undefined;
    alpha3!: string | undefined;
    numericCode!: number | undefined;
    isO31662Code!: string | undefined;
    otherNames!: any[] | undefined;
    isBlacklist!: boolean;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.alpha2 = _data["alpha2"];
            this.alpha3 = _data["alpha3"];
            this.numericCode = _data["numericCode"];
            this.isO31662Code = _data["isO31662Code"];
            if (Array.isArray(_data["otherNames"])) {
                this.otherNames = [] as any;
                for (let item of _data["otherNames"])
                    this.otherNames!.push(item);
            }
            this.isBlacklist = _data["isBlacklist"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["alpha2"] = this.alpha2;
        data["alpha3"] = this.alpha3;
        data["numericCode"] = this.numericCode;
        data["isO31662Code"] = this.isO31662Code;
        if (Array.isArray(this.otherNames)) {
            data["otherNames"] = [];
            for (let item of this.otherNames)
                data["otherNames"].push(item);
        }
        data["isBlacklist"] = this.isBlacklist;
        return data;
    }
}

export interface ICountryDto {
    id: string | undefined;
    code: string | undefined;
    name: string | undefined;
    shortName: string | undefined;
    alpha2: string | undefined;
    alpha3: string | undefined;
    numericCode: number | undefined;
    isO31662Code: string | undefined;
    otherNames: any[] | undefined;
    isBlacklist: boolean;
}

export class Widget implements IWidget {
    widgetId!: string | undefined;
    height!: number;
    width!: number;
    positionX!: number;
    positionY!: number;

    constructor(data?: IWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.positionX = _data["positionX"];
            this.positionY = _data["positionY"];
        }
    }

    static fromJS(data: any): Widget {
        data = typeof data === 'object' ? data : {};
        let result = new Widget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["height"] = this.height;
        data["width"] = this.width;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        return data;
    }
}

export interface IWidget {
    widgetId: string | undefined;
    height: number;
    width: number;
    positionX: number;
    positionY: number;
}

export class Page implements IPage {
    id!: string | undefined;
    name!: string | undefined;
    widgets!: Widget[] | undefined;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(Widget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPage {
    id: string | undefined;
    name: string | undefined;
    widgets: Widget[] | undefined;
}

export class Dashboard implements IDashboard {
    dashboardName!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboard {
    dashboardName: string | undefined;
    pages: Page[] | undefined;
}

export class SavePageInput implements ISavePageInput {
    dashboardName!: string | undefined;
    application!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: ISavePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.application = _data["application"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SavePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["application"] = this.application;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISavePageInput {
    dashboardName: string | undefined;
    application: string | undefined;
    pages: Page[] | undefined;
}

export class RenamePageInput implements IRenamePageInput {
    dashboardName!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IRenamePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): RenamePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IRenamePageInput {
    dashboardName: string | undefined;
    id: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageInput implements IAddNewPageInput {
    dashboardName!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IAddNewPageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddNewPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddNewPageInput {
    dashboardName: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageOutput implements IAddNewPageOutput {
    pageId!: string | undefined;

    constructor(data?: IAddNewPageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
        }
    }

    static fromJS(data: any): AddNewPageOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        return data;
    }
}

export interface IAddNewPageOutput {
    pageId: string | undefined;
}

export class AddWidgetInput implements IAddWidgetInput {
    widgetId!: string | undefined;
    pageId!: string | undefined;
    dashboardName!: string | undefined;
    width!: number;
    height!: number;
    application!: string | undefined;

    constructor(data?: IAddWidgetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.pageId = _data["pageId"];
            this.dashboardName = _data["dashboardName"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddWidgetInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddWidgetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["pageId"] = this.pageId;
        data["dashboardName"] = this.dashboardName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddWidgetInput {
    widgetId: string | undefined;
    pageId: string | undefined;
    dashboardName: string | undefined;
    width: number;
    height: number;
    application: string | undefined;
}

export class WidgetFilterOutput implements IWidgetFilterOutput {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IWidgetFilterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WidgetFilterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetFilterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWidgetFilterOutput {
    id: string | undefined;
    name: string | undefined;
}

export class WidgetOutput implements IWidgetOutput {
    id!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    filters!: WidgetFilterOutput[] | undefined;

    constructor(data?: IWidgetOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(WidgetFilterOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WidgetOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWidgetOutput {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    filters: WidgetFilterOutput[] | undefined;
}

export class DashboardOutput implements IDashboardOutput {
    name!: string | undefined;
    widgets!: WidgetOutput[] | undefined;

    constructor(data?: IDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(WidgetOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardOutput {
    name: string | undefined;
    widgets: WidgetOutput[] | undefined;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString!: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateString = _data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class DynamicEntityPropertyDto implements IDynamicEntityPropertyDto {
    entityFullName!: string | undefined;
    dynamicPropertyName!: string | undefined;
    dynamicPropertyId!: number;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IDynamicEntityPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityFullName = _data["entityFullName"];
            this.dynamicPropertyName = _data["dynamicPropertyName"];
            this.dynamicPropertyId = _data["dynamicPropertyId"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicEntityPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityFullName"] = this.entityFullName;
        data["dynamicPropertyName"] = this.dynamicPropertyName;
        data["dynamicPropertyId"] = this.dynamicPropertyId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicEntityPropertyDto {
    entityFullName: string | undefined;
    dynamicPropertyName: string | undefined;
    dynamicPropertyId: number;
    tenantId: number | undefined;
    id: number;
}

export class ListResultDtoOfDynamicEntityPropertyDto implements IListResultDtoOfDynamicEntityPropertyDto {
    items!: DynamicEntityPropertyDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicEntityPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicEntityPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicEntityPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicEntityPropertyDto {
    items: DynamicEntityPropertyDto[] | undefined;
}

export class GetAllEntitiesHasDynamicPropertyOutput implements IGetAllEntitiesHasDynamicPropertyOutput {
    entityFullName!: string | undefined;

    constructor(data?: IGetAllEntitiesHasDynamicPropertyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityFullName = _data["entityFullName"];
        }
    }

    static fromJS(data: any): GetAllEntitiesHasDynamicPropertyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEntitiesHasDynamicPropertyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityFullName"] = this.entityFullName;
        return data;
    }
}

export interface IGetAllEntitiesHasDynamicPropertyOutput {
    entityFullName: string | undefined;
}

export class ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput implements IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
    items!: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllEntitiesHasDynamicPropertyOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllEntitiesHasDynamicPropertyOutput {
    items: GetAllEntitiesHasDynamicPropertyOutput[] | undefined;
}

export class DynamicEntityPropertyValueDto implements IDynamicEntityPropertyValueDto {
    value!: string | undefined;
    entityId!: string | undefined;
    dynamicEntityPropertyId!: number;
    id!: number;

    constructor(data?: IDynamicEntityPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.entityId = _data["entityId"];
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicEntityPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicEntityPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["entityId"] = this.entityId;
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicEntityPropertyValueDto {
    value: string | undefined;
    entityId: string | undefined;
    dynamicEntityPropertyId: number;
    id: number;
}

export class ListResultDtoOfDynamicEntityPropertyValueDto implements IListResultDtoOfDynamicEntityPropertyValueDto {
    items!: DynamicEntityPropertyValueDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicEntityPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicEntityPropertyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicEntityPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicEntityPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicEntityPropertyValueDto {
    items: DynamicEntityPropertyValueDto[] | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this).attributes![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this).attributes![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export class GetAllDynamicEntityPropertyValuesOutputItem implements IGetAllDynamicEntityPropertyValuesOutputItem {
    dynamicEntityPropertyId!: number;
    propertyName!: string | undefined;
    inputType!: IInputType;
    selectedValues!: string[] | undefined;
    allValuesInputTypeHas!: string[] | undefined;

    constructor(data?: IGetAllDynamicEntityPropertyValuesOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.propertyName = _data["propertyName"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
            if (Array.isArray(_data["selectedValues"])) {
                this.selectedValues = [] as any;
                for (let item of _data["selectedValues"])
                    this.selectedValues!.push(item);
            }
            if (Array.isArray(_data["allValuesInputTypeHas"])) {
                this.allValuesInputTypeHas = [] as any;
                for (let item of _data["allValuesInputTypeHas"])
                    this.allValuesInputTypeHas!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDynamicEntityPropertyValuesOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["propertyName"] = this.propertyName;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedValues)) {
            data["selectedValues"] = [];
            for (let item of this.selectedValues)
                data["selectedValues"].push(item);
        }
        if (Array.isArray(this.allValuesInputTypeHas)) {
            data["allValuesInputTypeHas"] = [];
            for (let item of this.allValuesInputTypeHas)
                data["allValuesInputTypeHas"].push(item);
        }
        return data;
    }
}

export interface IGetAllDynamicEntityPropertyValuesOutputItem {
    dynamicEntityPropertyId: number;
    propertyName: string | undefined;
    inputType: IInputType;
    selectedValues: string[] | undefined;
    allValuesInputTypeHas: string[] | undefined;
}

export class GetAllDynamicEntityPropertyValuesOutput implements IGetAllDynamicEntityPropertyValuesOutput {
    items!: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;

    constructor(data?: IGetAllDynamicEntityPropertyValuesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllDynamicEntityPropertyValuesOutputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllDynamicEntityPropertyValuesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDynamicEntityPropertyValuesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllDynamicEntityPropertyValuesOutput {
    items: GetAllDynamicEntityPropertyValuesOutputItem[] | undefined;
}

export class InsertOrUpdateAllValuesInputItem implements IInsertOrUpdateAllValuesInputItem {
    entityId!: string | undefined;
    dynamicEntityPropertyId!: number;
    values!: string[] | undefined;

    constructor(data?: IInsertOrUpdateAllValuesInputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertOrUpdateAllValuesInputItem {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrUpdateAllValuesInputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IInsertOrUpdateAllValuesInputItem {
    entityId: string | undefined;
    dynamicEntityPropertyId: number;
    values: string[] | undefined;
}

export class InsertOrUpdateAllValuesInput implements IInsertOrUpdateAllValuesInput {
    items!: InsertOrUpdateAllValuesInputItem[] | undefined;

    constructor(data?: IInsertOrUpdateAllValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InsertOrUpdateAllValuesInputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertOrUpdateAllValuesInput {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrUpdateAllValuesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsertOrUpdateAllValuesInput {
    items: InsertOrUpdateAllValuesInputItem[] | undefined;
}

export class CleanValuesInput implements ICleanValuesInput {
    dynamicEntityPropertyId!: number;
    entityId!: string | undefined;

    constructor(data?: ICleanValuesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dynamicEntityPropertyId = _data["dynamicEntityPropertyId"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): CleanValuesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CleanValuesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dynamicEntityPropertyId"] = this.dynamicEntityPropertyId;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface ICleanValuesInput {
    dynamicEntityPropertyId: number;
    entityId: string | undefined;
}

export class DynamicPropertyDto implements IDynamicPropertyDto {
    propertyName!: string | undefined;
    inputType!: string | undefined;
    permission!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.inputType = _data["inputType"];
            this.permission = _data["permission"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["inputType"] = this.inputType;
        data["permission"] = this.permission;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicPropertyDto {
    propertyName: string | undefined;
    inputType: string | undefined;
    permission: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class ListResultDtoOfDynamicPropertyDto implements IListResultDtoOfDynamicPropertyDto {
    items!: DynamicPropertyDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicPropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicPropertyDto {
    items: DynamicPropertyDto[] | undefined;
}

export class DynamicPropertyValueDto implements IDynamicPropertyValueDto {
    value!: string | undefined;
    tenantId!: number | undefined;
    dynamicPropertyId!: number;
    id!: number;

    constructor(data?: IDynamicPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.tenantId = _data["tenantId"];
            this.dynamicPropertyId = _data["dynamicPropertyId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DynamicPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["tenantId"] = this.tenantId;
        data["dynamicPropertyId"] = this.dynamicPropertyId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDynamicPropertyValueDto {
    value: string | undefined;
    tenantId: number | undefined;
    dynamicPropertyId: number;
    id: number;
}

export class ListResultDtoOfDynamicPropertyValueDto implements IListResultDtoOfDynamicPropertyValueDto {
    items!: DynamicPropertyValueDto[] | undefined;

    constructor(data?: IListResultDtoOfDynamicPropertyValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicPropertyValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDynamicPropertyValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDynamicPropertyValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfDynamicPropertyValueDto {
    items: DynamicPropertyValueDto[] | undefined;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.trialDayCount = _data["trialDayCount"];
            this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    expiringEditionId: number | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        this.attributes![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[];
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export enum StatusDto {
    Created = 1,
    Pending = 2,
    Completed = 3,
    Error = 4,
}

export class GetAllEventSyncInputDto implements IGetAllEventSyncInputDto {
    status!: StatusDto[] | undefined;
    pnr!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IGetAllEventSyncInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.pnr = _data["pnr"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllEventSyncInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEventSyncInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["pnr"] = this.pnr;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllEventSyncInputDto {
    status: StatusDto[] | undefined;
    pnr: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class ChangeIndicatorDto implements IChangeIndicatorDto {
    hasChanged!: boolean;
    name!: string | undefined;

    constructor(data?: IChangeIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasChanged = _data["hasChanged"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ChangeIndicatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasChanged"] = this.hasChanged;
        data["name"] = this.name;
        return data;
    }
}

export interface IChangeIndicatorDto {
    hasChanged: boolean;
    name: string | undefined;
}

export class EventSyncDto implements IEventSyncDto {
    id!: string | undefined;
    tenantId!: number | undefined;
    messageId!: string | undefined;
    ownPcc!: string | undefined;
    homePcc!: string | undefined;
    locator!: string | undefined;
    sourceTimestamp!: string | undefined;
    changeIndicators!: ChangeIndicatorDto[] | undefined;
    status!: StatusDto;
    count!: number;

    constructor(data?: IEventSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.messageId = _data["messageId"];
            this.ownPcc = _data["ownPcc"];
            this.homePcc = _data["homePcc"];
            this.locator = _data["locator"];
            this.sourceTimestamp = _data["sourceTimestamp"];
            if (Array.isArray(_data["changeIndicators"])) {
                this.changeIndicators = [] as any;
                for (let item of _data["changeIndicators"])
                    this.changeIndicators!.push(ChangeIndicatorDto.fromJS(item));
            }
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): EventSyncDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["messageId"] = this.messageId;
        data["ownPcc"] = this.ownPcc;
        data["homePcc"] = this.homePcc;
        data["locator"] = this.locator;
        data["sourceTimestamp"] = this.sourceTimestamp;
        if (Array.isArray(this.changeIndicators)) {
            data["changeIndicators"] = [];
            for (let item of this.changeIndicators)
                data["changeIndicators"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IEventSyncDto {
    id: string | undefined;
    tenantId: number | undefined;
    messageId: string | undefined;
    ownPcc: string | undefined;
    homePcc: string | undefined;
    locator: string | undefined;
    sourceTimestamp: string | undefined;
    changeIndicators: ChangeIndicatorDto[] | undefined;
    status: StatusDto;
    count: number;
}

export class PagedResultDtoOfEventSyncDto implements IPagedResultDtoOfEventSyncDto {
    totalCount!: number;
    items!: EventSyncDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEventSyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EventSyncDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEventSyncDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEventSyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEventSyncDto {
    totalCount: number;
    items: EventSyncDto[] | undefined;
}

export class ChangeStatusEventSyncInputDto implements IChangeStatusEventSyncInputDto {
    id!: string | undefined;
    status!: StatusDto;

    constructor(data?: IChangeStatusEventSyncInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ChangeStatusEventSyncInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeStatusEventSyncInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IChangeStatusEventSyncInputDto {
    id: string | undefined;
    status: StatusDto;
}

export class FeeDto implements IFeeDto {
    id!: string | undefined;
    enabled!: boolean;
    productFeeType!: FeeProductType;
    applicationType!: FeeApplicationType;
    agencyFilterId!: string | undefined;
    agencyFilterName!: string | undefined;
    supplierFilterId!: string | undefined;
    supplierFilterName!: string | undefined;
    name!: string | undefined;
    value!: number;
    valueType!: FeeValueType;
    flightFeeValues!: FlightFeeValueDto;
    feeType!: FeeType;
    description!: string | undefined;
    validFrom!: moment.Moment | undefined;
    validTo!: moment.Moment | undefined;
    hotelFeeFilter!: HotelFeeFilterDto;
    flightFeeFilter!: FlightFeeFilterDto;

    constructor(data?: IFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enabled = _data["enabled"];
            this.productFeeType = _data["productFeeType"];
            this.applicationType = _data["applicationType"];
            this.agencyFilterId = _data["agencyFilterId"];
            this.agencyFilterName = _data["agencyFilterName"];
            this.supplierFilterId = _data["supplierFilterId"];
            this.supplierFilterName = _data["supplierFilterName"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
            this.flightFeeValues = _data["flightFeeValues"] ? FlightFeeValueDto.fromJS(_data["flightFeeValues"]) : <any>undefined;
            this.feeType = _data["feeType"];
            this.description = _data["description"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : <any>undefined;
            this.hotelFeeFilter = _data["hotelFeeFilter"] ? HotelFeeFilterDto.fromJS(_data["hotelFeeFilter"]) : <any>undefined;
            this.flightFeeFilter = _data["flightFeeFilter"] ? FlightFeeFilterDto.fromJS(_data["flightFeeFilter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enabled"] = this.enabled;
        data["productFeeType"] = this.productFeeType;
        data["applicationType"] = this.applicationType;
        data["agencyFilterId"] = this.agencyFilterId;
        data["agencyFilterName"] = this.agencyFilterName;
        data["supplierFilterId"] = this.supplierFilterId;
        data["supplierFilterName"] = this.supplierFilterName;
        data["name"] = this.name;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["flightFeeValues"] = this.flightFeeValues ? this.flightFeeValues.toJSON() : <any>undefined;
        data["feeType"] = this.feeType;
        data["description"] = this.description;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["hotelFeeFilter"] = this.hotelFeeFilter ? this.hotelFeeFilter.toJSON() : <any>undefined;
        data["flightFeeFilter"] = this.flightFeeFilter ? this.flightFeeFilter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeeDto {
    id: string | undefined;
    enabled: boolean;
    productFeeType: FeeProductType;
    applicationType: FeeApplicationType;
    agencyFilterId: string | undefined;
    agencyFilterName: string | undefined;
    supplierFilterId: string | undefined;
    supplierFilterName: string | undefined;
    name: string | undefined;
    value: number;
    valueType: FeeValueType;
    flightFeeValues: FlightFeeValueDto;
    feeType: FeeType;
    description: string | undefined;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    hotelFeeFilter: HotelFeeFilterDto;
    flightFeeFilter: FlightFeeFilterDto;
}

export class FeeRoot implements IFeeRoot {
    agencyFilterId!: string | undefined;
    agencyFilterName!: string | undefined;
    supplierFilterId!: string | undefined;
    supplierFilterName!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    value!: number;
    valueType!: FeeValueType;
    feeType!: FeeType;
    productType!: FeeProductType;
    applicationType!: FeeApplicationType;
    flightFeeValues!: FlightFeeValue;
    enabled!: boolean;
    validFrom!: moment.Moment | undefined;
    validTo!: moment.Moment | undefined;
    hotelFeeFilter!: HotelFeeFilter;
    flightFeeFilter!: FlightFeeFilter;
    trainFeeFilter!: TrainFeeFilter;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: IFeeRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyFilterId = _data["agencyFilterId"];
            this.agencyFilterName = _data["agencyFilterName"];
            this.supplierFilterId = _data["supplierFilterId"];
            this.supplierFilterName = _data["supplierFilterName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
            this.feeType = _data["feeType"];
            this.productType = _data["productType"];
            this.applicationType = _data["applicationType"];
            this.flightFeeValues = _data["flightFeeValues"] ? FlightFeeValue.fromJS(_data["flightFeeValues"]) : <any>undefined;
            this.enabled = _data["enabled"];
            this.validFrom = _data["validFrom"] ? moment(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? moment(_data["validTo"].toString()) : <any>undefined;
            this.hotelFeeFilter = _data["hotelFeeFilter"] ? HotelFeeFilter.fromJS(_data["hotelFeeFilter"]) : <any>undefined;
            this.flightFeeFilter = _data["flightFeeFilter"] ? FlightFeeFilter.fromJS(_data["flightFeeFilter"]) : <any>undefined;
            this.trainFeeFilter = _data["trainFeeFilter"] ? TrainFeeFilter.fromJS(_data["trainFeeFilter"]) : <any>undefined;
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): FeeRoot {
        data = typeof data === 'object' ? data : {};
        let result = new FeeRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyFilterId"] = this.agencyFilterId;
        data["agencyFilterName"] = this.agencyFilterName;
        data["supplierFilterId"] = this.supplierFilterId;
        data["supplierFilterName"] = this.supplierFilterName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["feeType"] = this.feeType;
        data["productType"] = this.productType;
        data["applicationType"] = this.applicationType;
        data["flightFeeValues"] = this.flightFeeValues ? this.flightFeeValues.toJSON() : <any>undefined;
        data["enabled"] = this.enabled;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["hotelFeeFilter"] = this.hotelFeeFilter ? this.hotelFeeFilter.toJSON() : <any>undefined;
        data["flightFeeFilter"] = this.flightFeeFilter ? this.flightFeeFilter.toJSON() : <any>undefined;
        data["trainFeeFilter"] = this.trainFeeFilter ? this.trainFeeFilter.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IFeeRoot {
    agencyFilterId: string | undefined;
    agencyFilterName: string | undefined;
    supplierFilterId: string | undefined;
    supplierFilterName: string | undefined;
    name: string | undefined;
    description: string | undefined;
    value: number;
    valueType: FeeValueType;
    feeType: FeeType;
    productType: FeeProductType;
    applicationType: FeeApplicationType;
    flightFeeValues: FlightFeeValue;
    enabled: boolean;
    validFrom: moment.Moment | undefined;
    validTo: moment.Moment | undefined;
    hotelFeeFilter: HotelFeeFilter;
    flightFeeFilter: FlightFeeFilter;
    trainFeeFilter: TrainFeeFilter;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class ZucchettiSettingsEditDto implements IZucchettiSettingsEditDto {
    active!: boolean;
    isAllStringsUpperCase!: boolean;
    codiceServizioFlight!: string | undefined;
    codiceServizioHotel!: string | undefined;
    codiceServizioCar!: string | undefined;
    codiceServizioSconto!: string | undefined;
    seriePratica!: string | undefined;
    statoPratica!: string | undefined;
    codiceAppPratica!: string | undefined;

    constructor(data?: IZucchettiSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.isAllStringsUpperCase = _data["isAllStringsUpperCase"];
            this.codiceServizioFlight = _data["codiceServizioFlight"];
            this.codiceServizioHotel = _data["codiceServizioHotel"];
            this.codiceServizioCar = _data["codiceServizioCar"];
            this.codiceServizioSconto = _data["codiceServizioSconto"];
            this.seriePratica = _data["seriePratica"];
            this.statoPratica = _data["statoPratica"];
            this.codiceAppPratica = _data["codiceAppPratica"];
        }
    }

    static fromJS(data: any): ZucchettiSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZucchettiSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["isAllStringsUpperCase"] = this.isAllStringsUpperCase;
        data["codiceServizioFlight"] = this.codiceServizioFlight;
        data["codiceServizioHotel"] = this.codiceServizioHotel;
        data["codiceServizioCar"] = this.codiceServizioCar;
        data["codiceServizioSconto"] = this.codiceServizioSconto;
        data["seriePratica"] = this.seriePratica;
        data["statoPratica"] = this.statoPratica;
        data["codiceAppPratica"] = this.codiceAppPratica;
        return data;
    }
}

export interface IZucchettiSettingsEditDto {
    active: boolean;
    isAllStringsUpperCase: boolean;
    codiceServizioFlight: string | undefined;
    codiceServizioHotel: string | undefined;
    codiceServizioCar: string | undefined;
    codiceServizioSconto: string | undefined;
    seriePratica: string | undefined;
    statoPratica: string | undefined;
    codiceAppPratica: string | undefined;
}

export class FeedAccountantSettingsEditDto implements IFeedAccountantSettingsEditDto {
    zucchettiSettings!: ZucchettiSettingsEditDto;

    constructor(data?: IFeedAccountantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zucchettiSettings = _data["zucchettiSettings"] ? ZucchettiSettingsEditDto.fromJS(_data["zucchettiSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeedAccountantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedAccountantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zucchettiSettings"] = this.zucchettiSettings ? this.zucchettiSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeedAccountantSettingsEditDto {
    zucchettiSettings: ZucchettiSettingsEditDto;
}

export enum RangeTimeTypeDto {
    Departure = 0,
    Arrival = 1,
}

export class PassengerTypeDTO implements IPassengerTypeDTO {
    code!: string | undefined;
    quantity!: number;
    ages: Array<number> | undefined;

    constructor(data?: IPassengerTypeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.quantity = _data["quantity"];
            this.ages = _data["ages"];
        }
    }

    static fromJS(data: any): PassengerTypeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerTypeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        data["ages"] = this.ages;
        return data;
    }
}

export interface IPassengerTypeDTO {
    code: string | undefined;
    quantity: number;
}

export enum CompaniesFilterTypeDto {
    IncludeCompaniesOnly = 0,
    ExcludeCompaniesOnly = 1,
}

export enum LuggageFilterTypeDto {
    None = 0,
    IncludedLuggageOnly = 1,
    NotIncludedLuggageOnly = 2,
}

export enum FareRestrictionsTypeDto {
    Undefined = 0,
    Changeable = 1,
    ChangeableWithoutPenalty = 2,
    Refundable = 3,
    RefundableWithoutPenalty = 4,
    ExcludeAllRestrictions = 5,
}

export class AvailabilityRequestDTO implements IAvailabilityRequestDTO {
    originAirportCode!: string | undefined;
    destinationAirportCode!: string | undefined;
    departureDate!: moment.Moment;
    returnDate!: moment.Moment | undefined;
    originAirport!: AirportDTO;
    destinationAirport!: AirportDTO;
    departureRangeStartTime!: string | undefined;
    departureRangeEndTime!: string | undefined;
    returnRangeStartTime!: string | undefined;
    returnRangeEndTime!: string | undefined;
    departureRangeType!: RangeTimeTypeDto;
    returnRangeType!: RangeTimeTypeDto;
    passengers!: PassengerTypeDTO[] | undefined;
    cabin!: string | undefined;
    directOnly!: boolean;
    nearAirports!: boolean;
    includeTrainSearch!: boolean;
    tripType!: TripTypeDTO;
    readonly totalPax!: number;
    companiesFilterType!: CompaniesFilterTypeDto;
    companiesFilter!: NameValueDto[] | undefined;
    luggageFilterType!: LuggageFilterTypeDto;
    excludeNightStops!: boolean;
    alliancesFilter!: string[] | undefined;
    customerCode!: string | undefined;
    accountCode!: string | undefined;
    negotiatedFaresOnly!: boolean;
    fareRestrictions!: FareRestrictionsTypeDto;

    constructor(data?: IAvailabilityRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originAirportCode = _data["originAirportCode"];
            this.destinationAirportCode = _data["destinationAirportCode"];
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : <any>undefined;
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : <any>undefined;
            this.originAirport = _data["originAirport"] ? AirportDTO.fromJS(_data["originAirport"]) : <any>undefined;
            this.destinationAirport = _data["destinationAirport"] ? AirportDTO.fromJS(_data["destinationAirport"]) : <any>undefined;
            this.departureRangeStartTime = _data["departureRangeStartTime"];
            this.departureRangeEndTime = _data["departureRangeEndTime"];
            this.returnRangeStartTime = _data["returnRangeStartTime"];
            this.returnRangeEndTime = _data["returnRangeEndTime"];
            this.departureRangeType = _data["departureRangeType"];
            this.returnRangeType = _data["returnRangeType"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PassengerTypeDTO.fromJS(item));
            }
            this.cabin = _data["cabin"];
            this.directOnly = _data["directOnly"];
            this.nearAirports = _data["nearAirports"];
            this.includeTrainSearch = _data["includeTrainSearch"];
            this.tripType = _data["tripType"];
            (<any>this).totalPax = _data["totalPax"];
            this.companiesFilterType = _data["companiesFilterType"];
            if (Array.isArray(_data["companiesFilter"])) {
                this.companiesFilter = [] as any;
                for (let item of _data["companiesFilter"])
                    this.companiesFilter!.push(NameValueDto.fromJS(item));
            }
            this.luggageFilterType = _data["luggageFilterType"];
            this.excludeNightStops = _data["excludeNightStops"];
            if (Array.isArray(_data["alliancesFilter"])) {
                this.alliancesFilter = [] as any;
                for (let item of _data["alliancesFilter"])
                    this.alliancesFilter!.push(item);
            }
            this.customerCode = _data["customerCode"];
            this.accountCode = _data["accountCode"];
            this.negotiatedFaresOnly = _data["negotiatedFaresOnly"];
            this.fareRestrictions = _data["fareRestrictions"];
        }
    }

    static fromJS(data: any): AvailabilityRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originAirportCode"] = this.originAirportCode;
        data["destinationAirportCode"] = this.destinationAirportCode;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["originAirport"] = this.originAirport ? this.originAirport.toJSON() : <any>undefined;
        data["destinationAirport"] = this.destinationAirport ? this.destinationAirport.toJSON() : <any>undefined;
        data["departureRangeStartTime"] = this.departureRangeStartTime;
        data["departureRangeEndTime"] = this.departureRangeEndTime;
        data["returnRangeStartTime"] = this.returnRangeStartTime;
        data["returnRangeEndTime"] = this.returnRangeEndTime;
        data["departureRangeType"] = this.departureRangeType;
        data["returnRangeType"] = this.returnRangeType;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["cabin"] = this.cabin;
        data["directOnly"] = this.directOnly;
        data["nearAirports"] = this.nearAirports;
        data["includeTrainSearch"] = this.includeTrainSearch;
        data["tripType"] = this.tripType;
        data["totalPax"] = this.totalPax;
        data["companiesFilterType"] = this.companiesFilterType;
        if (Array.isArray(this.companiesFilter)) {
            data["companiesFilter"] = [];
            for (let item of this.companiesFilter)
                data["companiesFilter"].push(item.toJSON());
        }
        data["luggageFilterType"] = this.luggageFilterType;
        data["excludeNightStops"] = this.excludeNightStops;
        if (Array.isArray(this.alliancesFilter)) {
            data["alliancesFilter"] = [];
            for (let item of this.alliancesFilter)
                data["alliancesFilter"].push(item);
        }
        data["customerCode"] = this.customerCode;
        data["accountCode"] = this.accountCode;
        data["negotiatedFaresOnly"] = this.negotiatedFaresOnly;
        data["fareRestrictions"] = this.fareRestrictions;
        return data;
    }
}

export interface IAvailabilityRequestDTO {
    originAirportCode: string | undefined;
    destinationAirportCode: string | undefined;
    departureDate: moment.Moment;
    returnDate: moment.Moment | undefined;
    originAirport: AirportDTO;
    destinationAirport: AirportDTO;
    departureRangeStartTime: string | undefined;
    departureRangeEndTime: string | undefined;
    returnRangeStartTime: string | undefined;
    returnRangeEndTime: string | undefined;
    departureRangeType: RangeTimeTypeDto;
    returnRangeType: RangeTimeTypeDto;
    passengers: PassengerTypeDTO[] | undefined;
    cabin: string | undefined;
    directOnly: boolean;
    nearAirports: boolean;
    includeTrainSearch: boolean;
    tripType: TripTypeDTO;
    totalPax: number;
    companiesFilterType: CompaniesFilterTypeDto;
    companiesFilter: NameValueDto[] | undefined;
    luggageFilterType: LuggageFilterTypeDto;
    excludeNightStops: boolean;
    alliancesFilter: string[] | undefined;
    customerCode: string | undefined;
    accountCode: string | undefined;
    negotiatedFaresOnly: boolean;
    fareRestrictions: FareRestrictionsTypeDto;
}

export class AvailabilityItineraryMulticityDTO implements IAvailabilityItineraryMulticityDTO {
    id!: string | undefined;
    idGroup!: string | undefined;
    supplierName!: string | undefined;
    totalPrice!: number;
    feeValue!: number;
    agencyFeeValue!: number;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;
    pricingInformation!: PricingInformationDTO[] | undefined;
    selectedPricingInformation!: PricingInformationDTO;
    legs!: LegDescDTO[] | undefined;
    readonly departureTimesWayTrip!: moment.Moment;
    readonly maxSchedulesCount!: number;
    readonly duration!: number;

    constructor(data?: IAvailabilityItineraryMulticityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idGroup = _data["idGroup"];
            this.supplierName = _data["supplierName"];
            this.totalPrice = _data["totalPrice"];
            this.feeValue = _data["feeValue"];
            this.agencyFeeValue = _data["agencyFeeValue"];
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
            if (Array.isArray(_data["pricingInformation"])) {
                this.pricingInformation = [] as any;
                for (let item of _data["pricingInformation"])
                    this.pricingInformation!.push(PricingInformationDTO.fromJS(item));
            }
            this.selectedPricingInformation = _data["selectedPricingInformation"] ? PricingInformationDTO.fromJS(_data["selectedPricingInformation"]) : <any>undefined;
            if (Array.isArray(_data["legs"])) {
                this.legs = [] as any;
                for (let item of _data["legs"])
                    this.legs!.push(LegDescDTO.fromJS(item));
            }
            (<any>this).departureTimesWayTrip = _data["departureTimesWayTrip"] ? moment(_data["departureTimesWayTrip"].toString()) : <any>undefined;
            (<any>this).maxSchedulesCount = _data["maxSchedulesCount"];
            (<any>this).duration = _data["duration"];
        }
    }

    static fromJS(data: any): AvailabilityItineraryMulticityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityItineraryMulticityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idGroup"] = this.idGroup;
        data["supplierName"] = this.supplierName;
        data["totalPrice"] = this.totalPrice;
        data["feeValue"] = this.feeValue;
        data["agencyFeeValue"] = this.agencyFeeValue;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        if (Array.isArray(this.pricingInformation)) {
            data["pricingInformation"] = [];
            for (let item of this.pricingInformation)
                data["pricingInformation"].push(item.toJSON());
        }
        data["selectedPricingInformation"] = this.selectedPricingInformation ? this.selectedPricingInformation.toJSON() : <any>undefined;
        if (Array.isArray(this.legs)) {
            data["legs"] = [];
            for (let item of this.legs)
                data["legs"].push(item.toJSON());
        }
        data["departureTimesWayTrip"] = this.departureTimesWayTrip ? this.departureTimesWayTrip.toISOString() : <any>undefined;
        data["maxSchedulesCount"] = this.maxSchedulesCount;
        data["duration"] = this.duration;
        return data;
    }
}

export interface IAvailabilityItineraryMulticityDTO {
    id: string | undefined;
    idGroup: string | undefined;
    supplierName: string | undefined;
    totalPrice: number;
    feeValue: number;
    agencyFeeValue: number;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
    pricingInformation: PricingInformationDTO[] | undefined;
    selectedPricingInformation: PricingInformationDTO;
    legs: LegDescDTO[] | undefined;
    departureTimesWayTrip: moment.Moment;
    maxSchedulesCount: number;
    duration: number;
}

export class AvailabilityResponseMulticityDTO implements IAvailabilityResponseMulticityDTO {
    id!: string | undefined;
    requestData!: any | undefined;
    data!: AvailabilityItineraryMulticityDTO[] | undefined;
    outwardData!: AvailabilityItineraryMulticityDTO[] | undefined;
    returnData!: AvailabilityItineraryMulticityDTO[] | undefined;

    constructor(data?: IAvailabilityResponseMulticityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestData = _data["requestData"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AvailabilityItineraryMulticityDTO.fromJS(item));
            }
            if (Array.isArray(_data["outwardData"])) {
                this.outwardData = [] as any;
                for (let item of _data["outwardData"])
                    this.outwardData!.push(AvailabilityItineraryMulticityDTO.fromJS(item));
            }
            if (Array.isArray(_data["returnData"])) {
                this.returnData = [] as any;
                for (let item of _data["returnData"])
                    this.returnData!.push(AvailabilityItineraryMulticityDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailabilityResponseMulticityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityResponseMulticityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestData"] = this.requestData;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.outwardData)) {
            data["outwardData"] = [];
            for (let item of this.outwardData)
                data["outwardData"].push(item.toJSON());
        }
        if (Array.isArray(this.returnData)) {
            data["returnData"] = [];
            for (let item of this.returnData)
                data["returnData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAvailabilityResponseMulticityDTO {
    id: string | undefined;
    requestData: any | undefined;
    data: AvailabilityItineraryMulticityDTO[] | undefined;
    outwardData: AvailabilityItineraryMulticityDTO[] | undefined;
    returnData: AvailabilityItineraryMulticityDTO[] | undefined;
}

export class MulticityDTO implements IMulticityDTO {
    originAirportCode!: string | undefined;
    destinationAirportCode!: string | undefined;
    departureDate!: moment.Moment;
    originAirport!: AirportDTO;
    destinationAirport!: AirportDTO;
    rangeStartTime!: string | undefined;
    rangeEndTime!: string | undefined;
    rangeType!: RangeTimeTypeDto;

    constructor(data?: IMulticityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originAirportCode = _data["originAirportCode"];
            this.destinationAirportCode = _data["destinationAirportCode"];
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : <any>undefined;
            this.originAirport = _data["originAirport"] ? AirportDTO.fromJS(_data["originAirport"]) : <any>undefined;
            this.destinationAirport = _data["destinationAirport"] ? AirportDTO.fromJS(_data["destinationAirport"]) : <any>undefined;
            this.rangeStartTime = _data["rangeStartTime"];
            this.rangeEndTime = _data["rangeEndTime"];
            this.rangeType = _data["rangeType"];
        }
    }

    static fromJS(data: any): MulticityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MulticityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originAirportCode"] = this.originAirportCode;
        data["destinationAirportCode"] = this.destinationAirportCode;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["originAirport"] = this.originAirport ? this.originAirport.toJSON() : <any>undefined;
        data["destinationAirport"] = this.destinationAirport ? this.destinationAirport.toJSON() : <any>undefined;
        data["rangeStartTime"] = this.rangeStartTime;
        data["rangeEndTime"] = this.rangeEndTime;
        data["rangeType"] = this.rangeType;
        return data;
    }
}

export interface IMulticityDTO {
    originAirportCode: string | undefined;
    destinationAirportCode: string | undefined;
    departureDate: moment.Moment;
    originAirport: AirportDTO;
    destinationAirport: AirportDTO;
    rangeStartTime: string | undefined;
    rangeEndTime: string | undefined;
    rangeType: RangeTimeTypeDto;
}

export class AvailabilityRequestMulticityDTO implements IAvailabilityRequestMulticityDTO {
    legs!: MulticityDTO[] | undefined;
    passengers!: PassengerTypeDTO[] | undefined;
    cabin!: string | undefined;
    directOnly!: boolean;
    nearAirports!: boolean;
    includeTrainSearch!: boolean;
    tripType!: TripTypeDTO;
    readonly totalPax!: number;
    companiesFilterType!: CompaniesFilterTypeDto;
    companiesFilter!: NameValueDto[] | undefined;
    luggageFilterType!: LuggageFilterTypeDto;
    excludeNightStops!: boolean;
    alliancesFilter!: string[] | undefined;
    customerCode!: string | undefined;
    accountCode!: string | undefined;
    negotiatedFaresOnly!: boolean;
    fareRestrictions!: FareRestrictionsTypeDto;
    co2Data!: Co2DataDTO | undefined

    constructor(data?: IAvailabilityRequestMulticityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["legs"])) {
                this.legs = [] as any;
                for (let item of _data["legs"])
                    this.legs!.push(MulticityDTO.fromJS(item));
            }
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PassengerTypeDTO.fromJS(item));
            }
            this.cabin = _data["cabin"];
            this.directOnly = _data["directOnly"];
            this.nearAirports = _data["nearAirports"];
            this.includeTrainSearch = _data["includeTrainSearch"];
            this.tripType = _data["tripType"];
            (<any>this).totalPax = _data["totalPax"];
            this.companiesFilterType = _data["companiesFilterType"];
            if (Array.isArray(_data["companiesFilter"])) {
                this.companiesFilter = [] as any;
                for (let item of _data["companiesFilter"])
                    this.companiesFilter!.push(NameValueDto.fromJS(item));
            }
            this.luggageFilterType = _data["luggageFilterType"];
            this.excludeNightStops = _data["excludeNightStops"];
            if (Array.isArray(_data["alliancesFilter"])) {
                this.alliancesFilter = [] as any;
                for (let item of _data["alliancesFilter"])
                    this.alliancesFilter!.push(item);
            }
            this.customerCode = _data["customerCode"];
            this.accountCode = _data["accountCode"];
            this.negotiatedFaresOnly = _data["negotiatedFaresOnly"];
            this.fareRestrictions = _data["fareRestrictions"];
            this.co2Data = _data["co2Data"];
        }
    }

    static fromJS(data: any): AvailabilityRequestMulticityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityRequestMulticityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.legs)) {
            data["legs"] = [];
            for (let item of this.legs)
                data["legs"].push(item.toJSON());
        }
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["cabin"] = this.cabin;
        data["directOnly"] = this.directOnly;
        data["nearAirports"] = this.nearAirports;
        data["includeTrainSearch"] = this.includeTrainSearch;
        data["tripType"] = this.tripType;
        data["totalPax"] = this.totalPax;
        data["companiesFilterType"] = this.companiesFilterType;
        if (Array.isArray(this.companiesFilter)) {
            data["companiesFilter"] = [];
            for (let item of this.companiesFilter)
                data["companiesFilter"].push(item.toJSON());
        }
        data["luggageFilterType"] = this.luggageFilterType;
        data["excludeNightStops"] = this.excludeNightStops;
        if (Array.isArray(this.alliancesFilter)) {
            data["alliancesFilter"] = [];
            for (let item of this.alliancesFilter)
                data["alliancesFilter"].push(item);
        }
        data["customerCode"] = this.customerCode;
        data["accountCode"] = this.accountCode;
        data["negotiatedFaresOnly"] = this.negotiatedFaresOnly;
        data["fareRestrictions"] = this.fareRestrictions;
        data["co2Data"] = this.co2Data;
        return data;
    }
}

export interface IAvailabilityRequestMulticityDTO {
    legs: MulticityDTO[] | undefined;
    passengers: PassengerTypeDTO[] | undefined;
    cabin: string | undefined;
    directOnly: boolean;
    nearAirports: boolean;
    includeTrainSearch: boolean;
    tripType: TripTypeDTO;
    totalPax: number;
    companiesFilterType: CompaniesFilterTypeDto;
    companiesFilter: NameValueDto[] | undefined;
    luggageFilterType: LuggageFilterTypeDto;
    excludeNightStops: boolean;
    alliancesFilter: string[] | undefined;
    customerCode: string | undefined;
    accountCode: string | undefined;
    negotiatedFaresOnly: boolean;
    fareRestrictions: FareRestrictionsTypeDto;
    co2Data: Co2DataDTO | undefined
}

export class OriginDestinationOptionDto implements IOriginDestinationOptionDto {
    departureDate!: moment.Moment;
    returnDate!: moment.Moment | undefined;
    price!: number;
    masterAirLineCode!: string | undefined;
    stopoversCount!: number;

    constructor(data?: IOriginDestinationOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : <any>undefined;
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : <any>undefined;
            this.price = _data["price"];
            this.masterAirLineCode = _data["masterAirLineCode"];
            this.stopoversCount = _data["stopoversCount"];
        }
    }

    static fromJS(data: any): OriginDestinationOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OriginDestinationOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["masterAirLineCode"] = this.masterAirLineCode;
        data["stopoversCount"] = this.stopoversCount;
        return data;
    }
}

export interface IOriginDestinationOptionDto {
    departureDate: moment.Moment;
    returnDate: moment.Moment | undefined;
    price: number;
    masterAirLineCode: string | undefined;
    stopoversCount: number;
}

export class PricedItineraryDto implements IPricedItineraryDto {
    departureDate!: moment.Moment;
    originDestinationOptions!: OriginDestinationOptionDto[] | undefined;

    constructor(data?: IPricedItineraryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["originDestinationOptions"])) {
                this.originDestinationOptions = [] as any;
                for (let item of _data["originDestinationOptions"])
                    this.originDestinationOptions!.push(OriginDestinationOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricedItineraryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricedItineraryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        if (Array.isArray(this.originDestinationOptions)) {
            data["originDestinationOptions"] = [];
            for (let item of this.originDestinationOptions)
                data["originDestinationOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPricedItineraryDto {
    departureDate: moment.Moment;
    originDestinationOptions: OriginDestinationOptionDto[] | undefined;
}

export class CalendarShoppingDto implements ICalendarShoppingDto {
    maxPrice!: number;
    bestPrice!: number;
    departureAirportCode!: string | undefined;
    returnAirportCode!: string | undefined;
    pricedItineraries!: PricedItineraryDto[] | undefined;

    constructor(data?: ICalendarShoppingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxPrice = _data["maxPrice"];
            this.bestPrice = _data["bestPrice"];
            this.departureAirportCode = _data["departureAirportCode"];
            this.returnAirportCode = _data["returnAirportCode"];
            if (Array.isArray(_data["pricedItineraries"])) {
                this.pricedItineraries = [] as any;
                for (let item of _data["pricedItineraries"])
                    this.pricedItineraries!.push(PricedItineraryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarShoppingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarShoppingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxPrice"] = this.maxPrice;
        data["bestPrice"] = this.bestPrice;
        data["departureAirportCode"] = this.departureAirportCode;
        data["returnAirportCode"] = this.returnAirportCode;
        if (Array.isArray(this.pricedItineraries)) {
            data["pricedItineraries"] = [];
            for (let item of this.pricedItineraries)
                data["pricedItineraries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalendarShoppingDto {
    maxPrice: number;
    bestPrice: number;
    departureAirportCode: string | undefined;
    returnAirportCode: string | undefined;
    pricedItineraries: PricedItineraryDto[] | undefined;
}

export class AirBookResponseDTO implements IAirBookResponseDTO {
    itinerary!: ItineraryDTO;
    paymentGateways!: PaymentGatewayDto[] | undefined;
    paymentProfiles!: ListResultDtoOfPaymentDataProfileDto;
    enableFopExtraPaymentProfile!: boolean;
    bookingConfirmationTypes!: BookingConfirmationTypeDto[] | undefined;
    luggageOptions!: LuggageOptionsDTO[] | undefined;
    handLuggageOptions!: LuggageOptionsDTO[] | undefined;
    flightExtrasOptions!: LuggageOptionsDTO[] | undefined;
    outwardLuggageOptions!: LuggageOptionsDTO[] | undefined;
    returnLuggageOptions!: LuggageOptionsDTO[] | undefined;
    outwardHandLuggageOptions!: LuggageOptionsDTO[] | undefined;
    returnHandLuggageOptions!: LuggageOptionsDTO[] | undefined;
    passengers!: PersonNameDataDTO[] | undefined;
    user!: ApplicationUserDto;
    orderId!: string | undefined;
    paymentGateway!: PaymentGatewayDto;
    discountCode!: string | undefined;
    bookingConfirmationType!: BookingConfirmationTypeDto;
    paymentData!: PaymentDataDto;
    paymentProfile!: PaymentDataProfileDto;
    personNameSsrs!: PersonNameSsrDto[] | undefined;
    luggageOption!: LuggageOptionsDTO;
    handLuggageOption!: LuggageOptionsDTO;
    remarks!: string | undefined;
    hideFareDetails!: boolean;
    skipAgeValidation!: boolean;
    availabilityId!: string | undefined;
    groupItineraryId!: string | undefined;
    itineraryId!: string | undefined;
    pricingInformationId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;

    constructor(data?: IAirBookResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerary = _data["itinerary"] ? ItineraryDTO.fromJS(_data["itinerary"]) : <any>undefined;
            if (Array.isArray(_data["paymentGateways"])) {
                this.paymentGateways = [] as any;
                for (let item of _data["paymentGateways"])
                    this.paymentGateways!.push(item);
            }
            this.paymentProfiles = _data["paymentProfiles"] ? ListResultDtoOfPaymentDataProfileDto.fromJS(_data["paymentProfiles"]) : <any>undefined;
            this.enableFopExtraPaymentProfile = _data["enableFopExtraPaymentProfile"];
            if (Array.isArray(_data["bookingConfirmationTypes"])) {
                this.bookingConfirmationTypes = [] as any;
                for (let item of _data["bookingConfirmationTypes"])
                    this.bookingConfirmationTypes!.push(item);
            }
            if (Array.isArray(_data["luggageOptions"])) {
                this.luggageOptions = [] as any;
                for (let item of _data["luggageOptions"])
                    this.luggageOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["handLuggageOptions"])) {
                this.handLuggageOptions = [] as any;
                for (let item of _data["handLuggageOptions"])
                    this.handLuggageOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["flightExtrasOptions"])) {
                this.flightExtrasOptions = [] as any;
                for (let item of _data["flightExtrasOptions"])
                    this.flightExtrasOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["outwardLuggageOptions"])) {
                this.outwardLuggageOptions = [] as any;
                for (let item of _data["outwardLuggageOptions"])
                    this.outwardLuggageOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["returnLuggageOptions"])) {
                this.returnLuggageOptions = [] as any;
                for (let item of _data["returnLuggageOptions"])
                    this.returnLuggageOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["outwardHandLuggageOptions"])) {
                this.outwardHandLuggageOptions = [] as any;
                for (let item of _data["outwardHandLuggageOptions"])
                    this.outwardHandLuggageOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["returnHandLuggageOptions"])) {
                this.returnHandLuggageOptions = [] as any;
                for (let item of _data["returnHandLuggageOptions"])
                    this.returnHandLuggageOptions!.push(LuggageOptionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PersonNameDataDTO.fromJS(item));
            }
            this.user = _data["user"] ? ApplicationUserDto.fromJS(_data["user"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.paymentGateway = _data["paymentGateway"];
            this.discountCode = _data["discountCode"];
            this.bookingConfirmationType = _data["bookingConfirmationType"];
            this.paymentData = _data["paymentData"] ? PaymentDataDto.fromJS(_data["paymentData"]) : <any>undefined;
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
            if (Array.isArray(_data["personNameSsrs"])) {
                this.personNameSsrs = [] as any;
                for (let item of _data["personNameSsrs"])
                    this.personNameSsrs!.push(PersonNameSsrDto.fromJS(item));
            }
            this.luggageOption = _data["luggageOption"] ? LuggageOptionsDTO.fromJS(_data["luggageOption"]) : <any>undefined;
            this.handLuggageOption = _data["handLuggageOption"] ? LuggageOptionsDTO.fromJS(_data["handLuggageOption"]) : <any>undefined;
            this.remarks = _data["remarks"];
            this.hideFareDetails = _data["hideFareDetails"];
            this.skipAgeValidation = _data["skipAgeValidation"];
            this.availabilityId = _data["availabilityId"];
            this.groupItineraryId = _data["groupItineraryId"];
            this.itineraryId = _data["itineraryId"];
            this.pricingInformationId = _data["pricingInformationId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
        }
    }

    static fromJS(data: any): AirBookResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirBookResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerary"] = this.itinerary ? this.itinerary.toJSON() : <any>undefined;
        if (Array.isArray(this.paymentGateways)) {
            data["paymentGateways"] = [];
            for (let item of this.paymentGateways)
                data["paymentGateways"].push(item);
        }
        data["paymentProfiles"] = this.paymentProfiles ? this.paymentProfiles.toJSON() : <any>undefined;
        data["enableFopExtraPaymentProfile"] = this.enableFopExtraPaymentProfile;
        if (Array.isArray(this.bookingConfirmationTypes)) {
            data["bookingConfirmationTypes"] = [];
            for (let item of this.bookingConfirmationTypes)
                data["bookingConfirmationTypes"].push(item);
        }
        if (Array.isArray(this.luggageOptions)) {
            data["luggageOptions"] = [];
            for (let item of this.luggageOptions)
                data["luggageOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.handLuggageOptions)) {
            data["handLuggageOptions"] = [];
            for (let item of this.handLuggageOptions)
                data["handLuggageOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.flightExtrasOptions)) {
            data["flightExtrasOptions"] = [];
            for (let item of this.flightExtrasOptions)
                data["flightExtrasOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.outwardLuggageOptions)) {
            data["outwardLuggageOptions"] = [];
            for (let item of this.outwardLuggageOptions)
                data["outwardLuggageOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.returnLuggageOptions)) {
            data["returnLuggageOptions"] = [];
            for (let item of this.returnLuggageOptions)
                data["returnLuggageOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.outwardHandLuggageOptions)) {
            data["outwardHandLuggageOptions"] = [];
            for (let item of this.outwardHandLuggageOptions)
                data["outwardHandLuggageOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.returnHandLuggageOptions)) {
            data["returnHandLuggageOptions"] = [];
            for (let item of this.returnHandLuggageOptions)
                data["returnHandLuggageOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["paymentGateway"] = this.paymentGateway;
        data["discountCode"] = this.discountCode;
        data["bookingConfirmationType"] = this.bookingConfirmationType;
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        if (Array.isArray(this.personNameSsrs)) {
            data["personNameSsrs"] = [];
            for (let item of this.personNameSsrs)
                data["personNameSsrs"].push(item.toJSON());
        }
        data["luggageOption"] = this.luggageOption ? this.luggageOption.toJSON() : <any>undefined;
        data["handLuggageOption"] = this.handLuggageOption ? this.handLuggageOption.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["hideFareDetails"] = this.hideFareDetails;
        data["skipAgeValidation"] = this.skipAgeValidation;
        data["availabilityId"] = this.availabilityId;
        data["groupItineraryId"] = this.groupItineraryId;
        data["itineraryId"] = this.itineraryId;
        data["pricingInformationId"] = this.pricingInformationId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        return data;
    }
}

export interface IAirBookResponseDTO {
    itinerary: ItineraryDTO;
    paymentGateways: PaymentGatewayDto[] | undefined;
    paymentProfiles: ListResultDtoOfPaymentDataProfileDto;
    enableFopExtraPaymentProfile: boolean;
    bookingConfirmationTypes: BookingConfirmationTypeDto[] | undefined;
    luggageOptions: LuggageOptionsDTO[] | undefined;
    handLuggageOptions: LuggageOptionsDTO[] | undefined;
    flightExtrasOptions: LuggageOptionsDTO[] | undefined;
    outwardLuggageOptions: LuggageOptionsDTO[] | undefined;
    returnLuggageOptions: LuggageOptionsDTO[] | undefined;
    outwardHandLuggageOptions: LuggageOptionsDTO[] | undefined;
    returnHandLuggageOptions: LuggageOptionsDTO[] | undefined;
    passengers: PersonNameDataDTO[] | undefined;
    user: ApplicationUserDto;
    orderId: string | undefined;
    paymentGateway: PaymentGatewayDto;
    discountCode: string | undefined;
    bookingConfirmationType: BookingConfirmationTypeDto;
    paymentData: PaymentDataDto;
    paymentProfile: PaymentDataProfileDto;
    personNameSsrs: PersonNameSsrDto[] | undefined;
    luggageOption: LuggageOptionsDTO;
    handLuggageOption: LuggageOptionsDTO;
    remarks: string | undefined;
    hideFareDetails: boolean;
    skipAgeValidation: boolean;
    availabilityId: string | undefined;
    groupItineraryId: string | undefined;
    itineraryId: string | undefined;
    pricingInformationId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
}

export class AirExtraRequestDTO implements IAirExtraRequestDTO {
    passengers!: PersonNameDataDTO[] | undefined;
    availabilityId!: string | undefined;
    groupItineraryId!: string | undefined;
    itineraryId!: string | undefined;
    pricingInformationId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;

    constructor(data?: IAirExtraRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PersonNameDataDTO.fromJS(item));
            }
            this.availabilityId = _data["availabilityId"];
            this.groupItineraryId = _data["groupItineraryId"];
            this.itineraryId = _data["itineraryId"];
            this.pricingInformationId = _data["pricingInformationId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
        }
    }

    static fromJS(data: any): AirExtraRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirExtraRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["availabilityId"] = this.availabilityId;
        data["groupItineraryId"] = this.groupItineraryId;
        data["itineraryId"] = this.itineraryId;
        data["pricingInformationId"] = this.pricingInformationId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        return data;
    }
}

export interface IAirExtraRequestDTO {
    passengers: PersonNameDataDTO[] | undefined;
    availabilityId: string | undefined;
    groupItineraryId: string | undefined;
    itineraryId: string | undefined;
    pricingInformationId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
}

export class FlightSeatDTO implements IFlightSeatDTO {
    seatName!: string | undefined;
    textPrice!: string | undefined;
    price!: number;
    window!: boolean;
    middle!: boolean | undefined;
    aisle!: boolean;
    center!: boolean;
    notSuitableForInfant!: boolean;
    notAllowedInfant!: boolean;
    notSuitableForChild!: boolean;
    bassinetFacility!: boolean;
    handicappedFacility!: boolean;
    exitRow!: boolean;
    unavailable!: boolean;
    noSeat!: string | undefined;
    emptySpace!: boolean;
    row!: number;
    warning!: boolean;
    extraLegSpace!: boolean;
    flightNumber!: string | undefined;
    seatAngle!: number;

    constructor(data?: IFlightSeatDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seatName = _data["seatName"];
            this.textPrice = _data["textPrice"];
            this.price = _data["price"];
            this.window = _data["window"];
            this.middle = _data["middle"];
            this.aisle = _data["aisle"];
            this.center = _data["center"];
            this.notSuitableForInfant = _data["notSuitableForInfant"];
            this.notAllowedInfant = _data["notAllowedInfant"];
            this.notSuitableForChild = _data["notSuitableForChild"];
            this.bassinetFacility = _data["bassinetFacility"];
            this.handicappedFacility = _data["handicappedFacility"];
            this.exitRow = _data["exitRow"];
            this.unavailable = _data["unavailable"];
            this.noSeat = _data["noSeat"];
            this.emptySpace = _data["emptySpace"];
            this.row = _data["row"];
            this.warning = _data["warning"];
            this.extraLegSpace = _data["extraLegSpace"];
            this.flightNumber = _data["flightNumber"];
            this.seatAngle = _data["seatAngle"];
        }
    }

    static fromJS(data: any): FlightSeatDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSeatDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seatName"] = this.seatName;
        data["textPrice"] = this.textPrice;
        data["price"] = this.price;
        data["window"] = this.window;
        data["middle"] = this.middle;
        data["aisle"] = this.aisle;
        data["center"] = this.center;
        data["notSuitableForInfant"] = this.notSuitableForInfant;
        data["notAllowedInfant"] = this.notAllowedInfant;
        data["notSuitableForChild"] = this.notSuitableForChild;
        data["bassinetFacility"] = this.bassinetFacility;
        data["handicappedFacility"] = this.handicappedFacility;
        data["exitRow"] = this.exitRow;
        data["unavailable"] = this.unavailable;
        data["noSeat"] = this.noSeat;
        data["emptySpace"] = this.emptySpace;
        data["row"] = this.row;
        data["warning"] = this.warning;
        data["extraLegSpace"] = this.extraLegSpace;
        data["flightNumber"] = this.flightNumber;
        data["seatAngle"] = this.seatAngle;
        return data;
    }
}

export interface IFlightSeatDTO {
    seatName: string | undefined;
    textPrice: string | undefined;
    price: number;
    window: boolean;
    middle: boolean | undefined;
    aisle: boolean;
    center: boolean;
    notSuitableForInfant: boolean;
    notAllowedInfant: boolean;
    notSuitableForChild: boolean;
    bassinetFacility: boolean;
    handicappedFacility: boolean;
    exitRow: boolean;
    unavailable: boolean;
    noSeat: string | undefined;
    emptySpace: boolean;
    row: number;
    warning: boolean;
    extraLegSpace: boolean;
    flightNumber: string | undefined;
    seatAngle: number;
}

export class FlightSeatRowDTO implements IFlightSeatRowDTO {
    row!: number;
    seats!: FlightSeatDTO[] | undefined;

    constructor(data?: IFlightSeatRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.row = _data["row"];
            if (Array.isArray(_data["seats"])) {
                this.seats = [] as any;
                for (let item of _data["seats"])
                    this.seats!.push(FlightSeatDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlightSeatRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSeatRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row;
        if (Array.isArray(this.seats)) {
            data["seats"] = [];
            for (let item of this.seats)
                data["seats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlightSeatRowDTO {
    row: number;
    seats: FlightSeatDTO[] | undefined;
}

export class FlightAncillaryData implements IFlightAncillaryData {
    flightNumber!: string | undefined;
    seatMap!: FlightSeatRowDTO[] | undefined;

    constructor(data?: IFlightAncillaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flightNumber = _data["flightNumber"];
            if (Array.isArray(_data["seatMap"])) {
                this.seatMap = [] as any;
                for (let item of _data["seatMap"])
                    this.seatMap!.push(FlightSeatRowDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlightAncillaryData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAncillaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flightNumber"] = this.flightNumber;
        if (Array.isArray(this.seatMap)) {
            data["seatMap"] = [];
            for (let item of this.seatMap)
                data["seatMap"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlightAncillaryData {
    flightNumber: string | undefined;
    seatMap: FlightSeatRowDTO[] | undefined;
}

export class FlightAncillaryDTO implements IFlightAncillaryDTO {
    flights!: FlightAncillaryData[] | undefined;
    error?: string | undefined;

    constructor(data?: IFlightAncillaryDTO, _error?: string) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if(_error){
            this.error = _error;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(FlightAncillaryData.fromJS(item));
            }
            if (_data["error"]) {
                this.error = _data["error"] as string;
            }
        }
    }

    static fromJS(data: any): FlightAncillaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FlightAncillaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item.toJSON());
        }
        if(this.error) {
            data["error"] = this.error;
        }
        return data;
    }
}

export interface IFlightAncillaryDTO {
    flights: FlightAncillaryData[] | undefined;
}

export class ApiResponseOfBoolean implements IApiResponseOfBoolean {
    result!: boolean;
    success!: boolean;
    error!: ErrorInfo;
    targetUrl!: string | undefined;

    constructor(data?: IApiResponseOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
        }
    }

    static fromJS(data: any): ApiResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        return data;
    }
}

export interface IApiResponseOfBoolean {
    result: boolean;
    success: boolean;
    error: ErrorInfo;
    targetUrl: string | undefined;
}

export class ApiResponseOfReservationDto implements IApiResponseOfReservationDto {
    result!: ReservationDto;
    success!: boolean;
    error!: ErrorInfo;
    targetUrl!: string | undefined;

    constructor(data?: IApiResponseOfReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ReservationDto.fromJS(_data["result"]) : <any>undefined;
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
        }
    }

    static fromJS(data: any): ApiResponseOfReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        return data;
    }
}

export interface IApiResponseOfReservationDto {
    result: ReservationDto;
    success: boolean;
    error: ErrorInfo;
    targetUrl: string | undefined;
}

export class LowestFareDTO implements ILowestFareDTO {
    airlineCodes!: string[] | undefined;
    fare!: number;

    constructor(data?: ILowestFareDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["airlineCodes"])) {
                this.airlineCodes = [] as any;
                for (let item of _data["airlineCodes"])
                    this.airlineCodes!.push(item);
            }
            this.fare = _data["fare"];
        }
    }

    static fromJS(data: any): LowestFareDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LowestFareDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.airlineCodes)) {
            data["airlineCodes"] = [];
            for (let item of this.airlineCodes)
                data["airlineCodes"].push(item);
        }
        data["fare"] = this.fare;
        return data;
    }
}

export interface ILowestFareDTO {
    airlineCodes: string[] | undefined;
    fare: number;
}

export class FareInfoDTO implements IFareInfoDTO {
    lowestFare!: LowestFareDTO;
    currencyCode!: string | undefined;
    lowestNonStopFare!: LowestFareDTO;
    departureDateTime!: moment.Moment | undefined;
    returnDateTime!: moment.Moment | undefined;

    constructor(data?: IFareInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lowestFare = _data["lowestFare"] ? LowestFareDTO.fromJS(_data["lowestFare"]) : <any>undefined;
            this.currencyCode = _data["currencyCode"];
            this.lowestNonStopFare = _data["lowestNonStopFare"] ? LowestFareDTO.fromJS(_data["lowestNonStopFare"]) : <any>undefined;
            this.departureDateTime = _data["departureDateTime"] ? moment(_data["departureDateTime"].toString()) : <any>undefined;
            this.returnDateTime = _data["returnDateTime"] ? moment(_data["returnDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FareInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FareInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lowestFare"] = this.lowestFare ? this.lowestFare.toJSON() : <any>undefined;
        data["currencyCode"] = this.currencyCode;
        data["lowestNonStopFare"] = this.lowestNonStopFare ? this.lowestNonStopFare.toJSON() : <any>undefined;
        data["departureDateTime"] = this.departureDateTime ? this.departureDateTime.toISOString() : <any>undefined;
        data["returnDateTime"] = this.returnDateTime ? this.returnDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFareInfoDTO {
    lowestFare: LowestFareDTO;
    currencyCode: string | undefined;
    lowestNonStopFare: LowestFareDTO;
    departureDateTime: moment.Moment | undefined;
    returnDateTime: moment.Moment | undefined;
}

export class LeadPriceCalendarDTO implements ILeadPriceCalendarDTO {
    originLocation!: string | undefined;
    destinationLocation!: string | undefined;
    fareInfo!: FareInfoDTO[] | undefined;

    constructor(data?: ILeadPriceCalendarDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originLocation = _data["originLocation"];
            this.destinationLocation = _data["destinationLocation"];
            if (Array.isArray(_data["fareInfo"])) {
                this.fareInfo = [] as any;
                for (let item of _data["fareInfo"])
                    this.fareInfo!.push(FareInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeadPriceCalendarDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LeadPriceCalendarDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originLocation"] = this.originLocation;
        data["destinationLocation"] = this.destinationLocation;
        if (Array.isArray(this.fareInfo)) {
            data["fareInfo"] = [];
            for (let item of this.fareInfo)
                data["fareInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILeadPriceCalendarDTO {
    originLocation: string | undefined;
    destinationLocation: string | undefined;
    fareInfo: FareInfoDTO[] | undefined;
}

export class AirBookRequestBaseDTO implements IAirBookRequestBaseDTO {
    availabilityId!: string | undefined;
    groupItineraryId!: string | undefined;
    itineraryId!: string | undefined;
    pricingInformationId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;

    constructor(data?: IAirBookRequestBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityId = _data["availabilityId"];
            this.groupItineraryId = _data["groupItineraryId"];
            this.itineraryId = _data["itineraryId"];
            this.pricingInformationId = _data["pricingInformationId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
        }
    }

    static fromJS(data: any): AirBookRequestBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirBookRequestBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityId"] = this.availabilityId;
        data["groupItineraryId"] = this.groupItineraryId;
        data["itineraryId"] = this.itineraryId;
        data["pricingInformationId"] = this.pricingInformationId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        return data;
    }
}

export interface IAirBookRequestBaseDTO {
    availabilityId: string | undefined;
    groupItineraryId: string | undefined;
    itineraryId: string | undefined;
    pricingInformationId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
}

export class FareRuleInfoParagraphDto implements IFareRuleInfoParagraphDto {
    body!: string | undefined;
    number!: string | undefined;
    title!: string | undefined;

    constructor(data?: IFareRuleInfoParagraphDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.body = _data["body"];
            this.number = _data["number"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): FareRuleInfoParagraphDto {
        data = typeof data === 'object' ? data : {};
        let result = new FareRuleInfoParagraphDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        data["number"] = this.number;
        data["title"] = this.title;
        return data;
    }
}

export interface IFareRuleInfoParagraphDto {
    body: string | undefined;
    number: string | undefined;
    title: string | undefined;
}

export class FareRuleInfoDto implements IFareRuleInfoDto {
    fareBasis!: string | undefined;
    originAirportCode!: string | undefined;
    destinationAirportCode!: string | undefined;
    governingCarrier!: string | undefined;
    departureDate!: moment.Moment;
    summary!: string | undefined;
    passengerType!: string[] | undefined;
    header!: NameValueDto[] | undefined;
    paragraphs!: FareRuleInfoParagraphDto[] | undefined;

    constructor(data?: IFareRuleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fareBasis = _data["fareBasis"];
            this.originAirportCode = _data["originAirportCode"];
            this.destinationAirportCode = _data["destinationAirportCode"];
            this.governingCarrier = _data["governingCarrier"];
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : <any>undefined;
            this.summary = _data["summary"];
            if (Array.isArray(_data["passengerType"])) {
                this.passengerType = [] as any;
                for (let item of _data["passengerType"])
                    this.passengerType!.push(item);
            }
            if (Array.isArray(_data["header"])) {
                this.header = [] as any;
                for (let item of _data["header"])
                    this.header!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["paragraphs"])) {
                this.paragraphs = [] as any;
                for (let item of _data["paragraphs"])
                    this.paragraphs!.push(FareRuleInfoParagraphDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FareRuleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FareRuleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fareBasis"] = this.fareBasis;
        data["originAirportCode"] = this.originAirportCode;
        data["destinationAirportCode"] = this.destinationAirportCode;
        data["governingCarrier"] = this.governingCarrier;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["summary"] = this.summary;
        if (Array.isArray(this.passengerType)) {
            data["passengerType"] = [];
            for (let item of this.passengerType)
                data["passengerType"].push(item);
        }
        if (Array.isArray(this.header)) {
            data["header"] = [];
            for (let item of this.header)
                data["header"].push(item.toJSON());
        }
        if (Array.isArray(this.paragraphs)) {
            data["paragraphs"] = [];
            for (let item of this.paragraphs)
                data["paragraphs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFareRuleInfoDto {
    fareBasis: string | undefined;
    originAirportCode: string | undefined;
    destinationAirportCode: string | undefined;
    governingCarrier: string | undefined;
    departureDate: moment.Moment;
    summary: string | undefined;
    passengerType: string[] | undefined;
    header: NameValueDto[] | undefined;
    paragraphs: FareRuleInfoParagraphDto[] | undefined;
}

export class FareRuleResponseDto implements IFareRuleResponseDto {
    fareRules!: FareRuleInfoDto[] | undefined;

    constructor(data?: IFareRuleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fareRules"])) {
                this.fareRules = [] as any;
                for (let item of _data["fareRules"])
                    this.fareRules!.push(FareRuleInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FareRuleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FareRuleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fareRules)) {
            data["fareRules"] = [];
            for (let item of this.fareRules)
                data["fareRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFareRuleResponseDto {
    fareRules: FareRuleInfoDto[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class FlightSerpItem implements IFlightSerpItem {
    groupItineraryId!: string | undefined;
    itineraryId!: string | undefined;
    pricingInformationId!: string | undefined;

    constructor(data?: IFlightSerpItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupItineraryId = _data["groupItineraryId"];
            this.itineraryId = _data["itineraryId"];
            this.pricingInformationId = _data["pricingInformationId"];
        }
    }

    static fromJS(data: any): FlightSerpItem {
        data = typeof data === 'object' ? data : {};
        let result = new FlightSerpItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupItineraryId"] = this.groupItineraryId;
        data["itineraryId"] = this.itineraryId;
        data["pricingInformationId"] = this.pricingInformationId;
        return data;
    }
}

export interface IFlightSerpItem {
    groupItineraryId: string | undefined;
    itineraryId: string | undefined;
    pricingInformationId: string | undefined;
}

export class FieldsEmailInput implements IFieldsEmailInput {
    recipient!: string | undefined;
    recipientName!: string | undefined;
    sender!: string | undefined;
    subject!: string | undefined;
    message!: string | undefined;

    constructor(data?: IFieldsEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipient = _data["recipient"];
            this.recipientName = _data["recipientName"];
            this.sender = _data["sender"];
            this.subject = _data["subject"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): FieldsEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new FieldsEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient;
        data["recipientName"] = this.recipientName;
        data["sender"] = this.sender;
        data["subject"] = this.subject;
        data["message"] = this.message;
        return data;
    }
}

export interface IFieldsEmailInput {
    recipient: string | undefined;
    recipientName: string | undefined;
    sender: string | undefined;
    subject: string | undefined;
    message: string | undefined;
}

export class MessageToCustomerInput implements IMessageToCustomerInput {
    flightSerpItems!: FlightSerpItem[] | undefined;
    requestData!: AvailabilityRequestMulticityDTO;
    email!: FieldsEmailInput;
    availabilityId!: string | undefined;
    tenantId!: string | undefined;
    userId!: string | undefined;
    userAgencyId!: string | undefined;

    constructor(data?: IMessageToCustomerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["flightSerpItems"])) {
                this.flightSerpItems = [] as any;
                for (let item of _data["flightSerpItems"])
                    this.flightSerpItems!.push(FlightSerpItem.fromJS(item));
            }
            this.requestData = _data["requestData"] ? AvailabilityRequestMulticityDTO.fromJS(_data["requestData"]) : <any>undefined;
            this.email = _data["email"] ? FieldsEmailInput.fromJS(_data["email"]) : <any>undefined;
            this.availabilityId = _data["availabilityId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.userAgencyId = _data["userAgencyId"];
        }
    }

    static fromJS(data: any): MessageToCustomerInput {
        data = typeof data === 'object' ? data : {};
        let result = new MessageToCustomerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flightSerpItems)) {
            data["flightSerpItems"] = [];
            for (let item of this.flightSerpItems)
                data["flightSerpItems"].push(item.toJSON());
        }
        data["requestData"] = this.requestData ? this.requestData.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["availabilityId"] = this.availabilityId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["userAgencyId"] = this.userAgencyId;
        return data;
    }
}

export interface IMessageToCustomerInput {
    flightSerpItems: FlightSerpItem[] | undefined;
    requestData: AvailabilityRequestMulticityDTO;
    email: FieldsEmailInput;
    availabilityId: string | undefined;
    tenantId: string | undefined;
    userId: string | undefined;
    userAgencyId: string | undefined;
}

export class FlightShareSerpItemsInput implements IFlightShareSerpItemsInput {
    availabilityId!: string | undefined;
    userAgencyId!: string | undefined;
    flightSerpItems!: FlightSerpItem[] | undefined;
    c!: string | undefined;

    constructor(data?: IFlightShareSerpItemsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityId = _data["availabilityId"];
            this.userAgencyId = _data["userAgencyId"];
            if (Array.isArray(_data["flightSerpItems"])) {
                this.flightSerpItems = [] as any;
                for (let item of _data["flightSerpItems"])
                    this.flightSerpItems!.push(FlightSerpItem.fromJS(item));
            }
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): FlightShareSerpItemsInput {
        data = typeof data === 'object' ? data : {};
        let result = new FlightShareSerpItemsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityId"] = this.availabilityId;
        data["userAgencyId"] = this.userAgencyId;
        if (Array.isArray(this.flightSerpItems)) {
            data["flightSerpItems"] = [];
            for (let item of this.flightSerpItems)
                data["flightSerpItems"].push(item.toJSON());
        }
        data["c"] = this.c;
        return data;
    }
}

export interface IFlightShareSerpItemsInput {
    availabilityId: string | undefined;
    userAgencyId: string | undefined;
    flightSerpItems: FlightSerpItem[] | undefined;
    c: string | undefined;
}

export class MessageToAgentInput implements IMessageToAgentInput {
    selectedFlightSerpItem!: FlightSerpItem;
    c!: string | undefined;
    requestData!: AvailabilityRequestMulticityDTO;
    email!: FieldsEmailInput;
    availabilityId!: string | undefined;
    tenantId!: string | undefined;
    userId!: string | undefined;
    userAgencyId!: string | undefined;

    constructor(data?: IMessageToAgentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedFlightSerpItem = _data["selectedFlightSerpItem"] ? FlightSerpItem.fromJS(_data["selectedFlightSerpItem"]) : <any>undefined;
            this.c = _data["c"];
            this.requestData = _data["requestData"] ? AvailabilityRequestMulticityDTO.fromJS(_data["requestData"]) : <any>undefined;
            this.email = _data["email"] ? FieldsEmailInput.fromJS(_data["email"]) : <any>undefined;
            this.availabilityId = _data["availabilityId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.userAgencyId = _data["userAgencyId"];
        }
    }

    static fromJS(data: any): MessageToAgentInput {
        data = typeof data === 'object' ? data : {};
        let result = new MessageToAgentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedFlightSerpItem"] = this.selectedFlightSerpItem ? this.selectedFlightSerpItem.toJSON() : <any>undefined;
        data["c"] = this.c;
        data["requestData"] = this.requestData ? this.requestData.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["availabilityId"] = this.availabilityId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["userAgencyId"] = this.userAgencyId;
        return data;
    }
}

export interface IMessageToAgentInput {
    selectedFlightSerpItem: FlightSerpItem;
    c: string | undefined;
    requestData: AvailabilityRequestMulticityDTO;
    email: FieldsEmailInput;
    availabilityId: string | undefined;
    tenantId: string | undefined;
    userId: string | undefined;
    userAgencyId: string | undefined;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data;
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: moment.Moment;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: moment.Moment;
    recentTenants!: RecentTenant[] | undefined;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? moment(_data["tenantCreationStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : <any>undefined;
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecentTenantsOutput {
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: moment.Moment;
    recentTenants: RecentTenant[] | undefined;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: moment.Moment;
    subscriptionEndDateEnd!: moment.Moment;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? moment(_data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? moment(_data["subscriptionEndDateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class IncomeStatisticDTO implements IIncomeStatisticDTO {
    label!: string | undefined;
    date!: moment.Moment;
    amount!: number;

    constructor(data?: IIncomeStatisticDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IncomeStatisticDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStatisticDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStatisticDTO {
    label: string | undefined;
    date: moment.Moment;
    amount: number;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStatisticDTO[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStatisticDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStatisticDTO[] | undefined;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class FileDownloadLinkDTO implements IFileDownloadLinkDTO {
    link!: string | undefined;
    alias!: string | undefined;
    addedByHost!: boolean;

    constructor(data?: IFileDownloadLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
            this.alias = _data["alias"];
            this.addedByHost = _data["addedByHost"];
        }
    }

    static fromJS(data: any): FileDownloadLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        data["alias"] = this.alias;
        data["addedByHost"] = this.addedByHost;
        return data;
    }
}

export interface IFileDownloadLinkDTO {
    link: string | undefined;
    alias: string | undefined;
    addedByHost: boolean;
}

export class FileDownloadLinksOutput implements IFileDownloadLinksOutput {
    elements!: FileDownloadLinkDTO[] | undefined;

    constructor(data?: IFileDownloadLinksOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(FileDownloadLinkDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileDownloadLinksOutput {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadLinksOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileDownloadLinksOutput {
    elements: FileDownloadLinkDTO[] | undefined;
}

export class NewsDTO implements INewsDTO {
    newsID!: string | undefined;
    title!: string | undefined;
    frontImageSource!: string | undefined;
    link!: FileDownloadLinkDTO;
    text!: string | undefined;
    newsDate!: moment.Moment;
    authorName!: string | undefined;
    userId!: number;

    constructor(data?: INewsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newsID = _data["newsID"];
            this.title = _data["title"];
            this.frontImageSource = _data["frontImageSource"];
            this.link = _data["link"] ? FileDownloadLinkDTO.fromJS(_data["link"]) : <any>undefined;
            this.text = _data["text"];
            this.newsDate = _data["newsDate"] ? moment(_data["newsDate"].toString()) : <any>undefined;
            this.authorName = _data["authorName"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): NewsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsID"] = this.newsID;
        data["title"] = this.title;
        data["frontImageSource"] = this.frontImageSource;
        data["link"] = this.link ? this.link.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["newsDate"] = this.newsDate ? this.newsDate.toISOString() : <any>undefined;
        data["authorName"] = this.authorName;
        data["userId"] = this.userId;
        return data;
    }
}

export interface INewsDTO {
    newsID: string | undefined;
    title: string | undefined;
    frontImageSource: string | undefined;
    link: FileDownloadLinkDTO;
    text: string | undefined;
    newsDate: moment.Moment;
    authorName: string | undefined;
    userId: number;
}

export class GetNewsOutput implements IGetNewsOutput {
    elements!: NewsDTO[] | undefined;

    constructor(data?: IGetNewsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(NewsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNewsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNewsOutput {
    elements: NewsDTO[] | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;
    showLockScreenWhenTimedOut!: boolean;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.timeOutSecond = _data["timeOutSecond"];
            this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data;
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
    showLockScreenWhenTimedOut: boolean;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpSslProtocols!: string | undefined;
    smtpAllowUntrustedCertificate!: boolean;
    smtpSecureSocketOptions!: string | undefined;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpSslProtocols = _data["smtpSslProtocols"];
            this.smtpAllowUntrustedCertificate = _data["smtpAllowUntrustedCertificate"];
            this.smtpSecureSocketOptions = _data["smtpSecureSocketOptions"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpSslProtocols"] = this.smtpSslProtocols;
        data["smtpAllowUntrustedCertificate"] = this.smtpAllowUntrustedCertificate;
        data["smtpSecureSocketOptions"] = this.smtpSecureSocketOptions;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpSslProtocols: string | undefined;
    smtpAllowUntrustedCertificate: boolean;
    smtpSecureSocketOptions: string | undefined;
    smtpUseDefaultCredentials: boolean;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class FacebookExternalLoginProviderSettings implements IFacebookExternalLoginProviderSettings {
    appId!: string | undefined;
    appSecret!: string | undefined;

    constructor(data?: IFacebookExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appSecret = _data["appSecret"];
        }
    }

    static fromJS(data: any): FacebookExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FacebookExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        return data;
    }
}

export interface IFacebookExternalLoginProviderSettings {
    appId: string | undefined;
    appSecret: string | undefined;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    userInfoEndpoint!: string | undefined;

    constructor(data?: IGoogleExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userInfoEndpoint = _data["userInfoEndpoint"];
        }
    }

    static fromJS(data: any): GoogleExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userInfoEndpoint"] = this.userInfoEndpoint;
        return data;
    }
}

export interface IGoogleExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    userInfoEndpoint: string | undefined;
}

export class TwitterExternalLoginProviderSettings implements ITwitterExternalLoginProviderSettings {
    consumerKey!: string | undefined;
    consumerSecret!: string | undefined;

    constructor(data?: ITwitterExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerKey = _data["consumerKey"];
            this.consumerSecret = _data["consumerSecret"];
        }
    }

    static fromJS(data: any): TwitterExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        return data;
    }
}

export interface ITwitterExternalLoginProviderSettings {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IMicrosoftExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IMicrosoftExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    authority!: string | undefined;
    loginUrl!: string | undefined;
    validateIssuer!: boolean;

    constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.authority = _data["authority"];
            this.loginUrl = _data["loginUrl"];
            this.validateIssuer = _data["validateIssuer"];
        }
    }

    static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OpenIdConnectExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["authority"] = this.authority;
        data["loginUrl"] = this.loginUrl;
        data["validateIssuer"] = this.validateIssuer;
        return data;
    }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    authority: string | undefined;
    loginUrl: string | undefined;
    validateIssuer: boolean;
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
    claim!: string | undefined;
    key!: string | undefined;

    constructor(data?: IJsonClaimMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claim = _data["claim"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): JsonClaimMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonClaimMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claim"] = this.claim;
        data["key"] = this.key;
        return data;
    }
}

export interface IJsonClaimMapDto {
    claim: string | undefined;
    key: string | undefined;
}

export class WsFederationExternalLoginProviderSettings implements IWsFederationExternalLoginProviderSettings {
    clientId!: string | undefined;
    tenant!: string | undefined;
    metaDataAddress!: string | undefined;
    wtrealm!: string | undefined;
    authority!: string | undefined;

    constructor(data?: IWsFederationExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.tenant = _data["tenant"];
            this.metaDataAddress = _data["metaDataAddress"];
            this.wtrealm = _data["wtrealm"];
            this.authority = _data["authority"];
        }
    }

    static fromJS(data: any): WsFederationExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WsFederationExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["tenant"] = this.tenant;
        data["metaDataAddress"] = this.metaDataAddress;
        data["wtrealm"] = this.wtrealm;
        data["authority"] = this.authority;
        return data;
    }
}

export interface IWsFederationExternalLoginProviderSettings {
    clientId: string | undefined;
    tenant: string | undefined;
    metaDataAddress: string | undefined;
    wtrealm: string | undefined;
    authority: string | undefined;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated!: boolean;
    facebook!: FacebookExternalLoginProviderSettings;
    google_IsDeactivated!: boolean;
    google!: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated!: boolean;
    twitter!: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated!: boolean;
    microsoft!: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated!: boolean;
    openIdConnect!: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated!: boolean;
    wsFederation!: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping!: JsonClaimMapDto[] | undefined;

    constructor(data?: IExternalLoginProviderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facebook_IsDeactivated = _data["facebook_IsDeactivated"];
            this.facebook = _data["facebook"] ? FacebookExternalLoginProviderSettings.fromJS(_data["facebook"]) : <any>undefined;
            this.google_IsDeactivated = _data["google_IsDeactivated"];
            this.google = _data["google"] ? GoogleExternalLoginProviderSettings.fromJS(_data["google"]) : <any>undefined;
            this.twitter_IsDeactivated = _data["twitter_IsDeactivated"];
            this.twitter = _data["twitter"] ? TwitterExternalLoginProviderSettings.fromJS(_data["twitter"]) : <any>undefined;
            this.microsoft_IsDeactivated = _data["microsoft_IsDeactivated"];
            this.microsoft = _data["microsoft"] ? MicrosoftExternalLoginProviderSettings.fromJS(_data["microsoft"]) : <any>undefined;
            this.openIdConnect_IsDeactivated = _data["openIdConnect_IsDeactivated"];
            this.openIdConnect = _data["openIdConnect"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["openIdConnect"]) : <any>undefined;
            if (Array.isArray(_data["openIdConnectClaimsMapping"])) {
                this.openIdConnectClaimsMapping = [] as any;
                for (let item of _data["openIdConnectClaimsMapping"])
                    this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            this.wsFederation_IsDeactivated = _data["wsFederation_IsDeactivated"];
            this.wsFederation = _data["wsFederation"] ? WsFederationExternalLoginProviderSettings.fromJS(_data["wsFederation"]) : <any>undefined;
            if (Array.isArray(_data["wsFederationClaimsMapping"])) {
                this.wsFederationClaimsMapping = [] as any;
                for (let item of _data["wsFederationClaimsMapping"])
                    this.wsFederationClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebook_IsDeactivated"] = this.facebook_IsDeactivated;
        data["facebook"] = this.facebook ? this.facebook.toJSON() : <any>undefined;
        data["google_IsDeactivated"] = this.google_IsDeactivated;
        data["google"] = this.google ? this.google.toJSON() : <any>undefined;
        data["twitter_IsDeactivated"] = this.twitter_IsDeactivated;
        data["twitter"] = this.twitter ? this.twitter.toJSON() : <any>undefined;
        data["microsoft_IsDeactivated"] = this.microsoft_IsDeactivated;
        data["microsoft"] = this.microsoft ? this.microsoft.toJSON() : <any>undefined;
        data["openIdConnect_IsDeactivated"] = this.openIdConnect_IsDeactivated;
        data["openIdConnect"] = this.openIdConnect ? this.openIdConnect.toJSON() : <any>undefined;
        if (Array.isArray(this.openIdConnectClaimsMapping)) {
            data["openIdConnectClaimsMapping"] = [];
            for (let item of this.openIdConnectClaimsMapping)
                data["openIdConnectClaimsMapping"].push(item.toJSON());
        }
        data["wsFederation_IsDeactivated"] = this.wsFederation_IsDeactivated;
        data["wsFederation"] = this.wsFederation ? this.wsFederation.toJSON() : <any>undefined;
        if (Array.isArray(this.wsFederationClaimsMapping)) {
            data["wsFederationClaimsMapping"] = [];
            for (let item of this.wsFederationClaimsMapping)
                data["wsFederationClaimsMapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated: boolean;
    facebook: FacebookExternalLoginProviderSettings;
    google_IsDeactivated: boolean;
    google: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated: boolean;
    twitter: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated: boolean;
    microsoft: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated: boolean;
    openIdConnect: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
    wsFederation_IsDeactivated: boolean;
    wsFederation: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping: JsonClaimMapDto[] | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class ExternalLoginSettingsDto implements IExternalLoginSettingsDto {
    enabledSocialLoginSettings!: string[] | undefined;

    constructor(data?: IExternalLoginSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledSocialLoginSettings"])) {
                this.enabledSocialLoginSettings = [] as any;
                for (let item of _data["enabledSocialLoginSettings"])
                    this.enabledSocialLoginSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalLoginSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledSocialLoginSettings)) {
            data["enabledSocialLoginSettings"] = [];
            for (let item of this.enabledSocialLoginSettings)
                data["enabledSocialLoginSettings"].push(item);
        }
        return data;
    }
}

export interface IExternalLoginSettingsDto {
    enabledSocialLoginSettings: string[] | undefined;
}

export enum DestinationTypeDto {
    City = 0,
    Poi = 1,
    Destination = 2,
    Structure = 3,
}

export class DestinationDto implements IDestinationDto {
    description!: string | undefined;
    type!: DestinationTypeDto;
    value!: any | undefined;
    isoCountry!: string | undefined;
    fromCache!: boolean;

    constructor(data?: IDestinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.isoCountry = _data["isoCountry"];
            this.fromCache = _data["fromCache"];
        }
    }

    static fromJS(data: any): DestinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DestinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        data["value"] = this.value;
        data["isoCountry"] = this.isoCountry;
        data["fromCache"] = this.fromCache;
        return data;
    }
}

export interface IDestinationDto {
    description: string | undefined;
    type: DestinationTypeDto;
    value: any | undefined;
    isoCountry: string | undefined;
    fromCache: boolean;
}

export class AvailabilityStructureDetailRequestDto implements IAvailabilityStructureDetailRequestDto {
    structureId!: string | undefined;
    searchToken!: string | undefined;
    pricingInformationId!: string | undefined;
    workflowId!: string;
    checkinDate!: moment.Moment;
    checkoutDate!: moment.Moment;
    guestComposition!: GuestCompositionDto[] | undefined;
    guestIsoCountry!: string | undefined;
    readonly totalGuests!: number;
    readonly totalNights!: number;

    constructor(data?: IAvailabilityStructureDetailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.searchToken = _data["searchToken"];
            this.pricingInformationId = _data["pricingInformationId"];
            this.workflowId = _data["workflowId"];
            this.checkinDate = _data["checkinDate"] ? moment(_data["checkinDate"].toString()) : <any>undefined;
            this.checkoutDate = _data["checkoutDate"] ? moment(_data["checkoutDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["guestComposition"])) {
                this.guestComposition = [] as any;
                for (let item of _data["guestComposition"])
                    this.guestComposition!.push(GuestCompositionDto.fromJS(item));
            }
            this.guestIsoCountry = _data["guestIsoCountry"];
            (<any>this).totalGuests = _data["totalGuests"];
            (<any>this).totalNights = _data["totalNights"];
        }
    }

    static fromJS(data: any): AvailabilityStructureDetailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureDetailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["searchToken"] = this.searchToken;
        data["pricingInformationId"] = this.pricingInformationId;
        data["workflowId"] = this.workflowId;
        data["checkinDate"] = this.checkinDate ? this.checkinDate.toISOString() : <any>undefined;
        data["checkoutDate"] = this.checkoutDate ? this.checkoutDate.toISOString() : <any>undefined;
        if (Array.isArray(this.guestComposition)) {
            data["guestComposition"] = [];
            for (let item of this.guestComposition)
                data["guestComposition"].push(item.toJSON());
        }
        data["guestIsoCountry"] = this.guestIsoCountry;
        data["totalGuests"] = this.totalGuests;
        data["totalNights"] = this.totalNights;
        return data;
    }
}

export interface IAvailabilityStructureDetailRequestDto {
    structureId: string | undefined;
    searchToken: string | undefined;
    pricingInformationId: string | undefined;
    workflowId: string;
    checkinDate: moment.Moment;
    checkoutDate: moment.Moment;
    guestComposition: GuestCompositionDto[] | undefined;
    guestIsoCountry: string | undefined;
    totalGuests: number;
    totalNights: number;
}

export class StructureBaseDto implements IStructureBaseDto {
    id!: string | undefined;
    ts!: moment.Moment;
    name!: string | undefined;
    thumb!: string | undefined;
    category!: TagOfStringString;
    address!: Address;
    contacts!: TagOfStringString[] | undefined;
    position!: GeoJsonPointOfGeoJson2DGeographicCoordinates;
    locations!: TagOfStringString[] | undefined;
    userScore!: UserScoreDto;
    amenityIds!: number[] | undefined;
    type!: TagOfStringString;
    isoCountry!: string | undefined;
    slug!: string | undefined;
    highRate!: number;
    lowRate!: number;
    destinationId!: string | undefined;

    constructor(data?: IStructureBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.thumb = _data["thumb"];
            this.category = _data["category"] ? TagOfStringString.fromJS(_data["category"]) : <any>undefined;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(TagOfStringString.fromJS(item));
            }
            this.position = _data["position"] ? GeoJsonPointOfGeoJson2DGeographicCoordinates.fromJS(_data["position"]) : <any>undefined;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(TagOfStringString.fromJS(item));
            }
            this.userScore = _data["userScore"] ? UserScoreDto.fromJS(_data["userScore"]) : <any>undefined;
            if (Array.isArray(_data["amenityIds"])) {
                this.amenityIds = [] as any;
                for (let item of _data["amenityIds"])
                    this.amenityIds!.push(item);
            }
            this.type = _data["type"] ? TagOfStringString.fromJS(_data["type"]) : <any>undefined;
            this.isoCountry = _data["isoCountry"];
            this.slug = _data["slug"];
            this.highRate = _data["highRate"];
            this.lowRate = _data["lowRate"];
            this.destinationId = _data["destinationId"];
        }
    }

    static fromJS(data: any): StructureBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["thumb"] = this.thumb;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["userScore"] = this.userScore ? this.userScore.toJSON() : <any>undefined;
        if (Array.isArray(this.amenityIds)) {
            data["amenityIds"] = [];
            for (let item of this.amenityIds)
                data["amenityIds"].push(item);
        }
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["isoCountry"] = this.isoCountry;
        data["slug"] = this.slug;
        data["highRate"] = this.highRate;
        data["lowRate"] = this.lowRate;
        data["destinationId"] = this.destinationId;
        return data;
    }
}

export interface IStructureBaseDto {
    id: string | undefined;
    ts: moment.Moment;
    name: string | undefined;
    thumb: string | undefined;
    category: TagOfStringString;
    address: Address;
    contacts: TagOfStringString[] | undefined;
    position: GeoJsonPointOfGeoJson2DGeographicCoordinates;
    locations: TagOfStringString[] | undefined;
    userScore: UserScoreDto;
    amenityIds: number[] | undefined;
    type: TagOfStringString;
    isoCountry: string | undefined;
    slug: string | undefined;
    highRate: number;
    lowRate: number;
    destinationId: string | undefined;
}

export class RoomDto implements IRoomDto {
    sequence!: number;
    value!: string | undefined;
    roomCount!: number;
    treatmentAmount!: number;
    rateId!: string | undefined;
    roomCode!: string | undefined;

    constructor(data?: IRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequence = _data["sequence"];
            this.value = _data["value"];
            this.roomCount = _data["roomCount"];
            this.treatmentAmount = _data["treatmentAmount"];
            this.rateId = _data["rateId"];
            this.roomCode = _data["roomCode"];
        }
    }

    static fromJS(data: any): RoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        data["value"] = this.value;
        data["roomCount"] = this.roomCount;
        data["treatmentAmount"] = this.treatmentAmount;
        data["rateId"] = this.rateId;
        data["roomCode"] = this.roomCode;
        return data;
    }
}

export interface IRoomDto {
    sequence: number;
    value: string | undefined;
    roomCount: number;
    treatmentAmount: number;
    rateId: string | undefined;
    roomCode: string | undefined;
}

export class TreatmentDto implements ITreatmentDto {
    id!: string | undefined;
    code!: string | undefined;
    room!: RoomDto[] | undefined;
    amount!: number;
    currency!: string | undefined;
    isCancellable!: boolean;
    providerLink!: TagOfStringString;
    negotiatedRate: boolean;

    constructor(data?: ITreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            if (Array.isArray(_data["room"])) {
                this.room = [] as any;
                for (let item of _data["room"])
                    this.room!.push(RoomDto.fromJS(item));
            }
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.isCancellable = _data["isCancellable"];
            this.providerLink = _data["providerLink"] ? TagOfStringString.fromJS(_data["providerLink"]) : <any>undefined;
            this.negotiatedRate = _data["negotiatedRate"];
        }
    }

    static fromJS(data: any): TreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        if (Array.isArray(this.room)) {
            data["room"] = [];
            for (let item of this.room)
                data["room"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["isCancellable"] = this.isCancellable;
        data["providerLink"] = this.providerLink ? this.providerLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITreatmentDto {
    id: string | undefined;
    code: string | undefined;
    room: RoomDto[] | undefined;
    amount: number;
    currency: string | undefined;
    isCancellable: boolean | undefined;
    providerLink: TagOfStringString;
    negotiatedRate: boolean;
}

export class SearchAvailabilityDto implements ISearchAvailabilityDto {
    structure!: StructureBaseDto;
    distanceFromPoi!: number;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;
    pricingInformation!: TreatmentDto[] | undefined;
    readonly bestPrice!: number;
    negotiatedRate: boolean;

    constructor(data?: ISearchAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structure = _data["structure"] ? StructureBaseDto.fromJS(_data["structure"]) : <any>undefined;
            this.distanceFromPoi = _data["distanceFromPoi"];
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
            if (Array.isArray(_data["pricingInformation"])) {
                this.pricingInformation = [] as any;
                for (let item of _data["pricingInformation"])
                    this.pricingInformation!.push(TreatmentDto.fromJS(item));
            }
            (<any>this).bestPrice = _data["bestPrice"];
            this.negotiatedRate = _data["negotiatedRate"];
        }
    }

    static fromJS(data: any): SearchAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structure"] = this.structure ? this.structure.toJSON() : <any>undefined;
        data["distanceFromPoi"] = this.distanceFromPoi;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        if (Array.isArray(this.pricingInformation)) {
            data["pricingInformation"] = [];
            for (let item of this.pricingInformation)
                data["pricingInformation"].push(item.toJSON());
        }
        data["bestPrice"] = this.bestPrice;
        return data;
    }
}

export interface ISearchAvailabilityDto {
    structure: StructureBaseDto;
    distanceFromPoi: number;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
    pricingInformation: TreatmentDto[] | undefined;
    bestPrice: number;
    negotiatedRate: boolean;
}

export class SearchAvailabilityDetailGroupedDto implements ISearchAvailabilityDetailGroupedDto {
    request!: AvailabilityStructureDetailRequestDto;
    options!: OptionsDetailDto[] | undefined;

    constructor(data?: ISearchAvailabilityDetailGroupedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? AvailabilityStructureDetailRequestDto.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(OptionsDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchAvailabilityDetailGroupedDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAvailabilityDetailGroupedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchAvailabilityDetailGroupedDto {
    request: AvailabilityStructureDetailRequestDto;
    options: OptionsDetailDto[] | undefined;
}

export class AvailabilityCacheDetail implements IAvailabilityCacheDetail {
    data!: SearchAvailabilityDetailGroupedDto;
    requestDataMD5!: string | undefined;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: IAvailabilityCacheDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SearchAvailabilityDetailGroupedDto.fromJS(_data["data"]) : <any>undefined;
            this.requestDataMD5 = _data["requestDataMD5"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AvailabilityCacheDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCacheDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["requestDataMD5"] = this.requestDataMD5;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAvailabilityCacheDetail {
    data: SearchAvailabilityDetailGroupedDto;
    requestDataMD5: string | undefined;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class CancellationPolicyRoomDto implements ICancellationPolicyRoomDto {
    optionId!: string | undefined;
    seq!: number;
    productCode!: string | undefined;
    arrayOfCancelPenalties!: ArrayOfCancelPenaltiesDto;

    constructor(data?: ICancellationPolicyRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionId = _data["optionId"];
            this.seq = _data["seq"];
            this.productCode = _data["productCode"];
            this.arrayOfCancelPenalties = _data["arrayOfCancelPenalties"] ? ArrayOfCancelPenaltiesDto.fromJS(_data["arrayOfCancelPenalties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CancellationPolicyRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationPolicyRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionId"] = this.optionId;
        data["seq"] = this.seq;
        data["productCode"] = this.productCode;
        data["arrayOfCancelPenalties"] = this.arrayOfCancelPenalties ? this.arrayOfCancelPenalties.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICancellationPolicyRoomDto {
    optionId: string | undefined;
    seq: number;
    productCode: string | undefined;
    arrayOfCancelPenalties: ArrayOfCancelPenaltiesDto;
}

export class CancellationPolicyRoomsDto implements ICancellationPolicyRoomsDto {
    optionId!: string | undefined;
    cancellationPolicyRooms!: CancellationPolicyRoomDto[] | undefined;

    constructor(data?: ICancellationPolicyRoomsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionId = _data["optionId"];
            if (Array.isArray(_data["cancellationPolicyRooms"])) {
                this.cancellationPolicyRooms = [] as any;
                for (let item of _data["cancellationPolicyRooms"])
                    this.cancellationPolicyRooms!.push(CancellationPolicyRoomDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CancellationPolicyRoomsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationPolicyRoomsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionId"] = this.optionId;
        if (Array.isArray(this.cancellationPolicyRooms)) {
            data["cancellationPolicyRooms"] = [];
            for (let item of this.cancellationPolicyRooms)
                data["cancellationPolicyRooms"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICancellationPolicyRoomsDto {
    optionId: string | undefined;
    cancellationPolicyRooms: CancellationPolicyRoomDto[] | undefined;
}

export class AvailabilityStructureOrderDto implements IAvailabilityStructureOrderDto {
    price!: string | undefined;
    category!: string | undefined;
    score!: string | undefined;
    distance!: string | undefined;

    constructor(data?: IAvailabilityStructureOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.category = _data["category"];
            this.score = _data["score"];
            this.distance = _data["distance"];
        }
    }

    static fromJS(data: any): AvailabilityStructureOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["category"] = this.category;
        data["score"] = this.score;
        data["distance"] = this.distance;
        return data;
    }
}

export interface IAvailabilityStructureOrderDto {
    price: string | undefined;
    category: string | undefined;
    score: string | undefined;
    distance: string | undefined;
}

export class AvailabilityStructureScoreFilterItemDto implements IAvailabilityStructureScoreFilterItemDto {
    active!: boolean;
    min!: number;
    max!: number;
    count!: number;

    constructor(data?: IAvailabilityStructureScoreFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityStructureScoreFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureScoreFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["min"] = this.min;
        data["max"] = this.max;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityStructureScoreFilterItemDto {
    active: boolean;
    min: number;
    max: number;
    count: number;
}

export class AvailabilityStructureScoreFilterDto implements IAvailabilityStructureScoreFilterDto {
    poor!: AvailabilityStructureScoreFilterItemDto;
    fair!: AvailabilityStructureScoreFilterItemDto;
    good!: AvailabilityStructureScoreFilterItemDto;
    veryGood!: AvailabilityStructureScoreFilterItemDto;
    excellent!: AvailabilityStructureScoreFilterItemDto;

    constructor(data?: IAvailabilityStructureScoreFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poor = _data["poor"] ? AvailabilityStructureScoreFilterItemDto.fromJS(_data["poor"]) : <any>undefined;
            this.fair = _data["fair"] ? AvailabilityStructureScoreFilterItemDto.fromJS(_data["fair"]) : <any>undefined;
            this.good = _data["good"] ? AvailabilityStructureScoreFilterItemDto.fromJS(_data["good"]) : <any>undefined;
            this.veryGood = _data["veryGood"] ? AvailabilityStructureScoreFilterItemDto.fromJS(_data["veryGood"]) : <any>undefined;
            this.excellent = _data["excellent"] ? AvailabilityStructureScoreFilterItemDto.fromJS(_data["excellent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityStructureScoreFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureScoreFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poor"] = this.poor ? this.poor.toJSON() : <any>undefined;
        data["fair"] = this.fair ? this.fair.toJSON() : <any>undefined;
        data["good"] = this.good ? this.good.toJSON() : <any>undefined;
        data["veryGood"] = this.veryGood ? this.veryGood.toJSON() : <any>undefined;
        data["excellent"] = this.excellent ? this.excellent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityStructureScoreFilterDto {
    poor: AvailabilityStructureScoreFilterItemDto;
    fair: AvailabilityStructureScoreFilterItemDto;
    good: AvailabilityStructureScoreFilterItemDto;
    veryGood: AvailabilityStructureScoreFilterItemDto;
    excellent: AvailabilityStructureScoreFilterItemDto;
}

export class AvailabilityStructureCategoryFilterItemDto implements IAvailabilityStructureCategoryFilterItemDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityStructureCategoryFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityStructureCategoryFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureCategoryFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityStructureCategoryFilterItemDto {
    active: boolean;
    count: number;
}

export class AvailabilityStructureCategoryFilterDto implements IAvailabilityStructureCategoryFilterDto {
    one!: AvailabilityStructureCategoryFilterItemDto;
    two!: AvailabilityStructureCategoryFilterItemDto;
    three!: AvailabilityStructureCategoryFilterItemDto;
    four!: AvailabilityStructureCategoryFilterItemDto;
    five!: AvailabilityStructureCategoryFilterItemDto;

    constructor(data?: IAvailabilityStructureCategoryFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.one = _data["one"] ? AvailabilityStructureCategoryFilterItemDto.fromJS(_data["one"]) : <any>undefined;
            this.two = _data["two"] ? AvailabilityStructureCategoryFilterItemDto.fromJS(_data["two"]) : <any>undefined;
            this.three = _data["three"] ? AvailabilityStructureCategoryFilterItemDto.fromJS(_data["three"]) : <any>undefined;
            this.four = _data["four"] ? AvailabilityStructureCategoryFilterItemDto.fromJS(_data["four"]) : <any>undefined;
            this.five = _data["five"] ? AvailabilityStructureCategoryFilterItemDto.fromJS(_data["five"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityStructureCategoryFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureCategoryFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["one"] = this.one ? this.one.toJSON() : <any>undefined;
        data["two"] = this.two ? this.two.toJSON() : <any>undefined;
        data["three"] = this.three ? this.three.toJSON() : <any>undefined;
        data["four"] = this.four ? this.four.toJSON() : <any>undefined;
        data["five"] = this.five ? this.five.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityStructureCategoryFilterDto {
    one: AvailabilityStructureCategoryFilterItemDto;
    two: AvailabilityStructureCategoryFilterItemDto;
    three: AvailabilityStructureCategoryFilterItemDto;
    four: AvailabilityStructureCategoryFilterItemDto;
    five: AvailabilityStructureCategoryFilterItemDto;
}

export class AvailabilityStructurePriceFilterDto implements IAvailabilityStructurePriceFilterDto {
    active!: boolean;
    start!: number;
    end!: number;
    min!: number | undefined;
    max!: number | undefined;
    count!: number;

    constructor(data?: IAvailabilityStructurePriceFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.start = _data["start"];
            this.end = _data["end"];
            this.min = _data["min"];
            this.max = _data["max"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityStructurePriceFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructurePriceFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["start"] = this.start;
        data["end"] = this.end;
        data["min"] = this.min;
        data["max"] = this.max;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityStructurePriceFilterDto {
    active: boolean;
    start: number;
    end: number;
    min: number | undefined;
    max: number | undefined;
    count: number;
}

export class AvailabilityStructureNameFilterDto implements IAvailabilityStructureNameFilterDto {
    name!: string | undefined;
    active!: boolean;
    resultNotFound!: boolean;

    constructor(data?: IAvailabilityStructureNameFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.active = _data["active"];
            this.resultNotFound = _data["resultNotFound"];
        }
    }

    static fromJS(data: any): AvailabilityStructureNameFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureNameFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["active"] = this.active;
        data["resultNotFound"] = this.resultNotFound;
        return data;
    }
}

export interface IAvailabilityStructureNameFilterDto {
    name: string | undefined;
    active: boolean;
    resultNotFound: boolean;
}

export class AvailabilityStructureDistanceFilterDto implements IAvailabilityStructureDistanceFilterDto {
    active!: boolean;
    max!: number | undefined;
    count!: number;

    constructor(data?: IAvailabilityStructureDistanceFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.max = _data["max"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityStructureDistanceFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureDistanceFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["max"] = this.max;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityStructureDistanceFilterDto {
    active: boolean;
    max: number | undefined;
    count: number;
}

export class AvailabilityStructureAmenityFilterItemDto implements IAvailabilityStructureAmenityFilterItemDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityStructureAmenityFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityStructureAmenityFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureAmenityFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityStructureAmenityFilterItemDto {
    active: boolean;
    count: number;
}

export class AvailabilityStructureAmenityFilterDto implements IAvailabilityStructureAmenityFilterDto {
    wifi!: AvailabilityStructureAmenityFilterItemDto;
    spa!: AvailabilityStructureAmenityFilterItemDto;
    parking!: AvailabilityStructureAmenityFilterItemDto;
    pool!: AvailabilityStructureAmenityFilterItemDto;
    wch!: AvailabilityStructureAmenityFilterItemDto;

    constructor(data?: IAvailabilityStructureAmenityFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wifi = _data["wifi"] ? AvailabilityStructureAmenityFilterItemDto.fromJS(_data["wifi"]) : <any>undefined;
            this.spa = _data["spa"] ? AvailabilityStructureAmenityFilterItemDto.fromJS(_data["spa"]) : <any>undefined;
            this.parking = _data["parking"] ? AvailabilityStructureAmenityFilterItemDto.fromJS(_data["parking"]) : <any>undefined;
            this.pool = _data["pool"] ? AvailabilityStructureAmenityFilterItemDto.fromJS(_data["pool"]) : <any>undefined;
            this.wch = _data["wch"] ? AvailabilityStructureAmenityFilterItemDto.fromJS(_data["wch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityStructureAmenityFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureAmenityFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wifi"] = this.wifi ? this.wifi.toJSON() : <any>undefined;
        data["spa"] = this.spa ? this.spa.toJSON() : <any>undefined;
        data["parking"] = this.parking ? this.parking.toJSON() : <any>undefined;
        data["pool"] = this.pool ? this.pool.toJSON() : <any>undefined;
        data["wch"] = this.wch ? this.wch.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityStructureAmenityFilterDto {
    wifi: AvailabilityStructureAmenityFilterItemDto;
    spa: AvailabilityStructureAmenityFilterItemDto;
    parking: AvailabilityStructureAmenityFilterItemDto;
    pool: AvailabilityStructureAmenityFilterItemDto;
    wch: AvailabilityStructureAmenityFilterItemDto;
}

export class AvailabilityStructureTypeFilterItemDto implements IAvailabilityStructureTypeFilterItemDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityStructureTypeFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityStructureTypeFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureTypeFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityStructureTypeFilterItemDto {
    active: boolean;
    count: number;
}

export class AvailabilityStructureTypeFilterDto implements IAvailabilityStructureTypeFilterDto {
    apartHotel!: AvailabilityStructureTypeFilterItemDto;
    bedAndBreakfast!: AvailabilityStructureTypeFilterItemDto;
    holidayHouse!: AvailabilityStructureTypeFilterItemDto;
    hotel!: AvailabilityStructureTypeFilterItemDto;
    hostel!: AvailabilityStructureTypeFilterItemDto;
    guestHouse!: AvailabilityStructureTypeFilterItemDto;

    constructor(data?: IAvailabilityStructureTypeFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apartHotel = _data["apartHotel"] ? AvailabilityStructureTypeFilterItemDto.fromJS(_data["apartHotel"]) : <any>undefined;
            this.bedAndBreakfast = _data["bedAndBreakfast"] ? AvailabilityStructureTypeFilterItemDto.fromJS(_data["bedAndBreakfast"]) : <any>undefined;
            this.holidayHouse = _data["holidayHouse"] ? AvailabilityStructureTypeFilterItemDto.fromJS(_data["holidayHouse"]) : <any>undefined;
            this.hotel = _data["hotel"] ? AvailabilityStructureTypeFilterItemDto.fromJS(_data["hotel"]) : <any>undefined;
            this.hostel = _data["hostel"] ? AvailabilityStructureTypeFilterItemDto.fromJS(_data["hostel"]) : <any>undefined;
            this.guestHouse = _data["guestHouse"] ? AvailabilityStructureTypeFilterItemDto.fromJS(_data["guestHouse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityStructureTypeFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureTypeFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apartHotel"] = this.apartHotel ? this.apartHotel.toJSON() : <any>undefined;
        data["bedAndBreakfast"] = this.bedAndBreakfast ? this.bedAndBreakfast.toJSON() : <any>undefined;
        data["holidayHouse"] = this.holidayHouse ? this.holidayHouse.toJSON() : <any>undefined;
        data["hotel"] = this.hotel ? this.hotel.toJSON() : <any>undefined;
        data["hostel"] = this.hostel ? this.hostel.toJSON() : <any>undefined;
        data["guestHouse"] = this.guestHouse ? this.guestHouse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityStructureTypeFilterDto {
    apartHotel: AvailabilityStructureTypeFilterItemDto;
    bedAndBreakfast: AvailabilityStructureTypeFilterItemDto;
    holidayHouse: AvailabilityStructureTypeFilterItemDto;
    hotel: AvailabilityStructureTypeFilterItemDto;
    hostel: AvailabilityStructureTypeFilterItemDto;
    guestHouse: AvailabilityStructureTypeFilterItemDto;
}

export class AvailabilityHotelOnlyInPolicyFilterDto implements IAvailabilityHotelOnlyInPolicyFilterDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityHotelOnlyInPolicyFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityHotelOnlyInPolicyFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityHotelOnlyInPolicyFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityHotelOnlyInPolicyFilterDto {
    active: boolean;
    count: number;
}

export class AvailabilityHotelNegotiatedRateFilterDto implements IAvailabilityHotelNegotiatedRateFilterDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityHotelNegotiatedRateFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityHotelNegotiatedRateFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityHotelNegotiatedRateFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityHotelNegotiatedRateFilterDto {
    active: boolean;
    count: number;
}

export class AvailabilityRoomCancellableFilterDto implements IAvailabilityRoomCancellableFilterDto {
    active!: boolean;
    count!: number;

    constructor(data?: IAvailabilityRoomCancellableFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): AvailabilityRoomCancellableFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityRoomCancellableFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["count"] = this.count;
        return data;
    }
}

export interface IAvailabilityRoomCancellableFilterDto {
    active: boolean;
    count: number;
}

export class AvailabilityStructureFilterDto implements IAvailabilityStructureFilterDto {
    score!: AvailabilityStructureScoreFilterDto;
    category!: AvailabilityStructureCategoryFilterDto;
    price!: AvailabilityStructurePriceFilterDto;
    structure!: AvailabilityStructureNameFilterDto;
    distance!: AvailabilityStructureDistanceFilterDto;
    amenity!: AvailabilityStructureAmenityFilterDto;
    type!: AvailabilityStructureTypeFilterDto;
    onlyInPolicy!: AvailabilityHotelOnlyInPolicyFilterDto;
    cancellable!: AvailabilityRoomCancellableFilterDto;
    negotiatedRate!: AvailabilityHotelNegotiatedRateFilterDto;

    constructor(data?: IAvailabilityStructureFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"] ? AvailabilityStructureScoreFilterDto.fromJS(_data["score"]) : <any>undefined;
            this.category = _data["category"] ? AvailabilityStructureCategoryFilterDto.fromJS(_data["category"]) : <any>undefined;
            this.price = _data["price"] ? AvailabilityStructurePriceFilterDto.fromJS(_data["price"]) : <any>undefined;
            this.structure = _data["structure"] ? AvailabilityStructureNameFilterDto.fromJS(_data["structure"]) : <any>undefined;
            this.distance = _data["distance"] ? AvailabilityStructureDistanceFilterDto.fromJS(_data["distance"]) : <any>undefined;
            this.amenity = _data["amenity"] ? AvailabilityStructureAmenityFilterDto.fromJS(_data["amenity"]) : <any>undefined;
            this.type = _data["type"] ? AvailabilityStructureTypeFilterDto.fromJS(_data["type"]) : <any>undefined;
            this.onlyInPolicy = _data["onlyInPolicy"] ? AvailabilityHotelOnlyInPolicyFilterDto.fromJS(_data["onlyInPolicy"]) : <any>undefined;
            this.cancellable = _data["cancellable"] ? AvailabilityRoomCancellableFilterDto.fromJS(_data["cancellable"]) : <any>undefined;
            this.negotiatedRate = _data["negotiatedRate"] ? AvailabilityHotelNegotiatedRateFilterDto.fromJS(_data["negotiatedRate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AvailabilityStructureFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructureFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score ? this.score.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["structure"] = this.structure ? this.structure.toJSON() : <any>undefined;
        data["distance"] = this.distance ? this.distance.toJSON() : <any>undefined;
        data["amenity"] = this.amenity ? this.amenity.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["onlyInPolicy"] = this.onlyInPolicy ? this.onlyInPolicy.toJSON() : <any>undefined;
        data["cancellable"] = this.cancellable ? this.cancellable.toJSON() : <any>undefined;
        data["negotiatedRate"] = this.negotiatedRate ? this.negotiatedRate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAvailabilityStructureFilterDto {
    score: AvailabilityStructureScoreFilterDto;
    category: AvailabilityStructureCategoryFilterDto;
    price: AvailabilityStructurePriceFilterDto;
    structure: AvailabilityStructureNameFilterDto;
    distance: AvailabilityStructureDistanceFilterDto;
    amenity: AvailabilityStructureAmenityFilterDto;
    type: AvailabilityStructureTypeFilterDto;
    onlyInPolicy: AvailabilityHotelOnlyInPolicyFilterDto;
    cancellable: AvailabilityRoomCancellableFilterDto;
    negotiatedRate: AvailabilityHotelNegotiatedRateFilterDto;
}

export class AvailabilityStructuresRequestDto implements IAvailabilityStructuresRequestDto {
    destination!: string | undefined;
    destinationInCache!: boolean;
    destinationIds!: string[] | undefined;
    structureId!: string | undefined;
    structureName!: string | undefined;
    latitude!: number;
    longitude!: number;
    ray!: number;
    order!: AvailabilityStructureOrderDto;
    filter!: AvailabilityStructureFilterDto;
    workflowId!: string;
    checkinDate!: moment.Moment;
    checkoutDate!: moment.Moment;
    guestComposition!: GuestCompositionDto[] | undefined;
    guestIsoCountry!: string | undefined;
    readonly totalGuests!: number;
    readonly totalNights!: number;
    co2Data!: Co2DataDTO | undefined

    constructor(data?: IAvailabilityStructuresRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destination = _data["destination"];
            this.destinationInCache = _data["destinationInCache"];
            if (Array.isArray(_data["destinationIds"])) {
                this.destinationIds = [] as any;
                for (let item of _data["destinationIds"])
                    this.destinationIds!.push(item);
            }
            this.structureId = _data["structureId"];
            this.structureName = _data["structureName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.ray = _data["ray"];
            this.order = _data["order"] ? AvailabilityStructureOrderDto.fromJS(_data["order"]) : <any>undefined;
            this.filter = _data["filter"] ? AvailabilityStructureFilterDto.fromJS(_data["filter"]) : <any>undefined;
            this.workflowId = _data["workflowId"];
            this.checkinDate = _data["checkinDate"] ? moment(_data["checkinDate"].toString()) : <any>undefined;
            this.checkoutDate = _data["checkoutDate"] ? moment(_data["checkoutDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["guestComposition"])) {
                this.guestComposition = [] as any;
                for (let item of _data["guestComposition"])
                    this.guestComposition!.push(GuestCompositionDto.fromJS(item));
            }
            this.guestIsoCountry = _data["guestIsoCountry"];
            (<any>this).totalGuests = _data["totalGuests"];
            (<any>this).totalNights = _data["totalNights"];
            this.co2Data = _data["co2Data"];
       }
    }

    static fromJS(data: any): AvailabilityStructuresRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructuresRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destination"] = this.destination;
        data["destinationInCache"] = this.destinationInCache;
        if (Array.isArray(this.destinationIds)) {
            data["destinationIds"] = [];
            for (let item of this.destinationIds)
                data["destinationIds"].push(item);
        }
        data["structureId"] = this.structureId;
        data["structureName"] = this.structureName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["ray"] = this.ray;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["workflowId"] = this.workflowId;
        data["checkinDate"] = this.checkinDate ? this.checkinDate.toISOString() : <any>undefined;
        data["checkoutDate"] = this.checkoutDate ? this.checkoutDate.toISOString() : <any>undefined;
        if (Array.isArray(this.guestComposition)) {
            data["guestComposition"] = [];
            for (let item of this.guestComposition)
                data["guestComposition"].push(item.toJSON());
        }
        data["guestIsoCountry"] = this.guestIsoCountry;
        data["totalGuests"] = this.totalGuests;
        data["totalNights"] = this.totalNights;
        data["co2Data"] = this.co2Data;
        return data;
    }
}

export interface IAvailabilityStructuresRequestDto {
    destination: string | undefined;
    destinationInCache: boolean;
    destinationIds: string[] | undefined;
    structureId: string | undefined;
    structureName: string | undefined;
    latitude: number;
    longitude: number;
    ray: number;
    order: AvailabilityStructureOrderDto;
    filter: AvailabilityStructureFilterDto;
    workflowId: string;
    checkinDate: moment.Moment;
    checkoutDate: moment.Moment;
    guestComposition: GuestCompositionDto[] | undefined;
    guestIsoCountry: string | undefined;
    totalGuests: number;
    totalNights: number;
}

export class ProviderStatusDto implements IProviderStatusDto {
    name!: string | undefined;
    token!: string | undefined;
    completed!: boolean;

    constructor(data?: IProviderStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.token = _data["token"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): ProviderStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["token"] = this.token;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IProviderStatusDto {
    name: string | undefined;
    token: string | undefined;
    completed: boolean;
}

export class AvailabilityCache implements IAvailabilityCache {
    workflowId!: string;
    requestData!: AvailabilityStructuresRequestDto;
    data!: SearchAvailabilityDto[] | undefined;
    structureData!: SearchAvailabilityDto;
    dataLength!: number;
    providers!: ProviderStatusDto[] | undefined;
    completed!: boolean;
    requestDataMD5!: string | undefined;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: IAvailabilityCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowId = _data["workflowId"];
            this.requestData = _data["requestData"] ? AvailabilityStructuresRequestDto.fromJS(_data["requestData"]) : <any>undefined;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SearchAvailabilityDto.fromJS(item));
            }
            this.structureData = _data["structureData"] ? SearchAvailabilityDto.fromJS(_data["structureData"]) : <any>undefined;
            this.dataLength = _data["dataLength"];
            if (Array.isArray(_data["providers"])) {
                this.providers = [] as any;
                for (let item of _data["providers"])
                    this.providers!.push(ProviderStatusDto.fromJS(item));
            }
            this.completed = _data["completed"];
            this.requestDataMD5 = _data["requestDataMD5"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AvailabilityCache {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowId"] = this.workflowId;
        data["requestData"] = this.requestData ? this.requestData.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["structureData"] = this.structureData ? this.structureData.toJSON() : <any>undefined;
        data["dataLength"] = this.dataLength;
        if (Array.isArray(this.providers)) {
            data["providers"] = [];
            for (let item of this.providers)
                data["providers"].push(item.toJSON());
        }
        data["completed"] = this.completed;
        data["requestDataMD5"] = this.requestDataMD5;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAvailabilityCache {
    workflowId: string;
    requestData: AvailabilityStructuresRequestDto;
    data: SearchAvailabilityDto[] | undefined;
    structureData: SearchAvailabilityDto;
    dataLength: number;
    providers: ProviderStatusDto[] | undefined;
    completed: boolean;
    requestDataMD5: string | undefined;
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class AvailabilityStructuresPagedRequestDto implements IAvailabilityStructuresPagedRequestDto {
    skipCount!: number;
    maxResultCount!: number;
    destination!: string | undefined;
    destinationInCache!: boolean;
    destinationIds!: string[] | undefined;
    structureId!: string | undefined;
    structureName!: string | undefined;
    latitude!: number;
    longitude!: number;
    ray!: number;
    order!: AvailabilityStructureOrderDto;
    filter!: AvailabilityStructureFilterDto;
    workflowId!: string;
    checkinDate!: moment.Moment;
    checkoutDate!: moment.Moment;
    guestComposition!: GuestCompositionDto[] | undefined;
    guestIsoCountry!: string | undefined;
    readonly totalGuests!: number;
    readonly totalNights!: number;

    constructor(data?: IAvailabilityStructuresPagedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
            this.destination = _data["destination"];
            this.destinationInCache = _data["destinationInCache"];
            if (Array.isArray(_data["destinationIds"])) {
                this.destinationIds = [] as any;
                for (let item of _data["destinationIds"])
                    this.destinationIds!.push(item);
            }
            this.structureId = _data["structureId"];
            this.structureName = _data["structureName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.ray = _data["ray"];
            this.order = _data["order"] ? AvailabilityStructureOrderDto.fromJS(_data["order"]) : <any>undefined;
            this.filter = _data["filter"] ? AvailabilityStructureFilterDto.fromJS(_data["filter"]) : <any>undefined;
            this.workflowId = _data["workflowId"];
            this.checkinDate = _data["checkinDate"] ? moment(_data["checkinDate"].toString()) : <any>undefined;
            this.checkoutDate = _data["checkoutDate"] ? moment(_data["checkoutDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["guestComposition"])) {
                this.guestComposition = [] as any;
                for (let item of _data["guestComposition"])
                    this.guestComposition!.push(GuestCompositionDto.fromJS(item));
            }
            this.guestIsoCountry = _data["guestIsoCountry"];
            (<any>this).totalGuests = _data["totalGuests"];
            (<any>this).totalNights = _data["totalNights"];
        }
    }

    static fromJS(data: any): AvailabilityStructuresPagedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityStructuresPagedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        data["destination"] = this.destination;
        data["destinationInCache"] = this.destinationInCache;
        if (Array.isArray(this.destinationIds)) {
            data["destinationIds"] = [];
            for (let item of this.destinationIds)
                data["destinationIds"].push(item);
        }
        data["structureId"] = this.structureId;
        data["structureName"] = this.structureName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["ray"] = this.ray;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["workflowId"] = this.workflowId;
        data["checkinDate"] = this.checkinDate ? this.checkinDate.toISOString() : <any>undefined;
        data["checkoutDate"] = this.checkoutDate ? this.checkoutDate.toISOString() : <any>undefined;
        if (Array.isArray(this.guestComposition)) {
            data["guestComposition"] = [];
            for (let item of this.guestComposition)
                data["guestComposition"].push(item.toJSON());
        }
        data["guestIsoCountry"] = this.guestIsoCountry;
        data["totalGuests"] = this.totalGuests;
        data["totalNights"] = this.totalNights;
        return data;
    }
}

export interface IAvailabilityStructuresPagedRequestDto {
    skipCount: number;
    maxResultCount: number;
    destination: string | undefined;
    destinationInCache: boolean;
    destinationIds: string[] | undefined;
    structureId: string | undefined;
    structureName: string | undefined;
    latitude: number;
    longitude: number;
    ray: number;
    order: AvailabilityStructureOrderDto;
    filter: AvailabilityStructureFilterDto;
    workflowId: string;
    checkinDate: moment.Moment;
    checkoutDate: moment.Moment;
    guestComposition: GuestCompositionDto[] | undefined;
    guestIsoCountry: string | undefined;
    totalGuests: number;
    totalNights: number;
}

export class PagedResultDtoOfSearchAvailabilityDto implements IPagedResultDtoOfSearchAvailabilityDto {
    totalCount!: number;
    items!: SearchAvailabilityDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSearchAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchAvailabilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSearchAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSearchAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSearchAvailabilityDto {
    totalCount: number;
    items: SearchAvailabilityDto[] | undefined;
}

export class PaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto implements IPaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto {
    request!: AvailabilityStructuresRequestDto;
    response!: PagedResultDtoOfSearchAvailabilityDto;

    constructor(data?: IPaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? AvailabilityStructuresRequestDto.fromJS(_data["request"]) : <any>undefined;
            this.response = _data["response"] ? PagedResultDtoOfSearchAvailabilityDto.fromJS(_data["response"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaginationOfAvailabilityStructuresRequestDtoSearchAvailabilityDto {
    request: AvailabilityStructuresRequestDto;
    response: PagedResultDtoOfSearchAvailabilityDto;
}

export class StructureMarkerDto implements IStructureMarkerDto {
    id!: string | undefined;
    name!: string | undefined;
    thumb!: string | undefined;
    category!: string | undefined;
    longitude!: number;
    latitude!: number;
    amount!: number;
    pricingInformationId!: string | undefined;
    isoCountry!: string | undefined;
    slug!: string | undefined;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;

    constructor(data?: IStructureMarkerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.thumb = _data["thumb"];
            this.category = _data["category"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.amount = _data["amount"];
            this.pricingInformationId = _data["pricingInformationId"];
            this.isoCountry = _data["isoCountry"];
            this.slug = _data["slug"];
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
        }
    }

    static fromJS(data: any): StructureMarkerDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureMarkerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["thumb"] = this.thumb;
        data["category"] = this.category;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["amount"] = this.amount;
        data["pricingInformationId"] = this.pricingInformationId;
        data["isoCountry"] = this.isoCountry;
        data["slug"] = this.slug;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        return data;
    }
}

export interface IStructureMarkerDto {
    id: string | undefined;
    name: string | undefined;
    thumb: string | undefined;
    category: string | undefined;
    longitude: number;
    latitude: number;
    amount: number;
    pricingInformationId: string | undefined;
    isoCountry: string | undefined;
    slug: string | undefined;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
}

export class SearchAvailabilityStructureDetailDto implements ISearchAvailabilityStructureDetailDto {
    request!: AvailabilityStructureDetailRequestDto;
    structure!: StructureDto;

    constructor(data?: ISearchAvailabilityStructureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? AvailabilityStructureDetailRequestDto.fromJS(_data["request"]) : <any>undefined;
            this.structure = _data["structure"] ? StructureDto.fromJS(_data["structure"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchAvailabilityStructureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchAvailabilityStructureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["structure"] = this.structure ? this.structure.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchAvailabilityStructureDetailDto {
    request: AvailabilityStructureDetailRequestDto;
    structure: StructureDto;
}

export class HotelBookResponseDto implements IHotelBookResponseDto {
    structure!: StructureBaseDto;
    paymentGateways!: PaymentGatewayDto[] | undefined;
    paymentProfiles!: ListResultDtoOfPaymentDataProfileDto;
    enableFopExtraPaymentProfile!: boolean;
    bookingConfirmationTypes!: HotelBookingConfirmationTypeDto[] | undefined;
    searchToken!: string | undefined;
    workflowId!: string;
    structureId!: string | undefined;
    checkIn!: moment.Moment;
    checkOut!: moment.Moment;
    rooms!: BuyStructureRoomRequestDto[] | undefined;
    quotation!: QuotationDto;
    discountCode!: string | undefined;
    inPolicy!: boolean | undefined;
    policyViolationDescription!: string | undefined;
    readonly isInPenalty!: boolean;
    paymentProfile!: PaymentDataProfileDto;
    paymentGateway!: PaymentGatewayDto;
    bookingConfirmationType!: HotelBookingConfirmationTypeDto;
    user!: ApplicationUserDto;
    remarks!: string | undefined;

    constructor(data?: IHotelBookResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structure = _data["structure"] ? StructureBaseDto.fromJS(_data["structure"]) : <any>undefined;
            if (Array.isArray(_data["paymentGateways"])) {
                this.paymentGateways = [] as any;
                for (let item of _data["paymentGateways"])
                    this.paymentGateways!.push(item);
            }
            this.paymentProfiles = _data["paymentProfiles"] ? ListResultDtoOfPaymentDataProfileDto.fromJS(_data["paymentProfiles"]) : <any>undefined;
            this.enableFopExtraPaymentProfile = _data["enableFopExtraPaymentProfile"];
            if (Array.isArray(_data["bookingConfirmationTypes"])) {
                this.bookingConfirmationTypes = [] as any;
                for (let item of _data["bookingConfirmationTypes"])
                    this.bookingConfirmationTypes!.push(item);
            }
            this.searchToken = _data["searchToken"];
            this.workflowId = _data["workflowId"];
            this.structureId = _data["structureId"];
            this.checkIn = _data["checkIn"] ? moment(_data["checkIn"].toString()) : <any>undefined;
            this.checkOut = _data["checkOut"] ? moment(_data["checkOut"].toString()) : <any>undefined;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(BuyStructureRoomRequestDto.fromJS(item));
            }
            this.quotation = _data["quotation"] ? QuotationDto.fromJS(_data["quotation"]) : <any>undefined;
            this.discountCode = _data["discountCode"];
            this.inPolicy = _data["inPolicy"];
            this.policyViolationDescription = _data["policyViolationDescription"];
            (<any>this).isInPenalty = _data["isInPenalty"];
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
            this.paymentGateway = _data["paymentGateway"];
            this.bookingConfirmationType = _data["bookingConfirmationType"];
            this.user = _data["user"] ? ApplicationUserDto.fromJS(_data["user"]) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): HotelBookResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotelBookResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structure"] = this.structure ? this.structure.toJSON() : <any>undefined;
        if (Array.isArray(this.paymentGateways)) {
            data["paymentGateways"] = [];
            for (let item of this.paymentGateways)
                data["paymentGateways"].push(item);
        }
        data["paymentProfiles"] = this.paymentProfiles ? this.paymentProfiles.toJSON() : <any>undefined;
        data["enableFopExtraPaymentProfile"] = this.enableFopExtraPaymentProfile;
        if (Array.isArray(this.bookingConfirmationTypes)) {
            data["bookingConfirmationTypes"] = [];
            for (let item of this.bookingConfirmationTypes)
                data["bookingConfirmationTypes"].push(item);
        }
        data["searchToken"] = this.searchToken;
        data["workflowId"] = this.workflowId;
        data["structureId"] = this.structureId;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : <any>undefined;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : <any>undefined;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["quotation"] = this.quotation ? this.quotation.toJSON() : <any>undefined;
        data["discountCode"] = this.discountCode;
        data["inPolicy"] = this.inPolicy;
        data["policyViolationDescription"] = this.policyViolationDescription;
        data["isInPenalty"] = this.isInPenalty;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        data["paymentGateway"] = this.paymentGateway;
        data["bookingConfirmationType"] = this.bookingConfirmationType;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IHotelBookResponseDto {
    structure: StructureBaseDto;
    paymentGateways: PaymentGatewayDto[] | undefined;
    paymentProfiles: ListResultDtoOfPaymentDataProfileDto;
    enableFopExtraPaymentProfile: boolean;
    bookingConfirmationTypes: HotelBookingConfirmationTypeDto[] | undefined;
    searchToken: string | undefined;
    workflowId: string;
    structureId: string | undefined;
    checkIn: moment.Moment;
    checkOut: moment.Moment;
    rooms: BuyStructureRoomRequestDto[] | undefined;
    quotation: QuotationDto;
    discountCode: string | undefined;
    inPolicy: boolean | undefined;
    policyViolationDescription: string | undefined;
    isInPenalty: boolean;
    paymentProfile: PaymentDataProfileDto;
    paymentGateway: PaymentGatewayDto;
    bookingConfirmationType: HotelBookingConfirmationTypeDto;
    user: ApplicationUserDto;
    remarks: string | undefined;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.adminPassword = _data["adminPassword"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverUrl = _data["serverUrl"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : <any>undefined;
            this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverSiteUrl = _data["serverSiteUrl"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: moment.Moment;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? moment(_data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = _data["tenantLegalName"];
            if (Array.isArray(_data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of _data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = _data["tenantTaxNo"];
            this.hostLegalName = _data["hostLegalName"];
            if (Array.isArray(_data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of _data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: moment.Moment;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data["defaultLanguageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityType!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: moment.Moment;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class OrganizationUnitSimpleDto implements IOrganizationUnitSimpleDto {
    id!: number;
    codeUnit!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: IOrganizationUnitSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codeUnit = _data["codeUnit"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationUnitSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codeUnit"] = this.codeUnit;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IOrganizationUnitSimpleDto {
    id: number;
    codeUnit: string | undefined;
    displayName: string | undefined;
}

export class AjaxResponseOfListResultDtoOfOrganizationUnitDto implements IAjaxResponseOfListResultDtoOfOrganizationUnitDto {
    result!: ListResultDtoOfOrganizationUnitDto;
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;

    constructor(data?: IAjaxResponseOfListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ListResultDtoOfOrganizationUnitDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IAjaxResponseOfListResultDtoOfOrganizationUnitDto {
    result: ListResultDtoOfOrganizationUnitDto;
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: moment.Moment;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.addedTime = _data["addedTime"] ? moment(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: moment.Moment;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? moment(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    creationTime!: moment.Moment;
    agencyId!: string;
    agencyName!: string | undefined;
    lastLoginTime!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.agencyId = _data["agencyId"];
            this.agencyName = _data["agencyName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["agencyId"] = this.agencyId;
        data["agencyName"] = this.agencyName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    agencyId: string;
    agencyName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    id: number;
}

export class CreateOrUpdateOrganizationUnitInput implements ICreateOrUpdateOrganizationUnitInput {
    id!: number;
    parentId!: number | undefined;
    codeUnit!: string | undefined;
    siapClientId!: string | undefined;
    displayName!: string | undefined;
    typeId!: number | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    requirePreAuthorization!: boolean;
    preAuthorizerGroupId!: string | undefined;
    requireAuthorization!: boolean;
    authorizerGroupId!: string | undefined;
    authorizerGroup!: UserListDto[] | undefined;
    travelPolicyPassengers!: boolean;
    requireBudgetAuthorization!: boolean;
    budgetAuthorizerGroupId!: string | undefined;
    budgetAuthorizerGroup!: UserListDto[] | undefined;
    requirePostAuthorization!: boolean;
    postAuthorizerGroupId!: string | undefined;

    constructor(data?: ICreateOrUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.codeUnit = _data["codeUnit"];
            this.siapClientId = _data["siapClientId"];
            this.displayName = _data["displayName"];
            this.typeId = _data["typeId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.requirePreAuthorization = _data["requirePreAuthorization"];
            this.preAuthorizerGroupId = _data["preAuthorizerGroupId"];
            this.requireAuthorization = _data["requireAuthorization"];
            this.authorizerGroupId = _data["authorizerGroupId"];
            if (Array.isArray(_data["authorizerGroup"])) {
                this.authorizerGroup = [] as any;
                for (let item of _data["authorizerGroup"])
                    this.authorizerGroup!.push(UserListDto.fromJS(item));
            }
            this.travelPolicyPassengers = _data["travelPolicyPassengers"];
            this.requireBudgetAuthorization = _data["requireBudgetAuthorization"];
            this.budgetAuthorizerGroupId = _data["budgetAuthorizerGroupId"];
            if (Array.isArray(_data["budgetAuthorizerGroup"])) {
                this.budgetAuthorizerGroup = [] as any;
                for (let item of _data["budgetAuthorizerGroup"])
                    this.budgetAuthorizerGroup!.push(UserListDto.fromJS(item));
            }
            this.requirePostAuthorization = _data["requirePostAuthorization"];
            this.postAuthorizerGroupId = _data["postAuthorizerGroupId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["codeUnit"] = this.codeUnit;
        data["siapClientId"] = this.siapClientId;
        data["displayName"] = this.displayName;
        data["typeId"] = this.typeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["requirePreAuthorization"] = this.requirePreAuthorization;
        data["preAuthorizerGroupId"] = this.preAuthorizerGroupId;
        data["requireAuthorization"] = this.requireAuthorization;
        data["authorizerGroupId"] = this.authorizerGroupId;
        if (Array.isArray(this.authorizerGroup)) {
            data["authorizerGroup"] = [];
            for (let item of this.authorizerGroup)
                data["authorizerGroup"].push(item.toJSON());
        }
        data["travelPolicyPassengers"] = this.travelPolicyPassengers;
        data["requireBudgetAuthorization"] = this.requireBudgetAuthorization;
        data["budgetAuthorizerGroupId"] = this.budgetAuthorizerGroupId;
        if (Array.isArray(this.budgetAuthorizerGroup)) {
            data["budgetAuthorizerGroup"] = [];
            for (let item of this.budgetAuthorizerGroup)
                data["budgetAuthorizerGroup"].push(item.toJSON());
        }
        data["requirePostAuthorization"] = this.requirePostAuthorization;
        data["postAuthorizerGroupId"] = this.postAuthorizerGroupId;
        return data;
    }
}

export interface ICreateOrUpdateOrganizationUnitInput {
    id: number;
    parentId: number | undefined;
    codeUnit: string | undefined;
    siapClientId: string | undefined;
    displayName: string | undefined;
    typeId: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    requirePreAuthorization: boolean;
    preAuthorizerGroupId: string | undefined;
    requireAuthorization: boolean;
    authorizerGroupId: string | undefined;
    authorizerGroup: UserListDto[] | undefined;
    travelPolicyPassengers: boolean;
    requireBudgetAuthorization: boolean;
    budgetAuthorizerGroupId: string | undefined;
    budgetAuthorizerGroup: UserListDto[] | undefined;
    requirePostAuthorization: boolean;
    postAuthorizerGroupId: string | undefined;
}

export class AjaxResponseOfOrganizationUnitDto implements IAjaxResponseOfOrganizationUnitDto {
    result!: OrganizationUnitDto;
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;

    constructor(data?: IAjaxResponseOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? OrganizationUnitDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IAjaxResponseOfOrganizationUnitDto {
    result: OrganizationUnitDto;
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class AjaxResponseOfListOfUserListDto implements IAjaxResponseOfListOfUserListDto {
    result!: UserListDto[] | undefined;
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;

    constructor(data?: IAjaxResponseOfListOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(UserListDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IAjaxResponseOfListOfUserListDto {
    result: UserListDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class ListResultDtoOfUserListDto implements IListResultDtoOfUserListDto {
    items!: UserListDto[] | undefined;

    constructor(data?: IListResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserListDto {
    items: UserListDto[] | undefined;
}

export class AjaxResponseOfListResultDtoOfUserListDto implements IAjaxResponseOfListResultDtoOfUserListDto {
    result!: ListResultDtoOfUserListDto;
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;

    constructor(data?: IAjaxResponseOfListResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ListResultDtoOfUserListDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IAjaxResponseOfListResultDtoOfUserListDto {
    result: ListResultDtoOfUserListDto;
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class OrganizationUntiTypeDto implements IOrganizationUntiTypeDto {
    codeType!: string | undefined;
    languageKey!: string | undefined;
    id!: number;

    constructor(data?: IOrganizationUntiTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeType = _data["codeType"];
            this.languageKey = _data["languageKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUntiTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUntiTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeType"] = this.codeType;
        data["languageKey"] = this.languageKey;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUntiTypeDto {
    codeType: string | undefined;
    languageKey: string | undefined;
    id: number;
}

export class AjaxResponseOfListOfOrganizationUntiTypeDto implements IAjaxResponseOfListOfOrganizationUntiTypeDto {
    result!: OrganizationUntiTypeDto[] | undefined;
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;

    constructor(data?: IAjaxResponseOfListOfOrganizationUntiTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(OrganizationUntiTypeDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfOrganizationUntiTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfOrganizationUntiTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IAjaxResponseOfListOfOrganizationUntiTypeDto {
    result: OrganizationUntiTypeDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;
    additionalData!: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
            this.additionalData = _data["additionalData"] ? AdditionalData.fromJS(_data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: AdditionalData | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition!: EditionSelectDto;
    additionalPrice!: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            this.additionalPrice = _data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data;
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;
}

export enum EditionPaymentType {
    NewRegistration = 0,
    BuyNow = 1,
    Upgrade = 2,
    Extend = 3,
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export enum SubscriptionPaymentGatewayType {
    Paypal = 1,
    Stripe = 2,
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId!: number;
    editionPaymentType!: EditionPaymentType;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionPaymentGatewayType!: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled!: boolean;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionId = _data["editionId"];
            this.editionPaymentType = _data["editionPaymentType"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = _data["subscriptionPaymentGatewayType"];
            this.recurringPaymentEnabled = _data["recurringPaymentEnabled"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data;
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: EditionPaymentType;
    paymentPeriodType: PaymentPeriodType;
    subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled: boolean;
    successUrl: string | undefined;
    errorUrl: string | undefined;
}

export class CancelPaymentDto implements ICancelPaymentDto {
    paymentId!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;

    constructor(data?: ICancelPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.gateway = _data["gateway"];
        }
    }

    static fromJS(data: any): CancelPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data;
    }
}

export interface ICancelPaymentDto {
    paymentId: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway!: string | undefined;
    amount!: number;
    editionId!: number;
    dayCount!: number;
    paymentPeriodType!: string | undefined;
    externalPaymentId!: string | undefined;
    payerId!: string | undefined;
    status!: string | undefined;
    editionDisplayName!: string | undefined;
    tenantId!: number;
    invoiceNo!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gateway = _data["gateway"];
            this.amount = _data["amount"];
            this.editionId = _data["editionId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.externalPaymentId = _data["externalPaymentId"];
            this.payerId = _data["payerId"];
            this.status = _data["status"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.tenantId = _data["tenantId"];
            this.invoiceNo = _data["invoiceNo"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["externalPaymentId"] = this.externalPaymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string | undefined;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string | undefined;
    externalPaymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number;
    invoiceNo: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount!: number;
    items!: SubscriptionPaymentListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[] | undefined;
}

export class PaymentGatewayModel implements IPaymentGatewayModel {
    gatewayType!: SubscriptionPaymentGatewayType;
    supportsRecurringPayments!: boolean;

    constructor(data?: IPaymentGatewayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gatewayType = _data["gatewayType"];
            this.supportsRecurringPayments = _data["supportsRecurringPayments"];
        }
    }

    static fromJS(data: any): PaymentGatewayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGatewayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data;
    }
}

export interface IPaymentGatewayModel {
    gatewayType: SubscriptionPaymentGatewayType;
    supportsRecurringPayments: boolean;
}

export enum SubscriptionPaymentStatus {
    NotPaid = 1,
    Paid = 2,
    Failed = 3,
    Cancelled = 4,
    Completed = 5,
}

export class SubscriptionPaymentDto implements ISubscriptionPaymentDto {
    description!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;
    amount!: number;
    editionId!: number;
    tenantId!: number;
    dayCount!: number;
    paymentPeriodType!: PaymentPeriodType;
    paymentId!: string | undefined;
    payerId!: string | undefined;
    editionDisplayName!: string | undefined;
    invoiceNo!: number;
    status!: SubscriptionPaymentStatus;
    isRecurring!: boolean;
    externalPaymentId!: string | undefined;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;
    editionPaymentType!: EditionPaymentType;
    id!: number;

    constructor(data?: ISubscriptionPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.gateway = _data["gateway"];
            this.amount = _data["amount"];
            this.editionId = _data["editionId"];
            this.tenantId = _data["tenantId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.paymentId = _data["paymentId"];
            this.payerId = _data["payerId"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.status = _data["status"];
            this.isRecurring = _data["isRecurring"];
            this.externalPaymentId = _data["externalPaymentId"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
            this.editionPaymentType = _data["editionPaymentType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["externalPaymentId"] = this.externalPaymentId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        data["editionPaymentType"] = this.editionPaymentType;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscriptionPaymentDto {
    description: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
    amount: number;
    editionId: number;
    tenantId: number;
    dayCount: number;
    paymentPeriodType: PaymentPeriodType;
    paymentId: string | undefined;
    payerId: string | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: number;
    status: SubscriptionPaymentStatus;
    isRecurring: boolean;
    externalPaymentId: string | undefined;
    successUrl: string | undefined;
    errorUrl: string | undefined;
    editionPaymentType: EditionPaymentType;
    id: number;
}

export class PaymentProfileDto implements IPaymentProfileDto {
    id!: string | undefined;
    idAgency!: string;
    agencyName!: string;
    code!: string;
    displayNumber!: string | undefined;
    cardHolderName!: string;
    expirationYear!: string;
    expirationMonth!: string;
    billingAddress!: string | undefined;
    isEnabled!: boolean;
    priority!: number;
    airlineFilter!: TagOfStringString[] | undefined;
    supplierFilter!: string | undefined;
    isEnabledVerificationCodeValidation!: boolean;

    constructor(data?: IPaymentProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idAgency = _data["idAgency"];
            this.agencyName = _data["agencyName"];
            this.code = _data["code"];
            this.displayNumber = _data["displayNumber"];
            this.cardHolderName = _data["cardHolderName"];
            this.expirationYear = _data["expirationYear"];
            this.expirationMonth = _data["expirationMonth"];
            this.billingAddress = _data["billingAddress"];
            this.isEnabled = _data["isEnabled"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["airlineFilter"])) {
                this.airlineFilter = [] as any;
                for (let item of _data["airlineFilter"])
                    this.airlineFilter!.push(TagOfStringString.fromJS(item));
            }
            this.supplierFilter = _data["supplierFilter"];
            this.isEnabledVerificationCodeValidation = _data["isEnabledVerificationCodeValidation"];
        }
    }

    static fromJS(data: any): PaymentProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idAgency"] = this.idAgency;
        data["agencyName"] = this.agencyName;
        data["code"] = this.code;
        data["displayNumber"] = this.displayNumber;
        data["cardHolderName"] = this.cardHolderName;
        data["expirationYear"] = this.expirationYear;
        data["expirationMonth"] = this.expirationMonth;
        data["billingAddress"] = this.billingAddress;
        data["isEnabled"] = this.isEnabled;
        data["priority"] = this.priority;
        if (Array.isArray(this.airlineFilter)) {
            data["airlineFilter"] = [];
            for (let item of this.airlineFilter)
                data["airlineFilter"].push(item.toJSON());
        }
        data["supplierFilter"] = this.supplierFilter;
        data["isEnabledVerificationCodeValidation"] = this.isEnabledVerificationCodeValidation;
        return data;
    }
}

export interface IPaymentProfileDto {
    id: string | undefined;
    idAgency: string;
    agencyName: string;
    code: string;
    displayNumber: string | undefined;
    cardHolderName: string;
    expirationYear: string;
    expirationMonth: string;
    billingAddress: string | undefined;
    isEnabled: boolean;
    priority: number;
    airlineFilter: TagOfStringString[] | undefined;
    supplierFilter: string | undefined;
    isEnabledVerificationCodeValidation: boolean;
}

export class GetPaymentProfileForView implements IGetPaymentProfileForView {
    paymentProfile!: PaymentProfileDto;

    constructor(data?: IGetPaymentProfileForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfile = _data["paymentProfile"] ? PaymentProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPaymentProfileForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentProfileForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPaymentProfileForView {
    paymentProfile: PaymentProfileDto;
}

export class PagedResultDtoOfGetPaymentProfileForView implements IPagedResultDtoOfGetPaymentProfileForView {
    totalCount!: number;
    items!: GetPaymentProfileForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPaymentProfileForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPaymentProfileForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPaymentProfileForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPaymentProfileForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPaymentProfileForView {
    totalCount: number;
    items: GetPaymentProfileForView[] | undefined;
}

export class EditPaymentProfileDto implements IEditPaymentProfileDto {
    id!: string | undefined;
    code!: string | undefined;
    displayNumber!: string | undefined;
    expirationMonth!: string | undefined;
    expirationYear!: string | undefined;
    airlineFilter!: TagOfStringString[] | undefined;
    priority!: number;
    supplierFilter!: string | undefined;
    isEnabledVerificationCodeValidation!: boolean;

    constructor(data?: IEditPaymentProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayNumber = _data["displayNumber"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            if (Array.isArray(_data["airlineFilter"])) {
                this.airlineFilter = [] as any;
                for (let item of _data["airlineFilter"])
                    this.airlineFilter!.push(TagOfStringString.fromJS(item));
            }
            this.priority = _data["priority"];
            this.supplierFilter = _data["supplierFilter"];
            this.isEnabledVerificationCodeValidation = _data["isEnabledVerificationCodeValidation"];
        }
    }

    static fromJS(data: any): EditPaymentProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPaymentProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayNumber"] = this.displayNumber;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        if (Array.isArray(this.airlineFilter)) {
            data["airlineFilter"] = [];
            for (let item of this.airlineFilter)
                data["airlineFilter"].push(item.toJSON());
        }
        data["priority"] = this.priority;
        data["supplierFilter"] = this.supplierFilter;
        data["isEnabledVerificationCodeValidation"] = this.isEnabledVerificationCodeValidation;
        return data;
    }
}

export interface IEditPaymentProfileDto {
    id: string | undefined;
    code: string | undefined;
    displayNumber: string | undefined;
    expirationMonth: string | undefined;
    expirationYear: string | undefined;
    airlineFilter: TagOfStringString[] | undefined;
    priority: number;
    supplierFilter: string | undefined;
    isEnabledVerificationCodeValidation: boolean;
}

export class GetPaymentProfileForEditOutput implements IGetPaymentProfileForEditOutput {
    paymentProfile!: EditPaymentProfileDto;

    constructor(data?: IGetPaymentProfileForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.paymentProfile = new EditPaymentProfileDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfile = _data["paymentProfile"] ? EditPaymentProfileDto.fromJS(_data["paymentProfile"]) : new EditPaymentProfileDto();
        }
    }

    static fromJS(data: any): GetPaymentProfileForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentProfileForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPaymentProfileForEditOutput {
    paymentProfile: EditPaymentProfileDto;
}

export class CreatePaymentProfileDto implements ICreatePaymentProfileDto {
    id!: string | undefined;
    agencyId!: Array<string>;
    agencyName!: string;
    displayNumber!: string | undefined;
    number!: string;
    cvv!: string;
    airlineFilter!: TagOfStringString[] | undefined;
    billingAddress!: string | undefined;
    cardHolderName!: string;
    code!: string;
    expirationMonth!: string;
    expirationYear!: string;
    isEnabled!: boolean;
    priority!: number;
    isEnabledVerificationCodeValidation!: boolean;
    supplierFilter!: Array<string> | undefined;

    constructor(data?: ICreatePaymentProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agencyId = _data["agencyId"];
            this.agencyName = _data["agencyName"];
            this.displayNumber = _data["displayNumber"];
            this.number = _data["number"];
            this.cvv = _data["cvv"];
            if (Array.isArray(_data["airlineFilter"])) {
                this.airlineFilter = [] as any;
                for (let item of _data["airlineFilter"])
                    this.airlineFilter!.push(TagOfStringString.fromJS(item));
            }
            this.billingAddress = _data["billingAddress"];
            this.cardHolderName = _data["cardHolderName"];
            this.code = _data["code"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            this.isEnabled = _data["isEnabled"];
            this.priority = _data["priority"];
            this.isEnabledVerificationCodeValidation = _data["isEnabledVerificationCodeValidation"];
            this.supplierFilter = _data["supplierFilter"];
        }
    }

    static fromJS(data: any): CreatePaymentProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agencyId"] = this.agencyId;
        data["agencyName"] = this.agencyName;
        data["displayNumber"] = this.displayNumber;
        data["number"] = this.number;
        data["cvv"] = this.cvv;
        if (Array.isArray(this.airlineFilter)) {
            data["airlineFilter"] = [];
            for (let item of this.airlineFilter)
                data["airlineFilter"].push(item.toJSON());
        }
        data["billingAddress"] = this.billingAddress;
        data["cardHolderName"] = this.cardHolderName;
        data["code"] = this.code;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["isEnabled"] = this.isEnabled;
        data["priority"] = this.priority;
        data["isEnabledVerificationCodeValidation"] = this.isEnabledVerificationCodeValidation;
        data["supplierFilter"] = this.supplierFilter;
        return data;
    }
}

export interface ICreatePaymentProfileDto {
    id: string | undefined;
    agencyId: Array<string>;
    agencyName: string;
    displayNumber: string | undefined;
    number: string;
    cvv: string;
    airlineFilter: TagOfStringString[] | undefined;
    billingAddress: string | undefined;
    cardHolderName: string;
    code: string;
    expirationMonth: string;
    expirationYear: string;
    isEnabled: boolean;
    priority: number;
    isEnabledVerificationCodeValidation: boolean;
    supplierFilter: Array<string> | undefined;
}

export class CreatePaymentProfileInputDto implements ICreatePaymentProfileInputDto {
    paymentProfile!: CreatePaymentProfileDto;

    constructor(data?: ICreatePaymentProfileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfile = _data["paymentProfile"] ? CreatePaymentProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePaymentProfileInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentProfileInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePaymentProfileInputDto {
    paymentProfile: CreatePaymentProfileDto;
}

export class EditPaymentProfileInputDto implements IEditPaymentProfileInputDto {
    paymentProfile!: EditPaymentProfileDto;

    constructor(data?: IEditPaymentProfileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.paymentProfile = new EditPaymentProfileDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProfile = _data["paymentProfile"] ? EditPaymentProfileDto.fromJS(_data["paymentProfile"]) : new EditPaymentProfileDto();
        }
    }

    static fromJS(data: any): EditPaymentProfileInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPaymentProfileInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditPaymentProfileInputDto {
    paymentProfile: EditPaymentProfileDto;
}

export class ChangeEnabledDto implements IChangeEnabledDto {
    id!: string;
    isEnabled!: boolean;

    constructor(data?: IChangeEnabledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ChangeEnabledDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEnabledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IChangeEnabledDto {
    id: string;
    isEnabled: boolean;
}

export class PayPalConfigurationDto implements IPayPalConfigurationDto {
    clientId!: string | undefined;
    demoUsername!: string | undefined;
    demoPassword!: string | undefined;

    constructor(data?: IPayPalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.demoUsername = _data["demoUsername"];
            this.demoPassword = _data["demoPassword"];
        }
    }

    static fromJS(data: any): PayPalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayPalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["demoUsername"] = this.demoUsername;
        data["demoPassword"] = this.demoPassword;
        return data;
    }
}

export interface IPayPalConfigurationDto {
    clientId: string | undefined;
    demoUsername: string | undefined;
    demoPassword: string | undefined;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    useGravatarProfilePicture!: boolean;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.useGravatarProfilePicture = _data["useGravatarProfilePicture"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["useGravatarProfilePicture"] = this.useGravatarProfilePicture;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
    useGravatarProfilePicture: boolean;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export enum ReasonType {
    TripApprovalRequest = 0,
    TripApprovalResponse = 1,
}

export class ReasonDto implements IReasonDto {
    id!: string | undefined;
    description!: LocalizedString;
    enabled!: boolean;
    priority!: number | undefined;
    organizationUnitId!: string | undefined;
    organizationUnitName!: string | undefined;
    code!: string | undefined;
    reasonType!: ReasonType;

    constructor(data?: IReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"] ? LocalizedString.fromJS(_data["description"]) : <any>undefined;
            this.enabled = _data["enabled"];
            this.priority = _data["priority"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.organizationUnitName = _data["organizationUnitName"];
            this.code = _data["code"];
            this.reasonType = _data["reasonType"];
        }
    }

    static fromJS(data: any): ReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["enabled"] = this.enabled;
        data["priority"] = this.priority;
        data["organizationUnitId"] = this.organizationUnitId;
        data["organizationUnitName"] = this.organizationUnitName;
        data["code"] = this.code;
        data["reasonType"] = this.reasonType;
        return data;
    }
}

export interface IReasonDto {
    id: string | undefined;
    description: LocalizedString;
    enabled: boolean;
    priority: number | undefined;
    organizationUnitId: string | undefined;
    organizationUnitName: string | undefined;
    code: string | undefined;
    reasonType: ReasonType;
}

export class CreateOrEditReasonDto implements ICreateOrEditReasonDto {
    reason!: ReasonDto;

    constructor(data?: ICreateOrEditReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] ? ReasonDto.fromJS(_data["reason"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrEditReasonDto {
    reason: ReasonDto;
}

export class RegionDto implements IRegionDto {
    id!: string | undefined;
    ts!: moment.Moment;
    parentId!: string | undefined;
    name!: LocalizedString;
    regionZone!: LocalizedString;
    country!: LocalizedString;
    displayName!: LocalizedString;
    alias!: string[] | undefined;
    isoCountry!: string | undefined;
    linkedReference!: TagOfStringString[] | undefined;
    position!: PositionDTO;
    numberStructures!: number;
    enabled!: boolean;
    regionType!: string | undefined;
    subClass!: string | undefined;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.parentId = _data["parentId"];
            this.name = _data["name"] ? LocalizedString.fromJS(_data["name"]) : <any>undefined;
            this.regionZone = _data["regionZone"] ? LocalizedString.fromJS(_data["regionZone"]) : <any>undefined;
            this.country = _data["country"] ? LocalizedString.fromJS(_data["country"]) : <any>undefined;
            this.displayName = _data["displayName"] ? LocalizedString.fromJS(_data["displayName"]) : <any>undefined;
            if (Array.isArray(_data["alias"])) {
                this.alias = [] as any;
                for (let item of _data["alias"])
                    this.alias!.push(item);
            }
            this.isoCountry = _data["isoCountry"];
            if (Array.isArray(_data["linkedReference"])) {
                this.linkedReference = [] as any;
                for (let item of _data["linkedReference"])
                    this.linkedReference!.push(TagOfStringString.fromJS(item));
            }
            this.position = _data["position"] ? PositionDTO.fromJS(_data["position"]) : <any>undefined;
            this.numberStructures = _data["numberStructures"];
            this.enabled = _data["enabled"];
            this.regionType = _data["regionType"];
            this.subClass = _data["subClass"];
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["parentId"] = this.parentId;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["regionZone"] = this.regionZone ? this.regionZone.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["displayName"] = this.displayName ? this.displayName.toJSON() : <any>undefined;
        if (Array.isArray(this.alias)) {
            data["alias"] = [];
            for (let item of this.alias)
                data["alias"].push(item);
        }
        data["isoCountry"] = this.isoCountry;
        if (Array.isArray(this.linkedReference)) {
            data["linkedReference"] = [];
            for (let item of this.linkedReference)
                data["linkedReference"].push(item.toJSON());
        }
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["numberStructures"] = this.numberStructures;
        data["enabled"] = this.enabled;
        data["regionType"] = this.regionType;
        data["subClass"] = this.subClass;
        return data;
    }
}

export interface IRegionDto {
    id: string | undefined;
    ts: moment.Moment;
    parentId: string | undefined;
    name: LocalizedString;
    regionZone: LocalizedString;
    country: LocalizedString;
    displayName: LocalizedString;
    alias: string[] | undefined;
    isoCountry: string | undefined;
    linkedReference: TagOfStringString[] | undefined;
    position: PositionDTO;
    numberStructures: number;
    enabled: boolean;
    regionType: string | undefined;
    subClass: string | undefined;
}

export class PagedResultDtoOfRegionDto implements IPagedResultDtoOfRegionDto {
    totalCount!: number;
    items!: RegionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RegionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRegionDto {
    totalCount: number;
    items: RegionDto[] | undefined;
}

export class RegisterAgencyDto implements IRegisterAgencyDto {
    companyName!: string;
    country!: string;
    city!: string;
    state!: string;
    address!: string;
    zipCode!: string;
    phoneNumber!: string;
    mobileNumber!: string | undefined;
    fax!: string | undefined;
    vatNumber!: string;
    cciaa!: string | undefined;
    email!: string;
    isActive!: boolean;
    password!: string;
    captchaResponse!: string | undefined;
    name!: string;
    surname!: string;

    constructor(data?: IRegisterAgencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.fax = _data["fax"];
            this.vatNumber = _data["vatNumber"];
            this.cciaa = _data["cciaa"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): RegisterAgencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterAgencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["country"] = this.country;
        data["city"] = this.city;
        data["state"] = this.state;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["phoneNumber"] = this.phoneNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["fax"] = this.fax;
        data["vatNumber"] = this.vatNumber;
        data["cciaa"] = this.cciaa;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }
}

export interface IRegisterAgencyDto {
    companyName: string;
    country: string;
    city: string;
    state: string;
    address: string;
    zipCode: string;
    phoneNumber: string;
    mobileNumber: string | undefined;
    fax: string | undefined;
    vatNumber: string;
    cciaa: string | undefined;
    email: string;
    isActive: boolean;
    password: string;
    captchaResponse: string | undefined;
    name: string;
    surname: string;
}

export class RegisterAgencyOutputDto implements IRegisterAgencyOutputDto {
    canLogin!: boolean;
    companyName!: string | undefined;
    reference!: string | undefined;
    isActive!: boolean;

    constructor(data?: IRegisterAgencyOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.companyName = _data["companyName"];
            this.reference = _data["reference"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): RegisterAgencyOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterAgencyOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["companyName"] = this.companyName;
        data["reference"] = this.reference;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRegisterAgencyOutputDto {
    canLogin: boolean;
    companyName: string | undefined;
    reference: string | undefined;
    isActive: boolean;
}

export class ReservationDateRangeDto implements IReservationDateRangeDto {
    start!: moment.Moment | undefined;
    end!: moment.Moment | undefined;

    constructor(data?: IReservationDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? moment(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? moment(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReservationDateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationDateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReservationDateRangeDto {
    start: moment.Moment | undefined;
    end: moment.Moment | undefined;
}

export class GetReservationsInput implements IGetReservationsInput {
    reservationStatus!: ReservationStatusDto[] | undefined;
    reservationDate!: ReservationDateRangeDto;
    departureDate!: ReservationDateRangeDto;
    reservationCode!: string | undefined;
    reservationType!: ReservationTypeDto;
    agenciesId!: string[] | undefined;
    firstName!: string | undefined;
    surname!: string | undefined;
    isOnlyReservationIssued!: boolean;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetReservationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reservationStatus"])) {
                this.reservationStatus = [] as any;
                for (let item of _data["reservationStatus"])
                    this.reservationStatus!.push(item);
            }
            this.reservationDate = _data["reservationDate"] ? ReservationDateRangeDto.fromJS(_data["reservationDate"]) : <any>undefined;
            this.departureDate = _data["departureDate"] ? ReservationDateRangeDto.fromJS(_data["departureDate"]) : <any>undefined;
            this.reservationCode = _data["reservationCode"];
            this.reservationType = _data["reservationType"];
            if (Array.isArray(_data["agenciesId"])) {
                this.agenciesId = [] as any;
                for (let item of _data["agenciesId"])
                    this.agenciesId!.push(item);
            }
            this.firstName = _data["firstName"];
            this.surname = _data["surname"];
            this.isOnlyReservationIssued = _data["isOnlyReservationIssued"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetReservationsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReservationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reservationStatus)) {
            data["reservationStatus"] = [];
            for (let item of this.reservationStatus)
                data["reservationStatus"].push(item);
        }
        data["reservationDate"] = this.reservationDate ? this.reservationDate.toJSON() : <any>undefined;
        data["departureDate"] = this.departureDate ? this.departureDate.toJSON() : <any>undefined;
        data["reservationCode"] = this.reservationCode;
        data["reservationType"] = this.reservationType;
        if (Array.isArray(this.agenciesId)) {
            data["agenciesId"] = [];
            for (let item of this.agenciesId)
                data["agenciesId"].push(item);
        }
        data["firstName"] = this.firstName;
        data["surname"] = this.surname;
        data["isOnlyReservationIssued"] = this.isOnlyReservationIssued;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetReservationsInput {
    reservationStatus: ReservationStatusDto[] | undefined;
    reservationDate: ReservationDateRangeDto;
    departureDate: ReservationDateRangeDto;
    reservationCode: string | undefined;
    reservationType: ReservationTypeDto;
    agenciesId: string[] | undefined;
    firstName: string | undefined;
    surname: string | undefined;
    isOnlyReservationIssued: boolean;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class PagedResultDtoOfReservationListDto implements IPagedResultDtoOfReservationListDto {
    totalCount!: number;
    items!: ReservationListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfReservationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReservationListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReservationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReservationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReservationListDto {
    totalCount: number;
    items: ReservationListDto[] | undefined;
}

export class RequestQueueForAssistanceInputDto implements IRequestQueueForAssistanceInputDto {
    id!: string;
    remark!: string;

    constructor(data?: IRequestQueueForAssistanceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): RequestQueueForAssistanceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestQueueForAssistanceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IRequestQueueForAssistanceInputDto {
    id: string;
    remark: string;
}

export class IssueReservationInput implements IIssueReservationInput {
    reservationId!: string;
    callbackData!: string | undefined;

    constructor(data?: IIssueReservationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.callbackData = _data["callbackData"];
        }
    }

    static fromJS(data: any): IssueReservationInput {
        data = typeof data === 'object' ? data : {};
        let result = new IssueReservationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["callbackData"] = this.callbackData;
        return data;
    }
}

export interface IIssueReservationInput {
    reservationId: string;
    callbackData: string | undefined;
}

export class IssueReservationOutput implements IIssueReservationOutput {
    reservationId!: string | undefined;

    constructor(data?: IIssueReservationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
        }
    }

    static fromJS(data: any): IssueReservationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IssueReservationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        return data;
    }
}

export interface IIssueReservationOutput {
    reservationId: string | undefined;
}

export class AjaxResponseOfIssueReservationOutput implements IAjaxResponseOfIssueReservationOutput {
    result!: IssueReservationOutput;
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;

    constructor(data?: IAjaxResponseOfIssueReservationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IssueReservationOutput.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIssueReservationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIssueReservationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IAjaxResponseOfIssueReservationOutput {
    result: IssueReservationOutput;
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class UpdatePassengersReservationInputDto implements IUpdatePassengersReservationInputDto {
    reservationId!: string | undefined;
    passengers!: PersonNameDataDTO[] | undefined;

    constructor(data?: IUpdatePassengersReservationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PersonNameDataDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePassengersReservationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePassengersReservationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdatePassengersReservationInputDto {
    reservationId: string | undefined;
    passengers: PersonNameDataDTO[] | undefined;
}

export class ChangePaymentProfileInput implements IChangePaymentProfileInput {
    reservationId!: string | undefined;
    paymentData!: PaymentDataDto;
    paymentProfile!: PaymentDataProfileDto;

    constructor(data?: IChangePaymentProfileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.paymentData = _data["paymentData"] ? PaymentDataDto.fromJS(_data["paymentData"]) : <any>undefined;
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangePaymentProfileInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePaymentProfileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChangePaymentProfileInput {
    reservationId: string | undefined;
    paymentData: PaymentDataDto;
    paymentProfile: PaymentDataProfileDto;
}

export class GetChangePaymentProfileOutput implements IGetChangePaymentProfileOutput {
    currentFormOfPayment!: PaymentDataProfileDto;
    paymentProfiles!: ListResultDtoOfPaymentDataProfileDto;

    constructor(data?: IGetChangePaymentProfileOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentFormOfPayment = _data["currentFormOfPayment"] ? PaymentDataProfileDto.fromJS(_data["currentFormOfPayment"]) : <any>undefined;
            this.paymentProfiles = _data["paymentProfiles"] ? ListResultDtoOfPaymentDataProfileDto.fromJS(_data["paymentProfiles"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetChangePaymentProfileOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetChangePaymentProfileOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentFormOfPayment"] = this.currentFormOfPayment ? this.currentFormOfPayment.toJSON() : <any>undefined;
        data["paymentProfiles"] = this.paymentProfiles ? this.paymentProfiles.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetChangePaymentProfileOutput {
    currentFormOfPayment: PaymentDataProfileDto;
    paymentProfiles: ListResultDtoOfPaymentDataProfileDto;
}

export class GetPaymentInfoOutput implements IGetPaymentInfoOutput {
    totalDue!: number;
    paymentGateways!: PaymentGatewayDto[] | undefined;
    paymentProfiles!: ListResultDtoOfPaymentDataProfileDto;

    constructor(data?: IGetPaymentInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalDue = _data["totalDue"];
            if (Array.isArray(_data["paymentGateways"])) {
                this.paymentGateways = [] as any;
                for (let item of _data["paymentGateways"])
                    this.paymentGateways!.push(item);
            }
            this.paymentProfiles = _data["paymentProfiles"] ? ListResultDtoOfPaymentDataProfileDto.fromJS(_data["paymentProfiles"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPaymentInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalDue"] = this.totalDue;
        if (Array.isArray(this.paymentGateways)) {
            data["paymentGateways"] = [];
            for (let item of this.paymentGateways)
                data["paymentGateways"].push(item);
        }
        data["paymentProfiles"] = this.paymentProfiles ? this.paymentProfiles.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPaymentInfoOutput {
    totalDue: number;
    paymentGateways: PaymentGatewayDto[] | undefined;
    paymentProfiles: ListResultDtoOfPaymentDataProfileDto;
}

export class PayReservationInput implements IPayReservationInput {
    reservationId!: string;
    paymentProfile!: PaymentDataProfileDto;
    paymentGateway!: PaymentGatewayDto;
    callbackData!: string | undefined;

    constructor(data?: IPayReservationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
            this.paymentGateway = _data["paymentGateway"];
            this.callbackData = _data["callbackData"];
        }
    }

    static fromJS(data: any): PayReservationInput {
        data = typeof data === 'object' ? data : {};
        let result = new PayReservationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        data["paymentGateway"] = this.paymentGateway;
        data["callbackData"] = this.callbackData;
        return data;
    }
}

export interface IPayReservationInput {
    reservationId: string;
    paymentProfile: PaymentDataProfileDto;
    paymentGateway: PaymentGatewayDto;
    callbackData: string | undefined;
}

export class PayReservationOutput implements IPayReservationOutput {
    reservationId!: string | undefined;

    constructor(data?: IPayReservationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
        }
    }

    static fromJS(data: any): PayReservationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PayReservationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        return data;
    }
}

export interface IPayReservationOutput {
    reservationId: string | undefined;
}

export class AjaxResponseOfPayReservationOutput implements IAjaxResponseOfPayReservationOutput {
    result!: PayReservationOutput;
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;

    constructor(data?: IAjaxResponseOfPayReservationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PayReservationOutput.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfPayReservationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfPayReservationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IAjaxResponseOfPayReservationOutput {
    result: PayReservationOutput;
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class FlightCancellationDetailsDto implements IFlightCancellationDetailsDto {
    paidAmount!: number | undefined;
    refundAmount!: number | undefined;
    supplierCharge!: number | undefined;
    customerCharge!: number | undefined;

    constructor(data?: IFlightCancellationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paidAmount = _data["paidAmount"];
            this.refundAmount = _data["refundAmount"];
            this.supplierCharge = _data["supplierCharge"];
            this.customerCharge = _data["customerCharge"];
        }
    }

    static fromJS(data: any): FlightCancellationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlightCancellationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidAmount"] = this.paidAmount;
        data["refundAmount"] = this.refundAmount;
        data["supplierCharge"] = this.supplierCharge;
        data["customerCharge"] = this.customerCharge;
        return data;
    }
}

export interface IFlightCancellationDetailsDto {
    paidAmount: number | undefined;
    refundAmount: number | undefined;
    supplierCharge: number | undefined;
    customerCharge: number | undefined;
}

export enum PostSaleActionType {
    UNCHANGED = 0,
    CANCELLATION = 1,
    REFUND = 2,
    BOOKING_CHANGE = 3,
    TRAVEL_CHANGE = 4,
    CHANGE_OFFER = 5,
    ADD_TRAVELLER = 6,
    MODIFY_TRAVEL = 7,
    TRAVELLER_CHANGE = 8,
    DATE_CHANGE = 9,
}

export class PostSaleActionDto implements IPostSaleActionDto {
    allowed!: boolean;
    messages!: string[] | undefined;
    penaltyAmount!: number;
    action!: PostSaleActionType;
    trainTicketInfo!: TrainTicketingInfo;
    allowChangeItinerayAction!: boolean;

    constructor(data?: IPostSaleActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowed = _data["allowed"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.penaltyAmount = _data["penaltyAmount"];
            this.action = _data["action"];
            this.trainTicketInfo = _data["trainTicketInfo"] ? TrainTicketingInfo.fromJS(_data["trainTicketInfo"]) : <any>undefined;
            this.allowChangeItinerayAction = _data["allowChangeItinerayAction"];
        }
    }

    static fromJS(data: any): PostSaleActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostSaleActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowed"] = this.allowed;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["penaltyAmount"] = this.penaltyAmount;
        data["action"] = this.action;
        data["trainTicketInfo"] = this.trainTicketInfo ? this.trainTicketInfo.toJSON() : <any>undefined;
        data["allowChangeItinerayAction"] = this.allowChangeItinerayAction;
        return data;
    }
}

export interface IPostSaleActionDto {
    allowed: boolean;
    messages: string[] | undefined;
    penaltyAmount: number;
    action: PostSaleActionType;
    trainTicketInfo: TrainTicketingInfo;
    allowChangeItinerayAction: boolean;
}

export class ModifyResult implements IModifyResult {
    success!: boolean;
    isWarning!: boolean;
    messages!: string | undefined;

    constructor(data?: IModifyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.isWarning = _data["isWarning"];
            this.messages = _data["messages"];
        }
    }

    static fromJS(data: any): ModifyResult {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["isWarning"] = this.isWarning;
        data["messages"] = this.messages;
        return data;
    }
}

export interface IModifyResult {
    success: boolean;
    isWarning: boolean;
    messages: string | undefined;
}

export class LocationDTO implements ILocationDTO {
    code!: string | undefined;
    cityName!: string | undefined;
    poiName!: string | undefined;
    countryCode!: string | undefined;
    countryName!: string | undefined;
    displayName!: string | undefined;
    longitude!: number;
    latitude!: number;
    isMultiCity!: boolean;

    constructor(data?: ILocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.cityName = _data["cityName"];
            this.poiName = _data["poiName"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.displayName = _data["displayName"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.isMultiCity = _data["isMultiCity"];
        }
    }

    static fromJS(data: any): LocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["cityName"] = this.cityName;
        data["poiName"] = this.poiName;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["displayName"] = this.displayName;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["isMultiCity"] = this.isMultiCity;
        return data;
    }
}

export interface ILocationDTO {
    code: string | undefined;
    cityName: string | undefined;
    poiName: string | undefined;
    countryCode: string | undefined;
    countryName: string | undefined;
    displayName: string | undefined;
    longitude: number;
    latitude: number;
    isMultiCity: boolean;
}

export class FidelityDTO implements IFidelityDTO {
    code!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: IFidelityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FidelityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FidelityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IFidelityDTO {
    code: string | undefined;
    name: string | undefined;
    value: string | undefined;
}

export class PassengerDTO implements IPassengerDTO {
    code!: string | undefined;
    age!: number;
    fidelity!: FidelityDTO;

    constructor(data?: IPassengerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.age = _data["age"];
            this.fidelity = _data["fidelity"] ? FidelityDTO.fromJS(_data["fidelity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PassengerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PassengerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["age"] = this.age;
        data["fidelity"] = this.fidelity ? this.fidelity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPassengerDTO {
    code: string | undefined;
    age: number;
    fidelity: FidelityDTO;
}

export class TrainAvailabilityRequestDTOExtended implements ITrainAvailabilityRequestDTOExtended {
    supplierName: string | undefined;
    tickets!: string[] | undefined;
    orderId!: string | undefined;
    addTraveller!: boolean;
    isEconomyChangeDate!: boolean;
    editTraveller!: boolean;
    originCode!: string | undefined;
    destinationCode!: string | undefined;
    departureDate!: moment.Moment;
    returnDate!: moment.Moment | undefined;
    originStation!: LocationDTO;
    destinationStation!: LocationDTO;
    departureRangeStartTime!: string | undefined;
    departureRangeEndTime!: string | undefined;
    returnRangeStartTime!: string | undefined;
    returnRangeEndTime!: string | undefined;
    departureRangeType!: RangeTimeTypeDto;
    returnRangeType!: RangeTimeTypeDto;
    passengers!: PassengerDTO[] | undefined;
    speedTrainOnly!: boolean;
    bestFareOnly!: boolean;
    directOnly!: boolean;
    nearAirports!: boolean;
    postSale!: boolean;
    tripType!: TripTypeDTO;

    constructor(data?: ITrainAvailabilityRequestDTOExtended) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(item);
            }
            this.supplierName = _data["supplierName"];
            this.orderId = _data["orderId"];
            this.addTraveller = _data["addTraveller"];
            this.isEconomyChangeDate = _data["isEconomyChangeDate"];
            this.editTraveller = _data["editTraveller"];
            this.originCode = _data["originCode"];
            this.destinationCode = _data["destinationCode"];
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : <any>undefined;
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : <any>undefined;
            this.originStation = _data["originStation"] ? LocationDTO.fromJS(_data["originStation"]) : <any>undefined;
            this.destinationStation = _data["destinationStation"] ? LocationDTO.fromJS(_data["destinationStation"]) : <any>undefined;
            this.departureRangeStartTime = _data["departureRangeStartTime"];
            this.departureRangeEndTime = _data["departureRangeEndTime"];
            this.returnRangeStartTime = _data["returnRangeStartTime"];
            this.returnRangeEndTime = _data["returnRangeEndTime"];
            this.departureRangeType = _data["departureRangeType"];
            this.returnRangeType = _data["returnRangeType"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PassengerDTO.fromJS(item));
            }
            this.speedTrainOnly = _data["speedTrainOnly"];
            this.bestFareOnly = _data["bestFareOnly"];
            this.directOnly = _data["directOnly"];
            this.nearAirports = _data["nearAirports"];
            this.postSale = _data["postSale"];
            this.tripType = _data["tripType"];
        }
    }

    static fromJS(data: any): TrainAvailabilityRequestDTOExtended {
        data = typeof data === 'object' ? data : {};
        let result = new TrainAvailabilityRequestDTOExtended();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item);
        }
        data["supplierName"] = this.supplierName;
        data["orderId"] = this.orderId;
        data["addTraveller"] = this.addTraveller;
        data["isEconomyChangeDate"] = this.isEconomyChangeDate;
        data["editTraveller"] = this.editTraveller;
        data["originCode"] = this.originCode;
        data["destinationCode"] = this.destinationCode;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["originStation"] = this.originStation ? this.originStation.toJSON() : <any>undefined;
        data["destinationStation"] = this.destinationStation ? this.destinationStation.toJSON() : <any>undefined;
        data["departureRangeStartTime"] = this.departureRangeStartTime;
        data["departureRangeEndTime"] = this.departureRangeEndTime;
        data["returnRangeStartTime"] = this.returnRangeStartTime;
        data["returnRangeEndTime"] = this.returnRangeEndTime;
        data["departureRangeType"] = this.departureRangeType;
        data["returnRangeType"] = this.returnRangeType;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["speedTrainOnly"] = this.speedTrainOnly;
        data["bestFareOnly"] = this.bestFareOnly;
        data["directOnly"] = this.directOnly;
        data["nearAirports"] = this.nearAirports;
        data["postSale"] = this.postSale;
        data["tripType"] = this.tripType;
        return data;
    }
}

export interface ITrainAvailabilityRequestDTOExtended {
    supplierName: string | undefined;
    tickets: string[] | undefined;
    orderId: string | undefined;
    addTraveller: boolean;
    isEconomyChangeDate: boolean;
    editTraveller: boolean;
    originCode: string | undefined;
    destinationCode: string | undefined;
    departureDate: moment.Moment;
    returnDate: moment.Moment | undefined;
    originStation: LocationDTO;
    destinationStation: LocationDTO;
    departureRangeStartTime: string | undefined;
    departureRangeEndTime: string | undefined;
    returnRangeStartTime: string | undefined;
    returnRangeEndTime: string | undefined;
    departureRangeType: RangeTimeTypeDto;
    returnRangeType: RangeTimeTypeDto;
    passengers: PassengerDTO[] | undefined;
    speedTrainOnly: boolean;
    bestFareOnly: boolean;
    directOnly: boolean;
    nearAirports: boolean;
    postSale: boolean;
    tripType: TripTypeDTO;
}

export class EvaluateTravelRequestDto implements IEvaluateTravelRequestDto {
    travelSolutionIds!: string[] | undefined;
    offerIds!: string[] | undefined;

    constructor(data?: IEvaluateTravelRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["travelSolutionIds"])) {
                this.travelSolutionIds = [] as any;
                for (let item of _data["travelSolutionIds"])
                    this.travelSolutionIds!.push(item);
            }
            if (Array.isArray(_data["offerIds"])) {
                this.offerIds = [] as any;
                for (let item of _data["offerIds"])
                    this.offerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): EvaluateTravelRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluateTravelRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.travelSolutionIds)) {
            data["travelSolutionIds"] = [];
            for (let item of this.travelSolutionIds)
                data["travelSolutionIds"].push(item);
        }
        if (Array.isArray(this.offerIds)) {
            data["offerIds"] = [];
            for (let item of this.offerIds)
                data["offerIds"].push(item);
        }
        return data;
    }
}

export interface IEvaluateTravelRequestDto {
    travelSolutionIds: string[] | undefined;
    offerIds: string[] | undefined;
}

export class EvaluateTravelResponseDto implements IEvaluateTravelResponseDto {
    allowed!: boolean;
    messages!: string | undefined;
    originalPrice!: number;
    feeAmount!: number;
    agencyFeeAmount!: number;
    additionalChargesAmount!: number;
    missingAmount!: number;

    constructor(data?: IEvaluateTravelResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowed = _data["allowed"];
            this.messages = _data["messages"];
            this.originalPrice = _data["originalPrice"];
            this.feeAmount = _data["feeAmount"];
            this.agencyFeeAmount = _data["agencyFeeAmount"];
            this.additionalChargesAmount = _data["additionalChargesAmount"];
            this.missingAmount = _data["missingAmount"];
        }
    }

    static fromJS(data: any): EvaluateTravelResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluateTravelResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowed"] = this.allowed;
        data["messages"] = this.messages;
        data["originalPrice"] = this.originalPrice;
        data["feeAmount"] = this.feeAmount;
        data["agencyFeeAmount"] = this.agencyFeeAmount;
        data["additionalChargesAmount"] = this.additionalChargesAmount;
        data["missingAmount"] = this.missingAmount;
        return data;
    }
}

export interface IEvaluateTravelResponseDto {
    allowed: boolean;
    messages: string | undefined;
    originalPrice: number;
    feeAmount: number;
    agencyFeeAmount: number;
    additionalChargesAmount: number;
    missingAmount: number;
}

export class TrainSeatDTO implements ITrainSeatDTO {
    number!: number;
    airCraftNumber!: string | undefined;
    available!: boolean;

    constructor(data?: ITrainSeatDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.airCraftNumber = _data["airCraftNumber"];
            this.available = _data["available"];
        }
    }

    static fromJS(data: any): TrainSeatDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrainSeatDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["airCraftNumber"] = this.airCraftNumber;
        data["available"] = this.available;
        return data;
    }
}

export interface ITrainSeatDTO {
    number: number;
    airCraftNumber: string | undefined;
    available: boolean;
}

export class SeatsAvailabilityDTO implements ISeatsAvailabilityDTO {
    wagonId!: string | undefined;
    type!: string | undefined;
    serviceId!: number;
    seats!: TrainSeatDTO[] | undefined;

    constructor(data?: ISeatsAvailabilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wagonId = _data["wagonId"];
            this.type = _data["type"];
            this.serviceId = _data["serviceId"];
            if (Array.isArray(_data["seats"])) {
                this.seats = [] as any;
                for (let item of _data["seats"])
                    this.seats!.push(TrainSeatDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeatsAvailabilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeatsAvailabilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wagonId"] = this.wagonId;
        data["type"] = this.type;
        data["serviceId"] = this.serviceId;
        if (Array.isArray(this.seats)) {
            data["seats"] = [];
            for (let item of this.seats)
                data["seats"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeatsAvailabilityDTO {
    wagonId: string | undefined;
    type: string | undefined;
    serviceId: number;
    seats: TrainSeatDTO[] | undefined;
}

export class TransportUnitsDTO implements ITransportUnitsDTO {
    unitIndex!: string;
    layout!: string | undefined;
    seatsAvailability!: SeatsAvailabilityDTO;
    totalQuantity!: number;
    availableQuantity!: number;
    reservedSeatsQuantity!: number;

    constructor(data?: ITransportUnitsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitIndex = _data["unitIndex"];
            this.layout = _data["layout"];
            this.seatsAvailability = _data["seatsAvailability"] ? SeatsAvailabilityDTO.fromJS(_data["seatsAvailability"]) : <any>undefined;
            this.totalQuantity = _data["totalQuantity"];
            this.availableQuantity = _data["availableQuantity"];
            this.reservedSeatsQuantity = _data["reservedSeatsQuantity"];
        }
    }

    static fromJS(data: any): TransportUnitsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TransportUnitsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitIndex"] = this.unitIndex;
        data["layout"] = this.layout;
        data["seatsAvailability"] = this.seatsAvailability ? this.seatsAvailability.toJSON() : <any>undefined;
        data["totalQuantity"] = this.totalQuantity;
        data["availableQuantity"] = this.availableQuantity;
        data["reservedSeatsQuantity"] = this.reservedSeatsQuantity;
        return data;
    }
}

export interface ITransportUnitsDTO {
    unitIndex: string;
    layout: string | undefined;
    seatsAvailability: SeatsAvailabilityDTO;
    totalQuantity: number;
    availableQuantity: number;
    reservedSeatsQuantity: number;
}

export class LayoutDTO implements ILayoutDTO {
    idXml!: string | undefined;
    trainNumber!: string | undefined;
    trainDenomination!: string | undefined;
    trainClassificationId!: string | undefined;
    seatPrice!: number;
    transportUnits!: TransportUnitsDTO[] | undefined;

    constructor(data?: ILayoutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idXml = _data["idXml"];
            this.trainNumber = _data["trainNumber"];
            this.trainDenomination = _data["trainDenomination"];
            this.trainClassificationId = _data["trainClassificationId"];
            this.seatPrice = _data["seatPrice"];
            if (Array.isArray(_data["transportUnits"])) {
                this.transportUnits = [] as any;
                for (let item of _data["transportUnits"])
                    this.transportUnits!.push(TransportUnitsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LayoutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idXml"] = this.idXml;
        data["trainNumber"] = this.trainNumber;
        data["trainDenomination"] = this.trainDenomination;
        data["trainClassificationId"] = this.trainClassificationId;
        data["seatPrice"] = this.seatPrice;
        if (Array.isArray(this.transportUnits)) {
            data["transportUnits"] = [];
            for (let item of this.transportUnits)
                data["transportUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILayoutDTO {
    idXml: string | undefined;
    trainNumber: string | undefined;
    trainDenomination: string | undefined;
    trainClassificationId: string | undefined;
    seatPrice: number;
    transportUnits: TransportUnitsDTO[] | undefined;
}

export class TrainLayoutDTO implements ITrainLayoutDTO {
    layouts!: LayoutDTO[] | undefined;
    evaluateTravel!: EvaluateTravelResponseDto;

    constructor(data?: ITrainLayoutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["layouts"])) {
                this.layouts = [] as any;
                for (let item of _data["layouts"])
                    this.layouts!.push(LayoutDTO.fromJS(item));
            }
            this.evaluateTravel = _data["evaluateTravel"] ? EvaluateTravelResponseDto.fromJS(_data["evaluateTravel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrainLayoutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrainLayoutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.layouts)) {
            data["layouts"] = [];
            for (let item of this.layouts)
                data["layouts"].push(item.toJSON());
        }
        data["evaluateTravel"] = this.evaluateTravel ? this.evaluateTravel.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITrainLayoutDTO {
    layouts: LayoutDTO[] | undefined;
    evaluateTravel: EvaluateTravelResponseDto;
}

export class ApiResponseOfTrainLayoutDTO implements IApiResponseOfTrainLayoutDTO {
    result!: TrainLayoutDTO;
    success!: boolean;
    error!: ErrorInfo;
    targetUrl!: string | undefined;

    constructor(data?: IApiResponseOfTrainLayoutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? TrainLayoutDTO.fromJS(_data["result"]) : <any>undefined;
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
        }
    }

    static fromJS(data: any): ApiResponseOfTrainLayoutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseOfTrainLayoutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        return data;
    }
}

export interface IApiResponseOfTrainLayoutDTO {
    result: TrainLayoutDTO;
    success: boolean;
    error: ErrorInfo;
    targetUrl: string | undefined;
}

export class SeatsDTO implements ISeatsDTO {
    trainNumber!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    seatName!: string | undefined;
    price!: number;

    constructor(data?: ISeatsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainNumber = _data["trainNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.seatName = _data["seatName"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): SeatsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeatsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainNumber"] = this.trainNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["seatName"] = this.seatName;
        data["price"] = this.price;
        return data;
    }
}

export interface ISeatsDTO {
    trainNumber: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    seatName: string | undefined;
    price: number;
}

export class AddSpecialServicesInputDto implements IAddSpecialServicesInputDto {
    reservationId!: string | undefined;
    passengersSpecialServices!: PersonNameSsrDto[] | undefined;

    constructor(data?: IAddSpecialServicesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            if (Array.isArray(_data["passengersSpecialServices"])) {
                this.passengersSpecialServices = [] as any;
                for (let item of _data["passengersSpecialServices"])
                    this.passengersSpecialServices!.push(PersonNameSsrDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddSpecialServicesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddSpecialServicesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        if (Array.isArray(this.passengersSpecialServices)) {
            data["passengersSpecialServices"] = [];
            for (let item of this.passengersSpecialServices)
                data["passengersSpecialServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddSpecialServicesInputDto {
    reservationId: string | undefined;
    passengersSpecialServices: PersonNameSsrDto[] | undefined;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class LogoFile implements ILogoFile {
    fileToken!: string;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: ILogoFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): LogoFile {
        data = typeof data === 'object' ? data : {};
        let result = new LogoFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface ILogoFile {
    fileToken: string;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class UpdateLogoPictureInput implements IUpdateLogoPictureInput {
    logo!: LogoFile;
    agencyId!: string;

    constructor(data?: IUpdateLogoPictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logo = _data["logo"] ? LogoFile.fromJS(_data["logo"]) : <any>undefined;
            this.agencyId = _data["agencyId"];
        }
    }

    static fromJS(data: any): UpdateLogoPictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLogoPictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        data["agencyId"] = this.agencyId;
        return data;
    }
}

export interface IUpdateLogoPictureInput {
    logo: LogoFile;
    agencyId: string;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    agencyId!: string | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.agencyId = _data["agencyId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["agencyId"] = this.agencyId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    agencyId: string | undefined;
    id: number;
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    creationTime!: moment.Moment;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    userDelegationIsEnabled!: boolean;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        this.features![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    userDelegationIsEnabled: boolean;
    features: { [key: string]: boolean; } | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    headerSkin!: string | undefined;
    minimizeDesktopHeaderType!: string | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.headerSkin = _data["headerSkin"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    headerSkin: string | undefined;
    minimizeDesktopHeaderType: string | undefined;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;
    subheaderSize!: number;
    titleStlye!: string | undefined;
    containerStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
            this.subheaderSize = _data["subheaderSize"];
            this.titleStlye = _data["titleStlye"];
            this.containerStyle = _data["containerStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        data["subheaderSize"] = this.subheaderSize;
        data["titleStlye"] = this.titleStlye;
        data["containerStyle"] = this.containerStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
    subheaderSize: number;
    titleStlye: string | undefined;
    containerStyle: string | undefined;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;
    enableSecondary!: boolean;
    hoverableAside!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
            this.enableSecondary = _data["enableSecondary"];
            this.hoverableAside = _data["hoverableAside"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        data["enableSecondary"] = this.enableSecondary;
        data["hoverableAside"] = this.hoverableAside;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
    enableSecondary: boolean;
    hoverableAside: boolean;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    impersonatorUser!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    impersonatorTenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    impersonatorUser: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    impersonatorTenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class StateListDto implements IStateListDto {
    id!: string | undefined;
    code!: string | undefined;
    shortName!: string | undefined;
    name!: string | undefined;
    isBlacklist!: boolean;

    constructor(data?: IStateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.shortName = _data["shortName"];
            this.name = _data["name"];
            this.isBlacklist = _data["isBlacklist"];
        }
    }

    static fromJS(data: any): StateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["shortName"] = this.shortName;
        data["name"] = this.name;
        data["isBlacklist"] = this.isBlacklist;
        return data;
    }
}

export interface IStateListDto {
    id: string | undefined;
    code: string | undefined;
    shortName: string | undefined;
    name: string | undefined;
    isBlacklist: boolean;
}

export class StateDto implements IStateDto {
    id!: string | undefined;
    code!: string | undefined;
    shortName!: string | undefined;
    name!: string | undefined;

    constructor(data?: IStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.shortName = _data["shortName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["shortName"] = this.shortName;
        data["name"] = this.name;
        return data;
    }
}

export interface IStateDto {
    id: string | undefined;
    code: string | undefined;
    shortName: string | undefined;
    name: string | undefined;
}

export class PagedResultDtoOfStateListDto implements IPagedResultDtoOfStateListDto {
    totalCount!: number;
    items!: StateListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StateListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfStateListDto {
    totalCount: number;
    items: StateListDto[] | undefined;
}

export class StationDTO implements IStationDTO {
    id!: string | undefined;
    cityName!: LocalizedString;
    poiName!: LocalizedString;
    position!: PositionDTO;
    countryCode!: string | undefined;
    countryName!: LocalizedString;
    isBlackList!: boolean;
    priority!: number;
    displayName!: string | undefined;
    alias!: string[] | undefined;
    isMultiCity!: boolean;
    groupCode!: string | undefined;
    slug!: string | undefined;
    providerLinks!: TagOfStringString[] | undefined;
    iata!: string | undefined;
    ts!: moment.Moment;

    constructor(data?: IStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cityName = _data["cityName"] ? LocalizedString.fromJS(_data["cityName"]) : <any>undefined;
            this.poiName = _data["poiName"] ? LocalizedString.fromJS(_data["poiName"]) : <any>undefined;
            this.position = _data["position"] ? PositionDTO.fromJS(_data["position"]) : <any>undefined;
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"] ? LocalizedString.fromJS(_data["countryName"]) : <any>undefined;
            this.isBlackList = _data["isBlackList"];
            this.priority = _data["priority"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["alias"])) {
                this.alias = [] as any;
                for (let item of _data["alias"])
                    this.alias!.push(item);
            }
            this.isMultiCity = _data["isMultiCity"];
            this.groupCode = _data["groupCode"];
            this.slug = _data["slug"];
            if (Array.isArray(_data["providerLinks"])) {
                this.providerLinks = [] as any;
                for (let item of _data["providerLinks"])
                    this.providerLinks!.push(TagOfStringString.fromJS(item));
            }
            this.iata = _data["iata"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cityName"] = this.cityName ? this.cityName.toJSON() : <any>undefined;
        data["poiName"] = this.poiName ? this.poiName.toJSON() : <any>undefined;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName ? this.countryName.toJSON() : <any>undefined;
        data["isBlackList"] = this.isBlackList;
        data["priority"] = this.priority;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.alias)) {
            data["alias"] = [];
            for (let item of this.alias)
                data["alias"].push(item);
        }
        data["isMultiCity"] = this.isMultiCity;
        data["groupCode"] = this.groupCode;
        data["slug"] = this.slug;
        if (Array.isArray(this.providerLinks)) {
            data["providerLinks"] = [];
            for (let item of this.providerLinks)
                data["providerLinks"].push(item.toJSON());
        }
        data["iata"] = this.iata;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStationDTO {
    id: string | undefined;
    cityName: LocalizedString;
    poiName: LocalizedString;
    position: PositionDTO;
    countryCode: string | undefined;
    countryName: LocalizedString;
    isBlackList: boolean;
    priority: number;
    displayName: string | undefined;
    alias: string[] | undefined;
    isMultiCity: boolean;
    groupCode: string | undefined;
    slug: string | undefined;
    providerLinks: TagOfStringString[] | undefined;
    iata: string | undefined;
    ts: moment.Moment;
}

export class PagedResultDtoOfStationDTO implements IPagedResultDtoOfStationDTO {
    totalCount!: number;
    items!: StationDTO[] | undefined;

    constructor(data?: IPagedResultDtoOfStationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfStationDTO {
    totalCount: number;
    items: StationDTO[] | undefined;
}

export class StripeConfigurationDto implements IStripeConfigurationDto {
    publishableKey!: string | undefined;

    constructor(data?: IStripeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publishableKey = _data["publishableKey"];
        }
    }

    static fromJS(data: any): StripeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data;
    }
}

export interface IStripeConfigurationDto {
    publishableKey: string | undefined;
}

export class StripeCreatePaymentSessionInput implements IStripeCreatePaymentSessionInput {
    paymentId!: number;
    successUrl!: string | undefined;
    cancelUrl!: string | undefined;

    constructor(data?: IStripeCreatePaymentSessionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
        }
    }

    static fromJS(data: any): StripeCreatePaymentSessionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeCreatePaymentSessionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    }
}

export interface IStripeCreatePaymentSessionInput {
    paymentId: number;
    successUrl: string | undefined;
    cancelUrl: string | undefined;
}

export class StripePaymentResultOutput implements IStripePaymentResultOutput {
    paymentDone!: boolean;

    constructor(data?: IStripePaymentResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDone = _data["paymentDone"];
        }
    }

    static fromJS(data: any): StripePaymentResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDone"] = this.paymentDone;
        return data;
    }
}

export interface IStripePaymentResultOutput {
    paymentDone: boolean;
}

export class Amenity implements IAmenity {
    id!: number;
    name!: LocalizedString;
    value!: LocalizedString;
    icon!: string | undefined;
    amenityType!: AmenityType;
    ts!: moment.Moment;

    constructor(data?: IAmenity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? LocalizedString.fromJS(_data["name"]) : <any>undefined;
            this.value = _data["value"] ? LocalizedString.fromJS(_data["value"]) : <any>undefined;
            this.icon = _data["icon"];
            this.amenityType = _data["amenityType"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Amenity {
        data = typeof data === 'object' ? data : {};
        let result = new Amenity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["icon"] = this.icon;
        data["amenityType"] = this.amenityType;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAmenity {
    id: number;
    name: LocalizedString;
    value: LocalizedString;
    icon: string | undefined;
    amenityType: AmenityType;
    ts: moment.Moment;
}

export class ProviderLinkObject implements IProviderLinkObject {
    n!: string | undefined;
    v!: string | undefined;
    score_MongoDB!: number | undefined;
    score_JT!: number | undefined;
    valueChecked!: boolean | undefined;
    lastSeen!: moment.Moment | undefined;

    constructor(data?: IProviderLinkObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.n = _data["n"];
            this.v = _data["v"];
            this.score_MongoDB = _data["score_MongoDB"];
            this.score_JT = _data["score_JT"];
            this.valueChecked = _data["valueChecked"];
            this.lastSeen = _data["lastSeen"] ? moment(_data["lastSeen"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderLinkObject {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderLinkObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["n"] = this.n;
        data["v"] = this.v;
        data["score_MongoDB"] = this.score_MongoDB;
        data["score_JT"] = this.score_JT;
        data["valueChecked"] = this.valueChecked;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProviderLinkObject {
    n: string | undefined;
    v: string | undefined;
    score_MongoDB: number | undefined;
    score_JT: number | undefined;
    valueChecked: boolean | undefined;
    lastSeen: moment.Moment | undefined;
}

export class StructureRootMasterDto implements IStructureRootMasterDto {
    id!: string | undefined;
    ts!: moment.Moment;
    addresses!: Address[] | undefined;
    airports!: Airport[] | undefined;
    amenities!: Amenity[] | undefined;
    category!: TagOfStringString;
    checkInTime!: string | undefined;
    checkOutTime!: string | undefined;
    contacts!: TagOfStringString[] | undefined;
    descriptions!: TagOfStringLocalizedString[] | undefined;
    destinationId!: string | undefined;
    readonly generalAmenities!: Amenity[] | undefined;
    highRate!: number;
    readonly hotelAmenities!: Amenity[] | undefined;
    info!: TagOfStringString[] | undefined;
    isBlacklist!: boolean;
    locations!: TagOfStringString[] | undefined;
    lowRate!: number;
    multimedia!: TagOfStringString[] | undefined;
    name!: string | undefined;
    readonly otherAmenities!: Amenity[] | undefined;
    position!: PositionDTO;
    providerLinks!: ProviderLinkObject[] | undefined;
    readonly roomAmenities!: Amenity[] | undefined;
    thumb!: string | undefined;
    readonly topAmenities!: Amenity[] | undefined;
    userScore!: UserScoreDto;
    type!: TagOfStringString;
    isoCountry!: string | undefined;
    slug!: string | undefined;

    constructor(data?: IStructureRootMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(Address.fromJS(item));
            }
            if (Array.isArray(_data["airports"])) {
                this.airports = [] as any;
                for (let item of _data["airports"])
                    this.airports!.push(Airport.fromJS(item));
            }
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities!.push(Amenity.fromJS(item));
            }
            this.category = _data["category"] ? TagOfStringString.fromJS(_data["category"]) : <any>undefined;
            this.checkInTime = _data["checkInTime"];
            this.checkOutTime = _data["checkOutTime"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(TagOfStringString.fromJS(item));
            }
            if (Array.isArray(_data["descriptions"])) {
                this.descriptions = [] as any;
                for (let item of _data["descriptions"])
                    this.descriptions!.push(TagOfStringLocalizedString.fromJS(item));
            }
            this.destinationId = _data["destinationId"];
            if (Array.isArray(_data["generalAmenities"])) {
                (<any>this).generalAmenities = [] as any;
                for (let item of _data["generalAmenities"])
                    (<any>this).generalAmenities!.push(Amenity.fromJS(item));
            }
            this.highRate = _data["highRate"];
            if (Array.isArray(_data["hotelAmenities"])) {
                (<any>this).hotelAmenities = [] as any;
                for (let item of _data["hotelAmenities"])
                    (<any>this).hotelAmenities!.push(Amenity.fromJS(item));
            }
            if (Array.isArray(_data["info"])) {
                this.info = [] as any;
                for (let item of _data["info"])
                    this.info!.push(TagOfStringString.fromJS(item));
            }
            this.isBlacklist = _data["isBlacklist"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(TagOfStringString.fromJS(item));
            }
            this.lowRate = _data["lowRate"];
            if (Array.isArray(_data["multimedia"])) {
                this.multimedia = [] as any;
                for (let item of _data["multimedia"])
                    this.multimedia!.push(TagOfStringString.fromJS(item));
            }
            this.name = _data["name"];
            if (Array.isArray(_data["otherAmenities"])) {
                (<any>this).otherAmenities = [] as any;
                for (let item of _data["otherAmenities"])
                    (<any>this).otherAmenities!.push(Amenity.fromJS(item));
            }
            this.position = _data["position"] ? PositionDTO.fromJS(_data["position"]) : <any>undefined;
            if (Array.isArray(_data["providerLinks"])) {
                this.providerLinks = [] as any;
                for (let item of _data["providerLinks"])
                    this.providerLinks!.push(ProviderLinkObject.fromJS(item));
            }
            if (Array.isArray(_data["roomAmenities"])) {
                (<any>this).roomAmenities = [] as any;
                for (let item of _data["roomAmenities"])
                    (<any>this).roomAmenities!.push(Amenity.fromJS(item));
            }
            this.thumb = _data["thumb"];
            if (Array.isArray(_data["topAmenities"])) {
                (<any>this).topAmenities = [] as any;
                for (let item of _data["topAmenities"])
                    (<any>this).topAmenities!.push(Amenity.fromJS(item));
            }
            this.userScore = _data["userScore"] ? UserScoreDto.fromJS(_data["userScore"]) : <any>undefined;
            this.type = _data["type"] ? TagOfStringString.fromJS(_data["type"]) : <any>undefined;
            this.isoCountry = _data["isoCountry"];
            this.slug = _data["slug"];
        }
    }

    static fromJS(data: any): StructureRootMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureRootMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.airports)) {
            data["airports"] = [];
            for (let item of this.airports)
                data["airports"].push(item.toJSON());
        }
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item.toJSON());
        }
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["checkInTime"] = this.checkInTime;
        data["checkOutTime"] = this.checkOutTime;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.descriptions)) {
            data["descriptions"] = [];
            for (let item of this.descriptions)
                data["descriptions"].push(item.toJSON());
        }
        data["destinationId"] = this.destinationId;
        if (Array.isArray(this.generalAmenities)) {
            data["generalAmenities"] = [];
            for (let item of this.generalAmenities)
                data["generalAmenities"].push(item.toJSON());
        }
        data["highRate"] = this.highRate;
        if (Array.isArray(this.hotelAmenities)) {
            data["hotelAmenities"] = [];
            for (let item of this.hotelAmenities)
                data["hotelAmenities"].push(item.toJSON());
        }
        if (Array.isArray(this.info)) {
            data["info"] = [];
            for (let item of this.info)
                data["info"].push(item.toJSON());
        }
        data["isBlacklist"] = this.isBlacklist;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["lowRate"] = this.lowRate;
        if (Array.isArray(this.multimedia)) {
            data["multimedia"] = [];
            for (let item of this.multimedia)
                data["multimedia"].push(item.toJSON());
        }
        data["name"] = this.name;
        if (Array.isArray(this.otherAmenities)) {
            data["otherAmenities"] = [];
            for (let item of this.otherAmenities)
                data["otherAmenities"].push(item.toJSON());
        }
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        if (Array.isArray(this.providerLinks)) {
            data["providerLinks"] = [];
            for (let item of this.providerLinks)
                data["providerLinks"].push(item.toJSON());
        }
        if (Array.isArray(this.roomAmenities)) {
            data["roomAmenities"] = [];
            for (let item of this.roomAmenities)
                data["roomAmenities"].push(item.toJSON());
        }
        data["thumb"] = this.thumb;
        if (Array.isArray(this.topAmenities)) {
            data["topAmenities"] = [];
            for (let item of this.topAmenities)
                data["topAmenities"].push(item.toJSON());
        }
        data["userScore"] = this.userScore ? this.userScore.toJSON() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["isoCountry"] = this.isoCountry;
        data["slug"] = this.slug;
        return data;
    }
}

export interface IStructureRootMasterDto {
    id: string | undefined;
    ts: moment.Moment;
    addresses: Address[] | undefined;
    airports: Airport[] | undefined;
    amenities: Amenity[] | undefined;
    category: TagOfStringString;
    checkInTime: string | undefined;
    checkOutTime: string | undefined;
    contacts: TagOfStringString[] | undefined;
    descriptions: TagOfStringLocalizedString[] | undefined;
    destinationId: string | undefined;
    generalAmenities: Amenity[] | undefined;
    highRate: number;
    hotelAmenities: Amenity[] | undefined;
    info: TagOfStringString[] | undefined;
    isBlacklist: boolean;
    locations: TagOfStringString[] | undefined;
    lowRate: number;
    multimedia: TagOfStringString[] | undefined;
    name: string | undefined;
    otherAmenities: Amenity[] | undefined;
    position: PositionDTO;
    providerLinks: ProviderLinkObject[] | undefined;
    roomAmenities: Amenity[] | undefined;
    thumb: string | undefined;
    topAmenities: Amenity[] | undefined;
    userScore: UserScoreDto;
    type: TagOfStringString;
    isoCountry: string | undefined;
    slug: string | undefined;
}

export class PagedResultDtoOfStructureRootMasterDto implements IPagedResultDtoOfStructureRootMasterDto {
    totalCount!: number;
    items!: StructureRootMasterDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStructureRootMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StructureRootMasterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStructureRootMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStructureRootMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfStructureRootMasterDto {
    totalCount: number;
    items: StructureRootMasterDto[] | undefined;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: moment.Moment;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number;
    closed!: number;
    rate!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.earnings = _data["earnings"];
            this.cases = _data["cases"];
            this.closed = _data["closed"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number;
    closed: number;
    rate: string | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of _data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class GetTopStatsOutput implements IGetTopStatsOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;

    constructor(data?: IGetTopStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
        }
    }

    static fromJS(data: any): GetTopStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        return data;
    }
}

export interface IGetTopStatsOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
}

export class GetProfitShareOutput implements IGetProfitShareOutput {
    profitShares!: number[] | undefined;

    constructor(data?: IGetProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetProfitShareOutput {
    profitShares: number[] | undefined;
}

export class GetDailySalesOutput implements IGetDailySalesOutput {
    dailySales!: number[] | undefined;

    constructor(data?: IGetDailySalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDailySalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailySalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        return data;
    }
}

export interface IGetDailySalesOutput {
    dailySales: number[] | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSalesSummaryOutput {
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number;
    change!: number[] | undefined;
    averagePrice!: number;
    totalPrice!: number;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.sales = _data["sales"];
            if (Array.isArray(_data["change"])) {
                this.change = [] as any;
                for (let item of _data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = _data["averagePrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): RegionalStatCountry {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalStatCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number;
    change: number[] | undefined;
    averagePrice: number;
    totalPrice: number;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(RegionalStatCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionalStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.captchaResponse = _data["captchaResponse"];
            this.subscriptionStartType = _data["subscriptionStartType"];
            this.editionId = _data["editionId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    useCaptchaOnLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpSslProtocols!: string | undefined;
    smtpAllowUntrustedCertificate!: boolean;
    smtpSecureSocketOptions!: string | undefined;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpSslProtocols = _data["smtpSslProtocols"];
            this.smtpAllowUntrustedCertificate = _data["smtpAllowUntrustedCertificate"];
            this.smtpSecureSocketOptions = _data["smtpSecureSocketOptions"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpSslProtocols"] = this.smtpSslProtocols;
        data["smtpAllowUntrustedCertificate"] = this.smtpAllowUntrustedCertificate;
        data["smtpSecureSocketOptions"] = this.smtpSecureSocketOptions;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpSslProtocols: string | undefined;
    smtpAllowUntrustedCertificate: boolean;
    smtpSecureSocketOptions: string | undefined;
    smtpUseDefaultCredentials: boolean;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class TenantSiapSettingsEditDto implements ITenantSiapSettingsEditDto {
    enabled!: boolean;
    username!: string | undefined;
    password!: string | undefined;
    companyCode!: string | undefined;
    userCode!: string | undefined;
    json!: string | undefined;

    constructor(data?: ITenantSiapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.companyCode = _data["companyCode"];
            this.userCode = _data["userCode"];
            this.json = _data["json"];
        }
    }

    static fromJS(data: any): TenantSiapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSiapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["username"] = this.username;
        data["password"] = this.password;
        data["companyCode"] = this.companyCode;
        data["userCode"] = this.userCode;
        data["json"] = this.json;
        return data;
    }
}

export interface ITenantSiapSettingsEditDto {
    enabled: boolean;
    username: string | undefined;
    password: string | undefined;
    companyCode: string | undefined;
    userCode: string | undefined;
    json: string | undefined;
}

export class AgencyManagementSettingsEditDto implements IAgencyManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredAgencyActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    customerServiceUserId!: number;

    constructor(data?: IAgencyManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredAgencyActiveByDefault = _data["isNewRegisteredAgencyActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.customerServiceUserId = _data["customerServiceUserId"];
        }
    }

    static fromJS(data: any): AgencyManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredAgencyActiveByDefault"] = this.isNewRegisteredAgencyActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["customerServiceUserId"] = this.customerServiceUserId;
        return data;
    }
}

export interface IAgencyManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredAgencyActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    customerServiceUserId: number;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;
    siapSettings!: TenantSiapSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;
    agencyManagement!: AgencyManagementSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
            this.agencyManagement = new AgencyManagementSettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.siapSettings = _data["siapSettings"] ? TenantSiapSettingsEditDto.fromJS(_data["siapSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
            this.agencyManagement = _data["agencyManagement"] ? AgencyManagementSettingsEditDto.fromJS(_data["agencyManagement"]) : new AgencyManagementSettingsEditDto();
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["siapSettings"] = this.siapSettings ? this.siapSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        data["agencyManagement"] = this.agencyManagement ? this.agencyManagement.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
    siapSettings: TenantSiapSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
    agencyManagement: AgencyManagementSettingsEditDto;
}

export class CommandMessageDto implements ICommandMessageDto {
    conversationId!: string;
    command!: string;

    constructor(data?: ICommandMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["conversationId"];
            this.command = _data["command"];
        }
    }

    static fromJS(data: any): CommandMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommandMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId;
        data["command"] = this.command;
        return data;
    }
}

export interface ICommandMessageDto {
    conversationId: string;
    command: string;
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        this.additionalParams![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    data["additionalParams"][key] = this.additionalParams[key];
            }
        }
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    waitingForActivation!: boolean;
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waitingForActivation = _data["waitingForActivation"];
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitingForActivation"] = this.waitingForActivation;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    waitingForActivation: boolean;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class TrainPaxClientDTO implements ITrainPaxClientDTO {
    type!: string | undefined;
    minAge!: number;
    maxAge!: number;
    ages!: number[] | undefined;

    constructor(data?: ITrainPaxClientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.minAge = _data["minAge"];
            this.maxAge = _data["maxAge"];
            if (Array.isArray(_data["ages"])) {
                this.ages = [] as any;
                for (let item of _data["ages"])
                    this.ages!.push(item);
            }
        }
    }

    static fromJS(data: any): TrainPaxClientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrainPaxClientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["minAge"] = this.minAge;
        data["maxAge"] = this.maxAge;
        if (Array.isArray(this.ages)) {
            data["ages"] = [];
            for (let item of this.ages)
                data["ages"].push(item);
        }
        return data;
    }
}

export interface ITrainPaxClientDTO {
    type: string | undefined;
    minAge: number;
    maxAge: number;
    ages: number[] | undefined;
}

export class TrainAvailabilityRequestDTO implements ITrainAvailabilityRequestDTO {
    originCode!: string | undefined;
    destinationCode!: string | undefined;
    departureDate!: moment.Moment;
    returnDate!: moment.Moment | undefined;
    originStation!: LocationDTO;
    destinationStation!: LocationDTO;
    departureRangeStartTime!: string | undefined;
    departureRangeEndTime!: string | undefined;
    returnRangeStartTime!: string | undefined;
    returnRangeEndTime!: string | undefined;
    departureRangeType!: RangeTimeTypeDto;
    returnRangeType!: RangeTimeTypeDto;
    passengers!: PassengerDTO[] | undefined;
    speedTrainOnly!: boolean;
    bestFareOnly!: boolean;
    directOnly!: boolean;
    nearAirports!: boolean;
    postSale!: boolean;
    tripType!: TripTypeDTO;
    carnetId!: string | undefined;
    co2Data!: Co2DataDTO | undefined

    constructor(data?: ITrainAvailabilityRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originCode = _data["originCode"];
            this.destinationCode = _data["destinationCode"];
            this.departureDate = _data["departureDate"] ? moment(_data["departureDate"].toString()) : <any>undefined;
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : <any>undefined;
            this.originStation = _data["originStation"] ? LocationDTO.fromJS(_data["originStation"]) : <any>undefined;
            this.destinationStation = _data["destinationStation"] ? LocationDTO.fromJS(_data["destinationStation"]) : <any>undefined;
            this.departureRangeStartTime = _data["departureRangeStartTime"];
            this.departureRangeEndTime = _data["departureRangeEndTime"];
            this.returnRangeStartTime = _data["returnRangeStartTime"];
            this.returnRangeEndTime = _data["returnRangeEndTime"];
            this.departureRangeType = _data["departureRangeType"];
            this.returnRangeType = _data["returnRangeType"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PassengerDTO.fromJS(item));
            }
            this.speedTrainOnly = _data["speedTrainOnly"];
            this.bestFareOnly = _data["bestFareOnly"];
            this.directOnly = _data["directOnly"];
            this.nearAirports = _data["nearAirports"];
            this.postSale = _data["postSale"];
            this.tripType = _data["tripType"];
            this.carnetId = _data["carnetId"];
            this.co2Data = _data["co2Data"];
        }
    }

    static fromJS(data: any): TrainAvailabilityRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrainAvailabilityRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originCode"] = this.originCode;
        data["destinationCode"] = this.destinationCode;
        data["departureDate"] = this.departureDate ? this.departureDate.toISOString() : <any>undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["originStation"] = this.originStation ? this.originStation.toJSON() : <any>undefined;
        data["destinationStation"] = this.destinationStation ? this.destinationStation.toJSON() : <any>undefined;
        data["departureRangeStartTime"] = this.departureRangeStartTime;
        data["departureRangeEndTime"] = this.departureRangeEndTime;
        data["returnRangeStartTime"] = this.returnRangeStartTime;
        data["returnRangeEndTime"] = this.returnRangeEndTime;
        data["departureRangeType"] = this.departureRangeType;
        data["returnRangeType"] = this.returnRangeType;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["speedTrainOnly"] = this.speedTrainOnly;
        data["bestFareOnly"] = this.bestFareOnly;
        data["directOnly"] = this.directOnly;
        data["nearAirports"] = this.nearAirports;
        data["postSale"] = this.postSale;
        data["tripType"] = this.tripType;
        data["carnetId"] = this.carnetId;
        data["co2Data"] = this.co2Data;
        return data;
    }
}

export interface ITrainAvailabilityRequestDTO {
    originCode: string | undefined;
    destinationCode: string | undefined;
    departureDate: moment.Moment;
    returnDate: moment.Moment | undefined;
    originStation: LocationDTO;
    destinationStation: LocationDTO;
    departureRangeStartTime: string | undefined;
    departureRangeEndTime: string | undefined;
    returnRangeStartTime: string | undefined;
    returnRangeEndTime: string | undefined;
    departureRangeType: RangeTimeTypeDto;
    returnRangeType: RangeTimeTypeDto;
    passengers: PassengerDTO[] | undefined;
    speedTrainOnly: boolean;
    bestFareOnly: boolean;
    directOnly: boolean;
    nearAirports: boolean;
    postSale: boolean;
    tripType: TripTypeDTO;
    carnetId: string | undefined;
    co2Data: Co2DataDTO | undefined
}

export class TrainBookRequestBaseDto implements ITrainBookRequestBaseDto {
    availabilityId!: string | undefined;
    outwardGroupItineraryId!: string | undefined;
    returnGroupItineraryId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;
    outwardPricingInformationIds!: string[] | undefined;
    returnPricingInformationIds!: string[] | undefined;

    constructor(data?: ITrainBookRequestBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityId = _data["availabilityId"];
            this.outwardGroupItineraryId = _data["outwardGroupItineraryId"];
            this.returnGroupItineraryId = _data["returnGroupItineraryId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
            if (Array.isArray(_data["outwardPricingInformationIds"])) {
                this.outwardPricingInformationIds = [] as any;
                for (let item of _data["outwardPricingInformationIds"])
                    this.outwardPricingInformationIds!.push(item);
            }
            if (Array.isArray(_data["returnPricingInformationIds"])) {
                this.returnPricingInformationIds = [] as any;
                for (let item of _data["returnPricingInformationIds"])
                    this.returnPricingInformationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TrainBookRequestBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainBookRequestBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityId"] = this.availabilityId;
        data["outwardGroupItineraryId"] = this.outwardGroupItineraryId;
        data["returnGroupItineraryId"] = this.returnGroupItineraryId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        if (Array.isArray(this.outwardPricingInformationIds)) {
            data["outwardPricingInformationIds"] = [];
            for (let item of this.outwardPricingInformationIds)
                data["outwardPricingInformationIds"].push(item);
        }
        if (Array.isArray(this.returnPricingInformationIds)) {
            data["returnPricingInformationIds"] = [];
            for (let item of this.returnPricingInformationIds)
                data["returnPricingInformationIds"].push(item);
        }
        return data;
    }
}

export interface ITrainBookRequestBaseDto {
    availabilityId: string | undefined;
    outwardGroupItineraryId: string | undefined;
    returnGroupItineraryId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
    outwardPricingInformationIds: string[] | undefined;
    returnPricingInformationIds: string[] | undefined;
}

export class OfferServiceOptionDto implements IOfferServiceOptionDto {
    availableCount!: number;
    id!: string | undefined;
    offer!: string | undefined;
    offerDescription!: string | undefined;
    catalogService!: string | undefined;
    catalogServiceDescription!: string | undefined;
    price!: number;
    feeValue!: number;
    agencyFeeValue!: number;

    constructor(data?: IOfferServiceOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availableCount = _data["availableCount"];
            this.id = _data["id"];
            this.offer = _data["offer"];
            this.offerDescription = _data["offerDescription"];
            this.catalogService = _data["catalogService"];
            this.catalogServiceDescription = _data["catalogServiceDescription"];
            this.price = _data["price"];
            this.feeValue = _data["feeValue"];
            this.agencyFeeValue = _data["agencyFeeValue"];
        }
    }

    static fromJS(data: any): OfferServiceOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferServiceOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availableCount"] = this.availableCount;
        data["id"] = this.id;
        data["offer"] = this.offer;
        data["offerDescription"] = this.offerDescription;
        data["catalogService"] = this.catalogService;
        data["catalogServiceDescription"] = this.catalogServiceDescription;
        data["price"] = this.price;
        data["feeValue"] = this.feeValue;
        data["agencyFeeValue"] = this.agencyFeeValue;
        return data;
    }
}

export interface IOfferServiceOptionDto {
    availableCount: number;
    id: string | undefined;
    offer: string | undefined;
    offerDescription: string | undefined;
    catalogService: string | undefined;
    catalogServiceDescription: string | undefined;
    price: number;
    feeValue: number;
    agencyFeeValue: number;
}

export class PricedOfferDto implements IPricedOfferDto {
    offer!: string | undefined;
    offerServiceOptions!: OfferServiceOptionDto[] | undefined;

    constructor(data?: IPricedOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offer = _data["offer"];
            if (Array.isArray(_data["offerServiceOptions"])) {
                this.offerServiceOptions = [] as any;
                for (let item of _data["offerServiceOptions"])
                    this.offerServiceOptions!.push(OfferServiceOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricedOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricedOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offer"] = this.offer;
        if (Array.isArray(this.offerServiceOptions)) {
            data["offerServiceOptions"] = [];
            for (let item of this.offerServiceOptions)
                data["offerServiceOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPricedOfferDto {
    offer: string | undefined;
    offerServiceOptions: OfferServiceOptionDto[] | undefined;
}

export class FareOfferDto implements IFareOfferDto {
    groupCode!: string | undefined;
    bestPrice!: number;
    pricedOffers!: PricedOfferDto[] | undefined;

    constructor(data?: IFareOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupCode = _data["groupCode"];
            this.bestPrice = _data["bestPrice"];
            if (Array.isArray(_data["pricedOffers"])) {
                this.pricedOffers = [] as any;
                for (let item of _data["pricedOffers"])
                    this.pricedOffers!.push(PricedOfferDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FareOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new FareOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupCode"] = this.groupCode;
        data["bestPrice"] = this.bestPrice;
        if (Array.isArray(this.pricedOffers)) {
            data["pricedOffers"] = [];
            for (let item of this.pricedOffers)
                data["pricedOffers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFareOfferDto {
    groupCode: string | undefined;
    bestPrice: number;
    pricedOffers: PricedOfferDto[] | undefined;
}

export class TrainBookResponseDto implements ITrainBookResponseDto {
    itinerary!: ItineraryDTO;
    paymentGateways!: PaymentGatewayDto[] | undefined;
    paymentProfiles!: ListResultDtoOfPaymentDataProfileDto;
    enableFopExtraPaymentProfile!: boolean;
    bookingConfirmationTypes!: BookingConfirmationTypeDto[] | undefined;
    requiresBirthDate!: boolean;
    passengers!: PersonNameDataDTO[] | undefined;
    user!: ApplicationUserDto;
    orderId!: string | undefined;
    paymentGateway!: PaymentGatewayDto;
    bookingConfirmationType!: BookingConfirmationTypeDto;
    paymentData!: PaymentDataDto;
    paymentProfile!: PaymentDataProfileDto;
    isHold!: boolean;
    availabilityId!: string | undefined;
    outwardGroupItineraryId!: string | undefined;
    returnGroupItineraryId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;
    outwardPricingInformationIds!: string[] | undefined;
    returnPricingInformationIds!: string[] | undefined;

    constructor(data?: ITrainBookResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerary = _data["itinerary"] ? ItineraryDTO.fromJS(_data["itinerary"]) : <any>undefined;
            if (Array.isArray(_data["paymentGateways"])) {
                this.paymentGateways = [] as any;
                for (let item of _data["paymentGateways"])
                    this.paymentGateways!.push(item);
            }
            this.paymentProfiles = _data["paymentProfiles"] ? ListResultDtoOfPaymentDataProfileDto.fromJS(_data["paymentProfiles"]) : <any>undefined;
            this.enableFopExtraPaymentProfile = _data["enableFopExtraPaymentProfile"];
            if (Array.isArray(_data["bookingConfirmationTypes"])) {
                this.bookingConfirmationTypes = [] as any;
                for (let item of _data["bookingConfirmationTypes"])
                    this.bookingConfirmationTypes!.push(item);
            }
            this.requiresBirthDate = _data["requiresBirthDate"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PersonNameDataDTO.fromJS(item));
            }
            this.user = _data["user"] ? ApplicationUserDto.fromJS(_data["user"]) : <any>undefined;
            this.orderId = _data["orderId"];
            this.paymentGateway = _data["paymentGateway"];
            this.bookingConfirmationType = _data["bookingConfirmationType"];
            this.paymentData = _data["paymentData"] ? PaymentDataDto.fromJS(_data["paymentData"]) : <any>undefined;
            this.paymentProfile = _data["paymentProfile"] ? PaymentDataProfileDto.fromJS(_data["paymentProfile"]) : <any>undefined;
            this.isHold = _data["isHold"];
            this.availabilityId = _data["availabilityId"];
            this.outwardGroupItineraryId = _data["outwardGroupItineraryId"];
            this.returnGroupItineraryId = _data["returnGroupItineraryId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
            if (Array.isArray(_data["outwardPricingInformationIds"])) {
                this.outwardPricingInformationIds = [] as any;
                for (let item of _data["outwardPricingInformationIds"])
                    this.outwardPricingInformationIds!.push(item);
            }
            if (Array.isArray(_data["returnPricingInformationIds"])) {
                this.returnPricingInformationIds = [] as any;
                for (let item of _data["returnPricingInformationIds"])
                    this.returnPricingInformationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TrainBookResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainBookResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerary"] = this.itinerary ? this.itinerary.toJSON() : <any>undefined;
        if (Array.isArray(this.paymentGateways)) {
            data["paymentGateways"] = [];
            for (let item of this.paymentGateways)
                data["paymentGateways"].push(item);
        }
        data["paymentProfiles"] = this.paymentProfiles ? this.paymentProfiles.toJSON() : <any>undefined;
        data["enableFopExtraPaymentProfile"] = this.enableFopExtraPaymentProfile;
        if (Array.isArray(this.bookingConfirmationTypes)) {
            data["bookingConfirmationTypes"] = [];
            for (let item of this.bookingConfirmationTypes)
                data["bookingConfirmationTypes"].push(item);
        }
        data["requiresBirthDate"] = this.requiresBirthDate;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["paymentGateway"] = this.paymentGateway;
        data["bookingConfirmationType"] = this.bookingConfirmationType;
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        data["paymentProfile"] = this.paymentProfile ? this.paymentProfile.toJSON() : <any>undefined;
        data["isHold"] = this.isHold;
        data["availabilityId"] = this.availabilityId;
        data["outwardGroupItineraryId"] = this.outwardGroupItineraryId;
        data["returnGroupItineraryId"] = this.returnGroupItineraryId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        if (Array.isArray(this.outwardPricingInformationIds)) {
            data["outwardPricingInformationIds"] = [];
            for (let item of this.outwardPricingInformationIds)
                data["outwardPricingInformationIds"].push(item);
        }
        if (Array.isArray(this.returnPricingInformationIds)) {
            data["returnPricingInformationIds"] = [];
            for (let item of this.returnPricingInformationIds)
                data["returnPricingInformationIds"].push(item);
        }
        return data;
    }
}

export interface ITrainBookResponseDto {
    itinerary: ItineraryDTO;
    paymentGateways: PaymentGatewayDto[] | undefined;
    paymentProfiles: ListResultDtoOfPaymentDataProfileDto;
    enableFopExtraPaymentProfile: boolean;
    bookingConfirmationTypes: BookingConfirmationTypeDto[] | undefined;
    requiresBirthDate: boolean;
    passengers: PersonNameDataDTO[] | undefined;
    user: ApplicationUserDto;
    orderId: string | undefined;
    paymentGateway: PaymentGatewayDto;
    bookingConfirmationType: BookingConfirmationTypeDto;
    paymentData: PaymentDataDto;
    paymentProfile: PaymentDataProfileDto;
    isHold: boolean;
    availabilityId: string | undefined;
    outwardGroupItineraryId: string | undefined;
    returnGroupItineraryId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
    outwardPricingInformationIds: string[] | undefined;
    returnPricingInformationIds: string[] | undefined;
}

export class TrainSeatsDTO implements ITrainSeatsDTO {
    cabin!: string | undefined;
    seatName!: string | undefined;
    textPrice!: string | undefined;
    price!: number;
    window!: boolean;
    middle!: boolean | undefined;
    aisle!: boolean;
    center!: boolean;
    notSuitableForInfant!: boolean;
    notAllowedInfant!: boolean;
    notSuitableForChild!: boolean;
    bassinetFacility!: boolean;
    handicappedFacility!: boolean;
    exitRow!: boolean;
    unavailable!: boolean;
    noSeat!: string | undefined;
    emptySpace!: boolean;
    row!: number;
    warning!: boolean;
    extraLegSpace!: boolean;
    trainNumber!: string | undefined;
    seatAngle!: number;

    constructor(data?: ITrainSeatsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabin = _data["cabin"];
            this.seatName = _data["seatName"];
            this.textPrice = _data["textPrice"];
            this.price = _data["price"];
            this.window = _data["window"];
            this.middle = _data["middle"];
            this.aisle = _data["aisle"];
            this.center = _data["center"];
            this.notSuitableForInfant = _data["notSuitableForInfant"];
            this.notAllowedInfant = _data["notAllowedInfant"];
            this.notSuitableForChild = _data["notSuitableForChild"];
            this.bassinetFacility = _data["bassinetFacility"];
            this.handicappedFacility = _data["handicappedFacility"];
            this.exitRow = _data["exitRow"];
            this.unavailable = _data["unavailable"];
            this.noSeat = _data["noSeat"];
            this.emptySpace = _data["emptySpace"];
            this.row = _data["row"];
            this.warning = _data["warning"];
            this.extraLegSpace = _data["extraLegSpace"];
            this.trainNumber = _data["trainNumber"];
            this.seatAngle = _data["seatAngle"];
        }
    }

    static fromJS(data: any): TrainSeatsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrainSeatsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabin"] = this.cabin;
        data["seatName"] = this.seatName;
        data["textPrice"] = this.textPrice;
        data["price"] = this.price;
        data["window"] = this.window;
        data["middle"] = this.middle;
        data["aisle"] = this.aisle;
        data["center"] = this.center;
        data["notSuitableForInfant"] = this.notSuitableForInfant;
        data["notAllowedInfant"] = this.notAllowedInfant;
        data["notSuitableForChild"] = this.notSuitableForChild;
        data["bassinetFacility"] = this.bassinetFacility;
        data["handicappedFacility"] = this.handicappedFacility;
        data["exitRow"] = this.exitRow;
        data["unavailable"] = this.unavailable;
        data["noSeat"] = this.noSeat;
        data["emptySpace"] = this.emptySpace;
        data["row"] = this.row;
        data["warning"] = this.warning;
        data["extraLegSpace"] = this.extraLegSpace;
        data["trainNumber"] = this.trainNumber;
        data["seatAngle"] = this.seatAngle;
        return data;
    }
}

export interface ITrainSeatsDTO {
    cabin: string | undefined;
    seatName: string | undefined;
    textPrice: string | undefined;
    price: number;
    window: boolean;
    middle: boolean | undefined;
    aisle: boolean;
    center: boolean;
    notSuitableForInfant: boolean;
    notAllowedInfant: boolean;
    notSuitableForChild: boolean;
    bassinetFacility: boolean;
    handicappedFacility: boolean;
    exitRow: boolean;
    unavailable: boolean;
    noSeat: string | undefined;
    emptySpace: boolean;
    row: number;
    warning: boolean;
    extraLegSpace: boolean;
    trainNumber: string | undefined;
    seatAngle: number;
}

export class SeatsRowDTO implements ISeatsRowDTO {
    row!: number;
    seats!: TrainSeatsDTO[] | undefined;

    constructor(data?: ISeatsRowDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.row = _data["row"];
            if (Array.isArray(_data["seats"])) {
                this.seats = [] as any;
                for (let item of _data["seats"])
                    this.seats!.push(TrainSeatsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SeatsRowDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SeatsRowDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row;
        if (Array.isArray(this.seats)) {
            data["seats"] = [];
            for (let item of this.seats)
                data["seats"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeatsRowDTO {
    row: number;
    seats: TrainSeatsDTO[] | undefined;
}

export class CabinsDTO implements ICabinsDTO {
    cabinNumber!: string | undefined;
    seatMap!: SeatsRowDTO[] | undefined;

    constructor(data?: ICabinsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cabinNumber = _data["cabinNumber"];
            if (Array.isArray(_data["seatMap"])) {
                this.seatMap = [] as any;
                for (let item of _data["seatMap"])
                    this.seatMap!.push(SeatsRowDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CabinsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CabinsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cabinNumber"] = this.cabinNumber;
        if (Array.isArray(this.seatMap)) {
            data["seatMap"] = [];
            for (let item of this.seatMap)
                data["seatMap"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICabinsDTO {
    cabinNumber: string | undefined;
    seatMap: SeatsRowDTO[] | undefined;
}

export class TrainSeatsMapDTO implements ITrainSeatsMapDTO {
    trainNumber!: string | undefined;
    cabinsMap!: CabinsDTO[] | undefined;

    constructor(data?: ITrainSeatsMapDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainNumber = _data["trainNumber"];
            if (Array.isArray(_data["cabinsMap"])) {
                this.cabinsMap = [] as any;
                for (let item of _data["cabinsMap"])
                    this.cabinsMap!.push(CabinsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainSeatsMapDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrainSeatsMapDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainNumber"] = this.trainNumber;
        if (Array.isArray(this.cabinsMap)) {
            data["cabinsMap"] = [];
            for (let item of this.cabinsMap)
                data["cabinsMap"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrainSeatsMapDTO {
    trainNumber: string | undefined;
    cabinsMap: CabinsDTO[] | undefined;
}

export class TrainSeatsResponse implements ITrainSeatsResponse {
    trains!: TrainSeatsMapDTO[] | undefined;

    constructor(data?: ITrainSeatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trains"])) {
                this.trains = [] as any;
                for (let item of _data["trains"])
                    this.trains!.push(TrainSeatsMapDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainSeatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainSeatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trains)) {
            data["trains"] = [];
            for (let item of this.trains)
                data["trains"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrainSeatsResponse {
    trains: TrainSeatsMapDTO[] | undefined;
}

export class UpdatePassengersDTO implements IUpdatePassengersDTO {
    ticketIds!: string | undefined;
    passengers!: PersonNameDataDTO[] | undefined;
    buyer!: ApplicationUserDto;

    constructor(data?: IUpdatePassengersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketIds = _data["ticketIds"];
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PersonNameDataDTO.fromJS(item));
            }
            this.buyer = _data["buyer"] ? ApplicationUserDto.fromJS(_data["buyer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePassengersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePassengersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketIds"] = this.ticketIds;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdatePassengersDTO {
    ticketIds: string | undefined;
    passengers: PersonNameDataDTO[] | undefined;
    buyer: ApplicationUserDto;
}

export class TrainSerpItem implements ITrainSerpItem {
    groupItineraryId!: string | undefined;
    itineraryId!: string | undefined;
    pricingInformationIds!: string[] | undefined;

    constructor(data?: ITrainSerpItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupItineraryId = _data["groupItineraryId"];
            this.itineraryId = _data["itineraryId"];
            if (Array.isArray(_data["pricingInformationIds"])) {
                this.pricingInformationIds = [] as any;
                for (let item of _data["pricingInformationIds"])
                    this.pricingInformationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TrainSerpItem {
        data = typeof data === 'object' ? data : {};
        let result = new TrainSerpItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupItineraryId"] = this.groupItineraryId;
        data["itineraryId"] = this.itineraryId;
        if (Array.isArray(this.pricingInformationIds)) {
            data["pricingInformationIds"] = [];
            for (let item of this.pricingInformationIds)
                data["pricingInformationIds"].push(item);
        }
        return data;
    }
}

export interface ITrainSerpItem {
    groupItineraryId: string | undefined;
    itineraryId: string | undefined;
    pricingInformationIds: string[] | undefined;
}

export class TrainMessageToCustomerInput implements ITrainMessageToCustomerInput {
    outwardTrainSerpItems!: TrainSerpItem[] | undefined;
    returnTrainSerpItems!: TrainSerpItem[] | undefined;
    requestData!: TrainAvailabilityRequestDTO;
    email!: FieldsEmailInput;
    availabilityId!: string | undefined;
    tenantId!: string | undefined;
    userId!: string | undefined;
    userAgencyId!: string | undefined;

    constructor(data?: ITrainMessageToCustomerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["outwardTrainSerpItems"])) {
                this.outwardTrainSerpItems = [] as any;
                for (let item of _data["outwardTrainSerpItems"])
                    this.outwardTrainSerpItems!.push(TrainSerpItem.fromJS(item));
            }
            if (Array.isArray(_data["returnTrainSerpItems"])) {
                this.returnTrainSerpItems = [] as any;
                for (let item of _data["returnTrainSerpItems"])
                    this.returnTrainSerpItems!.push(TrainSerpItem.fromJS(item));
            }
            this.requestData = _data["requestData"] ? TrainAvailabilityRequestDTO.fromJS(_data["requestData"]) : <any>undefined;
            this.email = _data["email"] ? FieldsEmailInput.fromJS(_data["email"]) : <any>undefined;
            this.availabilityId = _data["availabilityId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.userAgencyId = _data["userAgencyId"];
        }
    }

    static fromJS(data: any): TrainMessageToCustomerInput {
        data = typeof data === 'object' ? data : {};
        let result = new TrainMessageToCustomerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.outwardTrainSerpItems)) {
            data["outwardTrainSerpItems"] = [];
            for (let item of this.outwardTrainSerpItems)
                data["outwardTrainSerpItems"].push(item.toJSON());
        }
        if (Array.isArray(this.returnTrainSerpItems)) {
            data["returnTrainSerpItems"] = [];
            for (let item of this.returnTrainSerpItems)
                data["returnTrainSerpItems"].push(item.toJSON());
        }
        data["requestData"] = this.requestData ? this.requestData.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["availabilityId"] = this.availabilityId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["userAgencyId"] = this.userAgencyId;
        return data;
    }
}

export interface ITrainMessageToCustomerInput {
    outwardTrainSerpItems: TrainSerpItem[] | undefined;
    returnTrainSerpItems: TrainSerpItem[] | undefined;
    requestData: TrainAvailabilityRequestDTO;
    email: FieldsEmailInput;
    availabilityId: string | undefined;
    tenantId: string | undefined;
    userId: string | undefined;
    userAgencyId: string | undefined;
}

export class TrainMessageToAgentInput implements ITrainMessageToAgentInput {
    selectedOutwardTrainSerpItem!: TrainSerpItem;
    selectedReturnTrainSerpItem!: TrainSerpItem;
    c!: string | undefined;
    requestData!: TrainAvailabilityRequestDTO;
    email!: FieldsEmailInput;
    availabilityId!: string | undefined;
    tenantId!: string | undefined;
    userId!: string | undefined;
    userAgencyId!: string | undefined;

    constructor(data?: ITrainMessageToAgentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedOutwardTrainSerpItem = _data["selectedOutwardTrainSerpItem"] ? TrainSerpItem.fromJS(_data["selectedOutwardTrainSerpItem"]) : <any>undefined;
            this.selectedReturnTrainSerpItem = _data["selectedReturnTrainSerpItem"] ? TrainSerpItem.fromJS(_data["selectedReturnTrainSerpItem"]) : <any>undefined;
            this.c = _data["c"];
            this.requestData = _data["requestData"] ? TrainAvailabilityRequestDTO.fromJS(_data["requestData"]) : <any>undefined;
            this.email = _data["email"] ? FieldsEmailInput.fromJS(_data["email"]) : <any>undefined;
            this.availabilityId = _data["availabilityId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.userAgencyId = _data["userAgencyId"];
        }
    }

    static fromJS(data: any): TrainMessageToAgentInput {
        data = typeof data === 'object' ? data : {};
        let result = new TrainMessageToAgentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedOutwardTrainSerpItem"] = this.selectedOutwardTrainSerpItem ? this.selectedOutwardTrainSerpItem.toJSON() : <any>undefined;
        data["selectedReturnTrainSerpItem"] = this.selectedReturnTrainSerpItem ? this.selectedReturnTrainSerpItem.toJSON() : <any>undefined;
        data["c"] = this.c;
        data["requestData"] = this.requestData ? this.requestData.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["availabilityId"] = this.availabilityId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["userAgencyId"] = this.userAgencyId;
        return data;
    }
}

export interface ITrainMessageToAgentInput {
    selectedOutwardTrainSerpItem: TrainSerpItem;
    selectedReturnTrainSerpItem: TrainSerpItem;
    c: string | undefined;
    requestData: TrainAvailabilityRequestDTO;
    email: FieldsEmailInput;
    availabilityId: string | undefined;
    tenantId: string | undefined;
    userId: string | undefined;
    userAgencyId: string | undefined;
}

export class TrainShareSerpItemsInput implements ITrainShareSerpItemsInput {
    availabilityId!: string | undefined;
    userAgencyId!: string | undefined;
    outwardTrainSerpItems!: TrainSerpItem[] | undefined;
    returnTrainSerpItems!: TrainSerpItem[] | undefined;
    c!: string | undefined;

    constructor(data?: ITrainShareSerpItemsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityId = _data["availabilityId"];
            this.userAgencyId = _data["userAgencyId"];
            if (Array.isArray(_data["outwardTrainSerpItems"])) {
                this.outwardTrainSerpItems = [] as any;
                for (let item of _data["outwardTrainSerpItems"])
                    this.outwardTrainSerpItems!.push(TrainSerpItem.fromJS(item));
            }
            if (Array.isArray(_data["returnTrainSerpItems"])) {
                this.returnTrainSerpItems = [] as any;
                for (let item of _data["returnTrainSerpItems"])
                    this.returnTrainSerpItems!.push(TrainSerpItem.fromJS(item));
            }
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): TrainShareSerpItemsInput {
        data = typeof data === 'object' ? data : {};
        let result = new TrainShareSerpItemsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityId"] = this.availabilityId;
        data["userAgencyId"] = this.userAgencyId;
        if (Array.isArray(this.outwardTrainSerpItems)) {
            data["outwardTrainSerpItems"] = [];
            for (let item of this.outwardTrainSerpItems)
                data["outwardTrainSerpItems"].push(item.toJSON());
        }
        if (Array.isArray(this.returnTrainSerpItems)) {
            data["returnTrainSerpItems"] = [];
            for (let item of this.returnTrainSerpItems)
                data["returnTrainSerpItems"].push(item.toJSON());
        }
        data["c"] = this.c;
        return data;
    }
}

export interface ITrainShareSerpItemsInput {
    availabilityId: string | undefined;
    userAgencyId: string | undefined;
    outwardTrainSerpItems: TrainSerpItem[] | undefined;
    returnTrainSerpItems: TrainSerpItem[] | undefined;
    c: string | undefined;
}

export class BasicDataItemDto implements IBasicDataItemDto {
    id!: number;
    code!: string | undefined;
    displayName!: string | undefined;
    description!: LocalizedString;

    constructor(data?: IBasicDataItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.description = _data["description"] ? LocalizedString.fromJS(_data["description"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BasicDataItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicDataItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBasicDataItemDto {
    id: number;
    code: string | undefined;
    displayName: string | undefined;
    description: LocalizedString;
}

export class ActiveDataDto implements IActiveDataDto {
    isActive!: boolean;
    id!: number;
    code!: string | undefined;
    displayName!: string | undefined;
    description!: LocalizedString;

    constructor(data?: IActiveDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.description = _data["description"] ? LocalizedString.fromJS(_data["description"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActiveDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActiveDataDto {
    isActive: boolean;
    id: number;
    code: string | undefined;
    displayName: string | undefined;
    description: LocalizedString;
}

export class TrainsSettingsOutputDto implements ITrainsSettingsOutputDto {
    admissibleOffers!: BasicDataItemDto[] | undefined;
    admissibleServices!: BasicDataItemDto[] | undefined;
    activeOffers!: ActiveDataDto[] | undefined;
    activeServices!: ActiveDataDto[] | undefined;

    constructor(data?: ITrainsSettingsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["admissibleOffers"])) {
                this.admissibleOffers = [] as any;
                for (let item of _data["admissibleOffers"])
                    this.admissibleOffers!.push(BasicDataItemDto.fromJS(item));
            }
            if (Array.isArray(_data["admissibleServices"])) {
                this.admissibleServices = [] as any;
                for (let item of _data["admissibleServices"])
                    this.admissibleServices!.push(BasicDataItemDto.fromJS(item));
            }
            if (Array.isArray(_data["activeOffers"])) {
                this.activeOffers = [] as any;
                for (let item of _data["activeOffers"])
                    this.activeOffers!.push(ActiveDataDto.fromJS(item));
            }
            if (Array.isArray(_data["activeServices"])) {
                this.activeServices = [] as any;
                for (let item of _data["activeServices"])
                    this.activeServices!.push(ActiveDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainsSettingsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainsSettingsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.admissibleOffers)) {
            data["admissibleOffers"] = [];
            for (let item of this.admissibleOffers)
                data["admissibleOffers"].push(item.toJSON());
        }
        if (Array.isArray(this.admissibleServices)) {
            data["admissibleServices"] = [];
            for (let item of this.admissibleServices)
                data["admissibleServices"].push(item.toJSON());
        }
        if (Array.isArray(this.activeOffers)) {
            data["activeOffers"] = [];
            for (let item of this.activeOffers)
                data["activeOffers"].push(item.toJSON());
        }
        if (Array.isArray(this.activeServices)) {
            data["activeServices"] = [];
            for (let item of this.activeServices)
                data["activeServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrainsSettingsOutputDto {
    admissibleOffers: BasicDataItemDto[] | undefined;
    admissibleServices: BasicDataItemDto[] | undefined;
    activeOffers: ActiveDataDto[] | undefined;
    activeServices: ActiveDataDto[] | undefined;
}

export class TrainsSettingsEditDto implements ITrainsSettingsEditDto {
    selectedOffers!: ActiveDataDto[] | undefined;
    selectedServices!: ActiveDataDto[] | undefined;

    constructor(data?: ITrainsSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedOffers"])) {
                this.selectedOffers = [] as any;
                for (let item of _data["selectedOffers"])
                    this.selectedOffers!.push(ActiveDataDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedServices"])) {
                this.selectedServices = [] as any;
                for (let item of _data["selectedServices"])
                    this.selectedServices!.push(ActiveDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainsSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainsSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedOffers)) {
            data["selectedOffers"] = [];
            for (let item of this.selectedOffers)
                data["selectedOffers"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedServices)) {
            data["selectedServices"] = [];
            for (let item of this.selectedServices)
                data["selectedServices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrainsSettingsEditDto {
    selectedOffers: ActiveDataDto[] | undefined;
    selectedServices: ActiveDataDto[] | undefined;
}

export enum TripStatusDto {
    Created = 0,
    Draft = 1,
    PendingApproval = 2,
    Approved = 3,
    Declined = 4,
    Booked = 5,
    Pending = 6,
    Confirmed = 7,
    Error = 8,
    Deleted = 9,
    Assisted = 10,
    AssistedDraft = 11,
}

export enum TripItemTypeDto {
    Flight = 0,
    Hotel = 1,
    Train = 2,
    Car = 3,
    ExtraServices = 4,
    PackageRate = 5
}

export class FlightData implements IFlightData {
    itinerary!: ItineraryDTO;
    passengers!: PersonNameDataDTO[] | undefined;
    luggageOption!: LuggageOptionsDTO;
    handLuggageOption!: LuggageOptionsDTO;
    personNameSsrs!: PersonNameSsrDto[] | undefined;
    availabilityId!: string | undefined;
    groupItineraryId!: string | undefined;
    itineraryId!: string | undefined;
    pricingInformationId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;

    constructor(data?: IFlightData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerary = _data["itinerary"] ? ItineraryDTO.fromJS(_data["itinerary"]) : <any>undefined;
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PersonNameDataDTO.fromJS(item));
            }
            this.luggageOption = _data["luggageOption"] ? LuggageOptionsDTO.fromJS(_data["luggageOption"]) : <any>undefined;
            this.handLuggageOption = _data["handLuggageOption"] ? LuggageOptionsDTO.fromJS(_data["handLuggageOption"]) : <any>undefined;
            if (Array.isArray(_data["personNameSsrs"])) {
                this.personNameSsrs = [] as any;
                for (let item of _data["personNameSsrs"])
                    this.personNameSsrs!.push(PersonNameSsrDto.fromJS(item));
            }
            this.availabilityId = _data["availabilityId"];
            this.groupItineraryId = _data["groupItineraryId"];
            this.itineraryId = _data["itineraryId"];
            this.pricingInformationId = _data["pricingInformationId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
        }
    }

    static fromJS(data: any): FlightData {
        data = typeof data === 'object' ? data : {};
        let result = new FlightData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerary"] = this.itinerary ? this.itinerary.toJSON() : <any>undefined;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["luggageOption"] = this.luggageOption ? this.luggageOption.toJSON() : <any>undefined;
        data["handLuggageOption"] = this.handLuggageOption ? this.handLuggageOption.toJSON() : <any>undefined;
        if (Array.isArray(this.personNameSsrs)) {
            data["personNameSsrs"] = [];
            for (let item of this.personNameSsrs)
                data["personNameSsrs"].push(item.toJSON());
        }
        data["availabilityId"] = this.availabilityId;
        data["groupItineraryId"] = this.groupItineraryId;
        data["itineraryId"] = this.itineraryId;
        data["pricingInformationId"] = this.pricingInformationId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        return data;
    }
}

export interface IFlightData {
    itinerary: ItineraryDTO;
    passengers: PersonNameDataDTO[] | undefined;
    luggageOption: LuggageOptionsDTO;
    handLuggageOption: LuggageOptionsDTO;
    personNameSsrs: PersonNameSsrDto[] | undefined;
    availabilityId: string | undefined;
    groupItineraryId: string | undefined;
    itineraryId: string | undefined;
    pricingInformationId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
}

export class HotelData implements IHotelData {
    availabilityId!: string | undefined;
    optionId!: string | undefined;
    bookingData!: HotelBookResponseDto;

    constructor(data?: IHotelData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availabilityId = _data["availabilityId"];
            this.optionId = _data["optionId"];
            this.bookingData = _data["bookingData"] ? HotelBookResponseDto.fromJS(_data["bookingData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HotelData {
        data = typeof data === 'object' ? data : {};
        let result = new HotelData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availabilityId"] = this.availabilityId;
        data["optionId"] = this.optionId;
        data["bookingData"] = this.bookingData ? this.bookingData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHotelData {
    availabilityId: string | undefined;
    optionId: string | undefined;
    bookingData: HotelBookResponseDto;
}

export class TrainData implements ITrainData {
    itinerary!: ItineraryDTO;
    passengers!: PersonNameDataDTO[] | undefined;
    availabilityId!: string | undefined;
    outwardGroupItineraryId!: string | undefined;
    returnGroupItineraryId!: string | undefined;
    outwardId!: string | undefined;
    returnId!: string | undefined;
    outwardPricingInformationIds!: string[] | undefined;
    returnPricingInformationIds!: string[] | undefined;

    constructor(data?: ITrainData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itinerary = _data["itinerary"] ? ItineraryDTO.fromJS(_data["itinerary"]) : <any>undefined;
            if (Array.isArray(_data["passengers"])) {
                this.passengers = [] as any;
                for (let item of _data["passengers"])
                    this.passengers!.push(PersonNameDataDTO.fromJS(item));
            }
            this.availabilityId = _data["availabilityId"];
            this.outwardGroupItineraryId = _data["outwardGroupItineraryId"];
            this.returnGroupItineraryId = _data["returnGroupItineraryId"];
            this.outwardId = _data["outwardId"];
            this.returnId = _data["returnId"];
            if (Array.isArray(_data["outwardPricingInformationIds"])) {
                this.outwardPricingInformationIds = [] as any;
                for (let item of _data["outwardPricingInformationIds"])
                    this.outwardPricingInformationIds!.push(item);
            }
            if (Array.isArray(_data["returnPricingInformationIds"])) {
                this.returnPricingInformationIds = [] as any;
                for (let item of _data["returnPricingInformationIds"])
                    this.returnPricingInformationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TrainData {
        data = typeof data === 'object' ? data : {};
        let result = new TrainData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itinerary"] = this.itinerary ? this.itinerary.toJSON() : <any>undefined;
        if (Array.isArray(this.passengers)) {
            data["passengers"] = [];
            for (let item of this.passengers)
                data["passengers"].push(item.toJSON());
        }
        data["availabilityId"] = this.availabilityId;
        data["outwardGroupItineraryId"] = this.outwardGroupItineraryId;
        data["returnGroupItineraryId"] = this.returnGroupItineraryId;
        data["outwardId"] = this.outwardId;
        data["returnId"] = this.returnId;
        if (Array.isArray(this.outwardPricingInformationIds)) {
            data["outwardPricingInformationIds"] = [];
            for (let item of this.outwardPricingInformationIds)
                data["outwardPricingInformationIds"].push(item);
        }
        if (Array.isArray(this.returnPricingInformationIds)) {
            data["returnPricingInformationIds"] = [];
            for (let item of this.returnPricingInformationIds)
                data["returnPricingInformationIds"].push(item);
        }
        return data;
    }
}

export interface ITrainData {
    itinerary: ItineraryDTO;
    passengers: PersonNameDataDTO[] | undefined;
    availabilityId: string | undefined;
    outwardGroupItineraryId: string | undefined;
    returnGroupItineraryId: string | undefined;
    outwardId: string | undefined;
    returnId: string | undefined;
    outwardPricingInformationIds: string[] | undefined;
    returnPricingInformationIds: string[] | undefined;
}

export class CarData implements ICarData {
    carBoookingData!: CarBookResponseDto;

    constructor(data?: ICarData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carBoookingData = _data["carBoookingData"] ? CarBookResponseDto.fromJS(_data["carBoookingData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CarData {
        data = typeof data === 'object' ? data : {};
        let result = new CarData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carBoookingData"] = this.carBoookingData ? this.carBoookingData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICarData {
    carBoookingData: CarBookResponseDto;
}

export class TripItemDto implements ITripItemDto {
    id!: string | undefined;
    itemId!: number | undefined;
    type!: TripItemTypeDto;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    totalPrice!: number;
    productDescription!: string | undefined;
    flightData!: FlightData;
    hotelData!: HotelData;
    trainData!: TrainData;
    carData!: CarData;
    inPolicy!: boolean;

    constructor(data?: ITripItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.type = _data["type"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.totalPrice = _data["totalPrice"];
            this.productDescription = _data["productDescription"];
            this.flightData = _data["flightData"] ? FlightData.fromJS(_data["flightData"]) : <any>undefined;
            this.hotelData = _data["hotelData"] ? HotelData.fromJS(_data["hotelData"]) : <any>undefined;
            this.trainData = _data["trainData"] ? TrainData.fromJS(_data["trainData"]) : <any>undefined;
            this.carData = _data["carData"] ? CarData.fromJS(_data["carData"]) : <any>undefined;
            this.inPolicy = _data["inPolicy"];
        }
    }

    static fromJS(data: any): TripItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TripItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["type"] = this.type;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalPrice"] = this.totalPrice;
        data["productDescription"] = this.productDescription;
        data["flightData"] = this.flightData ? this.flightData.toJSON() : <any>undefined;
        data["hotelData"] = this.hotelData ? this.hotelData.toJSON() : <any>undefined;
        data["trainData"] = this.trainData ? this.trainData.toJSON() : <any>undefined;
        data["carData"] = this.carData ? this.carData.toJSON() : <any>undefined;
        data["inPolicy"] = this.inPolicy;
        return data;
    }
}

export interface ITripItemDto {
    id: string | undefined;
    itemId: number | undefined;
    type: TripItemTypeDto;
    startDate: moment.Moment;
    endDate: moment.Moment;
    totalPrice: number;
    productDescription: string | undefined;
    flightData: FlightData;
    hotelData: HotelData;
    trainData: TrainData;
    carData: CarData;
    inPolicy: boolean;
}

export class TripReservationItemDto implements ITripReservationItemDto {
    reservationId!: string | undefined;
    packageRateAvailabilityId!: string | undefined;
    reservationType!: ReservationTypeDto;
    reservationStatus!: ReservationStatusDto;
    description!: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;

    constructor(data?: ITripReservationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationId = _data["reservationId"];
            this.packageRateAvailabilityId = _data["packageRateAvailabilityId"];
            this.reservationType = _data["reservationType"];
            this.reservationStatus = _data["reservationStatus"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TripReservationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TripReservationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationId"] = this.reservationId;
        data["packageRateAvailabilityId"] = this.packageRateAvailabilityId;
        data["reservationType"] = this.reservationType;
        data["reservationStatus"] = this.reservationStatus;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITripReservationItemDto {
    reservationId: string | undefined;
    packageRateAvailabilityId: string | undefined;
    reservationType: ReservationTypeDto;
    reservationStatus: ReservationStatusDto;
    description: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
}

export class TripUserDto implements ITripUserDto {
    userId!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: ITripUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): TripUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new TripUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ITripUserDto {
    userId: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
}

export enum ApprovalProcessStatus {
    Pending = 0,
    Accepted = 1,
    Closed = 2,
    Declined = 3,
}

export class ApprovalRequestDto implements IApprovalRequestDto {
    sender!: TripUserDto;
    reasonId!: string | undefined;
    reasonCode!: string | undefined;
    reasonDescription!: string | undefined;
    message!: string | undefined;
    status!: TripStatusDto;
    approvalProcessStatus!: ApprovalProcessStatus;
    timestamp!: moment.Moment;

    constructor(data?: IApprovalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sender = _data["sender"] ? TripUserDto.fromJS(_data["sender"]) : <any>undefined;
            this.reasonId = _data["reasonId"];
            this.reasonCode = _data["reasonCode"];
            this.reasonDescription = _data["reasonDescription"];
            this.message = _data["message"];
            this.status = _data["status"];
            this.approvalProcessStatus = _data["approvalProcessStatus"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApprovalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender ? this.sender.toJSON() : <any>undefined;
        data["reasonId"] = this.reasonId;
        data["reasonCode"] = this.reasonCode;
        data["reasonDescription"] = this.reasonDescription;
        data["message"] = this.message;
        data["status"] = this.status;
        data["approvalProcessStatus"] = this.approvalProcessStatus;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApprovalRequestDto {
    sender: TripUserDto;
    reasonId: string | undefined;
    reasonCode: string | undefined;
    reasonDescription: string | undefined;
    message: string | undefined;
    status: TripStatusDto;
    approvalProcessStatus: ApprovalProcessStatus;
    timestamp: moment.Moment;
}

export class ExtraServicesDto implements IExtraServicesDto {
    optionId!: number;
    startDate!: moment.Moment;
    endDate!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: IExtraServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionId = _data["optionId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ExtraServicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraServicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionId"] = this.optionId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IExtraServicesDto {
    optionId: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    notes: string | undefined;
}

export class SearchItemDto implements ISearchItemDto {
    id!: number;
    flightRequest!: AvailabilityRequestMulticityDTO;
    hotelRequest!: AvailabilityStructuresRequestDto;
    trainRequest!: TrainAvailabilityRequestDTO;
    carRequest!: CarAvailabilityRequestDto;
    extraServicesRequest!: ExtraServicesDto;

    constructor(data?: ISearchItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.flightRequest = _data["flightRequest"] ? AvailabilityRequestMulticityDTO.fromJS(_data["flightRequest"]) : <any>undefined;
            this.hotelRequest = _data["hotelRequest"] ? AvailabilityStructuresRequestDto.fromJS(_data["hotelRequest"]) : <any>undefined;
            this.trainRequest = _data["trainRequest"] ? TrainAvailabilityRequestDTO.fromJS(_data["trainRequest"]) : <any>undefined;
            this.carRequest = _data["carRequest"] ? CarAvailabilityRequestDto.fromJS(_data["carRequest"]) : <any>undefined;
            this.extraServicesRequest = _data["extraServicesRequest"] ? ExtraServicesDto.fromJS(_data["extraServicesRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["flightRequest"] = this.flightRequest ? this.flightRequest.toJSON() : <any>undefined;
        data["hotelRequest"] = this.hotelRequest ? this.hotelRequest.toJSON() : <any>undefined;
        data["trainRequest"] = this.trainRequest ? this.trainRequest.toJSON() : <any>undefined;
        data["carRequest"] = this.carRequest ? this.carRequest.toJSON() : <any>undefined;
        data["extraServicesRequest"] = this.extraServicesRequest ? this.extraServicesRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISearchItemDto {
    id: number;
    flightRequest: AvailabilityRequestMulticityDTO;
    hotelRequest: AvailabilityStructuresRequestDto;
    trainRequest: TrainAvailabilityRequestDTO;
    carRequest: CarAvailabilityRequestDto;
    extraServicesRequest: ExtraServicesDto;
}

export enum Authorization {
    Authorization = 0,
    AuthorizationBudget = 1,
    PreAuthorization = 2,
    PostAuthorization = 3,
}

export class AuthorizerDto implements IAuthorizerDto {
    id!: string;
    fullName!: string | undefined;
    email!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IAuthorizerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): AuthorizerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IAuthorizerDto {
    id: string | undefined;
    fullName: string | undefined;
    email: string | undefined;
    isSelected: boolean;
}

export class AuthorizationRequestDto implements IAuthorizationRequestDto {
    type!: Authorization;
    isAuthorized!: boolean;
    isRejected!: boolean;
    authorizers!: AuthorizerDto[] | undefined;

    constructor(data?: IAuthorizationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.isAuthorized = _data["isAuthorized"];
            this.isRejected = _data["isRejected"];
            if (Array.isArray(_data["authorizers"])) {
                this.authorizers = [] as any;
                for (let item of _data["authorizers"])
                    this.authorizers!.push(AuthorizerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthorizationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["isAuthorized"] = this.isAuthorized;
        data["isRejected"] = this.isRejected;
        if (Array.isArray(this.authorizers)) {
            data["authorizers"] = [];
            for (let item of this.authorizers)
                data["authorizers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuthorizationRequestDto {
    type: Authorization;
    isAuthorized: boolean;
    isRejected: boolean;
    authorizers: AuthorizerDto[] | undefined;
}

export class TripDto implements ITripDto {
    id!: string | undefined;
    tripCode!: string | undefined;
    status!: TripStatusDto;
    tripName!: string | undefined;
    organizationUnitId!: string | undefined;
    centerOfCostsId!: number | undefined;
    companyHeadquartersId!: number | undefined;
    centerOfCostsCodeUnit!: string | undefined;
    companyHeadquartersCodeUnit!: string | undefined;
    userId!: string | undefined;
    username!: string | undefined;
    readonly startDate!: moment.Moment | undefined;
    readonly endDate!: moment.Moment | undefined;
    tripItems!: TripItemDto[] | undefined;
    reservations!: TripReservationItemDto[] | undefined;
    travelers!: UserProfileDto[] | undefined;
    invoiceProfile!: InvoiceProfileDto;
    policy!: TravelPolicyDto;
    readonly inPolicy!: boolean;
    labels!: string[] | undefined;
    requiresApproval!: boolean;
    approvalSkip!: boolean;
    approvalProcessFlowId!: string | undefined;
    approvers!: ApproverDto[] | undefined;
    approvalRequests!: ApprovalRequestDto[] | undefined;
    approvalProcesses!: ApprovalProcessDto[] | undefined;
    tripDate!: moment.Moment;
    totalPaymentInfo!: PaymentInfoDataDto;
    paymentInfo!: PaymentInfoDataDto;
    ts!: moment.Moment;
    customFields!: CustomFieldDto[] | undefined;
    logs!: LogDto[] | undefined;
    searchItems!: SearchItemDto[] | undefined;
    assistedStartDate!: moment.Moment | undefined;
    assistedEndDate!: moment.Moment | undefined;
    notes!: string | undefined;
    currentOwnerId!: string | undefined;
    setForTravelAgency!: boolean;
    authorizationRequests!: AuthorizationRequestDto[] | undefined;
    skipAuthorization!: boolean;
    isFullAssisted!: boolean | undefined;
    assistedTicketId: number | undefined;
    assistedServicesBooked: TripAssistedServiceBooked[] | undefined
    preventCheckoutAuthorizer: boolean;

    constructor(data?: ITripDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tripCode = _data["tripCode"];
            this.status = _data["status"];
            this.tripName = _data["tripName"];
            this.organizationUnitId = _data["organizationUnitId"];
            this.centerOfCostsId = _data["centerOfCostsId"];
            this.companyHeadquartersId = _data["companyHeadquartersId"];
            this.centerOfCostsCodeUnit = _data["centerOfCostsCodeUnit"];
            this.companyHeadquartersCodeUnit = _data["companyHeadquartersCodeUnit"];
            this.userId = _data["userId"];
            this.username = _data["username"];
            (<any>this).startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            (<any>this).endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["tripItems"])) {
                this.tripItems = [] as any;
                for (let item of _data["tripItems"])
                    this.tripItems!.push(TripItemDto.fromJS(item));
            }
            if (Array.isArray(_data["reservations"])) {
                this.reservations = [] as any;
                for (let item of _data["reservations"])
                    this.reservations!.push(TripReservationItemDto.fromJS(item));
            }
            if (Array.isArray(_data["travelers"])) {
                this.travelers = [] as any;
                for (let item of _data["travelers"])
                    this.travelers!.push(UserProfileDto.fromJS(item));
            }
            this.invoiceProfile = _data["invoiceProfile"] ? InvoiceProfileDto.fromJS(_data["invoiceProfile"]) : <any>undefined;
            this.policy = _data["policy"] ? TravelPolicyDto.fromJS(_data["policy"]) : <any>undefined;
            (<any>this).inPolicy = _data["inPolicy"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.requiresApproval = _data["requiresApproval"];
            this.approvalSkip = _data["approvalSkip"];
            this.approvalProcessFlowId = _data["approvalProcessFlowId"];
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(ApproverDto.fromJS(item));
            }
            if (Array.isArray(_data["approvalRequests"])) {
                this.approvalRequests = [] as any;
                for (let item of _data["approvalRequests"])
                    this.approvalRequests!.push(ApprovalRequestDto.fromJS(item));
            }
            if (Array.isArray(_data["approvalProcesses"])) {
                this.approvalProcesses = [] as any;
                for (let item of _data["approvalProcesses"])
                    this.approvalProcesses!.push(ApprovalProcessDto.fromJS(item));
            }
            this.tripDate = _data["tripDate"] ? moment(_data["tripDate"].toString()) : <any>undefined;
            this.totalPaymentInfo = _data["totalPaymentInfo"] ? PaymentInfoDataDto.fromJS(_data["totalPaymentInfo"]) : <any>undefined;
            this.paymentInfo = _data["paymentInfo"] ? PaymentInfoDataDto.fromJS(_data["paymentInfo"]) : <any>undefined;
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(LogDto.fromJS(item));
            }
            if (Array.isArray(_data["searchItems"])) {
                this.searchItems = [] as any;
                for (let item of _data["searchItems"])
                    this.searchItems!.push(SearchItemDto.fromJS(item));
            }
            this.assistedStartDate = _data["assistedStartDate"] ? moment(_data["assistedStartDate"].toString()) : <any>undefined;
            this.assistedEndDate = _data["assistedEndDate"] ? moment(_data["assistedEndDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.currentOwnerId = _data["currentOwnerId"];
            this.setForTravelAgency = _data["setForTravelAgency"];
            if (Array.isArray(_data["authorizationRequests"])) {
                this.authorizationRequests = [] as any;
                for (let item of _data["authorizationRequests"])
                    this.authorizationRequests!.push(AuthorizationRequestDto.fromJS(item));
            }
            this.skipAuthorization = _data["skipAuthorization"];
            this.isFullAssisted = _data["isFullAssisted"];
            this.assistedTicketId = _data["assistedTicketId"];
            this.assistedServicesBooked = _data["assistedServicesBooked"];
            this.preventCheckoutAuthorizer = _data["preventCheckoutAuthorizer"];
        }
    }

    static fromJS(data: any): TripDto {
        data = typeof data === 'object' ? data : {};
        let result = new TripDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tripCode"] = this.tripCode;
        data["status"] = this.status;
        data["tripName"] = this.tripName;
        data["organizationUnitId"] = this.organizationUnitId;
        data["centerOfCostsId"] = this.centerOfCostsId;
        data["companyHeadquartersId"] = this.companyHeadquartersId;
        data["centerOfCostsCodeUnit"] = this.centerOfCostsCodeUnit;
        data["companyHeadquartersCodeUnit"] = this.companyHeadquartersCodeUnit;
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.tripItems)) {
            data["tripItems"] = [];
            for (let item of this.tripItems)
                data["tripItems"].push(item.toJSON());
        }
        if (Array.isArray(this.reservations)) {
            data["reservations"] = [];
            for (let item of this.reservations)
                data["reservations"].push(item.toJSON());
        }
        if (Array.isArray(this.travelers)) {
            data["travelers"] = [];
            for (let item of this.travelers)
                data["travelers"].push(item.toJSON());
        }
        data["invoiceProfile"] = this.invoiceProfile ? this.invoiceProfile.toJSON() : <any>undefined;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["inPolicy"] = this.inPolicy;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["requiresApproval"] = this.requiresApproval;
        data["approvalSkip"] = this.approvalSkip;
        data["approvalProcessFlowId"] = this.approvalProcessFlowId;
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        if (Array.isArray(this.approvalRequests)) {
            data["approvalRequests"] = [];
            for (let item of this.approvalRequests)
                data["approvalRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.approvalProcesses)) {
            data["approvalProcesses"] = [];
            for (let item of this.approvalProcesses)
                data["approvalProcesses"].push(item.toJSON());
        }
        data["tripDate"] = this.tripDate ? this.tripDate.toISOString() : <any>undefined;
        data["totalPaymentInfo"] = this.totalPaymentInfo ? this.totalPaymentInfo.toJSON() : <any>undefined;
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        if (Array.isArray(this.searchItems)) {
            data["searchItems"] = [];
            for (let item of this.searchItems)
                data["searchItems"].push(item.toJSON());
        }
        data["assistedStartDate"] = this.assistedStartDate ? this.assistedStartDate.toISOString() : <any>undefined;
        data["assistedEndDate"] = this.assistedEndDate ? this.assistedEndDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["currentOwnerId"] = this.currentOwnerId;
        data["setForTravelAgency"] = this.setForTravelAgency;
        if (Array.isArray(this.authorizationRequests)) {
            data["authorizationRequests"] = [];
            for (let item of this.authorizationRequests)
                data["authorizationRequests"].push(item.toJSON());
        }
        data["skipAuthorization"] = this.skipAuthorization;
        data["isFullAssisted"] = this.isFullAssisted;
        data["assistedTicketId"] = this.assistedTicketId;
        data["assistedServicesBooked"] = this.assistedServicesBooked;
        data["preventCheckoutAuthorizer"] = this.preventCheckoutAuthorizer;
        return data;
    }
}

export interface ITripDto {
    id: string | undefined;
    tripCode: string | undefined;
    status: TripStatusDto;
    tripName: string | undefined;
    organizationUnitId: string | undefined;
    centerOfCostsId: number | undefined;
    companyHeadquartersId: number | undefined;
    centerOfCostsCodeUnit: string | undefined;
    companyHeadquartersCodeUnit: string | undefined;
    userId: string | undefined;
    username: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    tripItems: TripItemDto[] | undefined;
    reservations: TripReservationItemDto[] | undefined;
    travelers: UserProfileDto[] | undefined;
    invoiceProfile: InvoiceProfileDto;
    policy: TravelPolicyDto;
    inPolicy: boolean;
    labels: string[] | undefined;
    requiresApproval: boolean;
    approvalSkip: boolean;
    approvalProcessFlowId: string | undefined;
    approvers: ApproverDto[] | undefined;
    approvalRequests: ApprovalRequestDto[] | undefined;
    approvalProcesses: ApprovalProcessDto[] | undefined;
    tripDate: moment.Moment;
    totalPaymentInfo: PaymentInfoDataDto;
    paymentInfo: PaymentInfoDataDto;
    ts: moment.Moment;
    customFields: CustomFieldDto[] | undefined;
    logs: LogDto[] | undefined;
    searchItems: SearchItemDto[] | undefined;
    assistedStartDate: moment.Moment | undefined;
    assistedEndDate: moment.Moment | undefined;
    notes: string | undefined;
    currentOwnerId: string | undefined;
    setForTravelAgency: boolean;
    authorizationRequests: AuthorizationRequestDto[] | undefined;
    skipAuthorization: boolean;
    isFullAssisted: boolean | undefined;
    assistedTicketId: number | undefined;
    assistedServicesBooked: TripAssistedServiceBooked[];
    preventCheckoutAuthorizer: boolean;
}

export class TripAssistedServiceBooked implements ITripAssistedServiceBooked {
    productName: string;
    serviceCategory: string;
    price: string;
    attachmentNames: string[];

    constructor(data?: ITripAssistedServiceBooked) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["productName"];
            this.serviceCategory = _data["serviceCategory"];
            this.price = _data["price"];
            this.attachmentNames = _data["attachmentNames"]
        }
    }

    static fromJS(data: any): TripAssistedServiceBooked {
        data = typeof data === 'object' ? data : {};
        let result = new TripAssistedServiceBooked();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["serviceCategory"] = this.serviceCategory;
        data["price"] = this.price;
        data["attachmentNames"] = this.attachmentNames;
    }
}

export interface ITripAssistedServiceBooked {
    productName: string
    serviceCategory: string;
    price: string;
    attachmentNames: string[] | undefined
}

export class TripListDto implements ITripListDto {
    id!: string | undefined;
    tripName!: string | undefined;
    status!: TripStatusDto;
    tripCode!: string | undefined;
    totalPrice!: number;
    tripDate!: moment.Moment;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    labels!: string[] | undefined;
    reservationItems!: TripReservationItemDto[] | undefined;
    travelers!: UserProfileDto[] | undefined;
    logs!: LogDto[] | undefined;
    idAssistedBooking!: string | undefined;

    constructor(data?: ITripListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tripName = _data["tripName"];
            this.status = _data["status"];
            this.tripCode = _data["tripCode"];
            this.totalPrice = _data["totalPrice"];
            this.tripDate = _data["tripDate"] ? moment(_data["tripDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            if (Array.isArray(_data["reservationItems"])) {
                this.reservationItems = [] as any;
                for (let item of _data["reservationItems"])
                    this.reservationItems!.push(TripReservationItemDto.fromJS(item));
            }
            if (Array.isArray(_data["travelers"])) {
                this.travelers = [] as any;
                for (let item of _data["travelers"])
                    this.travelers!.push(UserProfileDto.fromJS(item));
            }
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(LogDto.fromJS(item));
            }
            this.idAssistedBooking = _data["idAssistedBooking"];
        }
    }

    static fromJS(data: any): TripListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TripListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tripName"] = this.tripName;
        data["status"] = this.status;
        data["tripCode"] = this.tripCode;
        data["totalPrice"] = this.totalPrice;
        data["tripDate"] = this.tripDate ? this.tripDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        if (Array.isArray(this.reservationItems)) {
            data["reservationItems"] = [];
            for (let item of this.reservationItems)
                data["reservationItems"].push(item.toJSON());
        }
        if (Array.isArray(this.travelers)) {
            data["travelers"] = [];
            for (let item of this.travelers)
                data["travelers"].push(item.toJSON());
        }
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        data["idAssistedBooking"] = this.idAssistedBooking;
        return data;
    }
}

export interface ITripListDto {
    id: string | undefined;
    tripName: string | undefined;
    status: TripStatusDto;
    tripCode: string | undefined;
    totalPrice: number;
    tripDate: moment.Moment;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    labels: string[] | undefined;
    reservationItems: TripReservationItemDto[] | undefined;
    travelers: UserProfileDto[] | undefined;
    logs: LogDto[] | undefined;
    idAssistedBooking: string | undefined;
}

export class PagedResultDtoOfTripListDto implements IPagedResultDtoOfTripListDto {
    totalCount!: number;
    items!: TripListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTripListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TripListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTripListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTripListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTripListDto {
    totalCount: number;
    items: TripListDto[] | undefined;
}

export enum TripFilterDto {
    MyTrips = 0,
    ToBeApprovedTrips = 1,
    PastTrips = 2,
    DraftTrips = 3,
    AssistedTrips = 4,
}

export class UpdateTravelerInputDto implements IUpdateTravelerInputDto {
    tripId!: string | undefined;
    index!: number;
    traveler!: UserProfileDto;

    constructor(data?: IUpdateTravelerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripId = _data["tripId"];
            this.index = _data["index"];
            this.traveler = _data["traveler"] ? UserProfileDto.fromJS(_data["traveler"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTravelerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTravelerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripId"] = this.tripId;
        data["index"] = this.index;
        data["traveler"] = this.traveler ? this.traveler.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateTravelerInputDto {
    tripId: string | undefined;
    index: number;
    traveler: UserProfileDto;
}

export class CheckTripDataOutputDto implements ICheckTripDataOutputDto {
    isValid!: boolean;
    errors!: string[] | undefined;

    constructor(data?: ICheckTripDataOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): CheckTripDataOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTripDataOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface ICheckTripDataOutputDto {
    isValid: boolean;
    errors: string[] | undefined;
}

export class CreateTripInput implements ICreateTripInput {
    userProfiles!: UserProfileDto[] | undefined;
    name!: string | undefined;
    centerOfCostId!: number | undefined;
    headquartersId!: number | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment | undefined;
    isFullAssisted!: boolean | undefined;

    constructor(data?: ICreateTripInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userProfiles"])) {
                this.userProfiles = [] as any;
                for (let item of _data["userProfiles"])
                    this.userProfiles!.push(UserProfileDto.fromJS(item));
            }
            this.name = _data["name"];
            this.centerOfCostId = _data["centerOfCostId"];
            this.headquartersId = _data["headquartersId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTripInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTripInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userProfiles)) {
            data["userProfiles"] = [];
            for (let item of this.userProfiles)
                data["userProfiles"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["centerOfCostId"] = this.centerOfCostId;
        data["headquartersId"] = this.headquartersId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isFullAssisted"] = this.isFullAssisted;
        return data;
    }
}

export interface ICreateTripInput {
    userProfiles: UserProfileDto[] | undefined;
    name: string | undefined;
    centerOfCostId: number | undefined;
    headquartersId: number | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    isFullAssisted: boolean | undefined;
}

export class AuthorizationResponseDto implements IAuthorizationResponseDto {
    type!: Authorization;
    isAuthorized!: boolean;
    isRejected!: boolean;
    notes!: string | undefined;
    authorizer!: AuthorizerDto;

    constructor(data?: IAuthorizationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.isAuthorized = _data["isAuthorized"];
            this.isRejected = _data["isRejected"];
            this.notes = _data["notes"];
            this.authorizer = _data["authorizer"] ? AuthorizerDto.fromJS(_data["authorizer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthorizationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["isAuthorized"] = this.isAuthorized;
        data["isRejected"] = this.isRejected;
        data["notes"] = this.notes;
        data["authorizer"] = this.authorizer ? this.authorizer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthorizationResponseDto {
    type: Authorization;
    isAuthorized: boolean;
    isRejected: boolean;
    notes: string | undefined;
    authorizer: AuthorizerDto;
}

export class SaveTripSearchInput implements ISaveTripSearchInput {
    searchItems!: SearchItemDto[] | undefined;
    tripId!: string | undefined;
    sendRequest!: boolean;
    notes!: string | undefined;
    authorizations!: AuthorizationResponseDto[] | undefined;
    skipAuthorization!: boolean;
    requireNewAuthorization!: boolean;

    constructor(data?: ISaveTripSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchItems"])) {
                this.searchItems = [] as any;
                for (let item of _data["searchItems"])
                    this.searchItems!.push(SearchItemDto.fromJS(item));
            }
            this.tripId = _data["tripId"];
            this.sendRequest = _data["sendRequest"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["authorizations"])) {
                this.authorizations = [] as any;
                for (let item of _data["authorizations"])
                    this.authorizations!.push(AuthorizationResponseDto.fromJS(item));
            }
            this.skipAuthorization = _data["skipAuthorization"];
            this.requireNewAuthorization = _data["requireNewAuthorization"];
        }
    }

    static fromJS(data: any): SaveTripSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTripSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchItems)) {
            data["searchItems"] = [];
            for (let item of this.searchItems)
                data["searchItems"].push(item.toJSON());
        }
        data["tripId"] = this.tripId;
        data["sendRequest"] = this.sendRequest;
        data["notes"] = this.notes;
        if (Array.isArray(this.authorizations)) {
            data["authorizations"] = [];
            for (let item of this.authorizations)
                data["authorizations"].push(item.toJSON());
        }
        data["skipAuthorization"] = this.skipAuthorization;
        data["requireNewAuthorization"] = this.requireNewAuthorization;
        return data;
    }
}

export interface ISaveTripSearchInput {
    searchItems: SearchItemDto[] | undefined;
    tripId: string | undefined;
    sendRequest: boolean;
    notes: string | undefined;
    authorizations: AuthorizationResponseDto[] | undefined;
    skipAuthorization: boolean;
    requireNewAuthorization: boolean;
}

export class AjaxResponseOfTripDto implements IAjaxResponseOfTripDto {
    result!: TripDto;
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorInfo;
    unAuthorizedRequest!: boolean;
    readonly __abp!: boolean;

    constructor(data?: IAjaxResponseOfTripDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? TripDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfTripDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfTripDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IAjaxResponseOfTripDto {
    result: TripDto;
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorInfo;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class BookTripResponseDto implements IBookTripResponseDto {
    trip!: TripDto;
    invoiceProfiles!: InvoiceProfileDto[] | undefined;
    labels!: LabelDto[] | undefined;
    paymentGateways!: PaymentGatewayDto[] | undefined;
    reasons!: ReasonDto[] | undefined;
    tripId!: string | undefined;
    invoiceProfile!: InvoiceProfileDto;
    paymentGateway!: PaymentGatewayDto;
    selectedLabels!: LabelDto[] | undefined;

    constructor(data?: IBookTripResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trip = _data["trip"] ? TripDto.fromJS(_data["trip"]) : <any>undefined;
            if (Array.isArray(_data["invoiceProfiles"])) {
                this.invoiceProfiles = [] as any;
                for (let item of _data["invoiceProfiles"])
                    this.invoiceProfiles!.push(InvoiceProfileDto.fromJS(item));
            }
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(LabelDto.fromJS(item));
            }
            if (Array.isArray(_data["paymentGateways"])) {
                this.paymentGateways = [] as any;
                for (let item of _data["paymentGateways"])
                    this.paymentGateways!.push(item);
            }
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(ReasonDto.fromJS(item));
            }
            this.tripId = _data["tripId"];
            this.invoiceProfile = _data["invoiceProfile"] ? InvoiceProfileDto.fromJS(_data["invoiceProfile"]) : <any>undefined;
            this.paymentGateway = _data["paymentGateway"];
            if (Array.isArray(_data["selectedLabels"])) {
                this.selectedLabels = [] as any;
                for (let item of _data["selectedLabels"])
                    this.selectedLabels!.push(LabelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookTripResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookTripResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trip"] = this.trip ? this.trip.toJSON() : <any>undefined;
        if (Array.isArray(this.invoiceProfiles)) {
            data["invoiceProfiles"] = [];
            for (let item of this.invoiceProfiles)
                data["invoiceProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentGateways)) {
            data["paymentGateways"] = [];
            for (let item of this.paymentGateways)
                data["paymentGateways"].push(item);
        }
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        data["tripId"] = this.tripId;
        data["invoiceProfile"] = this.invoiceProfile ? this.invoiceProfile.toJSON() : <any>undefined;
        data["paymentGateway"] = this.paymentGateway;
        if (Array.isArray(this.selectedLabels)) {
            data["selectedLabels"] = [];
            for (let item of this.selectedLabels)
                data["selectedLabels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookTripResponseDto {
    trip: TripDto;
    invoiceProfiles: InvoiceProfileDto[] | undefined;
    labels: LabelDto[] | undefined;
    paymentGateways: PaymentGatewayDto[] | undefined;
    reasons: ReasonDto[] | undefined;
    tripId: string | undefined;
    invoiceProfile: InvoiceProfileDto;
    paymentGateway: PaymentGatewayDto;
    selectedLabels: LabelDto[] | undefined;
}

export class ApprovalRequestInputDto implements IApprovalRequestInputDto {
    tripId!: string | undefined;
    approvers!: ApproverDto[] | undefined;
    message!: string | undefined;
    reasonId!: string | undefined;
    userSkippedFlow!: boolean;

    constructor(data?: IApprovalRequestInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripId = _data["tripId"];
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(ApproverDto.fromJS(item));
            }
            this.message = _data["message"];
            this.reasonId = _data["reasonId"];
            this.userSkippedFlow = _data["userSkippedFlow"];
        }
    }

    static fromJS(data: any): ApprovalRequestInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalRequestInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripId"] = this.tripId;
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["reasonId"] = this.reasonId;
        data["userSkippedFlow"] = this.userSkippedFlow;
        return data;
    }
}

export interface IApprovalRequestInputDto {
    tripId: string | undefined;
    approvers: ApproverDto[] | undefined;
    message: string | undefined;
    reasonId: string | undefined;
    userSkippedFlow: boolean;
}

export class BookTripRequestDto implements IBookTripRequestDto {
    tripId!: string | undefined;
    invoiceProfile!: InvoiceProfileDto;
    paymentGateway!: PaymentGatewayDto;
    selectedLabels!: LabelDto[] | undefined;

    constructor(data?: IBookTripRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripId = _data["tripId"];
            this.invoiceProfile = _data["invoiceProfile"] ? InvoiceProfileDto.fromJS(_data["invoiceProfile"]) : <any>undefined;
            this.paymentGateway = _data["paymentGateway"];
            if (Array.isArray(_data["selectedLabels"])) {
                this.selectedLabels = [] as any;
                for (let item of _data["selectedLabels"])
                    this.selectedLabels!.push(LabelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BookTripRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookTripRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripId"] = this.tripId;
        data["invoiceProfile"] = this.invoiceProfile ? this.invoiceProfile.toJSON() : <any>undefined;
        data["paymentGateway"] = this.paymentGateway;
        if (Array.isArray(this.selectedLabels)) {
            data["selectedLabels"] = [];
            for (let item of this.selectedLabels)
                data["selectedLabels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBookTripRequestDto {
    tripId: string | undefined;
    invoiceProfile: InvoiceProfileDto;
    paymentGateway: PaymentGatewayDto;
    selectedLabels: LabelDto[] | undefined;
}

export class CostDivisionElementDto implements ICostDivisionElementDto {
    costCenterId!: number;
    costCenterName!: string | undefined;
    costCenterDivisionValue!: number;
    totalTripDue!: number;

    constructor(data?: ICostDivisionElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.costCenterDivisionValue = _data["costCenterDivisionValue"];
            this.totalTripDue = _data["totalTripDue"];
        }
    }

    static fromJS(data: any): CostDivisionElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostDivisionElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["costCenterDivisionValue"] = this.costCenterDivisionValue;
        data["totalTripDue"] = this.totalTripDue;
        return data;
    }
}

export interface ICostDivisionElementDto {
    costCenterId: number;
    costCenterName: string | undefined;
    costCenterDivisionValue: number;
    totalTripDue: number;
}

export class ApprovalProcessSingleWrapDto implements IApprovalProcessSingleWrapDto {
    approvalProcess!: ApprovalProcessDto;
    approvalProcessStatus!: ApprovalProcessStatus;
    choosedApprover!: ApproverDto;
    costDivisionElements!: CostDivisionElementDto[] | undefined;

    constructor(data?: IApprovalProcessSingleWrapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvalProcess = _data["approvalProcess"] ? ApprovalProcessDto.fromJS(_data["approvalProcess"]) : <any>undefined;
            this.approvalProcessStatus = _data["approvalProcessStatus"];
            this.choosedApprover = _data["choosedApprover"] ? ApproverDto.fromJS(_data["choosedApprover"]) : <any>undefined;
            if (Array.isArray(_data["costDivisionElements"])) {
                this.costDivisionElements = [] as any;
                for (let item of _data["costDivisionElements"])
                    this.costDivisionElements!.push(CostDivisionElementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalProcessSingleWrapDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalProcessSingleWrapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalProcess"] = this.approvalProcess ? this.approvalProcess.toJSON() : <any>undefined;
        data["approvalProcessStatus"] = this.approvalProcessStatus;
        data["choosedApprover"] = this.choosedApprover ? this.choosedApprover.toJSON() : <any>undefined;
        if (Array.isArray(this.costDivisionElements)) {
            data["costDivisionElements"] = [];
            for (let item of this.costDivisionElements)
                data["costDivisionElements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApprovalProcessSingleWrapDto {
    approvalProcess: ApprovalProcessDto;
    approvalProcessStatus: ApprovalProcessStatus;
    choosedApprover: ApproverDto;
    costDivisionElements: CostDivisionElementDto[] | undefined;
}

export class ApprovalProcessFlowDto implements IApprovalProcessFlowDto {
    tripId!: string | undefined;
    approvalProcesses!: ApprovalProcessSingleWrapDto[] | undefined;
    flowStatus!: ApprovalProcessStatus;
    approvalProcessFlowRequest!: ApprovalRequestDto;
    userSkippedFlow!: boolean;
    nextApprovalProcessId!: string | undefined;

    constructor(data?: IApprovalProcessFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripId = _data["tripId"];
            if (Array.isArray(_data["approvalProcesses"])) {
                this.approvalProcesses = [] as any;
                for (let item of _data["approvalProcesses"])
                    this.approvalProcesses!.push(ApprovalProcessSingleWrapDto.fromJS(item));
            }
            this.flowStatus = _data["flowStatus"];
            this.approvalProcessFlowRequest = _data["approvalProcessFlowRequest"] ? ApprovalRequestDto.fromJS(_data["approvalProcessFlowRequest"]) : <any>undefined;
            this.userSkippedFlow = _data["userSkippedFlow"];
            this.nextApprovalProcessId = _data["nextApprovalProcessId"];
        }
    }

    static fromJS(data: any): ApprovalProcessFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalProcessFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripId"] = this.tripId;
        if (Array.isArray(this.approvalProcesses)) {
            data["approvalProcesses"] = [];
            for (let item of this.approvalProcesses)
                data["approvalProcesses"].push(item.toJSON());
        }
        data["flowStatus"] = this.flowStatus;
        data["approvalProcessFlowRequest"] = this.approvalProcessFlowRequest ? this.approvalProcessFlowRequest.toJSON() : <any>undefined;
        data["userSkippedFlow"] = this.userSkippedFlow;
        data["nextApprovalProcessId"] = this.nextApprovalProcessId;
        return data;
    }
}

export interface IApprovalProcessFlowDto {
    tripId: string | undefined;
    approvalProcesses: ApprovalProcessSingleWrapDto[] | undefined;
    flowStatus: ApprovalProcessStatus;
    approvalProcessFlowRequest: ApprovalRequestDto;
    userSkippedFlow: boolean;
    nextApprovalProcessId: string | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    inheritedFromOrganizationUnit!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
            this.inheritedFromOrganizationUnit = _data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    inheritedFromOrganizationUnit: boolean;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    memberedOrganizationUnits!: OrganizationUnitDto[] | undefined;
    agencyId!: string | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            this.agencyId = _data["agencyId"];
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item.toJSON());
        }
        data["agencyId"] = this.agencyId;
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    memberedOrganizationUnits: OrganizationUnitDto[] | undefined;
    agencyId: string | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;
    agencyId!: string | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
            this.agencyId = _data["agencyId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        data["agencyId"] = this.agencyId;
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
    agencyId: string | undefined;
}

export class UserDelegationDto implements IUserDelegationDto {
    username!: string | undefined;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    id!: number;

    constructor(data?: IUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDelegationDto {
    username: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfUserDelegationDto implements IPagedResultDtoOfUserDelegationDto {
    totalCount!: number;
    items!: UserDelegationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDelegationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserDelegationDto {
    totalCount: number;
    items: UserDelegationDto[] | undefined;
}

export class CreateUserDelegationDto implements ICreateUserDelegationDto {
    targetUserId!: number;
    startTime!: moment.Moment;
    endTime!: moment.Moment;

    constructor(data?: ICreateUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateUserDelegationDto {
    targetUserId: number;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class CreateOrEditUserProfileInputDto implements ICreateOrEditUserProfileInputDto {
    userProfile!: UserProfileDto;

    constructor(data?: ICreateOrEditUserProfileInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProfile = _data["userProfile"] ? UserProfileDto.fromJS(_data["userProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditUserProfileInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUserProfileInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrEditUserProfileInputDto {
    userProfile: UserProfileDto;
}

export class PagedResultDtoOfUserProfileDto implements IPagedResultDtoOfUserProfileDto {
    totalCount!: number;
    items!: UserProfileDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserProfileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserProfileDto {
    totalCount: number;
    items: UserProfileDto[] | undefined;
}

export class CreateUserProfilesInputDto implements ICreateUserProfilesInputDto {
    userProfiles!: UserProfileDto[] | undefined;

    constructor(data?: ICreateUserProfilesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userProfiles"])) {
                this.userProfiles = [] as any;
                for (let item of _data["userProfiles"])
                    this.userProfiles!.push(UserProfileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUserProfilesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserProfilesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userProfiles)) {
            data["userProfiles"] = [];
            for (let item of this.userProfiles)
                data["userProfiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateUserProfilesInputDto {
    userProfiles: UserProfileDto[] | undefined;
}

export class ValidatingCarrierDto implements IValidatingCarrierDto {
    id!: string | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    enabled!: boolean;
    isValidatingCarrier!: boolean;
    isTravelFusionCarrier!: boolean;
    travelFusionCarrierIdentifiers!: string[] | undefined;
    isTravelPortCarrier : boolean

    constructor(data?: IValidatingCarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.enabled = _data["enabled"];
            this.isValidatingCarrier = _data["isValidatingCarrier"];
            this.isTravelFusionCarrier = _data["isTravelFusionCarrier"];
            if (Array.isArray(_data["travelFusionCarrierIdentifiers"])) {
                this.travelFusionCarrierIdentifiers = [] as any;
                for (let item of _data["travelFusionCarrierIdentifiers"])
                    this.travelFusionCarrierIdentifiers!.push(item);
            }
            this.isTravelPortCarrier = _data["isTravelPortCarrier"];
        }
    }

    static fromJS(data: any): ValidatingCarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatingCarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["enabled"] = this.enabled;
        data["isValidatingCarrier"] = this.isValidatingCarrier;
        data["isTravelFusionCarrier"] = this.isTravelFusionCarrier;
        if (Array.isArray(this.travelFusionCarrierIdentifiers)) {
            data["travelFusionCarrierIdentifiers"] = [];
            for (let item of this.travelFusionCarrierIdentifiers)
                data["travelFusionCarrierIdentifiers"].push(item);
        }
        data["isTravelPortCarrier"] = this.isTravelPortCarrier;
        return data;
    }
}

export interface IValidatingCarrierDto {
    id: string | undefined;
    code: string | undefined;
    displayName: string | undefined;
    enabled: boolean;
    isValidatingCarrier: boolean;
    isTravelFusionCarrier: boolean;
    travelFusionCarrierIdentifiers: string[] | undefined;
    isTravelPortCarrier: boolean
}

export class ValidatingCarrierRoot implements IValidatingCarrierRoot {
    airlineCompanyCode!: string | undefined;
    airlineCompanyName!: string | undefined;
    enabled!: boolean;
    isValidatingCarrier!: boolean;
    isTravelFusionCarrier!: boolean;
    travelFusionCarrierIdentifiers!: string[] | undefined;
    isTravelPortCarrier: boolean;
    id!: string | undefined;
    ts!: moment.Moment;
    tenantId!: number | undefined;

    constructor(data?: IValidatingCarrierRoot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.airlineCompanyCode = _data["airlineCompanyCode"];
            this.airlineCompanyName = _data["airlineCompanyName"];
            this.enabled = _data["enabled"];
            this.isValidatingCarrier = _data["isValidatingCarrier"];
            this.isTravelFusionCarrier = _data["isTravelFusionCarrier"];
            if (Array.isArray(_data["travelFusionCarrierIdentifiers"])) {
                this.travelFusionCarrierIdentifiers = [] as any;
                for (let item of _data["travelFusionCarrierIdentifiers"])
                    this.travelFusionCarrierIdentifiers!.push(item);
            }
            this.isTravelPortCarrier = _data["isTravelPortCarrier"];
            this.id = _data["id"];
            this.ts = _data["ts"] ? moment(_data["ts"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ValidatingCarrierRoot {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatingCarrierRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineCompanyCode"] = this.airlineCompanyCode;
        data["airlineCompanyName"] = this.airlineCompanyName;
        data["enabled"] = this.enabled;
        data["isValidatingCarrier"] = this.isValidatingCarrier;
        data["isTravelFusionCarrier"] = this.isTravelFusionCarrier;
        if (Array.isArray(this.travelFusionCarrierIdentifiers)) {
            data["travelFusionCarrierIdentifiers"] = [];
            for (let item of this.travelFusionCarrierIdentifiers)
                data["travelFusionCarrierIdentifiers"].push(item);
        }
        data["isTravelPortCarrier"] = this.isTravelPortCarrier;
        data["id"] = this.id;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IValidatingCarrierRoot {
    airlineCompanyCode: string | undefined;
    airlineCompanyName: string | undefined;
    enabled: boolean;
    isValidatingCarrier: boolean;
    isTravelFusionCarrier: boolean;
    travelFusionCarrierIdentifiers: string[] | undefined;
    isTravelPortCarrier: boolean
    id: string | undefined;
    ts: moment.Moment;
    tenantId: number | undefined;
}

export class PagedResultDtoOfValidatingCarrierDto implements IPagedResultDtoOfValidatingCarrierDto {
    totalCount!: number;
    items!: ValidatingCarrierDto[] | undefined;

    constructor(data?: IPagedResultDtoOfValidatingCarrierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ValidatingCarrierDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfValidatingCarrierDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfValidatingCarrierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfValidatingCarrierDto {
    totalCount: number;
    items: ValidatingCarrierDto[] | undefined;
}

export class CreateOrEditValidatingCarrierInput implements ICreateOrEditValidatingCarrierInput {
    item!: ValidatingCarrierDto;

    constructor(data?: ICreateOrEditValidatingCarrierInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? ValidatingCarrierDto.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditValidatingCarrierInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditValidatingCarrierInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrEditValidatingCarrierInput {
    item: ValidatingCarrierDto;
}

export class GetValidatingCarrierForView implements IGetValidatingCarrierForView {
    item!: ValidatingCarrierDto;

    constructor(data?: IGetValidatingCarrierForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? ValidatingCarrierDto.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetValidatingCarrierForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetValidatingCarrierForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetValidatingCarrierForView {
    item: ValidatingCarrierDto;
}

export class WebhookEvent implements IWebhookEvent {
    webhookName!: string;
    data!: string | undefined;
    creationTime!: moment.Moment;
    tenantId!: number | undefined;
    isDeleted!: boolean;
    deletionTime!: moment.Moment | undefined;
    id!: string;

    constructor(data?: IWebhookEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webhookName = _data["webhookName"];
            this.data = _data["data"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.isDeleted = _data["isDeleted"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WebhookEvent {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IWebhookEvent {
    webhookName: string;
    data: string | undefined;
    creationTime: moment.Moment;
    tenantId: number | undefined;
    isDeleted: boolean;
    deletionTime: moment.Moment | undefined;
    id: string;
}

export enum HttpStatusCode {
    Continue = 100,
    SwitchingProtocols = 101,
    Processing = 102,
    EarlyHints = 103,
    OK = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    MultiStatus = 207,
    AlreadyReported = 208,
    IMUsed = 226,
    MultipleChoices = 300,
    Ambiguous = 301,
    MovedPermanently = 302,
    Moved = 303,
    Found = 304,
    Redirect = 305,
    SeeOther = 306,
    RedirectMethod = 307,
    NotModified = 308,
    UseProxy = 400,
    Unused = 401,
    TemporaryRedirect = 402,
    RedirectKeepVerb = 403,
    PermanentRedirect = 404,
    BadRequest = 405,
    Unauthorized = 406,
    PaymentRequired = 407,
    Forbidden = 408,
    NotFound = 409,
    MethodNotAllowed = 410,
    NotAcceptable = 411,
    ProxyAuthenticationRequired = 412,
    RequestTimeout = 413,
    Conflict = 414,
    Gone = 415,
    LengthRequired = 416,
    PreconditionFailed = 417,
    RequestEntityTooLarge = 421,
    RequestUriTooLong = 422,
    UnsupportedMediaType = 423,
    RequestedRangeNotSatisfiable = 424,
    ExpectationFailed = 426,
    MisdirectedRequest = 428,
    UnprocessableEntity = 429,
    Locked = 431,
    FailedDependency = 451,
    UpgradeRequired = 500,
    PreconditionRequired = 501,
    TooManyRequests = 502,
    RequestHeaderFieldsTooLarge = 503,
    UnavailableForLegalReasons = 504,
    InternalServerError = 505,
    NotImplemented = 506,
    BadGateway = 507,
    ServiceUnavailable = 508,
    GatewayTimeout = 510,
    HttpVersionNotSupported = 511,
}

export class GetAllSendAttemptsOutput implements IGetAllSendAttemptsOutput {
    id!: string;
    webhookEventId!: string;
    webhookName!: string | undefined;
    data!: string | undefined;
    response!: string | undefined;
    responseStatusCode!: HttpStatusCode;
    creationTime!: moment.Moment;

    constructor(data?: IGetAllSendAttemptsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookEventId = _data["webhookEventId"];
            this.webhookName = _data["webhookName"];
            this.data = _data["data"];
            this.response = _data["response"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllSendAttemptsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSendAttemptsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookEventId"] = this.webhookEventId;
        data["webhookName"] = this.webhookName;
        data["data"] = this.data;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAllSendAttemptsOutput {
    id: string;
    webhookEventId: string;
    webhookName: string | undefined;
    data: string | undefined;
    response: string | undefined;
    responseStatusCode: HttpStatusCode;
    creationTime: moment.Moment;
}

export class PagedResultDtoOfGetAllSendAttemptsOutput implements IPagedResultDtoOfGetAllSendAttemptsOutput {
    totalCount!: number;
    items!: GetAllSendAttemptsOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSendAttemptsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSendAttemptsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSendAttemptsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSendAttemptsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllSendAttemptsOutput {
    totalCount: number;
    items: GetAllSendAttemptsOutput[] | undefined;
}

export class GetAllSendAttemptsOfWebhookEventOutput implements IGetAllSendAttemptsOfWebhookEventOutput {
    id!: string;
    webhookUri!: string | undefined;
    webhookSubscriptionId!: string;
    response!: string | undefined;
    responseStatusCode!: HttpStatusCode;
    creationTime!: moment.Moment;
    lastModificationTime!: moment.Moment | undefined;

    constructor(data?: IGetAllSendAttemptsOfWebhookEventOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webhookUri = _data["webhookUri"];
            this.webhookSubscriptionId = _data["webhookSubscriptionId"];
            this.response = _data["response"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllSendAttemptsOfWebhookEventOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webhookUri"] = this.webhookUri;
        data["webhookSubscriptionId"] = this.webhookSubscriptionId;
        data["response"] = this.response;
        data["responseStatusCode"] = this.responseStatusCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAllSendAttemptsOfWebhookEventOutput {
    id: string;
    webhookUri: string | undefined;
    webhookSubscriptionId: string;
    response: string | undefined;
    responseStatusCode: HttpStatusCode;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput implements IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    items!: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSendAttemptsOfWebhookEventOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    items: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;
}

export class GetAllSubscriptionsOutput implements IGetAllSubscriptionsOutput {
    webhookUri!: string | undefined;
    isActive!: boolean;
    webhooks!: string[] | undefined;
    id!: string;

    constructor(data?: IGetAllSubscriptionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webhookUri = _data["webhookUri"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAllSubscriptionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSubscriptionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webhookUri"] = this.webhookUri;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAllSubscriptionsOutput {
    webhookUri: string | undefined;
    isActive: boolean;
    webhooks: string[] | undefined;
    id: string;
}

export class ListResultDtoOfGetAllSubscriptionsOutput implements IListResultDtoOfGetAllSubscriptionsOutput {
    items!: GetAllSubscriptionsOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllSubscriptionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllSubscriptionsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllSubscriptionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllSubscriptionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllSubscriptionsOutput {
    items: GetAllSubscriptionsOutput[] | undefined;
}

export class WebhookSubscription implements IWebhookSubscription {
    tenantId!: number | undefined;
    webhookUri!: string | undefined;
    secret!: string | undefined;
    isActive!: boolean;
    webhooks!: string[] | undefined;
    headers!: { [key: string]: string; } | undefined;
    id!: string;

    constructor(data?: IWebhookSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.webhookUri = _data["webhookUri"];
            this.secret = _data["secret"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["webhooks"])) {
                this.webhooks = [] as any;
                for (let item of _data["webhooks"])
                    this.webhooks!.push(item);
            }
            if (_data["headers"]) {
                this.headers = {} as any;
                for (let key in _data["headers"]) {
                    if (_data["headers"].hasOwnProperty(key))
                        this.headers![key] = _data["headers"][key];
                }
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WebhookSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["webhookUri"] = this.webhookUri;
        data["secret"] = this.secret;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.webhooks)) {
            data["webhooks"] = [];
            for (let item of this.webhooks)
                data["webhooks"].push(item);
        }
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    data["headers"][key] = this.headers[key];
            }
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IWebhookSubscription {
    tenantId: number | undefined;
    webhookUri: string | undefined;
    secret: string | undefined;
    isActive: boolean;
    webhooks: string[] | undefined;
    headers: { [key: string]: string; } | undefined;
    id: string;
}

export class ActivateWebhookSubscriptionInput implements IActivateWebhookSubscriptionInput {
    subscriptionId!: string;
    isActive!: boolean;

    constructor(data?: IActivateWebhookSubscriptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ActivateWebhookSubscriptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateWebhookSubscriptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IActivateWebhookSubscriptionInput {
    subscriptionId: string;
    isActive: boolean;
}

export class GetAllAvailableWebhooksOutput implements IGetAllAvailableWebhooksOutput {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IGetAllAvailableWebhooksOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetAllAvailableWebhooksOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetAllAvailableWebhooksOutput {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class ListResultDtoOfGetAllAvailableWebhooksOutput implements IListResultDtoOfGetAllAvailableWebhooksOutput {
    items!: GetAllAvailableWebhooksOutput[] | undefined;

    constructor(data?: IListResultDtoOfGetAllAvailableWebhooksOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetAllAvailableWebhooksOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAllAvailableWebhooksOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGetAllAvailableWebhooksOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfGetAllAvailableWebhooksOutput {
    items: GetAllAvailableWebhooksOutput[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class AdditionalData implements IAdditionalData {
    paypal!: { [key: string]: string; };
    stripe!: { [key: string]: string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["Paypal"]) {
                this.paypal = {} as any;
                for (let key in _data["Paypal"]) {
                    if (_data["Paypal"].hasOwnProperty(key))
                        this.paypal![key] = _data["Paypal"][key];
                }
            }
            if (_data["Stripe"]) {
                this.stripe = {} as any;
                for (let key in _data["Stripe"]) {
                    if (_data["Stripe"].hasOwnProperty(key))
                        this.stripe![key] = _data["Stripe"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (let key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    data["Stripe"][key] = this.stripe[key];
            }
        }
        return data;
    }
}

export interface IAdditionalData {
    paypal: { [key: string]: string; };
    stripe: { [key: string]: string; };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
